/// <reference path="./custom.d.ts" />
/* eslint-disable */
/**
 * Plato frontend API
 * Used by plato front
 *
 * OpenAPI spec version: v0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import url from "url";

import { handleGeneratedApiResponse } from "src/api/helpers";

import { Configuration } from "./configuration";

const BASE_PATH = "https://localhost/prv".replace(/\/+$/, "");

/**
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetchData: FetchAPI = fetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AgencyApiAuthentication
 */
export interface AgencyApiAuthentication {
    /**
     * 
     * @type {string}
     * @memberof AgencyApiAuthentication
     */
    type: AgencyApiAuthentication_TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AgencyApiAuthentication
     */
    client_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyApiAuthentication
     */
    client_secret?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyApiAuthentication
     */
    token?: string;
    /**
     * URL to get the token - Only used by the native poller
     * @type {string}
     * @memberof AgencyApiAuthentication
     */
    token_url?: string;
    /**
     * Expiration delay in seconds
     * @type {number}
     * @memberof AgencyApiAuthentication
     */
    expires_in?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum AgencyApiAuthentication_TypeEnum {
    'header' = 'header',
    'none' = 'none',
    'oauth2' = 'oauth2',
    'spin' = 'spin',
    'token' = 'token',
    'bolt' = 'bolt',
    'dott' = 'dott',
    'helloride' = 'helloride',
    'serve_robotics' = 'serve_robotics',
    'query_string_authentication' = 'query_string_authentication',
    'ario' = 'ario'
}

/**
 * 
 * @export
 * @interface AgencyApiConfiguration
 */
export interface AgencyApiConfiguration {
    /**
     * 
     * @type {string}
     * @memberof AgencyApiConfiguration
     */
    api_version: AgencyApiConfiguration_ApiVersionEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgencyApiConfiguration_ApiVersionEnum {
    'none' = 'none',
    'v0_3' = 'v0_3',
    'v0_4' = 'v0_4',
    'v1_0' = 'v1_0',
    'v1_1' = 'v1_1',
    'v1_2' = 'v1_2',
    'v2_0' = 'v2_0'
}

/**
 * 
 * @export
 * @interface AgencyLogo
 */
export interface AgencyLogo {
    /**
     * 
     * @type {string}
     * @memberof AgencyLogo
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyLogo
     */
    brand_name?: string;
}
/**
 * 
 * @export
 * @interface AgencySettings
 */
export interface AgencySettings {
    /**
     * 
     * @type {number}
     * @memberof AgencySettings
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AgencySettings
     */
    trip_threshold: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencySettings
     */
    enabled_extensions: Array<AgencySettings_EnabledExtensionsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencySettings
     */
    enabled_features: Array<AgencySettings_EnabledFeaturesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencySettings
     */
    vehicle_types: Array<AgencySettings_VehicleTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencySettings
     */
    allowed_vehicle_types?: Array<AgencySettings_AllowedVehicleTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencySettings
     */
    vehicle_propulsions: Array<AgencySettings_VehiclePropulsionsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencySettings
     */
    vehicle_states: Array<AgencySettings_VehicleStatesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencySettings
     */
    event_types: Array<AgencySettings_EventTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencySettings
     */
    line_types: Array<AgencySettings_LineTypesEnum>;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: Array<string>; }; }}
     * @memberof AgencySettings
     */
    vehicle_state_events?: { [key: string]: { [key: string]: Array<string>; }; };
    /**
     * 
     * @type {number}
     * @memberof AgencySettings
     */
    smart_patrol_parking_threshold: number;
    /**
     * 
     * @type {string}
     * @memberof AgencySettings
     */
    distance_unit: string;
    /**
     * 
     * @type {string}
     * @memberof AgencySettings
     */
    language_code: string;
    /**
     * 
     * @type {string}
     * @memberof AgencySettings
     */
    penalty_currency_code: string;
    /**
     * 
     * @type {string}
     * @memberof AgencySettings
     */
    permit_currency_code: string;
    /**
     * 
     * @type {string}
     * @memberof AgencySettings
     */
    speed_unit: string;
    /**
     * 
     * @type {string}
     * @memberof AgencySettings
     */
    speed_unit_display: string;
    /**
     * 
     * @type {string}
     * @memberof AgencySettings
     */
    device_type_to_category_mapping: string;
    /**
     * 
     * @type {number}
     * @memberof AgencySettings
     */
    kpi_filter_number_of_units: number;
    /**
     * 
     * @type {string}
     * @memberof AgencySettings
     */
    kpi_filter_unit: string;
    /**
     * 
     * @type {string}
     * @memberof AgencySettings
     */
    kpi_filter_granularity: string;
    /**
     * 
     * @type {number}
     * @memberof AgencySettings
     */
    kpi_infrastructure_train_distance: number;
    /**
     * 
     * @type {number}
     * @memberof AgencySettings
     */
    kpi_infrastructure_tram_distance: number;
    /**
     * 
     * @type {number}
     * @memberof AgencySettings
     */
    kpi_infrastructure_subway_distance: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencySettings
     */
    mds_compatible_kinds?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum AgencySettings_EnabledExtensionsEnum {
    'gbfs' = 'gbfs',
    'gtfs' = 'gtfs',
    'mds' = 'mds',
    'cds' = 'cds',
    'databrix' = 'databrix'
}
/**
    * @export
    * @enum {string}
    */
export enum AgencySettings_EnabledFeaturesEnum {
    'heatmap_origin_destination' = 'heatmap_origin_destination',
    'heatmap_trips' = 'heatmap_trips',
    'environment_kpi' = 'environment_kpi',
    'user_kpi' = 'user_kpi',
    'violation_map' = 'violation_map',
    'mds.raw_data_transfer' = 'mds.raw_data_transfer',
    'mds_policy.absolute_fleet_size' = 'mds_policy.absolute_fleet_size',
    'mds_policy.fleet_budget' = 'mds_policy.fleet_budget',
    'mds_policy.geofence' = 'mds_policy.geofence',
    'mds_policy.parking' = 'mds_policy.parking',
    'mds_policy.old_permit' = 'mds_policy.old_permit',
    'mds_policy.speed' = 'mds_policy.speed',
    'mds_policy.trip_taxation' = 'mds_policy.trip_taxation',
    'mds_policy.maintenance' = 'mds_policy.maintenance',
    'mds_policy.dwell_time' = 'mds_policy.dwell_time',
    'reports.area_flow' = 'reports.area_flow',
    'reports.effective_presence' = 'reports.effective_presence',
    'reports.historical_map' = 'reports.historical_map',
    'buffered_areas' = 'buffered_areas',
    'policies_events_and_states_configuration' = 'policies_events_and_states_configuration',
    'policies_beginner_mode.beginner_speed_limit' = 'policies_beginner_mode.beginner_speed_limit',
    'policies_beginner_mode.beginner_allowed_hours' = 'policies_beginner_mode.beginner_allowed_hours',
    'policy_workspace' = 'policy_workspace',
    'fee_rates.permit' = 'fee_rates.permit',
    'fee_rates.vehicle_deployment' = 'fee_rates.vehicle_deployment',
    'dispatch_911' = 'dispatch_911',
    'smart_patrol.create_from_web' = 'smart_patrol.create_from_web',
    'smart_patrol.tiger_events' = 'smart_patrol.tiger_events',
    'mds_policy.abandoned' = 'mds_policy.abandoned',
    'mds_policy.balancing' = 'mds_policy.balancing',
    'mds_policy.sidewalk' = 'mds_policy.sidewalk',
    'mds_policy.time' = 'mds_policy.time',
    'mds_policy.user' = 'mds_policy.user',
    'databrix_jobs_per_provider' = 'databrix_jobs_per_provider'
}
/**
    * @export
    * @enum {string}
    */
export enum AgencySettings_VehicleTypesEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}
/**
    * @export
    * @enum {string}
    */
export enum AgencySettings_AllowedVehicleTypesEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}
/**
    * @export
    * @enum {string}
    */
export enum AgencySettings_VehiclePropulsionsEnum {
    'human' = 'human',
    'electric_assist' = 'electric_assist',
    'electric' = 'electric',
    'combustion' = 'combustion',
    'missing' = 'missing'
}
/**
    * @export
    * @enum {string}
    */
export enum AgencySettings_VehicleStatesEnum {
    'available' = 'available',
    'elsewhere' = 'elsewhere',
    'non_operational' = 'non_operational',
    'on_trip' = 'on_trip',
    'removed' = 'removed',
    'reserved' = 'reserved',
    'unknown' = 'unknown',
    'stopped' = 'stopped',
    'non_contactable' = 'non_contactable',
    'missing' = 'missing'
}
/**
    * @export
    * @enum {string}
    */
export enum AgencySettings_EventTypesEnum {
    'agency_drop_off' = 'agency_drop_off',
    'agency_pick_up' = 'agency_pick_up',
    'battery_charged' = 'battery_charged',
    'battery_low' = 'battery_low',
    'comms_lost' = 'comms_lost',
    'comms_restored' = 'comms_restored',
    'compliance_pick_up' = 'compliance_pick_up',
    'decommissioned' = 'decommissioned',
    'driver_cancellation' = 'driver_cancellation',
    'located' = 'located',
    'maintenance' = 'maintenance',
    'maintenance_pick_up' = 'maintenance_pick_up',
    'missing' = 'missing',
    'off_hours' = 'off_hours',
    'on_hours' = 'on_hours',
    'passenger_cancellation' = 'passenger_cancellation',
    'provider_drop_off' = 'provider_drop_off',
    'rebalance_pick_up' = 'rebalance_pick_up',
    'reservation_cancel' = 'reservation_cancel',
    'reservation_start' = 'reservation_start',
    'reservation_stop' = 'reservation_stop',
    'service_end' = 'service_end',
    'system_resume' = 'system_resume',
    'system_start' = 'system_start',
    'system_suspend' = 'system_suspend',
    'trip_cancel' = 'trip_cancel',
    'trip_end' = 'trip_end',
    'trip_enter_jurisdiction' = 'trip_enter_jurisdiction',
    'trip_leave_jurisdiction' = 'trip_leave_jurisdiction',
    'trip_start' = 'trip_start',
    'trip_stop' = 'trip_stop',
    'unspecified' = 'unspecified',
    'notification_sent' = 'notification_sent',
    'changed_geographies' = 'changed_geographies',
    'charging_end' = 'charging_end',
    'charging_start' = 'charging_start',
    'customer_cancellation' = 'customer_cancellation',
    'fueling_end' = 'fueling_end',
    'fueling_start' = 'fueling_start',
    'maintenance_end' = 'maintenance_end',
    'not_located' = 'not_located',
    'order_drop_off' = 'order_drop_off',
    'order_pick_up' = 'order_pick_up',
    'provider_cancellation' = 'provider_cancellation',
    'recommission' = 'recommission',
    'remote_end' = 'remote_end',
    'remote_start' = 'remote_start',
    'service_start' = 'service_start',
    'trip_pause' = 'trip_pause',
    'trip_resume' = 'trip_resume'
}
/**
    * @export
    * @enum {string}
    */
export enum AgencySettings_LineTypesEnum {
    'bus' = 'bus',
    'train' = 'train',
    'tram' = 'tram',
    'subway' = 'subway',
    'bike' = 'bike',
    'ferry' = 'ferry'
}

/**
 * 
 * @export
 * @interface AgencySettingsResponse
 */
export interface AgencySettingsResponse {
    /**
     * 
     * @type {AgencySettings}
     * @memberof AgencySettingsResponse
     */
    settings: AgencySettings;
    /**
     * 
     * @type {string}
     * @memberof AgencySettingsResponse
     */
    last_modified: string;
}
/**
 * 
 * @export
 * @interface Agent
 */
export interface Agent {
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    pk: number;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    full_name: string;
}
/**
 * 
 * @export
 * @interface AllowedViolationType
 */
export interface AllowedViolationType {
    /**
     * 
     * @type {string}
     * @memberof AllowedViolationType
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AllowedViolationType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AllowedViolationType
     */
    localized_name: string;
}
/**
 * 
 * @export
 * @interface Area
 */
export interface Area {
    /**
     * 
     * @type {string}
     * @memberof Area
     */
    pk?: string;
}
/**
 * 
 * @export
 * @interface AreaLabelResponse
 */
export interface AreaLabelResponse {
    /**
     * 
     * @type {string}
     * @memberof AreaLabelResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AreaLabelResponse
     */
    label: string;
}
/**
 * 
 * @export
 * @interface AreaPolygonResponse
 */
export interface AreaPolygonResponse {
    /**
     * Unique Polygon identifier (UUID)
     * @type {string}
     * @memberof AreaPolygonResponse
     */
    id: string;
    /**
     * Name of the polygon
     * @type {string}
     * @memberof AreaPolygonResponse
     */
    label: string;
    /**
     * 
     * @type {Polygon}
     * @memberof AreaPolygonResponse
     */
    geom: Polygon;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AreaPolygonResponse
     */
    properties: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface AreaRequest
 */
export interface AreaRequest {
    /**
     * Name of the Area
     * @type {string}
     * @memberof AreaRequest
     */
    label: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AreaRequest
     */
    polygons: Array<string>;
    /**
     * Color of the Area
     * @type {string}
     * @memberof AreaRequest
     */
    color?: string;
    /**
     * Tags of the Area, replacing the current ones. Unknown ones are created
     * @type {Array<string>}
     * @memberof AreaRequest
     */
    tags: Array<string>;
}
/**
 * 
 * @export
 * @interface AreaResponse
 */
export interface AreaResponse {
    /**
     * 
     * @type {string}
     * @memberof AreaResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AreaResponse
     */
    label: string;
    /**
     * 
     * @type {Array<AreaPolygonResponse>}
     * @memberof AreaResponse
     */
    polygons: Array<AreaPolygonResponse>;
    /**
     * 
     * @type {string}
     * @memberof AreaResponse
     */
    color: string;
    /**
     * 
     * @type {string}
     * @memberof AreaResponse
     */
    correlation_id: string;
}
/**
 * 
 * @export
 * @interface AuditLog
 */
export interface AuditLog {
    /**
     * 
     * @type {string}
     * @memberof AuditLog
     */
    history_date?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLog
     */
    history_user_name?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLog
     */
    history_type?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLog
     */
    history_kind?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditLog
     */
    display_name?: string;
}
/**
 * 
 * @export
 * @interface AuditLogResponse
 */
export interface AuditLogResponse {
    /**
     * 
     * @type {Array<AuditLog>}
     * @memberof AuditLogResponse
     */
    results: Array<AuditLog>;
}
/**
 * 
 * @export
 * @interface BufferAreaRequest
 */
export interface BufferAreaRequest {
    /**
     * Name of the buffered Area
     * @type {string}
     * @memberof BufferAreaRequest
     */
    label: string;
    /**
     * Color of the buffered Area
     * @type {string}
     * @memberof BufferAreaRequest
     */
    color: string;
    /**
     * Id of the Area to buffer
     * @type {string}
     * @memberof BufferAreaRequest
     */
    area: string;
    /**
     * Buffer distance in meters
     * @type {number}
     * @memberof BufferAreaRequest
     */
    distance: number;
    /**
     * Tags of the buffered Area. Unknown ones are created
     * @type {Array<string>}
     * @memberof BufferAreaRequest
     */
    tags?: Array<string>;
}
/**
 * 
 * @export
 * @interface ChangePassword
 */
export interface ChangePassword {
    /**
     * 
     * @type {string}
     * @memberof ChangePassword
     */
    current: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePassword
     */
    password: string;
}
/**
 * 
 * @export
 * @interface CreatePenaltyScheme
 */
export interface CreatePenaltyScheme {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePenaltyScheme
     */
    policies: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePenaltyScheme
     */
    providers: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreatePenaltyScheme
     */
    start_date: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePenaltyScheme
     */
    end_date: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePenaltyScheme
     */
    is_fee_rates: boolean;
}
/**
 * 
 * @export
 * @interface CreateReport
 */
export interface CreateReport {
    /**
     * 
     * @type {string}
     * @memberof CreateReport
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReport
     */
    kind: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReport
     */
    start_at: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReport
     */
    end_at: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReport
     */
    area_id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReport
     */
    vehicle_type?: CreateReport_VehicleTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateReport_VehicleTypeEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}

/**
 * 
 * @export
 * @interface CreatedAreaResponse
 */
export interface CreatedAreaResponse {
    /**
     * 
     * @type {string}
     * @memberof CreatedAreaResponse
     */
    id: string;
}
/**
 * 
 * @export
 * @interface DeleteListPolygonRequest
 */
export interface DeleteListPolygonRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteListPolygonRequest
     */
    ids: Array<string>;
}
/**
 * 
 * @export
 * @interface DomainPermission
 */
export interface DomainPermission {
    /**
     * 
     * @type {string}
     * @memberof DomainPermission
     */
    domain: DomainPermission_DomainEnum;
    /**
     * 
     * @type {string}
     * @memberof DomainPermission
     */
    verb: DomainPermission_VerbEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DomainPermission_DomainEnum {
    'administration' = 'administration',
    'area' = 'area',
    'audit' = 'audit',
    'device' = 'device',
    'gbfs' = 'gbfs',
    'instance' = 'instance',
    'kpi' = 'kpi',
    'map' = 'map',
    'mds' = 'mds',
    'policy' = 'policy',
    'provider' = 'provider',
    'report' = 'report',
    'trip' = 'trip',
    'fee_rates' = 'fee_rates',
    'smart_patrol' = 'smart_patrol',
    'parking' = 'parking',
    'ride_hailing' = 'ride_hailing',
    'ycurb' = 'ycurb',
    'safety' = 'safety',
    'docked_bikes' = 'docked_bikes',
    'passengers_services_test' = 'passengers_services_test',
    'senmap' = 'senmap',
    'parking_bay' = 'parking_bay',
    'vehicles_kpis' = 'vehicles_kpis',
    'utilization_kpis' = 'utilization_kpis',
    'trips_kpis' = 'trips_kpis',
    'heatmaps' = 'heatmaps',
    'environment_kpis' = 'environment_kpis',
    'data_quality_kpis' = 'data_quality_kpis',
    'smart_loading_zone' = 'smart_loading_zone',
    'street_segment' = 'street_segment',
    'user_kpis' = 'user_kpis',
    'curb_overview' = 'curb_overview',
    'policy_kind_activation' = 'policy_kind_activation',
    'all' = 'all'
}
/**
    * @export
    * @enum {string}
    */
export enum DomainPermission_VerbEnum {
    'read' = 'read',
    'summarize' = 'summarize',
    'analyze' = 'analyze',
    'write' = 'write',
    'manage' = 'manage'
}

/**
 * 
 * @export
 * @interface EmptyResponse
 */
export interface EmptyResponse {
}
/**
 * 
 * @export
 * @interface EventRecord
 */
export interface EventRecord {
    /**
     * 
     * @type {string}
     * @memberof EventRecord
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof EventRecord
     */
    provider_name: string;
    /**
     * 
     * @type {string}
     * @memberof EventRecord
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventRecord
     */
    device_vin: string;
    /**
     * 
     * @type {string}
     * @memberof EventRecord
     */
    vehicle_state: EventRecord_VehicleStateEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventRecord
     */
    event_types: Array<EventRecord_EventTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof EventRecord
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof EventRecord
     */
    longitude?: number;
    /**
     * 
     * @type {string}
     * @memberof EventRecord
     */
    source: string;
}

/**
    * @export
    * @enum {string}
    */
export enum EventRecord_VehicleStateEnum {
    'available' = 'available',
    'elsewhere' = 'elsewhere',
    'non_operational' = 'non_operational',
    'on_trip' = 'on_trip',
    'removed' = 'removed',
    'reserved' = 'reserved',
    'unknown' = 'unknown',
    'stopped' = 'stopped',
    'non_contactable' = 'non_contactable',
    'missing' = 'missing'
}
/**
    * @export
    * @enum {string}
    */
export enum EventRecord_EventTypesEnum {
    'agency_drop_off' = 'agency_drop_off',
    'agency_pick_up' = 'agency_pick_up',
    'battery_charged' = 'battery_charged',
    'battery_low' = 'battery_low',
    'comms_lost' = 'comms_lost',
    'comms_restored' = 'comms_restored',
    'compliance_pick_up' = 'compliance_pick_up',
    'decommissioned' = 'decommissioned',
    'driver_cancellation' = 'driver_cancellation',
    'located' = 'located',
    'maintenance' = 'maintenance',
    'maintenance_pick_up' = 'maintenance_pick_up',
    'missing' = 'missing',
    'off_hours' = 'off_hours',
    'on_hours' = 'on_hours',
    'passenger_cancellation' = 'passenger_cancellation',
    'provider_drop_off' = 'provider_drop_off',
    'rebalance_pick_up' = 'rebalance_pick_up',
    'reservation_cancel' = 'reservation_cancel',
    'reservation_start' = 'reservation_start',
    'reservation_stop' = 'reservation_stop',
    'service_end' = 'service_end',
    'system_resume' = 'system_resume',
    'system_start' = 'system_start',
    'system_suspend' = 'system_suspend',
    'trip_cancel' = 'trip_cancel',
    'trip_end' = 'trip_end',
    'trip_enter_jurisdiction' = 'trip_enter_jurisdiction',
    'trip_leave_jurisdiction' = 'trip_leave_jurisdiction',
    'trip_start' = 'trip_start',
    'trip_stop' = 'trip_stop',
    'unspecified' = 'unspecified',
    'notification_sent' = 'notification_sent',
    'changed_geographies' = 'changed_geographies',
    'charging_end' = 'charging_end',
    'charging_start' = 'charging_start',
    'customer_cancellation' = 'customer_cancellation',
    'fueling_end' = 'fueling_end',
    'fueling_start' = 'fueling_start',
    'maintenance_end' = 'maintenance_end',
    'not_located' = 'not_located',
    'order_drop_off' = 'order_drop_off',
    'order_pick_up' = 'order_pick_up',
    'provider_cancellation' = 'provider_cancellation',
    'recommission' = 'recommission',
    'remote_end' = 'remote_end',
    'remote_start' = 'remote_start',
    'service_start' = 'service_start',
    'trip_pause' = 'trip_pause',
    'trip_resume' = 'trip_resume'
}

/**
 * 
 * @export
 * @interface ExistPolicyResponse
 */
export interface ExistPolicyResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ExistPolicyResponse
     */
    exist: boolean;
}
/**
 * 
 * @export
 * @interface Favorite
 */
export interface Favorite {
    /**
     * Page ID
     * @type {string}
     * @memberof Favorite
     */
    page_id: Favorite_PageIdEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum Favorite_PageIdEnum {
    'reports' = 'reports',
    'report_area_flow' = 'report_area_flow',
    'report_historial_map' = 'report_historial_map',
    'map' = 'map',
    'trips' = 'trips',
    'trips_list' = 'trips_list',
    'trips_heatmap' = 'trips_heatmap',
    'trips_KPI' = 'trips_KPI',
    'trips_env_KPI' = 'trips_env_KPI',
    'trips_user_KPI' = 'trips_user_KPI',
    'vehicles' = 'vehicles',
    'vehicles_list' = 'vehicles_list',
    'vehicles_deployment_KPI' = 'vehicles_deployment_KPI',
    'vehicles_utilization_KPI' = 'vehicles_utilization_KPI',
    'providers' = 'providers',
    'fee_rates' = 'fee_rates',
    'fee_rates_list' = 'fee_rates_list',
    'fee_scheme' = 'fee_scheme',
    'fees_table' = 'fees_table',
    'policies' = 'policies',
    'policies_list' = 'policies_list',
    'policies_violations' = 'policies_violations',
    'policies_violation_detail' = 'policies_violation_detail',
    'policies_details_graphs' = 'policies_details_graphs',
    'policies_smart_patrol' = 'policies_smart_patrol',
    'policies_violation_map' = 'policies_violation_map',
    'policies_penalty_scheme' = 'policies_penalty_scheme',
    'policies_kpi' = 'policies_kpi',
    'mds' = 'mds',
    'areas' = 'areas',
    'logs' = 'logs',
    'parking' = 'parking',
    'ride_hailing' = 'ride_hailing',
    'ycurb' = 'ycurb',
    'safety' = 'safety',
    'docked_bikes' = 'docked_bikes',
    'passengers_services_test' = 'passengers_services_test',
    'senmap' = 'senmap',
    'parking_bay' = 'parking_bay',
    'vehicles_kpis' = 'vehicles_kpis',
    'utilization_kpis' = 'utilization_kpis',
    'trips_kpis' = 'trips_kpis',
    'heatmaps' = 'heatmaps',
    'heatmaps_street_segment' = 'heatmaps_street_segment',
    'environment_kpis' = 'environment_kpis',
    'data_quality_kpis' = 'data_quality_kpis',
    'vehicles_list_standalone' = 'vehicles_list_standalone',
    'trips_list_standalone' = 'trips_list_standalone',
    'trips_user_KPI_standalone' = 'trips_user_KPI_standalone',
    'smart_loading_zone' = 'smart_loading_zone',
    'curb_overview' = 'curb_overview'
}

/**
 * 
 * @export
 * @interface Feature
 */
export interface Feature {
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    type: Feature_TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Feature
     */
    id?: string;
    /**
     * 
     * @type {any}
     * @memberof Feature
     */
    properties: any;
    /**
     * 
     * @type {Geometry}
     * @memberof Feature
     */
    geometry: Geometry;
}

/**
    * @export
    * @enum {string}
    */
export enum Feature_TypeEnum {
    'Feature' = 'Feature'
}

/**
 * 
 * @export
 * @interface FeatureCollection
 */
export interface FeatureCollection {
    /**
     * 
     * @type {string}
     * @memberof FeatureCollection
     */
    type: FeatureCollection_TypeEnum;
    /**
     * 
     * @type {Array<Feature>}
     * @memberof FeatureCollection
     */
    features: Array<Feature>;
}

/**
    * @export
    * @enum {string}
    */
export enum FeatureCollection_TypeEnum {
    'FeatureCollection' = 'FeatureCollection'
}

/**
 * 
 * @export
 * @interface Fees
 */
export interface Fees {
    /**
     * 
     * @type {string}
     * @memberof Fees
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof Fees
     */
    provider_id: string;
    /**
     * 
     * @type {string}
     * @memberof Fees
     */
    provider_name: string;
    /**
     * 
     * @type {string}
     * @memberof Fees
     */
    policy_id: string;
    /**
     * 
     * @type {string}
     * @memberof Fees
     */
    policy_name: string;
    /**
     * 
     * @type {string}
     * @memberof Fees
     */
    policy_kind: Fees_PolicyKindEnum;
    /**
     * 
     * @type {string}
     * @memberof Fees
     */
    policy_start_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof Fees
     */
    policy_end_datetime?: string;
    /**
     * 
     * @type {number}
     * @memberof Fees
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof Fees
     */
    status: Fees_StatusEnum;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof Fees
     */
    prorations?: { [key: string]: number; };
}

/**
    * @export
    * @enum {string}
    */
export enum Fees_PolicyKindEnum {
    'permit' = 'permit',
    'trip_taxation' = 'trip_taxation',
    'vehicle_deployment' = 'vehicle_deployment'
}
/**
    * @export
    * @enum {string}
    */
export enum Fees_StatusEnum {
    'upcoming' = 'upcoming',
    'ongoing' = 'ongoing',
    'finished' = 'finished'
}

/**
 * 
 * @export
 * @interface FeesAggregations
 */
export interface FeesAggregations {
    /**
     * 
     * @type {number}
     * @memberof FeesAggregations
     */
    amount_min?: number;
    /**
     * 
     * @type {number}
     * @memberof FeesAggregations
     */
    amount_max?: number;
    /**
     * 
     * @type {number}
     * @memberof FeesAggregations
     */
    trip_datetime_min?: number;
    /**
     * 
     * @type {number}
     * @memberof FeesAggregations
     */
    trip_datetime_max?: number;
    /**
     * 
     * @type {number}
     * @memberof FeesAggregations
     */
    trip_distance_min?: number;
    /**
     * 
     * @type {number}
     * @memberof FeesAggregations
     */
    trip_distance_max?: number;
}
/**
 * 
 * @export
 * @interface FeesPolicyAmountsByProviderAggregations
 */
export interface FeesPolicyAmountsByProviderAggregations {
    /**
     * 
     * @type {string}
     * @memberof FeesPolicyAmountsByProviderAggregations
     */
    policy_id: string;
    /**
     * 
     * @type {string}
     * @memberof FeesPolicyAmountsByProviderAggregations
     */
    policy_kind: string;
    /**
     * 
     * @type {string}
     * @memberof FeesPolicyAmountsByProviderAggregations
     */
    policy_name: string;
    /**
     * 
     * @type {string}
     * @memberof FeesPolicyAmountsByProviderAggregations
     */
    policy_start_date: string;
    /**
     * 
     * @type {string}
     * @memberof FeesPolicyAmountsByProviderAggregations
     */
    policy_end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof FeesPolicyAmountsByProviderAggregations
     */
    policy_status: string;
    /**
     * 
     * @type {number}
     * @memberof FeesPolicyAmountsByProviderAggregations
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface Geometry
 */
export interface Geometry {
    /**
     * 
     * @type {string}
     * @memberof Geometry
     */
    type: string;
    /**
     * 
     * @type {Array<Array<Array<number>>>}
     * @memberof Geometry
     */
    coordinates: Array<Array<Array<number>>>;
}
/**
 * 
 * @export
 * @interface GraphBucket
 */
export interface GraphBucket {
    /**
     * 
     * @type {string}
     * @memberof GraphBucket
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof GraphBucket
     */
    doc_count: number;
    /**
     * 
     * @type {number}
     * @memberof GraphBucket
     */
    doc_count_without_percentage?: number;
}
/**
 * 
 * @export
 * @interface GraphBucketList
 */
export interface GraphBucketList {
    /**
     * 
     * @type {Array<GraphBucket>}
     * @memberof GraphBucketList
     */
    buckets: Array<GraphBucket>;
}
/**
 * 
 * @export
 * @interface GraphBucketResponse
 */
export interface GraphBucketResponse {
    /**
     * 
     * @type {string}
     * @memberof GraphBucketResponse
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof GraphBucketResponse
     */
    doc_count: number;
    /**
     * 
     * @type {GraphBucketList}
     * @memberof GraphBucketResponse
     */
    result?: GraphBucketList;
}
/**
 * 
 * @export
 * @interface GraphBucketWithTotalResponse
 */
export interface GraphBucketWithTotalResponse {
    /**
     * 
     * @type {number}
     * @memberof GraphBucketWithTotalResponse
     */
    total: number;
    /**
     * 
     * @type {Array<GraphBucketResponse>}
     * @memberof GraphBucketWithTotalResponse
     */
    data: Array<GraphBucketResponse>;
}
/**
 * 
 * @export
 * @interface GraphCompareResponse
 */
export interface GraphCompareResponse {
    /**
     * 
     * @type {string}
     * @memberof GraphCompareResponse
     */
    key: string;
    /**
     * 
     * @type {GraphBucketList}
     * @memberof GraphCompareResponse
     */
    compareBy: GraphBucketList;
    /**
     * 
     * @type {number}
     * @memberof GraphCompareResponse
     */
    average?: number;
    /**
     * 
     * @type {number}
     * @memberof GraphCompareResponse
     */
    doc_count?: number;
}
/**
 * 
 * @export
 * @interface GraphCompareWithTotalResponse
 */
export interface GraphCompareWithTotalResponse {
    /**
     * 
     * @type {number}
     * @memberof GraphCompareWithTotalResponse
     */
    total: number;
    /**
     * 
     * @type {Array<GraphCompareResponse>}
     * @memberof GraphCompareWithTotalResponse
     */
    data: Array<GraphCompareResponse>;
}
/**
 * 
 * @export
 * @interface GraphData
 */
export interface GraphData {
    /**
     * 
     * @type {Array<string>}
     * @memberof GraphData
     */
    labels: Array<string>;
    /**
     * 
     * @type {Array<GraphDataset>}
     * @memberof GraphData
     */
    datasets: Array<GraphDataset>;
}
/**
 * 
 * @export
 * @interface GraphDataset
 */
export interface GraphDataset {
    /**
     * 
     * @type {string}
     * @memberof GraphDataset
     */
    label: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GraphDataset
     */
    data: Array<number>;
}
/**
 * 
 * @export
 * @interface GraphFilters
 */
export interface GraphFilters {
    /**
     * 
     * @type {string}
     * @memberof GraphFilters
     */
    time_range_from?: string;
    /**
     * 
     * @type {string}
     * @memberof GraphFilters
     */
    time_range_to?: string;
    /**
     * 
     * @type {string}
     * @memberof GraphFilters
     */
    time_range_end_from?: string;
    /**
     * 
     * @type {string}
     * @memberof GraphFilters
     */
    time_range_end_to?: string;
    /**
     * 
     * @type {string}
     * @memberof GraphFilters
     */
    granularity: GraphFilters_GranularityEnum;
    /**
     * 
     * @type {string}
     * @memberof GraphFilters
     */
    layer?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GraphFilters
     */
    device_type?: Array<GraphFilters_DeviceTypeEnum>;
    /**
     * 
     * @type {number}
     * @memberof GraphFilters
     */
    duration_min?: number;
    /**
     * 
     * @type {number}
     * @memberof GraphFilters
     */
    duration_max?: number;
    /**
     * 
     * @type {number}
     * @memberof GraphFilters
     */
    distance_min?: number;
    /**
     * 
     * @type {number}
     * @memberof GraphFilters
     */
    distance_max?: number;
    /**
     * 
     * @type {number}
     * @memberof GraphFilters
     */
    speed_min?: number;
    /**
     * 
     * @type {number}
     * @memberof GraphFilters
     */
    speed_max?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GraphFilters
     */
    day_of_week?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GraphFilters
     */
    propulsion_type?: Array<GraphFilters_PropulsionTypeEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GraphFilters
     */
    vehicle_state?: Array<GraphFilters_VehicleStateEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GraphFilters
     */
    provider_ids?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GraphFilters
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof GraphFilters
     */
    zone?: GraphFilters_ZoneEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GraphFilters
     */
    trip_type?: Array<GraphFilters_TripTypeEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GraphFilters
     */
    close_means_of_transport?: Array<GraphFilters_CloseMeansOfTransportEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum GraphFilters_GranularityEnum {
    'quarter' = 'quarter',
    'month' = 'month',
    'week' = 'week',
    'day' = 'day',
    'hour' = 'hour'
}
/**
    * @export
    * @enum {string}
    */
export enum GraphFilters_DeviceTypeEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}
/**
    * @export
    * @enum {string}
    */
export enum GraphFilters_PropulsionTypeEnum {
    'human' = 'human',
    'electric_assist' = 'electric_assist',
    'electric' = 'electric',
    'combustion' = 'combustion',
    'missing' = 'missing'
}
/**
    * @export
    * @enum {string}
    */
export enum GraphFilters_VehicleStateEnum {
    'available' = 'available',
    'elsewhere' = 'elsewhere',
    'non_operational' = 'non_operational',
    'on_trip' = 'on_trip',
    'removed' = 'removed',
    'reserved' = 'reserved',
    'unknown' = 'unknown',
    'stopped' = 'stopped',
    'non_contactable' = 'non_contactable',
    'missing' = 'missing'
}
/**
    * @export
    * @enum {string}
    */
export enum GraphFilters_ZoneEnum {
    'origin' = 'origin',
    'destination' = 'destination'
}
/**
    * @export
    * @enum {string}
    */
export enum GraphFilters_TripTypeEnum {
    'delivery' = 'delivery',
    'return' = 'return',
    'advertising' = 'advertising',
    'mapping' = 'mapping',
    'roaming' = 'roaming',
    'rider' = 'rider',
    'rebalance' = 'rebalance',
    'maintenance' = 'maintenance',
    'private' = 'private',
    'shared' = 'shared',
    'empty' = 'empty',
    'reservation' = 'reservation',
    'unspecified' = 'unspecified'
}
/**
    * @export
    * @enum {string}
    */
export enum GraphFilters_CloseMeansOfTransportEnum {
    'bus' = 'bus',
    'train' = 'train',
    'tram' = 'tram',
    'subway' = 'subway',
    'bike' = 'bike',
    'ferry' = 'ferry'
}

/**
 * 
 * @export
 * @interface GraphFlowsResponse
 */
export interface GraphFlowsResponse {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: number; }; }}
     * @memberof GraphFlowsResponse
     */
    flows: { [key: string]: { [key: string]: number; }; };
}
/**
 * 
 * @export
 * @interface GraphReport
 */
export interface GraphReport {
    /**
     * 
     * @type {string}
     * @memberof GraphReport
     */
    type: GraphReport_TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GraphReport
     */
    section: string;
    /**
     * 
     * @type {string}
     * @memberof GraphReport
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof GraphReport
     */
    description?: string;
    /**
     * 
     * @type {GraphFilters}
     * @memberof GraphReport
     */
    filters: GraphFilters;
    /**
     * 
     * @type {any}
     * @memberof GraphReport
     */
    data: any;
}

/**
    * @export
    * @enum {string}
    */
export enum GraphReport_TypeEnum {
    'devices_deployed_per_provider' = 'devices_deployed_per_provider',
    'devices_per_status' = 'devices_per_status',
    'fleet_availability' = 'fleet_availability',
    'percent_devices_deployed_per_zone' = 'percent_devices_deployed_per_zone',
    'percent_devices_deployed_per_zone_per_provider' = 'percent_devices_deployed_per_zone_per_provider',
    'average_deployment_duration_per_zone' = 'average_deployment_duration_per_zone',
    'average_fleet_size_per_provider' = 'average_fleet_size_per_provider',
    'average_fleet_size_per_provider_on_range' = 'average_fleet_size_per_provider_on_range',
    'energy_consumption_per_provider' = 'energy_consumption_per_provider',
    'gaz_emission_per_provider' = 'gaz_emission_per_provider',
    'gaz_emission_compare_to_alternate_vehicle' = 'gaz_emission_compare_to_alternate_vehicle',
    'offenses_per_provider_per_date' = 'offenses_per_provider_per_date',
    'offense_price_per_provider_per_date' = 'offense_price_per_provider_per_date',
    'offenses_percentage_per_kind' = 'offenses_percentage_per_kind',
    'offenses_per_kind' = 'offenses_per_kind',
    'number_of_trips_per_provider' = 'number_of_trips_per_provider',
    'number_of_trips' = 'number_of_trips',
    'number_of_trips_per_zone' = 'number_of_trips_per_zone',
    'percentage_of_trips_per_provider' = 'percentage_of_trips_per_provider',
    'trips_flows' = 'trips_flows',
    'trips_total_distance' = 'trips_total_distance',
    'trips_total_distance_per_provider' = 'trips_total_distance_per_provider',
    'trips_by_distance_traveled' = 'trips_by_distance_traveled',
    'trips_by_distance_traveled_comparing' = 'trips_by_distance_traveled_comparing',
    'trips_by_duration' = 'trips_by_duration',
    'percentage_of_trips_close_to_stops' = 'percentage_of_trips_close_to_stops',
    'ratio_of_trip_per_device' = 'ratio_of_trip_per_device',
    'number_of_trip_per_device' = 'number_of_trip_per_device',
    'utilization_rate' = 'utilization_rate',
    'utilization_rate_per_provider' = 'utilization_rate_per_provider',
    'number_of_unique_users' = 'number_of_unique_users',
    'number_of_unique_users_per_provider' = 'number_of_unique_users_per_provider',
    'number_of_new_users' = 'number_of_new_users',
    'number_of_new_users_per_provider' = 'number_of_new_users_per_provider',
    'number_of_users_per_trip_performed' = 'number_of_users_per_trip_performed'
}

/**
 * 
 * @export
 * @interface GraphStackResponse
 */
export interface GraphStackResponse {
    /**
     * 
     * @type {string}
     * @memberof GraphStackResponse
     */
    key: string;
    /**
     * 
     * @type {GraphBucketList}
     * @memberof GraphStackResponse
     */
    stackedBy: GraphBucketList;
    /**
     * 
     * @type {number}
     * @memberof GraphStackResponse
     */
    doc_count?: number;
}
/**
 * 
 * @export
 * @interface GraphStackWithAverageResponse
 */
export interface GraphStackWithAverageResponse {
    /**
     * 
     * @type {number}
     * @memberof GraphStackWithAverageResponse
     */
    average: number;
    /**
     * 
     * @type {Array<GraphStackResponse>}
     * @memberof GraphStackWithAverageResponse
     */
    data: Array<GraphStackResponse>;
}
/**
 * 
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    jurisdiction: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    jurisdiction_key: string;
}
/**
 * 
 * @export
 * @interface HomepageVehicle
 */
export interface HomepageVehicle {
    /**
     * Vehicle type
     * @type {string}
     * @memberof HomepageVehicle
     */
    type: HomepageVehicle_TypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof HomepageVehicle
     */
    last_known_position?: Array<number>;
}

/**
    * @export
    * @enum {string}
    */
export enum HomepageVehicle_TypeEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}

/**
 * 
 * @export
 * @interface HomepageVehicleAggregation
 */
export interface HomepageVehicleAggregation {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof HomepageVehicleAggregation
     */
    categories: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface HomepageVehicleResponse
 */
export interface HomepageVehicleResponse {
    /**
     * 
     * @type {Array<HomepageVehicle>}
     * @memberof HomepageVehicleResponse
     */
    results: Array<HomepageVehicle>;
    /**
     * 
     * @type {HomepageVehicleAggregation}
     * @memberof HomepageVehicleResponse
     */
    aggregation: HomepageVehicleAggregation;
}
/**
 * 
 * @export
 * @interface Jurisdiction
 */
export interface Jurisdiction {
    /**
     * 
     * @type {string}
     * @memberof Jurisdiction
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Jurisdiction
     */
    logo: string;
    /**
     * 
     * @type {string}
     * @memberof Jurisdiction
     */
    agency_key: string;
    /**
     * 
     * @type {MapConfig}
     * @memberof Jurisdiction
     */
    map_config: MapConfig;
    /**
     * 
     * @type {string}
     * @memberof Jurisdiction
     */
    default_layer: string;
    /**
     * 
     * @type {string}
     * @memberof Jurisdiction
     */
    ycurb_url?: string;
    /**
     * 
     * @type {Array<AllowedViolationType>}
     * @memberof Jurisdiction
     */
    smart_patrol_violation_types: Array<AllowedViolationType>;
    /**
     * 
     * @type {string}
     * @memberof Jurisdiction
     */
    timezone: Jurisdiction_TimezoneEnum;
    /**
     * 
     * @type {string}
     * @memberof Jurisdiction
     */
    homepage_url?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum Jurisdiction_TimezoneEnum {
    'Africa/Abidjan' = 'Africa/Abidjan',
    'Africa/Accra' = 'Africa/Accra',
    'Africa/Addis_Ababa' = 'Africa/Addis_Ababa',
    'Africa/Algiers' = 'Africa/Algiers',
    'Africa/Asmara' = 'Africa/Asmara',
    'Africa/Asmera' = 'Africa/Asmera',
    'Africa/Bamako' = 'Africa/Bamako',
    'Africa/Bangui' = 'Africa/Bangui',
    'Africa/Banjul' = 'Africa/Banjul',
    'Africa/Bissau' = 'Africa/Bissau',
    'Africa/Blantyre' = 'Africa/Blantyre',
    'Africa/Brazzaville' = 'Africa/Brazzaville',
    'Africa/Bujumbura' = 'Africa/Bujumbura',
    'Africa/Cairo' = 'Africa/Cairo',
    'Africa/Casablanca' = 'Africa/Casablanca',
    'Africa/Ceuta' = 'Africa/Ceuta',
    'Africa/Conakry' = 'Africa/Conakry',
    'Africa/Dakar' = 'Africa/Dakar',
    'Africa/Dar_es_Salaam' = 'Africa/Dar_es_Salaam',
    'Africa/Djibouti' = 'Africa/Djibouti',
    'Africa/Douala' = 'Africa/Douala',
    'Africa/El_Aaiun' = 'Africa/El_Aaiun',
    'Africa/Freetown' = 'Africa/Freetown',
    'Africa/Gaborone' = 'Africa/Gaborone',
    'Africa/Harare' = 'Africa/Harare',
    'Africa/Johannesburg' = 'Africa/Johannesburg',
    'Africa/Juba' = 'Africa/Juba',
    'Africa/Kampala' = 'Africa/Kampala',
    'Africa/Khartoum' = 'Africa/Khartoum',
    'Africa/Kigali' = 'Africa/Kigali',
    'Africa/Kinshasa' = 'Africa/Kinshasa',
    'Africa/Lagos' = 'Africa/Lagos',
    'Africa/Libreville' = 'Africa/Libreville',
    'Africa/Lome' = 'Africa/Lome',
    'Africa/Luanda' = 'Africa/Luanda',
    'Africa/Lubumbashi' = 'Africa/Lubumbashi',
    'Africa/Lusaka' = 'Africa/Lusaka',
    'Africa/Malabo' = 'Africa/Malabo',
    'Africa/Maputo' = 'Africa/Maputo',
    'Africa/Maseru' = 'Africa/Maseru',
    'Africa/Mbabane' = 'Africa/Mbabane',
    'Africa/Mogadishu' = 'Africa/Mogadishu',
    'Africa/Monrovia' = 'Africa/Monrovia',
    'Africa/Nairobi' = 'Africa/Nairobi',
    'Africa/Ndjamena' = 'Africa/Ndjamena',
    'Africa/Niamey' = 'Africa/Niamey',
    'Africa/Nouakchott' = 'Africa/Nouakchott',
    'Africa/Ouagadougou' = 'Africa/Ouagadougou',
    'Africa/Porto-Novo' = 'Africa/Porto-Novo',
    'Africa/Sao_Tome' = 'Africa/Sao_Tome',
    'Africa/Timbuktu' = 'Africa/Timbuktu',
    'Africa/Tripoli' = 'Africa/Tripoli',
    'Africa/Tunis' = 'Africa/Tunis',
    'Africa/Windhoek' = 'Africa/Windhoek',
    'America/Adak' = 'America/Adak',
    'America/Anchorage' = 'America/Anchorage',
    'America/Anguilla' = 'America/Anguilla',
    'America/Antigua' = 'America/Antigua',
    'America/Araguaina' = 'America/Araguaina',
    'America/Argentina/Buenos_Aires' = 'America/Argentina/Buenos_Aires',
    'America/Argentina/Catamarca' = 'America/Argentina/Catamarca',
    'America/Argentina/ComodRivadavia' = 'America/Argentina/ComodRivadavia',
    'America/Argentina/Cordoba' = 'America/Argentina/Cordoba',
    'America/Argentina/Jujuy' = 'America/Argentina/Jujuy',
    'America/Argentina/La_Rioja' = 'America/Argentina/La_Rioja',
    'America/Argentina/Mendoza' = 'America/Argentina/Mendoza',
    'America/Argentina/Rio_Gallegos' = 'America/Argentina/Rio_Gallegos',
    'America/Argentina/Salta' = 'America/Argentina/Salta',
    'America/Argentina/San_Juan' = 'America/Argentina/San_Juan',
    'America/Argentina/San_Luis' = 'America/Argentina/San_Luis',
    'America/Argentina/Tucuman' = 'America/Argentina/Tucuman',
    'America/Argentina/Ushuaia' = 'America/Argentina/Ushuaia',
    'America/Aruba' = 'America/Aruba',
    'America/Asuncion' = 'America/Asuncion',
    'America/Atikokan' = 'America/Atikokan',
    'America/Atka' = 'America/Atka',
    'America/Bahia' = 'America/Bahia',
    'America/Bahia_Banderas' = 'America/Bahia_Banderas',
    'America/Barbados' = 'America/Barbados',
    'America/Belem' = 'America/Belem',
    'America/Belize' = 'America/Belize',
    'America/Blanc-Sablon' = 'America/Blanc-Sablon',
    'America/Boa_Vista' = 'America/Boa_Vista',
    'America/Bogota' = 'America/Bogota',
    'America/Boise' = 'America/Boise',
    'America/Buenos_Aires' = 'America/Buenos_Aires',
    'America/Cambridge_Bay' = 'America/Cambridge_Bay',
    'America/Campo_Grande' = 'America/Campo_Grande',
    'America/Cancun' = 'America/Cancun',
    'America/Caracas' = 'America/Caracas',
    'America/Catamarca' = 'America/Catamarca',
    'America/Cayenne' = 'America/Cayenne',
    'America/Cayman' = 'America/Cayman',
    'America/Chicago' = 'America/Chicago',
    'America/Chihuahua' = 'America/Chihuahua',
    'America/Ciudad_Juarez' = 'America/Ciudad_Juarez',
    'America/Coral_Harbour' = 'America/Coral_Harbour',
    'America/Cordoba' = 'America/Cordoba',
    'America/Costa_Rica' = 'America/Costa_Rica',
    'America/Coyhaique' = 'America/Coyhaique',
    'America/Creston' = 'America/Creston',
    'America/Cuiaba' = 'America/Cuiaba',
    'America/Curacao' = 'America/Curacao',
    'America/Danmarkshavn' = 'America/Danmarkshavn',
    'America/Dawson' = 'America/Dawson',
    'America/Dawson_Creek' = 'America/Dawson_Creek',
    'America/Denver' = 'America/Denver',
    'America/Detroit' = 'America/Detroit',
    'America/Dominica' = 'America/Dominica',
    'America/Edmonton' = 'America/Edmonton',
    'America/Eirunepe' = 'America/Eirunepe',
    'America/El_Salvador' = 'America/El_Salvador',
    'America/Ensenada' = 'America/Ensenada',
    'America/Fort_Nelson' = 'America/Fort_Nelson',
    'America/Fort_Wayne' = 'America/Fort_Wayne',
    'America/Fortaleza' = 'America/Fortaleza',
    'America/Glace_Bay' = 'America/Glace_Bay',
    'America/Godthab' = 'America/Godthab',
    'America/Goose_Bay' = 'America/Goose_Bay',
    'America/Grand_Turk' = 'America/Grand_Turk',
    'America/Grenada' = 'America/Grenada',
    'America/Guadeloupe' = 'America/Guadeloupe',
    'America/Guatemala' = 'America/Guatemala',
    'America/Guayaquil' = 'America/Guayaquil',
    'America/Guyana' = 'America/Guyana',
    'America/Halifax' = 'America/Halifax',
    'America/Havana' = 'America/Havana',
    'America/Hermosillo' = 'America/Hermosillo',
    'America/Indiana/Indianapolis' = 'America/Indiana/Indianapolis',
    'America/Indiana/Knox' = 'America/Indiana/Knox',
    'America/Indiana/Marengo' = 'America/Indiana/Marengo',
    'America/Indiana/Petersburg' = 'America/Indiana/Petersburg',
    'America/Indiana/Tell_City' = 'America/Indiana/Tell_City',
    'America/Indiana/Vevay' = 'America/Indiana/Vevay',
    'America/Indiana/Vincennes' = 'America/Indiana/Vincennes',
    'America/Indiana/Winamac' = 'America/Indiana/Winamac',
    'America/Indianapolis' = 'America/Indianapolis',
    'America/Inuvik' = 'America/Inuvik',
    'America/Iqaluit' = 'America/Iqaluit',
    'America/Jamaica' = 'America/Jamaica',
    'America/Jujuy' = 'America/Jujuy',
    'America/Juneau' = 'America/Juneau',
    'America/Kentucky/Louisville' = 'America/Kentucky/Louisville',
    'America/Kentucky/Monticello' = 'America/Kentucky/Monticello',
    'America/Knox_IN' = 'America/Knox_IN',
    'America/Kralendijk' = 'America/Kralendijk',
    'America/La_Paz' = 'America/La_Paz',
    'America/Lima' = 'America/Lima',
    'America/Los_Angeles' = 'America/Los_Angeles',
    'America/Louisville' = 'America/Louisville',
    'America/Lower_Princes' = 'America/Lower_Princes',
    'America/Maceio' = 'America/Maceio',
    'America/Managua' = 'America/Managua',
    'America/Manaus' = 'America/Manaus',
    'America/Marigot' = 'America/Marigot',
    'America/Martinique' = 'America/Martinique',
    'America/Matamoros' = 'America/Matamoros',
    'America/Mazatlan' = 'America/Mazatlan',
    'America/Mendoza' = 'America/Mendoza',
    'America/Menominee' = 'America/Menominee',
    'America/Merida' = 'America/Merida',
    'America/Metlakatla' = 'America/Metlakatla',
    'America/Mexico_City' = 'America/Mexico_City',
    'America/Miquelon' = 'America/Miquelon',
    'America/Moncton' = 'America/Moncton',
    'America/Monterrey' = 'America/Monterrey',
    'America/Montevideo' = 'America/Montevideo',
    'America/Montreal' = 'America/Montreal',
    'America/Montserrat' = 'America/Montserrat',
    'America/Nassau' = 'America/Nassau',
    'America/New_York' = 'America/New_York',
    'America/Nipigon' = 'America/Nipigon',
    'America/Nome' = 'America/Nome',
    'America/Noronha' = 'America/Noronha',
    'America/North_Dakota/Beulah' = 'America/North_Dakota/Beulah',
    'America/North_Dakota/Center' = 'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem' = 'America/North_Dakota/New_Salem',
    'America/Nuuk' = 'America/Nuuk',
    'America/Ojinaga' = 'America/Ojinaga',
    'America/Panama' = 'America/Panama',
    'America/Pangnirtung' = 'America/Pangnirtung',
    'America/Paramaribo' = 'America/Paramaribo',
    'America/Phoenix' = 'America/Phoenix',
    'America/Port-au-Prince' = 'America/Port-au-Prince',
    'America/Port_of_Spain' = 'America/Port_of_Spain',
    'America/Porto_Acre' = 'America/Porto_Acre',
    'America/Porto_Velho' = 'America/Porto_Velho',
    'America/Puerto_Rico' = 'America/Puerto_Rico',
    'America/Punta_Arenas' = 'America/Punta_Arenas',
    'America/Rainy_River' = 'America/Rainy_River',
    'America/Rankin_Inlet' = 'America/Rankin_Inlet',
    'America/Recife' = 'America/Recife',
    'America/Regina' = 'America/Regina',
    'America/Resolute' = 'America/Resolute',
    'America/Rio_Branco' = 'America/Rio_Branco',
    'America/Rosario' = 'America/Rosario',
    'America/Santa_Isabel' = 'America/Santa_Isabel',
    'America/Santarem' = 'America/Santarem',
    'America/Santiago' = 'America/Santiago',
    'America/Santo_Domingo' = 'America/Santo_Domingo',
    'America/Sao_Paulo' = 'America/Sao_Paulo',
    'America/Scoresbysund' = 'America/Scoresbysund',
    'America/Shiprock' = 'America/Shiprock',
    'America/Sitka' = 'America/Sitka',
    'America/St_Barthelemy' = 'America/St_Barthelemy',
    'America/St_Johns' = 'America/St_Johns',
    'America/St_Kitts' = 'America/St_Kitts',
    'America/St_Lucia' = 'America/St_Lucia',
    'America/St_Thomas' = 'America/St_Thomas',
    'America/St_Vincent' = 'America/St_Vincent',
    'America/Swift_Current' = 'America/Swift_Current',
    'America/Tegucigalpa' = 'America/Tegucigalpa',
    'America/Thule' = 'America/Thule',
    'America/Thunder_Bay' = 'America/Thunder_Bay',
    'America/Tijuana' = 'America/Tijuana',
    'America/Toronto' = 'America/Toronto',
    'America/Tortola' = 'America/Tortola',
    'America/Vancouver' = 'America/Vancouver',
    'America/Virgin' = 'America/Virgin',
    'America/Whitehorse' = 'America/Whitehorse',
    'America/Winnipeg' = 'America/Winnipeg',
    'America/Yakutat' = 'America/Yakutat',
    'America/Yellowknife' = 'America/Yellowknife',
    'Antarctica/Casey' = 'Antarctica/Casey',
    'Antarctica/Davis' = 'Antarctica/Davis',
    'Antarctica/DumontDUrville' = 'Antarctica/DumontDUrville',
    'Antarctica/Macquarie' = 'Antarctica/Macquarie',
    'Antarctica/Mawson' = 'Antarctica/Mawson',
    'Antarctica/McMurdo' = 'Antarctica/McMurdo',
    'Antarctica/Palmer' = 'Antarctica/Palmer',
    'Antarctica/Rothera' = 'Antarctica/Rothera',
    'Antarctica/South_Pole' = 'Antarctica/South_Pole',
    'Antarctica/Syowa' = 'Antarctica/Syowa',
    'Antarctica/Troll' = 'Antarctica/Troll',
    'Antarctica/Vostok' = 'Antarctica/Vostok',
    'Arctic/Longyearbyen' = 'Arctic/Longyearbyen',
    'Asia/Aden' = 'Asia/Aden',
    'Asia/Almaty' = 'Asia/Almaty',
    'Asia/Amman' = 'Asia/Amman',
    'Asia/Anadyr' = 'Asia/Anadyr',
    'Asia/Aqtau' = 'Asia/Aqtau',
    'Asia/Aqtobe' = 'Asia/Aqtobe',
    'Asia/Ashgabat' = 'Asia/Ashgabat',
    'Asia/Ashkhabad' = 'Asia/Ashkhabad',
    'Asia/Atyrau' = 'Asia/Atyrau',
    'Asia/Baghdad' = 'Asia/Baghdad',
    'Asia/Bahrain' = 'Asia/Bahrain',
    'Asia/Baku' = 'Asia/Baku',
    'Asia/Bangkok' = 'Asia/Bangkok',
    'Asia/Barnaul' = 'Asia/Barnaul',
    'Asia/Beirut' = 'Asia/Beirut',
    'Asia/Bishkek' = 'Asia/Bishkek',
    'Asia/Brunei' = 'Asia/Brunei',
    'Asia/Calcutta' = 'Asia/Calcutta',
    'Asia/Chita' = 'Asia/Chita',
    'Asia/Choibalsan' = 'Asia/Choibalsan',
    'Asia/Chongqing' = 'Asia/Chongqing',
    'Asia/Chungking' = 'Asia/Chungking',
    'Asia/Colombo' = 'Asia/Colombo',
    'Asia/Dacca' = 'Asia/Dacca',
    'Asia/Damascus' = 'Asia/Damascus',
    'Asia/Dhaka' = 'Asia/Dhaka',
    'Asia/Dili' = 'Asia/Dili',
    'Asia/Dubai' = 'Asia/Dubai',
    'Asia/Dushanbe' = 'Asia/Dushanbe',
    'Asia/Famagusta' = 'Asia/Famagusta',
    'Asia/Gaza' = 'Asia/Gaza',
    'Asia/Harbin' = 'Asia/Harbin',
    'Asia/Hebron' = 'Asia/Hebron',
    'Asia/Ho_Chi_Minh' = 'Asia/Ho_Chi_Minh',
    'Asia/Hong_Kong' = 'Asia/Hong_Kong',
    'Asia/Hovd' = 'Asia/Hovd',
    'Asia/Irkutsk' = 'Asia/Irkutsk',
    'Asia/Istanbul' = 'Asia/Istanbul',
    'Asia/Jakarta' = 'Asia/Jakarta',
    'Asia/Jayapura' = 'Asia/Jayapura',
    'Asia/Jerusalem' = 'Asia/Jerusalem',
    'Asia/Kabul' = 'Asia/Kabul',
    'Asia/Kamchatka' = 'Asia/Kamchatka',
    'Asia/Karachi' = 'Asia/Karachi',
    'Asia/Kashgar' = 'Asia/Kashgar',
    'Asia/Kathmandu' = 'Asia/Kathmandu',
    'Asia/Katmandu' = 'Asia/Katmandu',
    'Asia/Khandyga' = 'Asia/Khandyga',
    'Asia/Kolkata' = 'Asia/Kolkata',
    'Asia/Krasnoyarsk' = 'Asia/Krasnoyarsk',
    'Asia/Kuala_Lumpur' = 'Asia/Kuala_Lumpur',
    'Asia/Kuching' = 'Asia/Kuching',
    'Asia/Kuwait' = 'Asia/Kuwait',
    'Asia/Macao' = 'Asia/Macao',
    'Asia/Macau' = 'Asia/Macau',
    'Asia/Magadan' = 'Asia/Magadan',
    'Asia/Makassar' = 'Asia/Makassar',
    'Asia/Manila' = 'Asia/Manila',
    'Asia/Muscat' = 'Asia/Muscat',
    'Asia/Nicosia' = 'Asia/Nicosia',
    'Asia/Novokuznetsk' = 'Asia/Novokuznetsk',
    'Asia/Novosibirsk' = 'Asia/Novosibirsk',
    'Asia/Omsk' = 'Asia/Omsk',
    'Asia/Oral' = 'Asia/Oral',
    'Asia/Phnom_Penh' = 'Asia/Phnom_Penh',
    'Asia/Pontianak' = 'Asia/Pontianak',
    'Asia/Pyongyang' = 'Asia/Pyongyang',
    'Asia/Qatar' = 'Asia/Qatar',
    'Asia/Qostanay' = 'Asia/Qostanay',
    'Asia/Qyzylorda' = 'Asia/Qyzylorda',
    'Asia/Rangoon' = 'Asia/Rangoon',
    'Asia/Riyadh' = 'Asia/Riyadh',
    'Asia/Saigon' = 'Asia/Saigon',
    'Asia/Sakhalin' = 'Asia/Sakhalin',
    'Asia/Samarkand' = 'Asia/Samarkand',
    'Asia/Seoul' = 'Asia/Seoul',
    'Asia/Shanghai' = 'Asia/Shanghai',
    'Asia/Singapore' = 'Asia/Singapore',
    'Asia/Srednekolymsk' = 'Asia/Srednekolymsk',
    'Asia/Taipei' = 'Asia/Taipei',
    'Asia/Tashkent' = 'Asia/Tashkent',
    'Asia/Tbilisi' = 'Asia/Tbilisi',
    'Asia/Tehran' = 'Asia/Tehran',
    'Asia/Tel_Aviv' = 'Asia/Tel_Aviv',
    'Asia/Thimbu' = 'Asia/Thimbu',
    'Asia/Thimphu' = 'Asia/Thimphu',
    'Asia/Tokyo' = 'Asia/Tokyo',
    'Asia/Tomsk' = 'Asia/Tomsk',
    'Asia/Ujung_Pandang' = 'Asia/Ujung_Pandang',
    'Asia/Ulaanbaatar' = 'Asia/Ulaanbaatar',
    'Asia/Ulan_Bator' = 'Asia/Ulan_Bator',
    'Asia/Urumqi' = 'Asia/Urumqi',
    'Asia/Ust-Nera' = 'Asia/Ust-Nera',
    'Asia/Vientiane' = 'Asia/Vientiane',
    'Asia/Vladivostok' = 'Asia/Vladivostok',
    'Asia/Yakutsk' = 'Asia/Yakutsk',
    'Asia/Yangon' = 'Asia/Yangon',
    'Asia/Yekaterinburg' = 'Asia/Yekaterinburg',
    'Asia/Yerevan' = 'Asia/Yerevan',
    'Atlantic/Azores' = 'Atlantic/Azores',
    'Atlantic/Bermuda' = 'Atlantic/Bermuda',
    'Atlantic/Canary' = 'Atlantic/Canary',
    'Atlantic/Cape_Verde' = 'Atlantic/Cape_Verde',
    'Atlantic/Faeroe' = 'Atlantic/Faeroe',
    'Atlantic/Faroe' = 'Atlantic/Faroe',
    'Atlantic/Jan_Mayen' = 'Atlantic/Jan_Mayen',
    'Atlantic/Madeira' = 'Atlantic/Madeira',
    'Atlantic/Reykjavik' = 'Atlantic/Reykjavik',
    'Atlantic/South_Georgia' = 'Atlantic/South_Georgia',
    'Atlantic/St_Helena' = 'Atlantic/St_Helena',
    'Atlantic/Stanley' = 'Atlantic/Stanley',
    'Australia/ACT' = 'Australia/ACT',
    'Australia/Adelaide' = 'Australia/Adelaide',
    'Australia/Brisbane' = 'Australia/Brisbane',
    'Australia/Broken_Hill' = 'Australia/Broken_Hill',
    'Australia/Canberra' = 'Australia/Canberra',
    'Australia/Currie' = 'Australia/Currie',
    'Australia/Darwin' = 'Australia/Darwin',
    'Australia/Eucla' = 'Australia/Eucla',
    'Australia/Hobart' = 'Australia/Hobart',
    'Australia/LHI' = 'Australia/LHI',
    'Australia/Lindeman' = 'Australia/Lindeman',
    'Australia/Lord_Howe' = 'Australia/Lord_Howe',
    'Australia/Melbourne' = 'Australia/Melbourne',
    'Australia/NSW' = 'Australia/NSW',
    'Australia/North' = 'Australia/North',
    'Australia/Perth' = 'Australia/Perth',
    'Australia/Queensland' = 'Australia/Queensland',
    'Australia/South' = 'Australia/South',
    'Australia/Sydney' = 'Australia/Sydney',
    'Australia/Tasmania' = 'Australia/Tasmania',
    'Australia/Victoria' = 'Australia/Victoria',
    'Australia/West' = 'Australia/West',
    'Australia/Yancowinna' = 'Australia/Yancowinna',
    'Brazil/Acre' = 'Brazil/Acre',
    'Brazil/DeNoronha' = 'Brazil/DeNoronha',
    'Brazil/East' = 'Brazil/East',
    'Brazil/West' = 'Brazil/West',
    'CET' = 'CET',
    'CST6CDT' = 'CST6CDT',
    'Canada/Atlantic' = 'Canada/Atlantic',
    'Canada/Central' = 'Canada/Central',
    'Canada/Eastern' = 'Canada/Eastern',
    'Canada/Mountain' = 'Canada/Mountain',
    'Canada/Newfoundland' = 'Canada/Newfoundland',
    'Canada/Pacific' = 'Canada/Pacific',
    'Canada/Saskatchewan' = 'Canada/Saskatchewan',
    'Canada/Yukon' = 'Canada/Yukon',
    'Chile/Continental' = 'Chile/Continental',
    'Chile/EasterIsland' = 'Chile/EasterIsland',
    'Cuba' = 'Cuba',
    'EET' = 'EET',
    'EST' = 'EST',
    'EST5EDT' = 'EST5EDT',
    'Egypt' = 'Egypt',
    'Eire' = 'Eire',
    'Etc/GMT' = 'Etc/GMT',
    'Etc/GMT+0' = 'Etc/GMT+0',
    'Etc/GMT+1' = 'Etc/GMT+1',
    'Etc/GMT+10' = 'Etc/GMT+10',
    'Etc/GMT+11' = 'Etc/GMT+11',
    'Etc/GMT+12' = 'Etc/GMT+12',
    'Etc/GMT+2' = 'Etc/GMT+2',
    'Etc/GMT+3' = 'Etc/GMT+3',
    'Etc/GMT+4' = 'Etc/GMT+4',
    'Etc/GMT+5' = 'Etc/GMT+5',
    'Etc/GMT+6' = 'Etc/GMT+6',
    'Etc/GMT+7' = 'Etc/GMT+7',
    'Etc/GMT+8' = 'Etc/GMT+8',
    'Etc/GMT+9' = 'Etc/GMT+9',
    'Etc/GMT-0' = 'Etc/GMT-0',
    'Etc/GMT-1' = 'Etc/GMT-1',
    'Etc/GMT-10' = 'Etc/GMT-10',
    'Etc/GMT-11' = 'Etc/GMT-11',
    'Etc/GMT-12' = 'Etc/GMT-12',
    'Etc/GMT-13' = 'Etc/GMT-13',
    'Etc/GMT-14' = 'Etc/GMT-14',
    'Etc/GMT-2' = 'Etc/GMT-2',
    'Etc/GMT-3' = 'Etc/GMT-3',
    'Etc/GMT-4' = 'Etc/GMT-4',
    'Etc/GMT-5' = 'Etc/GMT-5',
    'Etc/GMT-6' = 'Etc/GMT-6',
    'Etc/GMT-7' = 'Etc/GMT-7',
    'Etc/GMT-8' = 'Etc/GMT-8',
    'Etc/GMT-9' = 'Etc/GMT-9',
    'Etc/GMT0' = 'Etc/GMT0',
    'Etc/Greenwich' = 'Etc/Greenwich',
    'Etc/UCT' = 'Etc/UCT',
    'Etc/UTC' = 'Etc/UTC',
    'Etc/Universal' = 'Etc/Universal',
    'Etc/Zulu' = 'Etc/Zulu',
    'Europe/Amsterdam' = 'Europe/Amsterdam',
    'Europe/Andorra' = 'Europe/Andorra',
    'Europe/Astrakhan' = 'Europe/Astrakhan',
    'Europe/Athens' = 'Europe/Athens',
    'Europe/Belfast' = 'Europe/Belfast',
    'Europe/Belgrade' = 'Europe/Belgrade',
    'Europe/Berlin' = 'Europe/Berlin',
    'Europe/Bratislava' = 'Europe/Bratislava',
    'Europe/Brussels' = 'Europe/Brussels',
    'Europe/Bucharest' = 'Europe/Bucharest',
    'Europe/Budapest' = 'Europe/Budapest',
    'Europe/Busingen' = 'Europe/Busingen',
    'Europe/Chisinau' = 'Europe/Chisinau',
    'Europe/Copenhagen' = 'Europe/Copenhagen',
    'Europe/Dublin' = 'Europe/Dublin',
    'Europe/Gibraltar' = 'Europe/Gibraltar',
    'Europe/Guernsey' = 'Europe/Guernsey',
    'Europe/Helsinki' = 'Europe/Helsinki',
    'Europe/Isle_of_Man' = 'Europe/Isle_of_Man',
    'Europe/Istanbul' = 'Europe/Istanbul',
    'Europe/Jersey' = 'Europe/Jersey',
    'Europe/Kaliningrad' = 'Europe/Kaliningrad',
    'Europe/Kiev' = 'Europe/Kiev',
    'Europe/Kirov' = 'Europe/Kirov',
    'Europe/Kyiv' = 'Europe/Kyiv',
    'Europe/Lisbon' = 'Europe/Lisbon',
    'Europe/Ljubljana' = 'Europe/Ljubljana',
    'Europe/London' = 'Europe/London',
    'Europe/Luxembourg' = 'Europe/Luxembourg',
    'Europe/Madrid' = 'Europe/Madrid',
    'Europe/Malta' = 'Europe/Malta',
    'Europe/Mariehamn' = 'Europe/Mariehamn',
    'Europe/Minsk' = 'Europe/Minsk',
    'Europe/Monaco' = 'Europe/Monaco',
    'Europe/Moscow' = 'Europe/Moscow',
    'Europe/Nicosia' = 'Europe/Nicosia',
    'Europe/Oslo' = 'Europe/Oslo',
    'Europe/Paris' = 'Europe/Paris',
    'Europe/Podgorica' = 'Europe/Podgorica',
    'Europe/Prague' = 'Europe/Prague',
    'Europe/Riga' = 'Europe/Riga',
    'Europe/Rome' = 'Europe/Rome',
    'Europe/Samara' = 'Europe/Samara',
    'Europe/San_Marino' = 'Europe/San_Marino',
    'Europe/Sarajevo' = 'Europe/Sarajevo',
    'Europe/Saratov' = 'Europe/Saratov',
    'Europe/Simferopol' = 'Europe/Simferopol',
    'Europe/Skopje' = 'Europe/Skopje',
    'Europe/Sofia' = 'Europe/Sofia',
    'Europe/Stockholm' = 'Europe/Stockholm',
    'Europe/Tallinn' = 'Europe/Tallinn',
    'Europe/Tirane' = 'Europe/Tirane',
    'Europe/Tiraspol' = 'Europe/Tiraspol',
    'Europe/Ulyanovsk' = 'Europe/Ulyanovsk',
    'Europe/Uzhgorod' = 'Europe/Uzhgorod',
    'Europe/Vaduz' = 'Europe/Vaduz',
    'Europe/Vatican' = 'Europe/Vatican',
    'Europe/Vienna' = 'Europe/Vienna',
    'Europe/Vilnius' = 'Europe/Vilnius',
    'Europe/Volgograd' = 'Europe/Volgograd',
    'Europe/Warsaw' = 'Europe/Warsaw',
    'Europe/Zagreb' = 'Europe/Zagreb',
    'Europe/Zaporozhye' = 'Europe/Zaporozhye',
    'Europe/Zurich' = 'Europe/Zurich',
    'GB' = 'GB',
    'GB-Eire' = 'GB-Eire',
    'GMT' = 'GMT',
    'GMT+0' = 'GMT+0',
    'GMT-0' = 'GMT-0',
    'GMT0' = 'GMT0',
    'Greenwich' = 'Greenwich',
    'HST' = 'HST',
    'Hongkong' = 'Hongkong',
    'Iceland' = 'Iceland',
    'Indian/Antananarivo' = 'Indian/Antananarivo',
    'Indian/Chagos' = 'Indian/Chagos',
    'Indian/Christmas' = 'Indian/Christmas',
    'Indian/Cocos' = 'Indian/Cocos',
    'Indian/Comoro' = 'Indian/Comoro',
    'Indian/Kerguelen' = 'Indian/Kerguelen',
    'Indian/Mahe' = 'Indian/Mahe',
    'Indian/Maldives' = 'Indian/Maldives',
    'Indian/Mauritius' = 'Indian/Mauritius',
    'Indian/Mayotte' = 'Indian/Mayotte',
    'Indian/Reunion' = 'Indian/Reunion',
    'Iran' = 'Iran',
    'Israel' = 'Israel',
    'Jamaica' = 'Jamaica',
    'Japan' = 'Japan',
    'Kwajalein' = 'Kwajalein',
    'Libya' = 'Libya',
    'MET' = 'MET',
    'MST' = 'MST',
    'MST7MDT' = 'MST7MDT',
    'Mexico/BajaNorte' = 'Mexico/BajaNorte',
    'Mexico/BajaSur' = 'Mexico/BajaSur',
    'Mexico/General' = 'Mexico/General',
    'NZ' = 'NZ',
    'NZ-CHAT' = 'NZ-CHAT',
    'Navajo' = 'Navajo',
    'PRC' = 'PRC',
    'PST8PDT' = 'PST8PDT',
    'Pacific/Apia' = 'Pacific/Apia',
    'Pacific/Auckland' = 'Pacific/Auckland',
    'Pacific/Bougainville' = 'Pacific/Bougainville',
    'Pacific/Chatham' = 'Pacific/Chatham',
    'Pacific/Chuuk' = 'Pacific/Chuuk',
    'Pacific/Easter' = 'Pacific/Easter',
    'Pacific/Efate' = 'Pacific/Efate',
    'Pacific/Enderbury' = 'Pacific/Enderbury',
    'Pacific/Fakaofo' = 'Pacific/Fakaofo',
    'Pacific/Fiji' = 'Pacific/Fiji',
    'Pacific/Funafuti' = 'Pacific/Funafuti',
    'Pacific/Galapagos' = 'Pacific/Galapagos',
    'Pacific/Gambier' = 'Pacific/Gambier',
    'Pacific/Guadalcanal' = 'Pacific/Guadalcanal',
    'Pacific/Guam' = 'Pacific/Guam',
    'Pacific/Honolulu' = 'Pacific/Honolulu',
    'Pacific/Johnston' = 'Pacific/Johnston',
    'Pacific/Kanton' = 'Pacific/Kanton',
    'Pacific/Kiritimati' = 'Pacific/Kiritimati',
    'Pacific/Kosrae' = 'Pacific/Kosrae',
    'Pacific/Kwajalein' = 'Pacific/Kwajalein',
    'Pacific/Majuro' = 'Pacific/Majuro',
    'Pacific/Marquesas' = 'Pacific/Marquesas',
    'Pacific/Midway' = 'Pacific/Midway',
    'Pacific/Nauru' = 'Pacific/Nauru',
    'Pacific/Niue' = 'Pacific/Niue',
    'Pacific/Norfolk' = 'Pacific/Norfolk',
    'Pacific/Noumea' = 'Pacific/Noumea',
    'Pacific/Pago_Pago' = 'Pacific/Pago_Pago',
    'Pacific/Palau' = 'Pacific/Palau',
    'Pacific/Pitcairn' = 'Pacific/Pitcairn',
    'Pacific/Pohnpei' = 'Pacific/Pohnpei',
    'Pacific/Ponape' = 'Pacific/Ponape',
    'Pacific/Port_Moresby' = 'Pacific/Port_Moresby',
    'Pacific/Rarotonga' = 'Pacific/Rarotonga',
    'Pacific/Saipan' = 'Pacific/Saipan',
    'Pacific/Samoa' = 'Pacific/Samoa',
    'Pacific/Tahiti' = 'Pacific/Tahiti',
    'Pacific/Tarawa' = 'Pacific/Tarawa',
    'Pacific/Tongatapu' = 'Pacific/Tongatapu',
    'Pacific/Truk' = 'Pacific/Truk',
    'Pacific/Wake' = 'Pacific/Wake',
    'Pacific/Wallis' = 'Pacific/Wallis',
    'Pacific/Yap' = 'Pacific/Yap',
    'Poland' = 'Poland',
    'Portugal' = 'Portugal',
    'ROC' = 'ROC',
    'ROK' = 'ROK',
    'Singapore' = 'Singapore',
    'Turkey' = 'Turkey',
    'UCT' = 'UCT',
    'US/Alaska' = 'US/Alaska',
    'US/Aleutian' = 'US/Aleutian',
    'US/Arizona' = 'US/Arizona',
    'US/Central' = 'US/Central',
    'US/East-Indiana' = 'US/East-Indiana',
    'US/Eastern' = 'US/Eastern',
    'US/Hawaii' = 'US/Hawaii',
    'US/Indiana-Starke' = 'US/Indiana-Starke',
    'US/Michigan' = 'US/Michigan',
    'US/Mountain' = 'US/Mountain',
    'US/Pacific' = 'US/Pacific',
    'US/Samoa' = 'US/Samoa',
    'UTC' = 'UTC',
    'Universal' = 'Universal',
    'W-SU' = 'W-SU',
    'WET' = 'WET',
    'Zulu' = 'Zulu'
}

/**
 * 
 * @export
 * @interface KPIGeometry
 */
export interface KPIGeometry {
    /**
     * Identifier for the layer
     * @type {string}
     * @memberof KPIGeometry
     */
    id: string;
    /**
     * Name of the layer
     * @type {string}
     * @memberof KPIGeometry
     */
    name: string;
    /**
     * Whether the geometry is a permit layer of the jurisdiction
     * @type {boolean}
     * @memberof KPIGeometry
     */
    is_default: boolean;
    /**
     * 
     * @type {KPIPolygon}
     * @memberof KPIGeometry
     */
    geom: KPIPolygon;
}
/**
 * FeatureCollection representation of the layer
 * @export
 * @interface KPIPolygon
 */
export interface KPIPolygon {
}
/**
 * 
 * @export
 * @interface LightArea
 */
export interface LightArea {
    /**
     * 
     * @type {string}
     * @memberof LightArea
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LightArea
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof LightArea
     */
    color: string;
    /**
     * 
     * @type {number}
     * @memberof LightArea
     */
    polygons_count: number;
    /**
     * 
     * @type {string}
     * @memberof LightArea
     */
    correlation_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LightArea
     */
    tags?: Array<string>;
}
/**
 * 
 * @export
 * @interface LightOffense
 */
export interface LightOffense {
    /**
     * 
     * @type {string}
     * @memberof LightOffense
     */
    pk: string;
    /**
     * 
     * @type {string}
     * @memberof LightOffense
     */
    provider_id: string;
    /**
     * 
     * @type {string}
     * @memberof LightOffense
     */
    policy_type: LightOffense_PolicyTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof LightOffense
     */
    gps_point: Array<number>;
}

/**
    * @export
    * @enum {string}
    */
export enum LightOffense_PolicyTypeEnum {
    'speed' = 'speed',
    'geofence' = 'geofence',
    'absolute_fleet_size' = 'absolute_fleet_size',
    'fleet_budget' = 'fleet_budget',
    'permit' = 'permit',
    'parking' = 'parking',
    'trip_taxation' = 'trip_taxation',
    'beginner_speed_limit' = 'beginner_speed_limit',
    'beginner_allowed_hours' = 'beginner_allowed_hours',
    'vehicle_deployment' = 'vehicle_deployment',
    'maintenance' = 'maintenance',
    'dwell_time' = 'dwell_time',
    'abandoned' = 'abandoned',
    'balancing' = 'balancing',
    'sidewalk' = 'sidewalk',
    'time' = 'time',
    'user' = 'user'
}

/**
 * 
 * @export
 * @interface LightPolicy
 */
export interface LightPolicy {
    /**
     * 
     * @type {string}
     * @memberof LightPolicy
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LightPolicy
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LightPolicy
     */
    kind: LightPolicy_KindEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof LightPolicy
     */
    providers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LightPolicy
     */
    start_date: string;
    /**
     * 
     * @type {string}
     * @memberof LightPolicy
     */
    end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof LightPolicy
     */
    published_date?: string;
    /**
     * 
     * @type {string}
     * @memberof LightPolicy
     */
    due_date?: string;
    /**
     * 
     * @type {number}
     * @memberof LightPolicy
     */
    total_price?: number;
    /**
     * 
     * @type {string}
     * @memberof LightPolicy
     */
    status: LightPolicy_StatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LightPolicy_KindEnum {
    'speed' = 'speed',
    'geofence' = 'geofence',
    'absolute_fleet_size' = 'absolute_fleet_size',
    'fleet_budget' = 'fleet_budget',
    'permit' = 'permit',
    'parking' = 'parking',
    'trip_taxation' = 'trip_taxation',
    'beginner_speed_limit' = 'beginner_speed_limit',
    'beginner_allowed_hours' = 'beginner_allowed_hours',
    'vehicle_deployment' = 'vehicle_deployment',
    'maintenance' = 'maintenance',
    'dwell_time' = 'dwell_time',
    'abandoned' = 'abandoned',
    'balancing' = 'balancing',
    'sidewalk' = 'sidewalk',
    'time' = 'time',
    'user' = 'user'
}
/**
    * @export
    * @enum {string}
    */
export enum LightPolicy_StatusEnum {
    'draft' = 'draft',
    'upcoming' = 'upcoming',
    'ongoing' = 'ongoing',
    'finished' = 'finished',
    'cancelled' = 'cancelled'
}

/**
 * 
 * @export
 * @interface LightPolicyResponse
 */
export interface LightPolicyResponse {
    /**
     * 
     * @type {Array<LightPolicy>}
     * @memberof LightPolicyResponse
     */
    results: Array<LightPolicy>;
    /**
     * 
     * @type {PolicyAggregation}
     * @memberof LightPolicyResponse
     */
    aggregation: PolicyAggregation;
}
/**
 * 
 * @export
 * @interface LightPolygon
 */
export interface LightPolygon {
    /**
     * 
     * @type {string}
     * @memberof LightPolygon
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LightPolygon
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof LightPolygon
     */
    areas_count: number;
}
/**
 * 
 * @export
 * @interface ListReport
 */
export interface ListReport {
    /**
     * 
     * @type {number}
     * @memberof ListReport
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ListReport
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListReport
     */
    kind: string;
    /**
     * 
     * @type {string}
     * @memberof ListReport
     */
    start_at: string;
    /**
     * 
     * @type {string}
     * @memberof ListReport
     */
    end_at: string;
    /**
     * 
     * @type {string}
     * @memberof ListReport
     */
    area_id: string;
    /**
     * 
     * @type {number}
     * @memberof ListReport
     */
    progress: number;
    /**
     * 
     * @type {boolean}
     * @memberof ListReport
     */
    result_available?: boolean;
    /**
     * 
     * @type {UserName}
     * @memberof ListReport
     */
    created_by: UserName;
}
/**
 * 
 * @export
 * @interface MapConfig
 */
export interface MapConfig {
    /**
     * 
     * @type {number}
     * @memberof MapConfig
     */
    zoom: number;
    /**
     * 
     * @type {MapCoordinate}
     * @memberof MapConfig
     */
    center: MapCoordinate;
}
/**
 * 
 * @export
 * @interface MapCoordinate
 */
export interface MapCoordinate {
    /**
     * 
     * @type {number}
     * @memberof MapCoordinate
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof MapCoordinate
     */
    latitude: number;
}
/**
 * 
 * @export
 * @interface MdsApiCredentials
 */
export interface MdsApiCredentials {
    /**
     * 
     * @type {number}
     * @memberof MdsApiCredentials
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MdsApiCredentials
     */
    base_api_url?: string;
    /**
     * 
     * @type {ProviderApiAuthentication}
     * @memberof MdsApiCredentials
     */
    api_authentication?: ProviderApiAuthentication;
    /**
     * 
     * @type {ProviderApiConfiguration}
     * @memberof MdsApiCredentials
     */
    api_configuration?: ProviderApiConfiguration;
    /**
     * 
     * @type {AgencyApiAuthentication}
     * @memberof MdsApiCredentials
     */
    agency_api_authentication?: AgencyApiAuthentication;
    /**
     * 
     * @type {AgencyApiConfiguration}
     * @memberof MdsApiCredentials
     */
    agency_api_configuration?: AgencyApiConfiguration;
}
/**
 * 
 * @export
 * @interface MergeAreasRequest
 */
export interface MergeAreasRequest {
    /**
     * Name of the merged Area
     * @type {string}
     * @memberof MergeAreasRequest
     */
    label: string;
    /**
     * Color of the merged Area
     * @type {string}
     * @memberof MergeAreasRequest
     */
    color: string;
    /**
     * Ids of the Areas to merge
     * @type {Array<string>}
     * @memberof MergeAreasRequest
     */
    areas: Array<string>;
    /**
     * Tags of the merged Area. Unknown ones are created
     * @type {Array<string>}
     * @memberof MergeAreasRequest
     */
    tags?: Array<string>;
}
/**
 * 
 * @export
 * @interface Offense
 */
export interface Offense {
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    id: string;
    /**
     * The amount of the offense.
     * @type {number}
     * @memberof Offense
     */
    price?: number;
    /**
     * Official start of the Offense according to the MDS specifications. See functional_specs documents for more details.
     * @type {string}
     * @memberof Offense
     */
    official_start_date?: string;
    /**
     * Official end of the Offense according to the MDS Specifications.  See functional_specs documents for more details.
     * @type {string}
     * @memberof Offense
     */
    official_end_date?: string;
    /**
     * Vehicle ID
     * @type {string}
     * @memberof Offense
     */
    device_id?: string;
    /**
     * Vehicle Identification Number
     * @type {string}
     * @memberof Offense
     */
    vin?: string;
    /**
     * Vehicle type
     * @type {string}
     * @memberof Offense
     */
    device_type?: Offense_DeviceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    provider_id: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    provider_name: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    policy_id: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    policy_name: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    policy_type: Offense_PolicyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    jurisdiction_key: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    jurisdiction_name: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    trip_id?: string;
    /**
     * 
     * @type {number}
     * @memberof Offense
     */
    speed?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Offense
     */
    gps_point: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    reason?: Offense_ReasonEnum;
    /**
     * 
     * @type {number}
     * @memberof Offense
     */
    fleet_proof_id?: number;
    /**
     * 
     * @type {VehicleEventType}
     * @memberof Offense
     */
    event?: VehicleEventType;
    /**
     * 
     * @type {number}
     * @memberof Offense
     */
    lapse?: number;
    /**
     * 
     * @type {number}
     * @memberof Offense
     */
    maintenance_duration?: number;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    maintenance_start_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    status?: Offense_StatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Offense
     */
    images?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    image_download_url?: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    agent_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    reporting_date_time?: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    fleet_size?: string;
    /**
     * 
     * @type {string}
     * @memberof Offense
     */
    fleet_size_time?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum Offense_DeviceTypeEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}
/**
    * @export
    * @enum {string}
    */
export enum Offense_PolicyTypeEnum {
    'speed' = 'speed',
    'geofence' = 'geofence',
    'absolute_fleet_size' = 'absolute_fleet_size',
    'fleet_budget' = 'fleet_budget',
    'permit' = 'permit',
    'parking' = 'parking',
    'trip_taxation' = 'trip_taxation',
    'beginner_speed_limit' = 'beginner_speed_limit',
    'beginner_allowed_hours' = 'beginner_allowed_hours',
    'vehicle_deployment' = 'vehicle_deployment',
    'maintenance' = 'maintenance',
    'dwell_time' = 'dwell_time',
    'abandoned' = 'abandoned',
    'balancing' = 'balancing',
    'sidewalk' = 'sidewalk',
    'time' = 'time',
    'user' = 'user'
}
/**
    * @export
    * @enum {string}
    */
export enum Offense_ReasonEnum {
    'under_minimum' = 'under_minimum',
    'over_maximum' = 'over_maximum'
}
/**
    * @export
    * @enum {string}
    */
export enum Offense_StatusEnum {
    'auto_confirmed' = 'auto_confirmed',
    'confirmed_by_agent' = 'confirmed_by_agent',
    'agent_to_check' = 'agent_to_check',
    'invalidated' = 'invalidated'
}

/**
 * 
 * @export
 * @interface OffenseListResponse
 */
export interface OffenseListResponse {
    /**
     * 
     * @type {Array<Offense>}
     * @memberof OffenseListResponse
     */
    results: Array<Offense>;
    /**
     * 
     * @type {boolean}
     * @memberof OffenseListResponse
     */
    truncated: boolean;
}
/**
 * 
 * @export
 * @interface OffenseMapListResponse
 */
export interface OffenseMapListResponse {
    /**
     * 
     * @type {Array<LightOffense>}
     * @memberof OffenseMapListResponse
     */
    results: Array<LightOffense>;
    /**
     * 
     * @type {boolean}
     * @memberof OffenseMapListResponse
     */
    truncated: boolean;
}
/**
 * 
 * @export
 * @interface ParkingBayInfo
 */
export interface ParkingBayInfo {
    /**
     * 
     * @type {string}
     * @memberof ParkingBayInfo
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof ParkingBayInfo
     */
    last_updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ParkingBayInfo
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface ParkingBayInputError
 */
export interface ParkingBayInputError {
    /**
     * 
     * @type {string}
     * @memberof ParkingBayInputError
     */
    curb_id: string;
    /**
     * 
     * @type {string}
     * @memberof ParkingBayInputError
     */
    reason: string;
}
/**
 * 
 * @export
 * @interface PenaltyScheme
 */
export interface PenaltyScheme {
    /**
     * 
     * @type {string}
     * @memberof PenaltyScheme
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof PenaltyScheme
     */
    is_fee_rates: boolean;
    /**
     * 
     * @type {string}
     * @memberof PenaltyScheme
     */
    start_date: string;
    /**
     * 
     * @type {string}
     * @memberof PenaltyScheme
     */
    end_date: string;
    /**
     * 
     * @type {Array<PolicyInfo>}
     * @memberof PenaltyScheme
     */
    policies_names: Array<PolicyInfo>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PenaltyScheme
     */
    providers: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<any>; }}
     * @memberof PenaltyScheme
     */
    policies_amounts: { [key: string]: Array<any>; };
}
/**
 * Latest GPS position
 * @export
 * @interface Point
 */
export interface Point {
    /**
     * 
     * @type {string}
     * @memberof Point
     */
    type: Point_TypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof Point
     */
    coordinates: Array<number>;
}

/**
    * @export
    * @enum {string}
    */
export enum Point_TypeEnum {
    'Point' = 'Point'
}

/**
 * 
 * @export
 * @interface Policy
 */
export interface Policy {
    /**
     * 
     * @type {Array<AreaLabelResponse>}
     * @memberof Policy
     */
    areas: Array<AreaLabelResponse>;
    /**
     * 
     * @type {PolicyConfig}
     * @memberof Policy
     */
    config: PolicyConfig;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    private_description?: string;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    due_date?: string;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    due_date_kind?: Policy_DueDateKindEnum;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Policy
     */
    prev_policies?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Policy
     */
    providers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    published_date?: string;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    kind: Policy_KindEnum;
    /**
     * 
     * @type {Array<PolicyRule>}
     * @memberof Policy
     */
    rules: Array<PolicyRule>;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    recurrence_repeat_every?: number;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    recurrence_ends_after?: number;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    recurrence_kind?: Policy_RecurrenceKindEnum;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    start_date: string;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    status: Policy_StatusEnum;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    fixed_price?: number;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    flat_penalty?: number;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    penalty_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    minimum_time_duration?: number;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    penalty_frequency?: Policy_PenaltyFrequencyEnum;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    confirmation_delay?: number;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    penalty_delay?: number;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    fee_calculation_method?: Policy_FeeCalculationMethodEnum;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof Policy
     */
    vehicle_events_and_states?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    notification_delay?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Policy
     */
    smart_patrol?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    parking_auto_confirm_threshold?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Policy
     */
    maintenance_kinds?: Array<Policy_MaintenanceKindsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof Policy
     */
    is_mds?: boolean;
    /**
     * Shared by all the versions of a policy, as editing a published policy publishes a new one
     * @type {string}
     * @memberof Policy
     */
    correlation_id?: string;
    /**
     * Is this policy the latest version of its correlation_id
     * @type {boolean}
     * @memberof Policy
     */
    is_latest?: boolean;
    /**
     * Start date of the first version of the policy
     * @type {string}
     * @memberof Policy
     */
    first_version_start_date?: string;
    /**
     * Start date of the next version of the policy, when a change is scheduled
     * @type {string}
     * @memberof Policy
     */
    next_version_start_date?: string;
    /**
     * Latest version of the policy, the one to edit
     * @type {string}
     * @memberof Policy
     */
    latest_version_id?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum Policy_DueDateKindEnum {
    'first_day' = 'first_day',
    'last_day' = 'last_day'
}
/**
    * @export
    * @enum {string}
    */
export enum Policy_KindEnum {
    'speed' = 'speed',
    'geofence' = 'geofence',
    'absolute_fleet_size' = 'absolute_fleet_size',
    'fleet_budget' = 'fleet_budget',
    'permit' = 'permit',
    'parking' = 'parking',
    'trip_taxation' = 'trip_taxation',
    'beginner_speed_limit' = 'beginner_speed_limit',
    'beginner_allowed_hours' = 'beginner_allowed_hours',
    'vehicle_deployment' = 'vehicle_deployment',
    'maintenance' = 'maintenance',
    'dwell_time' = 'dwell_time',
    'abandoned' = 'abandoned',
    'balancing' = 'balancing',
    'sidewalk' = 'sidewalk',
    'time' = 'time',
    'user' = 'user'
}
/**
    * @export
    * @enum {string}
    */
export enum Policy_RecurrenceKindEnum {
    'day' = 'day',
    'week' = 'week',
    'month' = 'month',
    'year' = 'year'
}
/**
    * @export
    * @enum {string}
    */
export enum Policy_StatusEnum {
    'draft' = 'draft',
    'upcoming' = 'upcoming',
    'ongoing' = 'ongoing',
    'finished' = 'finished',
    'cancelled' = 'cancelled'
}
/**
    * @export
    * @enum {string}
    */
export enum Policy_PenaltyFrequencyEnum {
    'hourly' = 'hourly',
    'daily' = 'daily'
}
/**
    * @export
    * @enum {string}
    */
export enum Policy_FeeCalculationMethodEnum {
    'lowest' = 'lowest',
    'highest' = 'highest',
    'sum' = 'sum',
    'mean' = 'mean',
    'origin' = 'origin',
    'destination' = 'destination'
}
/**
    * @export
    * @enum {string}
    */
export enum Policy_MaintenanceKindsEnum {
    'warehouse' = 'warehouse',
    'on_street' = 'on_street'
}

/**
 * 
 * @export
 * @interface PolicyAggregation
 */
export interface PolicyAggregation {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PolicyAggregation
     */
    statuses: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PolicyAggregation
     */
    kinds: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PolicyAggregation
     */
    providers: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof PolicyAggregation
     */
    total: number;
}
/**
 * 
 * @export
 * @interface PolicyAmount
 */
export interface PolicyAmount {
    /**
     * 
     * @type {number}
     * @memberof PolicyAmount
     */
    offenses_count: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyAmount
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyAmount
     */
    policy_id: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyAmount
     */
    policy_name: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyAmount
     */
    status?: PolicyAmount_StatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyAmount_StatusEnum {
    'draft' = 'draft',
    'upcoming' = 'upcoming',
    'ongoing' = 'ongoing',
    'finished' = 'finished',
    'cancelled' = 'cancelled'
}

/**
 * 
 * @export
 * @interface PolicyAmountCreate
 */
export interface PolicyAmountCreate {
    /**
     * 
     * @type {string}
     * @memberof PolicyAmountCreate
     */
    policy: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyAmountCreate
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyAmountCreate
     */
    subtype?: PolicyAmountCreate_SubtypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyAmountCreate_SubtypeEnum {
    'geofence_trip' = 'geofence_trip'
}

/**
 * 
 * @export
 * @interface PolicyChange
 */
export interface PolicyChange {
    /**
     * 
     * @type {number}
     * @memberof PolicyChange
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyChange
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyChange
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyChange
     */
    action: PolicyChange_ActionEnum;
    /**
     * Version of the policy the change applies to
     * @type {string}
     * @memberof PolicyChange
     */
    policy: string;
    /**
     * Date from which the change applies, the start of its version
     * @type {string}
     * @memberof PolicyChange
     */
    effective_date: string;
    /**
     * 
     * @type {Policy}
     * @memberof PolicyChange
     */
    before?: Policy;
    /**
     * 
     * @type {Policy}
     * @memberof PolicyChange
     */
    after?: Policy;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyChange_ActionEnum {
    'created' = 'created',
    'edited' = 'edited'
}

/**
 * 
 * @export
 * @interface PolicyConfig
 */
export interface PolicyConfig {
    /**
     * 
     * @type {number}
     * @memberof PolicyConfig
     */
    minimum_fleet_percentage?: number;
}
/**
 * 
 * @export
 * @interface PolicyFacetedGraphsResponse
 */
export interface PolicyFacetedGraphsResponse {
    /**
     * 
     * @type {GraphData}
     * @memberof PolicyFacetedGraphsResponse
     */
    penalty_score_per_provider_per_date: GraphData;
    /**
     * 
     * @type {GraphData}
     * @memberof PolicyFacetedGraphsResponse
     */
    offenses_per_provider_per_date: GraphData;
    /**
     * 
     * @type {PolicyOffenseAggregation}
     * @memberof PolicyFacetedGraphsResponse
     */
    filters_aggregations: PolicyOffenseAggregation;
}
/**
 * 
 * @export
 * @interface PolicyInfo
 */
export interface PolicyInfo {
    /**
     * 
     * @type {string}
     * @memberof PolicyInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyInfo
     */
    name: string;
}
/**
 * 
 * @export
 * @interface PolicyInput
 */
export interface PolicyInput {
    /**
     * 
     * @type {PolicyConfig}
     * @memberof PolicyInput
     */
    config?: PolicyConfig;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    private_description?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyInput
     */
    prev_policies?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyInput
     */
    providers?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyInput
     */
    publish?: boolean;
    /**
     * 
     * @type {Array<RuleInput>}
     * @memberof PolicyInput
     */
    rules: Array<RuleInput>;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    kind: PolicyInput_KindEnum;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    start_date: string;
    /**
     * 
     * @type {number}
     * @memberof PolicyInput
     */
    fixed_price?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyInput
     */
    flat_penalty?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyInput
     */
    penalty_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyInput
     */
    minimum_time_duration?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    penalty_frequency?: PolicyInput_PenaltyFrequencyEnum;
    /**
     * 
     * @type {number}
     * @memberof PolicyInput
     */
    confirmation_delay?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyInput
     */
    penalty_delay?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    penalty_frequency_str?: PolicyInput_PenaltyFrequencyStrEnum;
    /**
     * 
     * @type {number}
     * @memberof PolicyInput
     */
    confirmation_delay_seconds?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyInput
     */
    penalty_delay_seconds?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    due_date_kind?: PolicyInput_DueDateKindEnum;
    /**
     * 
     * @type {number}
     * @memberof PolicyInput
     */
    recurrence_repeat_every?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyInput
     */
    recurrence_ends_after?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    recurrence_kind?: PolicyInput_RecurrenceKindEnum;
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    fee_calculation_method?: PolicyInput_FeeCalculationMethodEnum;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof PolicyInput
     */
    vehicle_events_and_states: { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof PolicyInput
     */
    notification_delay?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyInput
     */
    smart_patrol?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyInput
     */
    maintenance_kinds?: Array<PolicyInput_MaintenanceKindsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyInput
     */
    is_mds: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyInput_KindEnum {
    'speed' = 'speed',
    'geofence' = 'geofence',
    'absolute_fleet_size' = 'absolute_fleet_size',
    'fleet_budget' = 'fleet_budget',
    'permit' = 'permit',
    'parking' = 'parking',
    'trip_taxation' = 'trip_taxation',
    'beginner_speed_limit' = 'beginner_speed_limit',
    'beginner_allowed_hours' = 'beginner_allowed_hours',
    'vehicle_deployment' = 'vehicle_deployment',
    'maintenance' = 'maintenance',
    'dwell_time' = 'dwell_time',
    'abandoned' = 'abandoned',
    'balancing' = 'balancing',
    'sidewalk' = 'sidewalk',
    'time' = 'time',
    'user' = 'user'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyInput_PenaltyFrequencyEnum {
    'hourly' = 'hourly',
    'daily' = 'daily'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyInput_PenaltyFrequencyStrEnum {
    'hourly' = 'hourly',
    'daily' = 'daily'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyInput_DueDateKindEnum {
    'first_day' = 'first_day',
    'last_day' = 'last_day'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyInput_RecurrenceKindEnum {
    'day' = 'day',
    'week' = 'week',
    'month' = 'month',
    'year' = 'year'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyInput_FeeCalculationMethodEnum {
    'lowest' = 'lowest',
    'highest' = 'highest',
    'sum' = 'sum',
    'mean' = 'mean',
    'origin' = 'origin',
    'destination' = 'destination'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyInput_MaintenanceKindsEnum {
    'warehouse' = 'warehouse',
    'on_street' = 'on_street'
}

/**
 * 
 * @export
 * @interface PolicyKind
 */
export interface PolicyKind {
    /**
     * 
     * @type {string}
     * @memberof PolicyKind
     */
    kind?: PolicyKind_KindEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyKind
     */
    is_active: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyKind_KindEnum {
    'speed' = 'speed',
    'geofence' = 'geofence',
    'absolute_fleet_size' = 'absolute_fleet_size',
    'fleet_budget' = 'fleet_budget',
    'permit' = 'permit',
    'parking' = 'parking',
    'trip_taxation' = 'trip_taxation',
    'beginner_speed_limit' = 'beginner_speed_limit',
    'beginner_allowed_hours' = 'beginner_allowed_hours',
    'vehicle_deployment' = 'vehicle_deployment',
    'maintenance' = 'maintenance',
    'dwell_time' = 'dwell_time',
    'abandoned' = 'abandoned',
    'balancing' = 'balancing',
    'sidewalk' = 'sidewalk',
    'time' = 'time',
    'user' = 'user'
}

/**
 * 
 * @export
 * @interface PolicyListItem
 */
export interface PolicyListItem {
    /**
     * 
     * @type {string}
     * @memberof PolicyListItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyListItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyListItem
     */
    kind: PolicyListItem_KindEnum;
    /**
     * 
     * @type {string}
     * @memberof PolicyListItem
     */
    status: PolicyListItem_StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PolicyListItem
     */
    start_date: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyListItem
     */
    end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyListItem
     */
    published_date?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyListItem
     */
    providers?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyListItem
     */
    has_timeslots: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyListItem
     */
    correlation_id: string;
    /**
     * Start date of the first version of the policy
     * @type {string}
     * @memberof PolicyListItem
     */
    first_version_start_date: string;
    /**
     * Start date of the next version of the policy, when a change is scheduled
     * @type {string}
     * @memberof PolicyListItem
     */
    next_version_start_date: string;
    /**
     * Latest version of the policy, the one to edit
     * @type {string}
     * @memberof PolicyListItem
     */
    latest_version_id: string;
    /**
     * Whether the policy was created or edited since the user last opened it
     * @type {boolean}
     * @memberof PolicyListItem
     */
    has_unseen_changes: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyListItem_KindEnum {
    'speed' = 'speed',
    'geofence' = 'geofence',
    'absolute_fleet_size' = 'absolute_fleet_size',
    'fleet_budget' = 'fleet_budget',
    'permit' = 'permit',
    'parking' = 'parking',
    'trip_taxation' = 'trip_taxation',
    'beginner_speed_limit' = 'beginner_speed_limit',
    'beginner_allowed_hours' = 'beginner_allowed_hours',
    'vehicle_deployment' = 'vehicle_deployment',
    'maintenance' = 'maintenance',
    'dwell_time' = 'dwell_time',
    'abandoned' = 'abandoned',
    'balancing' = 'balancing',
    'sidewalk' = 'sidewalk',
    'time' = 'time',
    'user' = 'user'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyListItem_StatusEnum {
    'draft' = 'draft',
    'upcoming' = 'upcoming',
    'ongoing' = 'ongoing',
    'finished' = 'finished',
    'cancelled' = 'cancelled'
}

/**
 * 
 * @export
 * @interface PolicyListResponse
 */
export interface PolicyListResponse {
    /**
     * 
     * @type {Array<PolicyListItem>}
     * @memberof PolicyListResponse
     */
    results: Array<PolicyListItem>;
}
/**
 * 
 * @export
 * @interface PolicyName
 */
export interface PolicyName {
    /**
     * 
     * @type {string}
     * @memberof PolicyName
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyName
     */
    name: string;
}
/**
 * 
 * @export
 * @interface PolicyNameArea
 */
export interface PolicyNameArea {
    /**
     * 
     * @type {string}
     * @memberof PolicyNameArea
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyNameArea
     */
    name: string;
    /**
     * 
     * @type {Array<Area>}
     * @memberof PolicyNameArea
     */
    areas: Array<Area>;
}
/**
 * 
 * @export
 * @interface PolicyNewVersionInput
 */
export interface PolicyNewVersionInput {
    /**
     * 
     * @type {PolicyConfig}
     * @memberof PolicyNewVersionInput
     */
    config?: PolicyConfig;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    private_description?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyNewVersionInput
     */
    providers?: Array<string>;
    /**
     * 
     * @type {Array<RuleInput>}
     * @memberof PolicyNewVersionInput
     */
    rules: Array<RuleInput>;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    kind: PolicyNewVersionInput_KindEnum;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    start_date: string;
    /**
     * 
     * @type {number}
     * @memberof PolicyNewVersionInput
     */
    fixed_price?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyNewVersionInput
     */
    flat_penalty?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyNewVersionInput
     */
    penalty_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyNewVersionInput
     */
    minimum_time_duration?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    penalty_frequency?: PolicyNewVersionInput_PenaltyFrequencyEnum;
    /**
     * 
     * @type {number}
     * @memberof PolicyNewVersionInput
     */
    confirmation_delay?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyNewVersionInput
     */
    penalty_delay?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    penalty_frequency_str?: PolicyNewVersionInput_PenaltyFrequencyStrEnum;
    /**
     * 
     * @type {number}
     * @memberof PolicyNewVersionInput
     */
    confirmation_delay_seconds?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyNewVersionInput
     */
    penalty_delay_seconds?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    due_date_kind?: PolicyNewVersionInput_DueDateKindEnum;
    /**
     * 
     * @type {number}
     * @memberof PolicyNewVersionInput
     */
    recurrence_repeat_every?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyNewVersionInput
     */
    recurrence_ends_after?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    recurrence_kind?: PolicyNewVersionInput_RecurrenceKindEnum;
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    fee_calculation_method?: PolicyNewVersionInput_FeeCalculationMethodEnum;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof PolicyNewVersionInput
     */
    vehicle_events_and_states: { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof PolicyNewVersionInput
     */
    notification_delay?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyNewVersionInput
     */
    smart_patrol?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyNewVersionInput
     */
    maintenance_kinds?: Array<PolicyNewVersionInput_MaintenanceKindsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyNewVersionInput
     */
    is_mds: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyNewVersionInput_KindEnum {
    'speed' = 'speed',
    'geofence' = 'geofence',
    'absolute_fleet_size' = 'absolute_fleet_size',
    'fleet_budget' = 'fleet_budget',
    'permit' = 'permit',
    'parking' = 'parking',
    'trip_taxation' = 'trip_taxation',
    'beginner_speed_limit' = 'beginner_speed_limit',
    'beginner_allowed_hours' = 'beginner_allowed_hours',
    'vehicle_deployment' = 'vehicle_deployment',
    'maintenance' = 'maintenance',
    'dwell_time' = 'dwell_time',
    'abandoned' = 'abandoned',
    'balancing' = 'balancing',
    'sidewalk' = 'sidewalk',
    'time' = 'time',
    'user' = 'user'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyNewVersionInput_PenaltyFrequencyEnum {
    'hourly' = 'hourly',
    'daily' = 'daily'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyNewVersionInput_PenaltyFrequencyStrEnum {
    'hourly' = 'hourly',
    'daily' = 'daily'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyNewVersionInput_DueDateKindEnum {
    'first_day' = 'first_day',
    'last_day' = 'last_day'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyNewVersionInput_RecurrenceKindEnum {
    'day' = 'day',
    'week' = 'week',
    'month' = 'month',
    'year' = 'year'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyNewVersionInput_FeeCalculationMethodEnum {
    'lowest' = 'lowest',
    'highest' = 'highest',
    'sum' = 'sum',
    'mean' = 'mean',
    'origin' = 'origin',
    'destination' = 'destination'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyNewVersionInput_MaintenanceKindsEnum {
    'warehouse' = 'warehouse',
    'on_street' = 'on_street'
}

/**
 * 
 * @export
 * @interface PolicyOffenseAggregation
 */
export interface PolicyOffenseAggregation {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PolicyOffenseAggregation
     */
    vehicle_types: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PolicyOffenseAggregation
     */
    providers: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PolicyOffenseAggregation
     */
    status: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PolicyOffenseAggregation
     */
    event_types: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof PolicyOffenseAggregation
     */
    total: number;
}
/**
 * 
 * @export
 * @interface PolicyOffenseListResponse
 */
export interface PolicyOffenseListResponse {
    /**
     * 
     * @type {Array<Offense>}
     * @memberof PolicyOffenseListResponse
     */
    results: Array<Offense>;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyOffenseListResponse
     */
    truncated: boolean;
}
/**
 * 
 * @export
 * @interface PolicyRule
 */
export interface PolicyRule {
    /**
     * 
     * @type {string}
     * @memberof PolicyRule
     */
    rule_id: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyRule
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyRule
     */
    rule_type: PolicyRule_RuleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PolicyRule
     */
    rule_units?: PolicyRule_RuleUnitsEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyRule
     */
    geographies: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyRule
     */
    buffered_geographies: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyRule
     */
    prohibited_parking_zones?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyRule
     */
    buffered_prohibited_parking_zones?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyRule
     */
    authorized_parking_zones?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyRule
     */
    buffered_authorized_parking_zones?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyRule
     */
    vehicle_types: Array<PolicyRule_VehicleTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof PolicyRule
     */
    minimum?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyRule
     */
    maximum?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyRule
     */
    buffer_speed?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyRule
     */
    rate_amount?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PolicyRule
     */
    config?: { [key: string]: string; };
    /**
     * 
     * @type {Array<PolicyTimeslot>}
     * @memberof PolicyRule
     */
    timeslots: Array<PolicyTimeslot>;
    /**
     * 
     * @type {string}
     * @memberof PolicyRule
     */
    proration_kind?: PolicyRule_ProrationKindEnum;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PolicyRule
     */
    proration_areas_mapping?: { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof PolicyRule
     */
    proration_time_spent_report_area?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyRule_RuleTypeEnum {
    'speed' = 'speed',
    'geofence' = 'geofence',
    'absolute_fleet_size' = 'absolute_fleet_size',
    'fleet_budget' = 'fleet_budget',
    'permit' = 'permit',
    'parking' = 'parking',
    'trip_taxation' = 'trip_taxation',
    'beginner_speed_limit' = 'beginner_speed_limit',
    'beginner_allowed_hours' = 'beginner_allowed_hours',
    'vehicle_deployment' = 'vehicle_deployment',
    'maintenance' = 'maintenance',
    'dwell_time' = 'dwell_time',
    'abandoned' = 'abandoned',
    'balancing' = 'balancing',
    'sidewalk' = 'sidewalk',
    'time' = 'time',
    'user' = 'user'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyRule_RuleUnitsEnum {
    'seconds' = 'seconds',
    'minutes' = 'minutes',
    'hours' = 'hours',
    'days' = 'days',
    'kmh' = 'kmh',
    'mph' = 'mph',
    'device' = 'device',
    'amount' = 'amount',
    'km' = 'km',
    'miles' = 'miles'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyRule_VehicleTypesEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyRule_ProrationKindEnum {
    'areas' = 'areas',
    'time_spent' = 'time_spent'
}

/**
 * 
 * @export
 * @interface PolicyTimeslot
 */
export interface PolicyTimeslot {
    /**
     * 
     * @type {string}
     * @memberof PolicyTimeslot
     */
    start_time?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyTimeslot
     */
    end_time?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyTimeslot
     */
    days: Array<PolicyTimeslot_DaysEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyTimeslot_DaysEnum {
    'sun' = 'sun',
    'mon' = 'mon',
    'tue' = 'tue',
    'wed' = 'wed',
    'thu' = 'thu',
    'fri' = 'fri',
    'sat' = 'sat'
}

/**
 * GeoJSON Polygon
 * @export
 * @interface Polygon
 */
export interface Polygon {
    /**
     * 
     * @type {string}
     * @memberof Polygon
     */
    type: Polygon_TypeEnum;
    /**
     * 
     * @type {Array<Array<Array<number>>>}
     * @memberof Polygon
     */
    coordinates: Array<Array<Array<number>>>;
}

/**
    * @export
    * @enum {string}
    */
export enum Polygon_TypeEnum {
    'Polygon' = 'Polygon',
    'MultiPolygon' = 'MultiPolygon'
}

/**
 * 
 * @export
 * @interface PolygonRequest
 */
export interface PolygonRequest {
    /**
     * 
     * @type {Polygon}
     * @memberof PolygonRequest
     */
    geom: Polygon;
    /**
     * Name of the polygon
     * @type {string}
     * @memberof PolygonRequest
     */
    label: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PolygonRequest
     */
    areas: Array<string>;
}
/**
 * 
 * @export
 * @interface PolygonResponse
 */
export interface PolygonResponse {
    /**
     * Unique Polygon identifier (UUID)
     * @type {string}
     * @memberof PolygonResponse
     */
    id: string;
    /**
     * Name of the polygon
     * @type {string}
     * @memberof PolygonResponse
     */
    label: string;
    /**
     * 
     * @type {Polygon}
     * @memberof PolygonResponse
     */
    geom: Polygon;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PolygonResponse
     */
    properties: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof PolygonResponse
     */
    areas?: Array<string>;
}
/**
 * 
 * @export
 * @interface PolygonsImportRequest
 */
export interface PolygonsImportRequest {
    /**
     * 
     * @type {Array<PolygonRequest>}
     * @memberof PolygonsImportRequest
     */
    polygons: Array<PolygonRequest>;
}
/**
 * 
 * @export
 * @interface PowerBIReport
 */
export interface PowerBIReport {
    /**
     * 
     * @type {string}
     * @memberof PowerBIReport
     */
    reportId: string;
    /**
     * 
     * @type {string}
     * @memberof PowerBIReport
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof PowerBIReport
     */
    embedUrl: string;
    /**
     * 
     * @type {PowerBiFiltersValue}
     * @memberof PowerBIReport
     */
    filtersValue: PowerBiFiltersValue;
}
/**
 * 
 * @export
 * @interface PowerBiFiltersValue
 */
export interface PowerBiFiltersValue {
    /**
     * 
     * @type {Array<string>}
     * @memberof PowerBiFiltersValue
     */
    providersId: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PowerBiFiltersValue
     */
    vehicleTypes: Array<PowerBiFiltersValue_VehicleTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof PowerBiFiltersValue
     */
    jurisdictionId: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PowerBiFiltersValue_VehicleTypesEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}

/**
 * 
 * @export
 * @interface Provider
 */
export interface Provider {
    /**
     * Unique provider identifier (UUID)
     * @type {string}
     * @memberof Provider
     */
    id: string;
    /**
     * Name of the Provider
     * @type {string}
     * @memberof Provider
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Provider
     */
    embed_id: number;
    /**
     * 
     * @type {ProviderColors}
     * @memberof Provider
     */
    colors?: ProviderColors;
    /**
     * Logo of provider
     * @type {string}
     * @memberof Provider
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    logo_b64?: string;
    /**
     * This provider is a device operator
     * @type {boolean}
     * @memberof Provider
     */
    is_active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    provider_kind?: Provider_ProviderKindEnum;
    /**
     * 
     * @type {number}
     * @memberof Provider
     */
    mds_credential_id?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum Provider_ProviderKindEnum {
    'gbfs' = 'gbfs',
    'gtfs' = 'gtfs',
    'mds' = 'mds',
    'cds' = 'cds',
    'databrix' = 'databrix'
}

/**
 * 
 * @export
 * @interface ProviderApiAuthentication
 */
export interface ProviderApiAuthentication {
    /**
     * 
     * @type {string}
     * @memberof ProviderApiAuthentication
     */
    type: ProviderApiAuthentication_TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProviderApiAuthentication
     */
    client_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderApiAuthentication
     */
    client_secret?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderApiAuthentication
     */
    token?: string;
    /**
     * URL to get the token - Only used by the native poller
     * @type {string}
     * @memberof ProviderApiAuthentication
     */
    token_url?: string;
    /**
     * OAuth2 parameters to fetch the token
     * @type {{ [key: string]: string; }}
     * @memberof ProviderApiAuthentication
     */
    token_params?: { [key: string]: string; };
}

/**
    * @export
    * @enum {string}
    */
export enum ProviderApiAuthentication_TypeEnum {
    'header' = 'header',
    'none' = 'none',
    'oauth2' = 'oauth2',
    'spin' = 'spin',
    'token' = 'token',
    'bolt' = 'bolt',
    'dott' = 'dott',
    'helloride' = 'helloride',
    'serve_robotics' = 'serve_robotics',
    'query_string_authentication' = 'query_string_authentication',
    'ario' = 'ario'
}

/**
 * 
 * @export
 * @interface ProviderApiConfiguration
 */
export interface ProviderApiConfiguration {
    /**
     * 
     * @type {string}
     * @memberof ProviderApiConfiguration
     */
    api_version: ProviderApiConfiguration_ApiVersionEnum;
    /**
     * Lag to wait for before polling the latest status changes
     * @type {string}
     * @memberof ProviderApiConfiguration
     */
    provider_polling_lag?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ProviderApiConfiguration_ApiVersionEnum {
    'none' = 'none',
    'v0_3' = 'v0_3',
    'v0_4' = 'v0_4',
    'v1_0' = 'v1_0',
    'v1_1' = 'v1_1',
    'v1_2' = 'v1_2',
    'v2_0' = 'v2_0'
}

/**
 * colors for distinguishing providers on map
 * @export
 * @interface ProviderColors
 */
export interface ProviderColors {
    /**
     * 
     * @type {string}
     * @memberof ProviderColors
     */
    primary?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderColors
     */
    secondary?: string;
}
/**
 * 
 * @export
 * @interface ProviderMetrics
 */
export interface ProviderMetrics {
    /**
     * 
     * @type {string}
     * @memberof ProviderMetrics
     */
    provider_id: string;
    /**
     * 
     * @type {number}
     * @memberof ProviderMetrics
     */
    offense_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ProviderMetrics
     */
    trip_count: number;
    /**
     * 
     * @type {number}
     * @memberof ProviderMetrics
     */
    vehicle_count: number;
    /**
     * 
     * @type {number}
     * @memberof ProviderMetrics
     */
    trip_ratio: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderMetrics
     */
    has_no_recent_data: boolean;
}
/**
 * 
 * @export
 * @interface RetrieveVehicle
 */
export interface RetrieveVehicle {
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof RetrieveVehicle
     */
    areas?: Array<{ [key: string]: string; }>;
    /**
     * Vehicle model
     * @type {string}
     * @memberof RetrieveVehicle
     */
    model?: string;
    /**
     * logo of the service provider of the device
     * @type {string}
     * @memberof RetrieveVehicle
     */
    provider_logo: string;
    /**
     * Unique device identifier (UUID)
     * @type {string}
     * @memberof RetrieveVehicle
     */
    id: string;
    /**
     * ID of the service provider of the device
     * @type {string}
     * @memberof RetrieveVehicle
     */
    provider_id: string;
    /**
     * Name of the service provider of the device
     * @type {string}
     * @memberof RetrieveVehicle
     */
    provider_name: string;
    /**
     * VIN (Vehicle Identification Number)
     * @type {string}
     * @memberof RetrieveVehicle
     */
    identification_number: string;
    /**
     * Device type
     * @type {string}
     * @memberof RetrieveVehicle
     */
    type: RetrieveVehicle_TypeEnum;
    /**
     * Propulsion type(s)
     * @type {Array<string>}
     * @memberof RetrieveVehicle
     */
    propulsion: Array<RetrieveVehicle_PropulsionEnum>;
    /**
     * Latest status
     * @type {string}
     * @memberof RetrieveVehicle
     */
    last_known_status: RetrieveVehicle_LastKnownStatusEnum;
    /**
     * Vehicle registration date
     * @type {string}
     * @memberof RetrieveVehicle
     */
    registration_date: string;
    /**
     * Latest GPS timestamp
     * @type {string}
     * @memberof RetrieveVehicle
     */
    last_known_timestamp: string;
    /**
     * Percentage between 0 and 1
     * @type {number}
     * @memberof RetrieveVehicle
     */
    last_known_battery_pct: number;
    /**
     * 
     * @type {Point}
     * @memberof RetrieveVehicle
     */
    position?: Point;
    /**
     * 
     * @type {number}
     * @memberof RetrieveVehicle
     */
    number_of_offenses?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum RetrieveVehicle_TypeEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}
/**
    * @export
    * @enum {string}
    */
export enum RetrieveVehicle_PropulsionEnum {
    'human' = 'human',
    'electric_assist' = 'electric_assist',
    'electric' = 'electric',
    'combustion' = 'combustion',
    'missing' = 'missing'
}
/**
    * @export
    * @enum {string}
    */
export enum RetrieveVehicle_LastKnownStatusEnum {
    'available' = 'available',
    'elsewhere' = 'elsewhere',
    'non_operational' = 'non_operational',
    'on_trip' = 'on_trip',
    'removed' = 'removed',
    'reserved' = 'reserved',
    'unknown' = 'unknown',
    'stopped' = 'stopped',
    'non_contactable' = 'non_contactable',
    'missing' = 'missing'
}

/**
 * 
 * @export
 * @interface RetrievedReport
 */
export interface RetrievedReport {
    /**
     * 
     * @type {number}
     * @memberof RetrievedReport
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RetrievedReport
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RetrievedReport
     */
    created_at?: string;
    /**
     * 
     * @type {number}
     * @memberof RetrievedReport
     */
    created_by?: number;
    /**
     * 
     * @type {string}
     * @memberof RetrievedReport
     */
    start_at: string;
    /**
     * 
     * @type {string}
     * @memberof RetrievedReport
     */
    end_at: string;
    /**
     * 
     * @type {string}
     * @memberof RetrievedReport
     */
    area_id: string;
    /**
     * 
     * @type {FeatureCollection}
     * @memberof RetrievedReport
     */
    area_geometry: FeatureCollection;
    /**
     * 
     * @type {string}
     * @memberof RetrievedReport
     */
    kind: string;
    /**
     * 
     * @type {any}
     * @memberof RetrievedReport
     */
    report?: any;
    /**
     * 
     * @type {any}
     * @memberof RetrievedReport
     */
    results?: any;
    /**
     * 
     * @type {number}
     * @memberof RetrievedReport
     */
    progress: number;
    /**
     * 
     * @type {boolean}
     * @memberof RetrievedReport
     */
    result_available?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RetrievedReport
     */
    vehicle_type?: string;
}
/**
 * 
 * @export
 * @interface RuleInput
 */
export interface RuleInput {
    /**
     * 
     * @type {string}
     * @memberof RuleInput
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RuleInput
     */
    rule_id: string;
    /**
     * 
     * @type {string}
     * @memberof RuleInput
     */
    rule_type: RuleInput_RuleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RuleInput
     */
    rule_units?: RuleInput_RuleUnitsEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleInput
     */
    geographies: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleInput
     */
    buffered_geographies: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleInput
     */
    vehicle_types: Array<RuleInput_VehicleTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleInput
     */
    prohibited_parking_zones?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleInput
     */
    buffered_prohibited_parking_zones?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleInput
     */
    authorized_parking_zones?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleInput
     */
    buffered_authorized_parking_zones?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RuleInput
     */
    minimum?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleInput
     */
    maximum?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleInput
     */
    rate_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof RuleInput
     */
    validation_error_message?: RuleInput_ValidationErrorMessageEnum;
    /**
     * 
     * @type {Array<TimeslotInput>}
     * @memberof RuleInput
     */
    timeslots: Array<TimeslotInput>;
    /**
     * 
     * @type {string}
     * @memberof RuleInput
     */
    proration_kind?: RuleInput_ProrationKindEnum;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof RuleInput
     */
    proration_areas_mapping?: { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof RuleInput
     */
    proration_time_spent_report_area?: string;
    /**
     * 
     * @type {string}
     * @memberof RuleInput
     */
    units?: RuleInput_UnitsEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleInput
     */
    propulsion_types?: Array<RuleInput_PropulsionTypesEnum>;
    /**
     * A null value mean no buffer speed
     * @type {number}
     * @memberof RuleInput
     */
    buffer_speed?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleInput
     */
    _order?: number;
    /**
     * 
     * @type {number}
     * @memberof RuleInput
     */
    proration_time_spent_report?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum RuleInput_RuleTypeEnum {
    'speed' = 'speed',
    'geofence' = 'geofence',
    'absolute_fleet_size' = 'absolute_fleet_size',
    'fleet_budget' = 'fleet_budget',
    'permit' = 'permit',
    'parking' = 'parking',
    'trip_taxation' = 'trip_taxation',
    'beginner_speed_limit' = 'beginner_speed_limit',
    'beginner_allowed_hours' = 'beginner_allowed_hours',
    'vehicle_deployment' = 'vehicle_deployment',
    'maintenance' = 'maintenance',
    'dwell_time' = 'dwell_time',
    'abandoned' = 'abandoned',
    'balancing' = 'balancing',
    'sidewalk' = 'sidewalk',
    'time' = 'time',
    'user' = 'user'
}
/**
    * @export
    * @enum {string}
    */
export enum RuleInput_RuleUnitsEnum {
    'seconds' = 'seconds',
    'minutes' = 'minutes',
    'hours' = 'hours',
    'days' = 'days',
    'kmh' = 'kmh',
    'mph' = 'mph',
    'device' = 'device',
    'amount' = 'amount',
    'km' = 'km',
    'miles' = 'miles'
}
/**
    * @export
    * @enum {string}
    */
export enum RuleInput_VehicleTypesEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}
/**
    * @export
    * @enum {string}
    */
export enum RuleInput_ValidationErrorMessageEnum {
    'empty_days' = 'empty_days',
    'empty_timeslot' = 'empty_timeslot',
    'intersection' = 'intersection',
    'time_order' = 'time_order'
}
/**
    * @export
    * @enum {string}
    */
export enum RuleInput_ProrationKindEnum {
    'areas' = 'areas',
    'time_spent' = 'time_spent'
}
/**
    * @export
    * @enum {string}
    */
export enum RuleInput_UnitsEnum {
    'seconds' = 'seconds',
    'minutes' = 'minutes',
    'hours' = 'hours',
    'days' = 'days',
    'kmh' = 'kmh',
    'mph' = 'mph',
    'device' = 'device',
    'amount' = 'amount',
    'km' = 'km',
    'miles' = 'miles'
}
/**
    * @export
    * @enum {string}
    */
export enum RuleInput_PropulsionTypesEnum {
    'human' = 'human',
    'electric_assist' = 'electric_assist',
    'electric' = 'electric',
    'combustion' = 'combustion',
    'missing' = 'missing'
}

/**
 * 
 * @export
 * @interface SmartPatrolOffense
 */
export interface SmartPatrolOffense {
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffense
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffense
     */
    provider_name?: string;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffense
     */
    vin: string;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffense
     */
    reportingDateTime: string;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffense
     */
    vehicleType: SmartPatrolOffense_VehicleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffense
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffense
     */
    agentName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SmartPatrolOffense
     */
    images?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffense
     */
    image_download_url?: string;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffense
     */
    comment: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SmartPatrolOffense_VehicleTypeEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}

/**
 * 
 * @export
 * @interface SmartPatrolOffenseAggregation
 */
export interface SmartPatrolOffenseAggregation {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SmartPatrolOffenseAggregation
     */
    provider_names: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SmartPatrolOffenseAggregation
     */
    vehicule_types: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SmartPatrolOffenseAggregation
     */
    agent_names: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SmartPatrolOffenseAggregation
     */
    type: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof SmartPatrolOffenseAggregation
     */
    total: number;
}
/**
 * 
 * @export
 * @interface SmartPatrolOffenseCreate
 */
export interface SmartPatrolOffenseCreate {
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffenseCreate
     */
    offense_type: string;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffenseCreate
     */
    provider_id: string;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffenseCreate
     */
    device_vin: string;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffenseCreate
     */
    device_type: SmartPatrolOffenseCreate_DeviceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SmartPatrolOffenseCreate
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof SmartPatrolOffenseCreate
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof SmartPatrolOffenseCreate
     */
    lon: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SmartPatrolOffenseCreate_DeviceTypeEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}

/**
 * 
 * @export
 * @interface SmartPatrolOffenseResponse
 */
export interface SmartPatrolOffenseResponse {
    /**
     * 
     * @type {Array<SmartPatrolOffense>}
     * @memberof SmartPatrolOffenseResponse
     */
    results: Array<SmartPatrolOffense>;
    /**
     * 
     * @type {SmartPatrolOffenseAggregation}
     * @memberof SmartPatrolOffenseResponse
     */
    aggregations: SmartPatrolOffenseAggregation;
}
/**
 * 
 * @export
 * @interface Stops
 */
export interface Stops {
    /**
     * 
     * @type {string}
     * @memberof Stops
     */
    uid: string;
    /**
     * 
     * @type {string}
     * @memberof Stops
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Stops
     */
    line_names?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Stops
     */
    line_type?: Stops_LineTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Stops
     */
    provider?: string;
    /**
     * 
     * @type {string}
     * @memberof Stops
     */
    gps_point?: string;
    /**
     * 
     * @type {string}
     * @memberof Stops
     */
    registration_date?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum Stops_LineTypeEnum {
    'bus' = 'bus',
    'train' = 'train',
    'tram' = 'tram',
    'subway' = 'subway',
    'bike' = 'bike',
    'ferry' = 'ferry'
}

/**
 * 
 * @export
 * @interface StopsResponse
 */
export interface StopsResponse {
    /**
     * 
     * @type {Array<Stops>}
     * @memberof StopsResponse
     */
    results: Array<Stops>;
}
/**
 * 
 * @export
 * @interface StreetSegmentDetail
 */
export interface StreetSegmentDetail {
    /**
     * 
     * @type {string}
     * @memberof StreetSegmentDetail
     */
    name: string;
    /**
     * 
     * @type {Geometry}
     * @memberof StreetSegmentDetail
     */
    geojson: Geometry;
}
/**
 * 
 * @export
 * @interface SubtractAreasRequest
 */
export interface SubtractAreasRequest {
    /**
     * Name of the resulting Area
     * @type {string}
     * @memberof SubtractAreasRequest
     */
    label: string;
    /**
     * Color of the resulting Area
     * @type {string}
     * @memberof SubtractAreasRequest
     */
    color: string;
    /**
     * Id of the Area to subtract from
     * @type {string}
     * @memberof SubtractAreasRequest
     */
    base_area: string;
    /**
     * Id of the Area to remove from the base Area
     * @type {string}
     * @memberof SubtractAreasRequest
     */
    subtracted_area: string;
    /**
     * Tags of the resulting Area. Unknown ones are created
     * @type {Array<string>}
     * @memberof SubtractAreasRequest
     */
    tags?: Array<string>;
}
/**
 * 
 * @export
 * @interface TigerTripAggregationsResponse
 */
export interface TigerTripAggregationsResponse {
    /**
     * 
     * @type {number}
     * @memberof TigerTripAggregationsResponse
     */
    count: number;
    /**
     * 
     * @type {TripsAggregations}
     * @memberof TigerTripAggregationsResponse
     */
    aggregations: TripsAggregations;
}
/**
 * 
 * @export
 * @interface TigerTripListResponse
 */
export interface TigerTripListResponse {
    /**
     * 
     * @type {Array<Trip>}
     * @memberof TigerTripListResponse
     */
    trips: Array<Trip>;
}
/**
 * 
 * @export
 * @interface TimeslotInput
 */
export interface TimeslotInput {
    /**
     * 
     * @type {string}
     * @memberof TimeslotInput
     */
    start_time?: string;
    /**
     * 
     * @type {string}
     * @memberof TimeslotInput
     */
    end_time?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TimeslotInput
     */
    days: Array<TimeslotInput_DaysEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum TimeslotInput_DaysEnum {
    'sun' = 'sun',
    'mon' = 'mon',
    'tue' = 'tue',
    'wed' = 'wed',
    'thu' = 'thu',
    'fri' = 'fri',
    'sat' = 'sat'
}

/**
 * 
 * @export
 * @interface TotpLink
 */
export interface TotpLink {
    /**
     * 
     * @type {string}
     * @memberof TotpLink
     */
    totp: string;
}
/**
 * 
 * @export
 * @interface Trip
 */
export interface Trip {
    /**
     * 
     * @type {string}
     * @memberof Trip
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Trip
     */
    vehicle_id: string;
    /**
     * 
     * @type {string}
     * @memberof Trip
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof Trip
     */
    start_time: string;
    /**
     * 
     * @type {string}
     * @memberof Trip
     */
    end_time: string;
    /**
     * 
     * @type {number}
     * @memberof Trip
     */
    duration: number;
    /**
     * 
     * @type {number}
     * @memberof Trip
     */
    distance: number;
    /**
     * 
     * @type {number}
     * @memberof Trip
     */
    speed: number;
    /**
     * 
     * @type {string}
     * @memberof Trip
     */
    provider_id: string;
    /**
     * 
     * @type {string}
     * @memberof Trip
     */
    vehicle_type: Trip_VehicleTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Trip
     */
    propulsion_types: Array<Trip_PropulsionTypesEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum Trip_VehicleTypeEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}
/**
    * @export
    * @enum {string}
    */
export enum Trip_PropulsionTypesEnum {
    'human' = 'human',
    'electric_assist' = 'electric_assist',
    'electric' = 'electric',
    'combustion' = 'combustion',
    'missing' = 'missing'
}

/**
 * 
 * @export
 * @interface TripCountInStreetSegment
 */
export interface TripCountInStreetSegment {
    /**
     * 
     * @type {string}
     * @memberof TripCountInStreetSegment
     */
    error_message?: string;
    /**
     * 
     * @type {{ [key: string]: StreetSegmentDetail; }}
     * @memberof TripCountInStreetSegment
     */
    street_segments: { [key: string]: StreetSegmentDetail; };
    /**
     * 
     * @type {Array<TripCountInStreetSegmentBucket>}
     * @memberof TripCountInStreetSegment
     */
    documents: Array<TripCountInStreetSegmentBucket>;
    /**
     * 
     * @type {number}
     * @memberof TripCountInStreetSegment
     */
    trips_per_street_min: number;
    /**
     * 
     * @type {number}
     * @memberof TripCountInStreetSegment
     */
    trips_per_street_max: number;
    /**
     * 
     * @type {number}
     * @memberof TripCountInStreetSegment
     */
    next_page?: number;
    /**
     * 
     * @type {number}
     * @memberof TripCountInStreetSegment
     */
    total_page_num: number;
}
/**
 * 
 * @export
 * @interface TripCountInStreetSegmentBucket
 */
export interface TripCountInStreetSegmentBucket {
    /**
     * 
     * @type {string}
     * @memberof TripCountInStreetSegmentBucket
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof TripCountInStreetSegmentBucket
     */
    doc_count: number;
}
/**
 * 
 * @export
 * @interface TripOriginDestination
 */
export interface TripOriginDestination {
    /**
     * 
     * @type {number}
     * @memberof TripOriginDestination
     */
    zoom: number;
    /**
     * 
     * @type {number}
     * @memberof TripOriginDestination
     */
    x: number;
    /**
     * 
     * @type {number}
     * @memberof TripOriginDestination
     */
    y: number;
    /**
     * 
     * @type {number}
     * @memberof TripOriginDestination
     */
    trip_count: number;
    /**
     * 
     * @type {string}
     * @memberof TripOriginDestination
     */
    kind: TripOriginDestination_KindEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum TripOriginDestination_KindEnum {
    'origin' = 'origin',
    'destination' = 'destination'
}

/**
 * 
 * @export
 * @interface TripTaxationFee
 */
export interface TripTaxationFee {
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFee
     */
    trip_id: string;
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFee
     */
    vehicle_id: string;
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFee
     */
    vehicle_type: string;
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFee
     */
    policy_id: string;
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFee
     */
    policy_name: string;
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFee
     */
    provider_id: string;
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFee
     */
    provider_name: string;
    /**
     * 
     * @type {number}
     * @memberof TripTaxationFee
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFee
     */
    trip_start_time: string;
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFee
     */
    trip_end_time: string;
    /**
     * 
     * @type {number}
     * @memberof TripTaxationFee
     */
    trip_duration: number;
    /**
     * 
     * @type {number}
     * @memberof TripTaxationFee
     */
    trip_distance: number;
}
/**
 * 
 * @export
 * @interface TripTaxationFeesAmountsByProviderResponse
 */
export interface TripTaxationFeesAmountsByProviderResponse {
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFeesAmountsByProviderResponse
     */
    provider_id: string;
    /**
     * 
     * @type {string}
     * @memberof TripTaxationFeesAmountsByProviderResponse
     */
    provider_name: string;
    /**
     * 
     * @type {Array<FeesPolicyAmountsByProviderAggregations>}
     * @memberof TripTaxationFeesAmountsByProviderResponse
     */
    policies: Array<FeesPolicyAmountsByProviderAggregations>;
}
/**
 * 
 * @export
 * @interface TripTaxationFeesResponse
 */
export interface TripTaxationFeesResponse {
    /**
     * 
     * @type {Array<TripTaxationFee>}
     * @memberof TripTaxationFeesResponse
     */
    fees: Array<TripTaxationFee>;
    /**
     * 
     * @type {number}
     * @memberof TripTaxationFeesResponse
     */
    fees_count: number;
    /**
     * 
     * @type {FeesAggregations}
     * @memberof TripTaxationFeesResponse
     */
    aggregations?: FeesAggregations;
}
/**
 * 
 * @export
 * @interface TripsAggregations
 */
export interface TripsAggregations {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TripsAggregations
     */
    provider_id?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TripsAggregations
     */
    vehicle_type?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TripsAggregations
     */
    location_type?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof TripsAggregations
     */
    duration_min?: number;
    /**
     * 
     * @type {number}
     * @memberof TripsAggregations
     */
    duration_max?: number;
    /**
     * 
     * @type {number}
     * @memberof TripsAggregations
     */
    distance_min?: number;
    /**
     * 
     * @type {number}
     * @memberof TripsAggregations
     */
    distance_max?: number;
    /**
     * 
     * @type {number}
     * @memberof TripsAggregations
     */
    speed_min?: number;
    /**
     * 
     * @type {number}
     * @memberof TripsAggregations
     */
    speed_max?: number;
}
/**
 * 
 * @export
 * @interface TripsFacetedListResponse
 */
export interface TripsFacetedListResponse {
    /**
     * 
     * @type {Array<Trip>}
     * @memberof TripsFacetedListResponse
     */
    documents: Array<Trip>;
    /**
     * 
     * @type {TripsAggregations}
     * @memberof TripsFacetedListResponse
     */
    aggregations: TripsAggregations;
    /**
     * 
     * @type {number}
     * @memberof TripsFacetedListResponse
     */
    number_of_matching_documents: number;
}
/**
 * 
 * @export
 * @interface TwoFactorToken
 */
export interface TwoFactorToken {
    /**
     * 
     * @type {string}
     * @memberof TwoFactorToken
     */
    token: string;
}
/**
 * 
 * @export
 * @interface TwoFactorValidation
 */
export interface TwoFactorValidation {
    /**
     * 
     * @type {boolean}
     * @memberof TwoFactorValidation
     */
    is_valid: boolean;
}
/**
 * 
 * @export
 * @interface UpdateReport
 */
export interface UpdateReport {
    /**
     * 
     * @type {string}
     * @memberof UpdateReport
     */
    name: string;
}
/**
 * 
 * @export
 * @interface UploadParkingBayValidation
 */
export interface UploadParkingBayValidation {
    /**
     * 
     * @type {boolean}
     * @memberof UploadParkingBayValidation
     */
    error_reading: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadParkingBayValidation
     */
    wrong_ids: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadParkingBayValidation
     */
    missing_fields: Array<string>;
    /**
     * 
     * @type {Array<ParkingBayInputError>}
     * @memberof UploadParkingBayValidation
     */
    input_errors: Array<ParkingBayInputError>;
    /**
     * 
     * @type {ParkingBayInfo}
     * @memberof UploadParkingBayValidation
     */
    infos: ParkingBayInfo;
}
/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {number}
     * @memberof UserInfo
     */
    id: number;
    /**
     * 
     * @type {Array<DomainPermission>}
     * @memberof UserInfo
     */
    domain_permissions: Array<DomainPermission>;
    /**
     * 
     * @type {Array<Group>}
     * @memberof UserInfo
     */
    groups: Array<Group>;
    /**
     * 
     * @type {Jurisdiction}
     * @memberof UserInfo
     */
    jurisdiction: Jurisdiction;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    username: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfo
     */
    two_factor_enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    last_password_update: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfo
     */
    must_update_password: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfo
     */
    password_login_enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfo
     */
    is_provider_user: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfo
     */
    is_superuser: boolean;
}
/**
 * 
 * @export
 * @interface UserName
 */
export interface UserName {
    /**
     * 
     * @type {number}
     * @memberof UserName
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserName
     */
    full_name: string;
}
/**
 * 
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * Unique device identifier (UUID)
     * @type {string}
     * @memberof Vehicle
     */
    id: string;
    /**
     * ID of the service provider of the device
     * @type {string}
     * @memberof Vehicle
     */
    provider_id: string;
    /**
     * Name of the service provider of the device
     * @type {string}
     * @memberof Vehicle
     */
    provider_name: string;
    /**
     * VIN (Vehicle Identification Number)
     * @type {string}
     * @memberof Vehicle
     */
    identification_number: string;
    /**
     * Device type
     * @type {string}
     * @memberof Vehicle
     */
    type: Vehicle_TypeEnum;
    /**
     * Propulsion type(s)
     * @type {Array<string>}
     * @memberof Vehicle
     */
    propulsion: Array<Vehicle_PropulsionEnum>;
    /**
     * Latest status
     * @type {string}
     * @memberof Vehicle
     */
    last_known_status: Vehicle_LastKnownStatusEnum;
    /**
     * Vehicle registration date
     * @type {string}
     * @memberof Vehicle
     */
    registration_date: string;
    /**
     * Latest GPS timestamp
     * @type {string}
     * @memberof Vehicle
     */
    last_known_timestamp: string;
    /**
     * Percentage between 0 and 1
     * @type {number}
     * @memberof Vehicle
     */
    last_known_battery_pct: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Vehicle
     */
    last_known_position?: Array<number>;
}

/**
    * @export
    * @enum {string}
    */
export enum Vehicle_TypeEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}
/**
    * @export
    * @enum {string}
    */
export enum Vehicle_PropulsionEnum {
    'human' = 'human',
    'electric_assist' = 'electric_assist',
    'electric' = 'electric',
    'combustion' = 'combustion',
    'missing' = 'missing'
}
/**
    * @export
    * @enum {string}
    */
export enum Vehicle_LastKnownStatusEnum {
    'available' = 'available',
    'elsewhere' = 'elsewhere',
    'non_operational' = 'non_operational',
    'on_trip' = 'on_trip',
    'removed' = 'removed',
    'reserved' = 'reserved',
    'unknown' = 'unknown',
    'stopped' = 'stopped',
    'non_contactable' = 'non_contactable',
    'missing' = 'missing'
}

/**
 * 
 * @export
 * @interface VehicleAggregation
 */
export interface VehicleAggregation {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof VehicleAggregation
     */
    categories: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof VehicleAggregation
     */
    statuses: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof VehicleAggregation
     */
    propulsions: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof VehicleAggregation
     */
    providers: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof VehicleAggregation
     */
    total: number;
}
/**
 * 
 * @export
 * @interface VehicleAutocomplete
 */
export interface VehicleAutocomplete {
    /**
     * 
     * @type {string}
     * @memberof VehicleAutocomplete
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleAutocomplete
     */
    vin: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleAutocomplete
     */
    type: VehicleAutocomplete_TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VehicleAutocomplete
     */
    provider_name: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleAutocomplete
     */
    state: string;
}

/**
    * @export
    * @enum {string}
    */
export enum VehicleAutocomplete_TypeEnum {
    'bicycle' = 'bicycle',
    'car' = 'car',
    'cargo_bicycle' = 'cargo_bicycle',
    'delivery_bot' = 'delivery_bot',
    'moped' = 'moped',
    'other' = 'other',
    'scooter' = 'scooter',
    'scooter_seated' = 'scooter_seated'
}

/**
 * 
 * @export
 * @interface VehicleEventType
 */
export interface VehicleEventType {
    /**
     * 
     * @type {string}
     * @memberof VehicleEventType
     */
    state?: VehicleEventType_StateEnum;
    /**
     * 
     * @type {string}
     * @memberof VehicleEventType
     */
    event?: VehicleEventType_EventEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum VehicleEventType_StateEnum {
    'available' = 'available',
    'elsewhere' = 'elsewhere',
    'non_operational' = 'non_operational',
    'on_trip' = 'on_trip',
    'removed' = 'removed',
    'reserved' = 'reserved',
    'unknown' = 'unknown',
    'stopped' = 'stopped',
    'non_contactable' = 'non_contactable',
    'missing' = 'missing'
}
/**
    * @export
    * @enum {string}
    */
export enum VehicleEventType_EventEnum {
    'agency_drop_off' = 'agency_drop_off',
    'agency_pick_up' = 'agency_pick_up',
    'battery_charged' = 'battery_charged',
    'battery_low' = 'battery_low',
    'comms_lost' = 'comms_lost',
    'comms_restored' = 'comms_restored',
    'compliance_pick_up' = 'compliance_pick_up',
    'decommissioned' = 'decommissioned',
    'driver_cancellation' = 'driver_cancellation',
    'located' = 'located',
    'maintenance' = 'maintenance',
    'maintenance_pick_up' = 'maintenance_pick_up',
    'missing' = 'missing',
    'off_hours' = 'off_hours',
    'on_hours' = 'on_hours',
    'passenger_cancellation' = 'passenger_cancellation',
    'provider_drop_off' = 'provider_drop_off',
    'rebalance_pick_up' = 'rebalance_pick_up',
    'reservation_cancel' = 'reservation_cancel',
    'reservation_start' = 'reservation_start',
    'reservation_stop' = 'reservation_stop',
    'service_end' = 'service_end',
    'system_resume' = 'system_resume',
    'system_start' = 'system_start',
    'system_suspend' = 'system_suspend',
    'trip_cancel' = 'trip_cancel',
    'trip_end' = 'trip_end',
    'trip_enter_jurisdiction' = 'trip_enter_jurisdiction',
    'trip_leave_jurisdiction' = 'trip_leave_jurisdiction',
    'trip_start' = 'trip_start',
    'trip_stop' = 'trip_stop',
    'unspecified' = 'unspecified',
    'notification_sent' = 'notification_sent',
    'changed_geographies' = 'changed_geographies',
    'charging_end' = 'charging_end',
    'charging_start' = 'charging_start',
    'customer_cancellation' = 'customer_cancellation',
    'fueling_end' = 'fueling_end',
    'fueling_start' = 'fueling_start',
    'maintenance_end' = 'maintenance_end',
    'not_located' = 'not_located',
    'order_drop_off' = 'order_drop_off',
    'order_pick_up' = 'order_pick_up',
    'provider_cancellation' = 'provider_cancellation',
    'recommission' = 'recommission',
    'remote_end' = 'remote_end',
    'remote_start' = 'remote_start',
    'service_start' = 'service_start',
    'trip_pause' = 'trip_pause',
    'trip_resume' = 'trip_resume'
}

/**
 * 
 * @export
 * @interface VehicleProperties
 */
export interface VehicleProperties {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof VehicleProperties
     */
    properties_mapping: { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface VehicleResponse
 */
export interface VehicleResponse {
    /**
     * 
     * @type {Array<Vehicle>}
     * @memberof VehicleResponse
     */
    results: Array<Vehicle>;
    /**
     * 
     * @type {VehicleAggregation}
     * @memberof VehicleResponse
     */
    aggregation: VehicleAggregation;
}
/**
 * 
 * @export
 * @interface VehicleUids
 */
export interface VehicleUids {
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleUids
     */
    uids: Array<string>;
}
/**
 * 
 * @export
 * @interface ZoneName
 */
export interface ZoneName {
    /**
     * 
     * @type {string}
     * @memberof ZoneName
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ZoneName
     */
    slug: string;
}

/**
 * agencyLogoRead parameters
 */
export interface IagencyLogoReadProps {
    options?: any,
};

/**
 * agencySettingsList parameters
 */
export interface IagencySettingsListProps {
    options?: any,
};

/**
 * AgencyApi - fetch parameter creator
 * @export
 */
export const AgencyApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyLogoRead({ options = {} }: IagencyLogoReadProps): FetchArgs {
            const localVarPath = `/agency/logo/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencySettingsList({ options = {} }: IagencySettingsListProps): FetchArgs {
            const localVarPath = `/agency/settings/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyApi - functional programming interface
 * @export
 */
export const AgencyApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        agencyLogoReadURL({ options }: IagencyLogoReadProps): FetchArgs {
            return AgencyApiFetchParamCreator(configuration).agencyLogoRead({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyLogoRead({ options }: IagencyLogoReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<AgencyLogo> {
            const localVarFetchArgs = this.agencyLogoReadURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        agencySettingsListURL({ options }: IagencySettingsListProps): FetchArgs {
            return AgencyApiFetchParamCreator(configuration).agencySettingsList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencySettingsList({ options }: IagencySettingsListProps): (fetch?: FetchAPI, basePath?: string) => Promise<AgencySettingsResponse> {
            const localVarFetchArgs = this.agencySettingsListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * AgencyApi - factory interface
 * @export
 */
export const AgencyApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyLogoRead({ options }: IagencyLogoReadProps) {
            return AgencyApiFp(configuration).agencyLogoRead({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencySettingsList({ options }: IagencySettingsListProps) {
            return AgencyApiFp(configuration).agencySettingsList({ options })(fetch, basePath);
        },
    };
};

/**
 * AgencyApi - object-oriented interface
 * @export
 * @class AgencyApi
 * @extends {BaseAPI}
 */
export class AgencyApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``agencyLogoRead`` for arguments and options.
     *
     */
    public agencyLogoReadURL({ options }: IagencyLogoReadProps = {}): FetchArgs {
        return AgencyApiFp(this.configuration).agencyLogoReadURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyLogoRead({ options }: IagencyLogoReadProps = {}) {
        return AgencyApiFp(this.configuration).agencyLogoRead({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``agencySettingsList`` for arguments and options.
     *
     */
    public agencySettingsListURL({ options }: IagencySettingsListProps = {}): FetchArgs {
        return AgencyApiFp(this.configuration).agencySettingsListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencySettingsList({ options }: IagencySettingsListProps = {}) {
        return AgencyApiFp(this.configuration).agencySettingsList({ options })(this.fetchData, this.basePath);
    }

}

/**
 * auditLogsExport parameters
 */
export interface IauditLogsExportProps {
    history_kind?: Array<string>, // 
    history_type?: Array<string>, // 
    name?: string, // 
    limit?: number, // Number of results to return per page.
    offset?: number, // The initial index from which to return the results.
    options?: any,
};

/**
 * auditLogsList parameters
 */
export interface IauditLogsListProps {
    history_kind?: Array<string>, // 
    history_type?: Array<string>, // 
    name?: string, // 
    limit?: number, // Number of results to return per page.
    offset?: number, // The initial index from which to return the results.
    options?: any,
};

/**
 * AuditLogsApi - fetch parameter creator
 * @export
 */
export const AuditLogsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} [history_kind] 
         * @param {Array<string>} [history_type] 
         * @param {string} [name] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogsExport({ history_kind, history_type, name, limit, offset, options = {} }: IauditLogsExportProps): FetchArgs {
            const localVarPath = `/audit_logs/export/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (history_kind) {
                localVarQueryParameter['history_kind'] = history_kind;
            }

            if (history_type) {
                localVarQueryParameter['history_type'] = history_type;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [history_kind] 
         * @param {Array<string>} [history_type] 
         * @param {string} [name] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogsList({ history_kind, history_type, name, limit, offset, options = {} }: IauditLogsListProps): FetchArgs {
            const localVarPath = `/audit_logs/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (history_kind) {
                localVarQueryParameter['history_kind'] = history_kind;
            }

            if (history_type) {
                localVarQueryParameter['history_type'] = history_type;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditLogsApi - functional programming interface
 * @export
 */
export const AuditLogsApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        auditLogsExportURL({ history_kind, history_type, name, limit, offset, options }: IauditLogsExportProps): FetchArgs {
            return AuditLogsApiFetchParamCreator(configuration).auditLogsExport({ history_kind, history_type, name, limit, offset, options });
        },

        /**
         * 
         * @param {Array<string>} [history_kind] 
         * @param {Array<string>} [history_type] 
         * @param {string} [name] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogsExport({ history_kind, history_type, name, limit, offset, options }: IauditLogsExportProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.auditLogsExportURL({ history_kind, history_type, name, limit, offset, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        auditLogsListURL({ history_kind, history_type, name, limit, offset, options }: IauditLogsListProps): FetchArgs {
            return AuditLogsApiFetchParamCreator(configuration).auditLogsList({ history_kind, history_type, name, limit, offset, options });
        },

        /**
         * 
         * @param {Array<string>} [history_kind] 
         * @param {Array<string>} [history_type] 
         * @param {string} [name] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogsList({ history_kind, history_type, name, limit, offset, options }: IauditLogsListProps): (fetch?: FetchAPI, basePath?: string) => Promise<AuditLogResponse> {
            const localVarFetchArgs = this.auditLogsListURL({ history_kind, history_type, name, limit, offset, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * AuditLogsApi - factory interface
 * @export
 */
export const AuditLogsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {Array<string>} [history_kind] 
         * @param {Array<string>} [history_type] 
         * @param {string} [name] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogsExport({ history_kind, history_type, name, limit, offset, options }: IauditLogsExportProps) {
            return AuditLogsApiFp(configuration).auditLogsExport({ history_kind, history_type, name, limit, offset, options })(fetch, basePath);
        },
        /**
         * 
         * @param {Array<string>} [history_kind] 
         * @param {Array<string>} [history_type] 
         * @param {string} [name] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditLogsList({ history_kind, history_type, name, limit, offset, options }: IauditLogsListProps) {
            return AuditLogsApiFp(configuration).auditLogsList({ history_kind, history_type, name, limit, offset, options })(fetch, basePath);
        },
    };
};

/**
 * AuditLogsApi - object-oriented interface
 * @export
 * @class AuditLogsApi
 * @extends {BaseAPI}
 */
export class AuditLogsApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``auditLogsExport`` for arguments and options.
     *
     */
    public auditLogsExportURL({ history_kind, history_type, name, limit, offset, options }: IauditLogsExportProps = {}): FetchArgs {
        return AuditLogsApiFp(this.configuration).auditLogsExportURL({ history_kind, history_type, name, limit, offset, options });
    }

    /**
     * 
     * @param {Array<string>} [history_kind] 
     * @param {Array<string>} [history_type] 
     * @param {string} [name] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogsApi
     */
    public auditLogsExport({ history_kind, history_type, name, limit, offset, options }: IauditLogsExportProps = {}) {
        return AuditLogsApiFp(this.configuration).auditLogsExport({ history_kind, history_type, name, limit, offset, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``auditLogsList`` for arguments and options.
     *
     */
    public auditLogsListURL({ history_kind, history_type, name, limit, offset, options }: IauditLogsListProps = {}): FetchArgs {
        return AuditLogsApiFp(this.configuration).auditLogsListURL({ history_kind, history_type, name, limit, offset, options });
    }

    /**
     * 
     * @param {Array<string>} [history_kind] 
     * @param {Array<string>} [history_type] 
     * @param {string} [name] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogsApi
     */
    public auditLogsList({ history_kind, history_type, name, limit, offset, options }: IauditLogsListProps = {}) {
        return AuditLogsApiFp(this.configuration).auditLogsList({ history_kind, history_type, name, limit, offset, options })(this.fetchData, this.basePath);
    }

}

/**
 * authentCreateApplicationCreate parameters
 */
export interface IauthentCreateApplicationCreateProps {
    options?: any,
};

/**
 * authentCreateApplicationDelete parameters
 */
export interface IauthentCreateApplicationDeleteProps {
    options?: any,
};

/**
 * authentDeleteApplicationCreate parameters
 */
export interface IauthentDeleteApplicationCreateProps {
    options?: any,
};

/**
 * authentDeleteApplicationDelete parameters
 */
export interface IauthentDeleteApplicationDeleteProps {
    options?: any,
};

/**
 * authentLongLivedTokenCreate parameters
 */
export interface IauthentLongLivedTokenCreateProps {
    options?: any,
};

/**
 * authentLongLivedTokenDelete parameters
 */
export interface IauthentLongLivedTokenDeleteProps {
    options?: any,
};

/**
 * authentRevokeApplicationCreate parameters
 */
export interface IauthentRevokeApplicationCreateProps {
    options?: any,
};

/**
 * authentRevokeApplicationDelete parameters
 */
export interface IauthentRevokeApplicationDeleteProps {
    options?: any,
};

/**
 * AuthentApi - fetch parameter creator
 * @export
 */
export const AuthentApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentCreateApplicationCreate({ options = {} }: IauthentCreateApplicationCreateProps): FetchArgs {
            const localVarPath = `/authent/create_application/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentCreateApplicationDelete({ options = {} }: IauthentCreateApplicationDeleteProps): FetchArgs {
            const localVarPath = `/authent/create_application/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentDeleteApplicationCreate({ options = {} }: IauthentDeleteApplicationCreateProps): FetchArgs {
            const localVarPath = `/authent/delete_application/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentDeleteApplicationDelete({ options = {} }: IauthentDeleteApplicationDeleteProps): FetchArgs {
            const localVarPath = `/authent/delete_application/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an alternate authentication method to Oauth2. An authorized user can generate such tokens and then transmit it to the token owner for future use with our API.
         * @summary Implements an endpoint to generate long lived (JWT) tokens.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentLongLivedTokenCreate({ options = {} }: IauthentLongLivedTokenCreateProps): FetchArgs {
            const localVarPath = `/authent/long_lived_token/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is an alternate authentication method to Oauth2. An authorized user can generate such tokens and then transmit it to the token owner for future use with our API.
         * @summary Implements an endpoint to generate long lived (JWT) tokens.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentLongLivedTokenDelete({ options = {} }: IauthentLongLivedTokenDeleteProps): FetchArgs {
            const localVarPath = `/authent/long_lived_token/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentRevokeApplicationCreate({ options = {} }: IauthentRevokeApplicationCreateProps): FetchArgs {
            const localVarPath = `/authent/revoke_application/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentRevokeApplicationDelete({ options = {} }: IauthentRevokeApplicationDeleteProps): FetchArgs {
            const localVarPath = `/authent/revoke_application/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthentApi - functional programming interface
 * @export
 */
export const AuthentApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        authentCreateApplicationCreateURL({ options }: IauthentCreateApplicationCreateProps): FetchArgs {
            return AuthentApiFetchParamCreator(configuration).authentCreateApplicationCreate({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentCreateApplicationCreate({ options }: IauthentCreateApplicationCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.authentCreateApplicationCreateURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        authentCreateApplicationDeleteURL({ options }: IauthentCreateApplicationDeleteProps): FetchArgs {
            return AuthentApiFetchParamCreator(configuration).authentCreateApplicationDelete({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentCreateApplicationDelete({ options }: IauthentCreateApplicationDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.authentCreateApplicationDeleteURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        authentDeleteApplicationCreateURL({ options }: IauthentDeleteApplicationCreateProps): FetchArgs {
            return AuthentApiFetchParamCreator(configuration).authentDeleteApplicationCreate({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentDeleteApplicationCreate({ options }: IauthentDeleteApplicationCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.authentDeleteApplicationCreateURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        authentDeleteApplicationDeleteURL({ options }: IauthentDeleteApplicationDeleteProps): FetchArgs {
            return AuthentApiFetchParamCreator(configuration).authentDeleteApplicationDelete({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentDeleteApplicationDelete({ options }: IauthentDeleteApplicationDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.authentDeleteApplicationDeleteURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        authentLongLivedTokenCreateURL({ options }: IauthentLongLivedTokenCreateProps): FetchArgs {
            return AuthentApiFetchParamCreator(configuration).authentLongLivedTokenCreate({ options });
        },

        /**
         * This is an alternate authentication method to Oauth2. An authorized user can generate such tokens and then transmit it to the token owner for future use with our API.
         * @summary Implements an endpoint to generate long lived (JWT) tokens.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentLongLivedTokenCreate({ options }: IauthentLongLivedTokenCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.authentLongLivedTokenCreateURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        authentLongLivedTokenDeleteURL({ options }: IauthentLongLivedTokenDeleteProps): FetchArgs {
            return AuthentApiFetchParamCreator(configuration).authentLongLivedTokenDelete({ options });
        },

        /**
         * This is an alternate authentication method to Oauth2. An authorized user can generate such tokens and then transmit it to the token owner for future use with our API.
         * @summary Implements an endpoint to generate long lived (JWT) tokens.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentLongLivedTokenDelete({ options }: IauthentLongLivedTokenDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.authentLongLivedTokenDeleteURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        authentRevokeApplicationCreateURL({ options }: IauthentRevokeApplicationCreateProps): FetchArgs {
            return AuthentApiFetchParamCreator(configuration).authentRevokeApplicationCreate({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentRevokeApplicationCreate({ options }: IauthentRevokeApplicationCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.authentRevokeApplicationCreateURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        authentRevokeApplicationDeleteURL({ options }: IauthentRevokeApplicationDeleteProps): FetchArgs {
            return AuthentApiFetchParamCreator(configuration).authentRevokeApplicationDelete({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentRevokeApplicationDelete({ options }: IauthentRevokeApplicationDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.authentRevokeApplicationDeleteURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * AuthentApi - factory interface
 * @export
 */
export const AuthentApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentCreateApplicationCreate({ options }: IauthentCreateApplicationCreateProps) {
            return AuthentApiFp(configuration).authentCreateApplicationCreate({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentCreateApplicationDelete({ options }: IauthentCreateApplicationDeleteProps) {
            return AuthentApiFp(configuration).authentCreateApplicationDelete({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentDeleteApplicationCreate({ options }: IauthentDeleteApplicationCreateProps) {
            return AuthentApiFp(configuration).authentDeleteApplicationCreate({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentDeleteApplicationDelete({ options }: IauthentDeleteApplicationDeleteProps) {
            return AuthentApiFp(configuration).authentDeleteApplicationDelete({ options })(fetch, basePath);
        },
        /**
         * This is an alternate authentication method to Oauth2. An authorized user can generate such tokens and then transmit it to the token owner for future use with our API.
         * @summary Implements an endpoint to generate long lived (JWT) tokens.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentLongLivedTokenCreate({ options }: IauthentLongLivedTokenCreateProps) {
            return AuthentApiFp(configuration).authentLongLivedTokenCreate({ options })(fetch, basePath);
        },
        /**
         * This is an alternate authentication method to Oauth2. An authorized user can generate such tokens and then transmit it to the token owner for future use with our API.
         * @summary Implements an endpoint to generate long lived (JWT) tokens.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentLongLivedTokenDelete({ options }: IauthentLongLivedTokenDeleteProps) {
            return AuthentApiFp(configuration).authentLongLivedTokenDelete({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentRevokeApplicationCreate({ options }: IauthentRevokeApplicationCreateProps) {
            return AuthentApiFp(configuration).authentRevokeApplicationCreate({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authentRevokeApplicationDelete({ options }: IauthentRevokeApplicationDeleteProps) {
            return AuthentApiFp(configuration).authentRevokeApplicationDelete({ options })(fetch, basePath);
        },
    };
};

/**
 * AuthentApi - object-oriented interface
 * @export
 * @class AuthentApi
 * @extends {BaseAPI}
 */
export class AuthentApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``authentCreateApplicationCreate`` for arguments and options.
     *
     */
    public authentCreateApplicationCreateURL({ options }: IauthentCreateApplicationCreateProps = {}): FetchArgs {
        return AuthentApiFp(this.configuration).authentCreateApplicationCreateURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentApi
     */
    public authentCreateApplicationCreate({ options }: IauthentCreateApplicationCreateProps = {}) {
        return AuthentApiFp(this.configuration).authentCreateApplicationCreate({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``authentCreateApplicationDelete`` for arguments and options.
     *
     */
    public authentCreateApplicationDeleteURL({ options }: IauthentCreateApplicationDeleteProps = {}): FetchArgs {
        return AuthentApiFp(this.configuration).authentCreateApplicationDeleteURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentApi
     */
    public authentCreateApplicationDelete({ options }: IauthentCreateApplicationDeleteProps = {}) {
        return AuthentApiFp(this.configuration).authentCreateApplicationDelete({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``authentDeleteApplicationCreate`` for arguments and options.
     *
     */
    public authentDeleteApplicationCreateURL({ options }: IauthentDeleteApplicationCreateProps = {}): FetchArgs {
        return AuthentApiFp(this.configuration).authentDeleteApplicationCreateURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentApi
     */
    public authentDeleteApplicationCreate({ options }: IauthentDeleteApplicationCreateProps = {}) {
        return AuthentApiFp(this.configuration).authentDeleteApplicationCreate({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``authentDeleteApplicationDelete`` for arguments and options.
     *
     */
    public authentDeleteApplicationDeleteURL({ options }: IauthentDeleteApplicationDeleteProps = {}): FetchArgs {
        return AuthentApiFp(this.configuration).authentDeleteApplicationDeleteURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentApi
     */
    public authentDeleteApplicationDelete({ options }: IauthentDeleteApplicationDeleteProps = {}) {
        return AuthentApiFp(this.configuration).authentDeleteApplicationDelete({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``authentLongLivedTokenCreate`` for arguments and options.
     *
     */
    public authentLongLivedTokenCreateURL({ options }: IauthentLongLivedTokenCreateProps = {}): FetchArgs {
        return AuthentApiFp(this.configuration).authentLongLivedTokenCreateURL({ options });
    }

    /**
     * This is an alternate authentication method to Oauth2. An authorized user can generate such tokens and then transmit it to the token owner for future use with our API.
     * @summary Implements an endpoint to generate long lived (JWT) tokens.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentApi
     */
    public authentLongLivedTokenCreate({ options }: IauthentLongLivedTokenCreateProps = {}) {
        return AuthentApiFp(this.configuration).authentLongLivedTokenCreate({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``authentLongLivedTokenDelete`` for arguments and options.
     *
     */
    public authentLongLivedTokenDeleteURL({ options }: IauthentLongLivedTokenDeleteProps = {}): FetchArgs {
        return AuthentApiFp(this.configuration).authentLongLivedTokenDeleteURL({ options });
    }

    /**
     * This is an alternate authentication method to Oauth2. An authorized user can generate such tokens and then transmit it to the token owner for future use with our API.
     * @summary Implements an endpoint to generate long lived (JWT) tokens.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentApi
     */
    public authentLongLivedTokenDelete({ options }: IauthentLongLivedTokenDeleteProps = {}) {
        return AuthentApiFp(this.configuration).authentLongLivedTokenDelete({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``authentRevokeApplicationCreate`` for arguments and options.
     *
     */
    public authentRevokeApplicationCreateURL({ options }: IauthentRevokeApplicationCreateProps = {}): FetchArgs {
        return AuthentApiFp(this.configuration).authentRevokeApplicationCreateURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentApi
     */
    public authentRevokeApplicationCreate({ options }: IauthentRevokeApplicationCreateProps = {}) {
        return AuthentApiFp(this.configuration).authentRevokeApplicationCreate({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``authentRevokeApplicationDelete`` for arguments and options.
     *
     */
    public authentRevokeApplicationDeleteURL({ options }: IauthentRevokeApplicationDeleteProps = {}): FetchArgs {
        return AuthentApiFp(this.configuration).authentRevokeApplicationDeleteURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthentApi
     */
    public authentRevokeApplicationDelete({ options }: IauthentRevokeApplicationDeleteProps = {}) {
        return AuthentApiFp(this.configuration).authentRevokeApplicationDelete({ options })(this.fetchData, this.basePath);
    }

}

/**
 * changeJurisdictionCreate parameters
 */
export interface IchangeJurisdictionCreateProps {
    options?: any,
};

/**
 * ChangeJurisdictionApi - fetch parameter creator
 * @export
 */
export const ChangeJurisdictionApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeJurisdictionCreate({ options = {} }: IchangeJurisdictionCreateProps): FetchArgs {
            const localVarPath = `/change_jurisdiction/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChangeJurisdictionApi - functional programming interface
 * @export
 */
export const ChangeJurisdictionApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        changeJurisdictionCreateURL({ options }: IchangeJurisdictionCreateProps): FetchArgs {
            return ChangeJurisdictionApiFetchParamCreator(configuration).changeJurisdictionCreate({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeJurisdictionCreate({ options }: IchangeJurisdictionCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.changeJurisdictionCreateURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * ChangeJurisdictionApi - factory interface
 * @export
 */
export const ChangeJurisdictionApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeJurisdictionCreate({ options }: IchangeJurisdictionCreateProps) {
            return ChangeJurisdictionApiFp(configuration).changeJurisdictionCreate({ options })(fetch, basePath);
        },
    };
};

/**
 * ChangeJurisdictionApi - object-oriented interface
 * @export
 * @class ChangeJurisdictionApi
 * @extends {BaseAPI}
 */
export class ChangeJurisdictionApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``changeJurisdictionCreate`` for arguments and options.
     *
     */
    public changeJurisdictionCreateURL({ options }: IchangeJurisdictionCreateProps = {}): FetchArgs {
        return ChangeJurisdictionApiFp(this.configuration).changeJurisdictionCreateURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeJurisdictionApi
     */
    public changeJurisdictionCreate({ options }: IchangeJurisdictionCreateProps = {}) {
        return ChangeJurisdictionApiFp(this.configuration).changeJurisdictionCreate({ options })(this.fetchData, this.basePath);
    }

}

/**
 * eventRecordsExport parameters
 */
export interface IeventRecordsExportProps {
    device: string,
    lang?: string,
    limit?: number,
    options?: any,
};

/**
 * eventRecordsList parameters
 */
export interface IeventRecordsListProps {
    device: string,
    lang?: string,
    limit?: number,
    options?: any,
};

/**
 * EventRecordsApi - fetch parameter creator
 * @export
 */
export const EventRecordsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} device 
         * @param {string} [lang] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventRecordsExport({ device, lang, limit, options = {} }: IeventRecordsExportProps): FetchArgs {
            // verify required parameter 'device' is not null or undefined
            if (device === null || device === undefined) {
                throw new RequiredError('device','Required parameter device was null or undefined when calling eventRecordsExport.');
            }
            const localVarPath = `/event_records/export/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (device !== undefined) {
                localVarQueryParameter['device'] = device;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} device 
         * @param {string} [lang] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventRecordsList({ device, lang, limit, options = {} }: IeventRecordsListProps): FetchArgs {
            // verify required parameter 'device' is not null or undefined
            if (device === null || device === undefined) {
                throw new RequiredError('device','Required parameter device was null or undefined when calling eventRecordsList.');
            }
            const localVarPath = `/event_records/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (device !== undefined) {
                localVarQueryParameter['device'] = device;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventRecordsApi - functional programming interface
 * @export
 */
export const EventRecordsApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        eventRecordsExportURL({ device, lang, limit, options }: IeventRecordsExportProps): FetchArgs {
            return EventRecordsApiFetchParamCreator(configuration).eventRecordsExport({ device, lang, limit, options });
        },

        /**
         * 
         * @param {string} device 
         * @param {string} [lang] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventRecordsExport({ device, lang, limit, options }: IeventRecordsExportProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<EventRecord>> {
            const localVarFetchArgs = this.eventRecordsExportURL({ device, lang, limit, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        eventRecordsListURL({ device, lang, limit, options }: IeventRecordsListProps): FetchArgs {
            return EventRecordsApiFetchParamCreator(configuration).eventRecordsList({ device, lang, limit, options });
        },

        /**
         * 
         * @param {string} device 
         * @param {string} [lang] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventRecordsList({ device, lang, limit, options }: IeventRecordsListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<EventRecord>> {
            const localVarFetchArgs = this.eventRecordsListURL({ device, lang, limit, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * EventRecordsApi - factory interface
 * @export
 */
export const EventRecordsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} device 
         * @param {string} [lang] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventRecordsExport({ device, lang, limit, options }: IeventRecordsExportProps) {
            return EventRecordsApiFp(configuration).eventRecordsExport({ device, lang, limit, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} device 
         * @param {string} [lang] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventRecordsList({ device, lang, limit, options }: IeventRecordsListProps) {
            return EventRecordsApiFp(configuration).eventRecordsList({ device, lang, limit, options })(fetch, basePath);
        },
    };
};

/**
 * EventRecordsApi - object-oriented interface
 * @export
 * @class EventRecordsApi
 * @extends {BaseAPI}
 */
export class EventRecordsApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``eventRecordsExport`` for arguments and options.
     *
     */
    public eventRecordsExportURL({ device, lang, limit, options }: IeventRecordsExportProps): FetchArgs {
        return EventRecordsApiFp(this.configuration).eventRecordsExportURL({ device, lang, limit, options });
    }

    /**
     * 
     * @param {string} device 
     * @param {string} [lang] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventRecordsApi
     */
    public eventRecordsExport({ device, lang, limit, options }: IeventRecordsExportProps) {
        return EventRecordsApiFp(this.configuration).eventRecordsExport({ device, lang, limit, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``eventRecordsList`` for arguments and options.
     *
     */
    public eventRecordsListURL({ device, lang, limit, options }: IeventRecordsListProps): FetchArgs {
        return EventRecordsApiFp(this.configuration).eventRecordsListURL({ device, lang, limit, options });
    }

    /**
     * 
     * @param {string} device 
     * @param {string} [lang] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventRecordsApi
     */
    public eventRecordsList({ device, lang, limit, options }: IeventRecordsListProps) {
        return EventRecordsApiFp(this.configuration).eventRecordsList({ device, lang, limit, options })(this.fetchData, this.basePath);
    }

}

/**
 * feesExport parameters
 */
export interface IfeesExportProps {
    areas_id?: Array<string>, // 
    provider_ids?: Array<string>, // 
    policy_ids?: Array<string>, // 
    policy_kinds?: Array<'permit' | 'trip_taxation' | 'vehicle_deployment'>, // 
    policy_state?: Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>, // 
    policy_start_date?: string, // 
    policy_end_date?: string, // 
    tz?: string, // 
    lang?: string, // 
    options?: any,
};

/**
 * feesList parameters
 */
export interface IfeesListProps {
    areas_id?: Array<string>, // 
    provider_ids?: Array<string>, // 
    policy_ids?: Array<string>, // 
    policy_kinds?: Array<'permit' | 'trip_taxation' | 'vehicle_deployment'>, // 
    policy_state?: Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>, // 
    policy_start_date?: string, // 
    policy_end_date?: string, // 
    tz?: string, // 
    lang?: string, // 
    options?: any,
};

/**
 * feesRead parameters
 */
export interface IfeesReadProps {
    uid: string, // A UUID string identifying this fee.
    options?: any,
};

/**
 * FeesApi - fetch parameter creator
 * @export
 */
export const FeesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} [areas_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'permit' | 'trip_taxation' | 'vehicle_deployment'>} [policy_kinds] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [policy_state] 
         * @param {string} [policy_start_date] 
         * @param {string} [policy_end_date] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feesExport({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options = {} }: IfeesExportProps): FetchArgs {
            const localVarPath = `/fees/export/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (areas_id) {
                localVarQueryParameter['areas_id'] = areas_id;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (policy_ids) {
                localVarQueryParameter['policy_ids'] = policy_ids;
            }

            if (policy_kinds) {
                localVarQueryParameter['policy_kinds'] = policy_kinds;
            }

            if (policy_state) {
                localVarQueryParameter['policy_state'] = policy_state;
            }

            if (policy_start_date !== undefined) {
                localVarQueryParameter['policy_start_date'] = policy_start_date;
            }

            if (policy_end_date !== undefined) {
                localVarQueryParameter['policy_end_date'] = policy_end_date;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [areas_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'permit' | 'trip_taxation' | 'vehicle_deployment'>} [policy_kinds] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [policy_state] 
         * @param {string} [policy_start_date] 
         * @param {string} [policy_end_date] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feesList({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options = {} }: IfeesListProps): FetchArgs {
            const localVarPath = `/fees/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (areas_id) {
                localVarQueryParameter['areas_id'] = areas_id;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (policy_ids) {
                localVarQueryParameter['policy_ids'] = policy_ids;
            }

            if (policy_kinds) {
                localVarQueryParameter['policy_kinds'] = policy_kinds;
            }

            if (policy_state) {
                localVarQueryParameter['policy_state'] = policy_state;
            }

            if (policy_start_date !== undefined) {
                localVarQueryParameter['policy_start_date'] = policy_start_date;
            }

            if (policy_end_date !== undefined) {
                localVarQueryParameter['policy_end_date'] = policy_end_date;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uid A UUID string identifying this fee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feesRead({ uid, options = {} }: IfeesReadProps): FetchArgs {
            // verify required parameter 'uid' is not null or undefined
            if (uid === null || uid === undefined) {
                throw new RequiredError('uid','Required parameter uid was null or undefined when calling feesRead.');
            }
            const localVarPath = `/fees/{uid}/`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeesApi - functional programming interface
 * @export
 */
export const FeesApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        feesExportURL({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options }: IfeesExportProps): FetchArgs {
            return FeesApiFetchParamCreator(configuration).feesExport({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options });
        },

        /**
         * 
         * @param {Array<string>} [areas_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'permit' | 'trip_taxation' | 'vehicle_deployment'>} [policy_kinds] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [policy_state] 
         * @param {string} [policy_start_date] 
         * @param {string} [policy_end_date] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feesExport({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options }: IfeesExportProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Fees>> {
            const localVarFetchArgs = this.feesExportURL({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        feesListURL({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options }: IfeesListProps): FetchArgs {
            return FeesApiFetchParamCreator(configuration).feesList({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options });
        },

        /**
         * 
         * @param {Array<string>} [areas_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'permit' | 'trip_taxation' | 'vehicle_deployment'>} [policy_kinds] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [policy_state] 
         * @param {string} [policy_start_date] 
         * @param {string} [policy_end_date] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feesList({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options }: IfeesListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Fees>> {
            const localVarFetchArgs = this.feesListURL({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        feesReadURL({ uid, options }: IfeesReadProps): FetchArgs {
            return FeesApiFetchParamCreator(configuration).feesRead({ uid, options });
        },

        /**
         * 
         * @param {string} uid A UUID string identifying this fee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feesRead({ uid, options }: IfeesReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<Fees> {
            const localVarFetchArgs = this.feesReadURL({ uid, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * FeesApi - factory interface
 * @export
 */
export const FeesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {Array<string>} [areas_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'permit' | 'trip_taxation' | 'vehicle_deployment'>} [policy_kinds] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [policy_state] 
         * @param {string} [policy_start_date] 
         * @param {string} [policy_end_date] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feesExport({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options }: IfeesExportProps) {
            return FeesApiFp(configuration).feesExport({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options })(fetch, basePath);
        },
        /**
         * 
         * @param {Array<string>} [areas_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'permit' | 'trip_taxation' | 'vehicle_deployment'>} [policy_kinds] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [policy_state] 
         * @param {string} [policy_start_date] 
         * @param {string} [policy_end_date] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feesList({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options }: IfeesListProps) {
            return FeesApiFp(configuration).feesList({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} uid A UUID string identifying this fee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feesRead({ uid, options }: IfeesReadProps) {
            return FeesApiFp(configuration).feesRead({ uid, options })(fetch, basePath);
        },
    };
};

/**
 * FeesApi - object-oriented interface
 * @export
 * @class FeesApi
 * @extends {BaseAPI}
 */
export class FeesApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``feesExport`` for arguments and options.
     *
     */
    public feesExportURL({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options }: IfeesExportProps = {}): FetchArgs {
        return FeesApiFp(this.configuration).feesExportURL({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options });
    }

    /**
     * 
     * @param {Array<string>} [areas_id] 
     * @param {Array<string>} [provider_ids] 
     * @param {Array<string>} [policy_ids] 
     * @param {Array<'permit' | 'trip_taxation' | 'vehicle_deployment'>} [policy_kinds] 
     * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [policy_state] 
     * @param {string} [policy_start_date] 
     * @param {string} [policy_end_date] 
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeesApi
     */
    public feesExport({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options }: IfeesExportProps = {}) {
        return FeesApiFp(this.configuration).feesExport({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``feesList`` for arguments and options.
     *
     */
    public feesListURL({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options }: IfeesListProps = {}): FetchArgs {
        return FeesApiFp(this.configuration).feesListURL({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options });
    }

    /**
     * 
     * @param {Array<string>} [areas_id] 
     * @param {Array<string>} [provider_ids] 
     * @param {Array<string>} [policy_ids] 
     * @param {Array<'permit' | 'trip_taxation' | 'vehicle_deployment'>} [policy_kinds] 
     * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [policy_state] 
     * @param {string} [policy_start_date] 
     * @param {string} [policy_end_date] 
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeesApi
     */
    public feesList({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options }: IfeesListProps = {}) {
        return FeesApiFp(this.configuration).feesList({ areas_id, provider_ids, policy_ids, policy_kinds, policy_state, policy_start_date, policy_end_date, tz, lang, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``feesRead`` for arguments and options.
     *
     */
    public feesReadURL({ uid, options }: IfeesReadProps): FetchArgs {
        return FeesApiFp(this.configuration).feesReadURL({ uid, options });
    }

    /**
     * 
     * @param {string} uid A UUID string identifying this fee.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeesApi
     */
    public feesRead({ uid, options }: IfeesReadProps) {
        return FeesApiFp(this.configuration).feesRead({ uid, options })(this.fetchData, this.basePath);
    }

}

/**
 * gbfsDataList parameters
 */
export interface IgbfsDataListProps {
    options?: any,
};

/**
 * GbfsDataApi - fetch parameter creator
 * @export
 */
export const GbfsDataApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gbfsDataList({ options = {} }: IgbfsDataListProps): FetchArgs {
            const localVarPath = `/gbfs_data`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GbfsDataApi - functional programming interface
 * @export
 */
export const GbfsDataApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        gbfsDataListURL({ options }: IgbfsDataListProps): FetchArgs {
            return GbfsDataApiFetchParamCreator(configuration).gbfsDataList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gbfsDataList({ options }: IgbfsDataListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.gbfsDataListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * GbfsDataApi - factory interface
 * @export
 */
export const GbfsDataApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gbfsDataList({ options }: IgbfsDataListProps) {
            return GbfsDataApiFp(configuration).gbfsDataList({ options })(fetch, basePath);
        },
    };
};

/**
 * GbfsDataApi - object-oriented interface
 * @export
 * @class GbfsDataApi
 * @extends {BaseAPI}
 */
export class GbfsDataApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``gbfsDataList`` for arguments and options.
     *
     */
    public gbfsDataListURL({ options }: IgbfsDataListProps = {}): FetchArgs {
        return GbfsDataApiFp(this.configuration).gbfsDataListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GbfsDataApi
     */
    public gbfsDataList({ options }: IgbfsDataListProps = {}) {
        return GbfsDataApiFp(this.configuration).gbfsDataList({ options })(this.fetchData, this.basePath);
    }

}

/**
 * getParkingBayInfosList parameters
 */
export interface IgetParkingBayInfosListProps {
    options?: any,
};

/**
 * GetParkingBayInfosApi - fetch parameter creator
 * @export
 */
export const GetParkingBayInfosApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkingBayInfosList({ options = {} }: IgetParkingBayInfosListProps): FetchArgs {
            const localVarPath = `/get_parking_bay_infos/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetParkingBayInfosApi - functional programming interface
 * @export
 */
export const GetParkingBayInfosApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        getParkingBayInfosListURL({ options }: IgetParkingBayInfosListProps): FetchArgs {
            return GetParkingBayInfosApiFetchParamCreator(configuration).getParkingBayInfosList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkingBayInfosList({ options }: IgetParkingBayInfosListProps): (fetch?: FetchAPI, basePath?: string) => Promise<ParkingBayInfo> {
            const localVarFetchArgs = this.getParkingBayInfosListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * GetParkingBayInfosApi - factory interface
 * @export
 */
export const GetParkingBayInfosApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkingBayInfosList({ options }: IgetParkingBayInfosListProps) {
            return GetParkingBayInfosApiFp(configuration).getParkingBayInfosList({ options })(fetch, basePath);
        },
    };
};

/**
 * GetParkingBayInfosApi - object-oriented interface
 * @export
 * @class GetParkingBayInfosApi
 * @extends {BaseAPI}
 */
export class GetParkingBayInfosApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``getParkingBayInfosList`` for arguments and options.
     *
     */
    public getParkingBayInfosListURL({ options }: IgetParkingBayInfosListProps = {}): FetchArgs {
        return GetParkingBayInfosApiFp(this.configuration).getParkingBayInfosListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetParkingBayInfosApi
     */
    public getParkingBayInfosList({ options }: IgetParkingBayInfosListProps = {}) {
        return GetParkingBayInfosApiFp(this.configuration).getParkingBayInfosList({ options })(this.fetchData, this.basePath);
    }

}

/**
 * graphAnomaliesPerProvider parameters
 */
export interface IgraphAnomaliesPerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphAnomaliesPerType parameters
 */
export interface IgraphAnomaliesPerTypeProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphAnomaliesRatePerProvider parameters
 */
export interface IgraphAnomaliesRatePerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphAverageDeploymentDurationPerZone parameters
 */
export interface IgraphAverageDeploymentDurationPerZoneProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphAverageFleetSizePerProvider parameters
 */
export interface IgraphAverageFleetSizePerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphAverageFleetSizePerProviderOnRange parameters
 */
export interface IgraphAverageFleetSizePerProviderOnRangeProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphDevicesDeployedPerProvider parameters
 */
export interface IgraphDevicesDeployedPerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphDevicesPerStatus parameters
 */
export interface IgraphDevicesPerStatusProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphEnergyConsumptionPerProvider parameters
 */
export interface IgraphEnergyConsumptionPerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphFleetAvailability parameters
 */
export interface IgraphFleetAvailabilityProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphGazEmissionCompareToAlternateVehicle parameters
 */
export interface IgraphGazEmissionCompareToAlternateVehicleProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphGazEmissionPerProvider parameters
 */
export interface IgraphGazEmissionPerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphLatencyHistogram parameters
 */
export interface IgraphLatencyHistogramProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphLatencyPerProvider parameters
 */
export interface IgraphLatencyPerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphNumberOfNewUsers parameters
 */
export interface IgraphNumberOfNewUsersProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphNumberOfNewUsersPerProvider parameters
 */
export interface IgraphNumberOfNewUsersPerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphNumberOfTrips parameters
 */
export interface IgraphNumberOfTripsProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphNumberOfTripsPerProvider parameters
 */
export interface IgraphNumberOfTripsPerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphNumberOfTripsPerVehicle parameters
 */
export interface IgraphNumberOfTripsPerVehicleProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphNumberOfTripsPerZone parameters
 */
export interface IgraphNumberOfTripsPerZoneProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphNumberOfUniqueUsers parameters
 */
export interface IgraphNumberOfUniqueUsersProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphNumberOfUniqueUsersPerProvider parameters
 */
export interface IgraphNumberOfUniqueUsersPerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphNumberOfUsersPerTripPerformed parameters
 */
export interface IgraphNumberOfUsersPerTripPerformedProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphOffensePricePerProviderPerDate parameters
 */
export interface IgraphOffensePricePerProviderPerDateProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphOffensesPerKind parameters
 */
export interface IgraphOffensesPerKindProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphOffensesPerProviderPerDate parameters
 */
export interface IgraphOffensesPerProviderPerDateProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphPercentDevicesDeployedPerZone parameters
 */
export interface IgraphPercentDevicesDeployedPerZoneProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphPercentDevicesDeployedPerZonePerProvider parameters
 */
export interface IgraphPercentDevicesDeployedPerZonePerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphPercentageOfOffensesPerKind parameters
 */
export interface IgraphPercentageOfOffensesPerKindProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphPercentageOfTripsCloseToPublicTransports parameters
 */
export interface IgraphPercentageOfTripsCloseToPublicTransportsProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphPercentageOfTripsPerProvider parameters
 */
export interface IgraphPercentageOfTripsPerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphRatioOfTripsPerVehiclePerProvider parameters
 */
export interface IgraphRatioOfTripsPerVehiclePerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphTotalDistance parameters
 */
export interface IgraphTotalDistanceProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphTotalDistancePerProvider parameters
 */
export interface IgraphTotalDistancePerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphTripFlows parameters
 */
export interface IgraphTripFlowsProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphTripsDistribution parameters
 */
export interface IgraphTripsDistributionProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphTripsDuration parameters
 */
export interface IgraphTripsDurationProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphUtilizationRate parameters
 */
export interface IgraphUtilizationRateProps {
    data: GraphFilters,
    options?: any,
};

/**
 * graphUtilizationRatePerProvider parameters
 */
export interface IgraphUtilizationRatePerProviderProps {
    data: GraphFilters,
    options?: any,
};

/**
 * reportGraphList parameters
 */
export interface IreportGraphListProps {
    report_id: string,
    options?: any,
};

/**
 * GraphsApi - fetch parameter creator
 * @export
 */
export const GraphsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAnomaliesPerProvider({ data, options = {} }: IgraphAnomaliesPerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphAnomaliesPerProvider.');
            }
            const localVarPath = `/graphs/anomalies-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAnomaliesPerType({ data, options = {} }: IgraphAnomaliesPerTypeProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphAnomaliesPerType.');
            }
            const localVarPath = `/graphs/anomalies-per-type/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAnomaliesRatePerProvider({ data, options = {} }: IgraphAnomaliesRatePerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphAnomaliesRatePerProvider.');
            }
            const localVarPath = `/graphs/anomalies-rate-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAverageDeploymentDurationPerZone({ data, options = {} }: IgraphAverageDeploymentDurationPerZoneProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphAverageDeploymentDurationPerZone.');
            }
            const localVarPath = `/graphs/device-duration-per-zone/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAverageFleetSizePerProvider({ data, options = {} }: IgraphAverageFleetSizePerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphAverageFleetSizePerProvider.');
            }
            const localVarPath = `/graphs/average-fleet-size-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAverageFleetSizePerProviderOnRange({ data, options = {} }: IgraphAverageFleetSizePerProviderOnRangeProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphAverageFleetSizePerProviderOnRange.');
            }
            const localVarPath = `/graphs/average-fleet-size-per-provider-on-range/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphDevicesDeployedPerProvider({ data, options = {} }: IgraphDevicesDeployedPerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphDevicesDeployedPerProvider.');
            }
            const localVarPath = `/graphs/devices-deployed-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphDevicesPerStatus({ data, options = {} }: IgraphDevicesPerStatusProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphDevicesPerStatus.');
            }
            const localVarPath = `/graphs/devices-per-status/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphEnergyConsumptionPerProvider({ data, options = {} }: IgraphEnergyConsumptionPerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphEnergyConsumptionPerProvider.');
            }
            const localVarPath = `/graphs/energy-consumption-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphFleetAvailability({ data, options = {} }: IgraphFleetAvailabilityProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphFleetAvailability.');
            }
            const localVarPath = `/graphs/fleet-availability/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphGazEmissionCompareToAlternateVehicle({ data, options = {} }: IgraphGazEmissionCompareToAlternateVehicleProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphGazEmissionCompareToAlternateVehicle.');
            }
            const localVarPath = `/graphs/gaz-emission-per-compare-to-alternate-vehicle/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphGazEmissionPerProvider({ data, options = {} }: IgraphGazEmissionPerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphGazEmissionPerProvider.');
            }
            const localVarPath = `/graphs/gaz-emission-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphLatencyHistogram({ data, options = {} }: IgraphLatencyHistogramProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphLatencyHistogram.');
            }
            const localVarPath = `/graphs/latency-histogram/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphLatencyPerProvider({ data, options = {} }: IgraphLatencyPerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphLatencyPerProvider.');
            }
            const localVarPath = `/graphs/latency-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfNewUsers({ data, options = {} }: IgraphNumberOfNewUsersProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphNumberOfNewUsers.');
            }
            const localVarPath = `/graphs/number-of-new-users/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfNewUsersPerProvider({ data, options = {} }: IgraphNumberOfNewUsersPerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphNumberOfNewUsersPerProvider.');
            }
            const localVarPath = `/graphs/number-of-new-users-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTrips({ data, options = {} }: IgraphNumberOfTripsProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphNumberOfTrips.');
            }
            const localVarPath = `/graphs/number-of-trips/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTripsPerProvider({ data, options = {} }: IgraphNumberOfTripsPerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphNumberOfTripsPerProvider.');
            }
            const localVarPath = `/graphs/number-of-trips-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTripsPerVehicle({ data, options = {} }: IgraphNumberOfTripsPerVehicleProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphNumberOfTripsPerVehicle.');
            }
            const localVarPath = `/graphs/numer-of-trips-per-vehicle/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTripsPerZone({ data, options = {} }: IgraphNumberOfTripsPerZoneProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphNumberOfTripsPerZone.');
            }
            const localVarPath = `/graphs/number-of-trips-per-zone/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfUniqueUsers({ data, options = {} }: IgraphNumberOfUniqueUsersProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphNumberOfUniqueUsers.');
            }
            const localVarPath = `/graphs/number-of-unique-users/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfUniqueUsersPerProvider({ data, options = {} }: IgraphNumberOfUniqueUsersPerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphNumberOfUniqueUsersPerProvider.');
            }
            const localVarPath = `/graphs/number-of-unique-users-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfUsersPerTripPerformed({ data, options = {} }: IgraphNumberOfUsersPerTripPerformedProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphNumberOfUsersPerTripPerformed.');
            }
            const localVarPath = `/graphs/number-of-users-per-trip-performed/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphOffensePricePerProviderPerDate({ data, options = {} }: IgraphOffensePricePerProviderPerDateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphOffensePricePerProviderPerDate.');
            }
            const localVarPath = `/graphs/offense-price-per-provider-per-date/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphOffensesPerKind({ data, options = {} }: IgraphOffensesPerKindProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphOffensesPerKind.');
            }
            const localVarPath = `/graphs/offenses-per-kind/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphOffensesPerProviderPerDate({ data, options = {} }: IgraphOffensesPerProviderPerDateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphOffensesPerProviderPerDate.');
            }
            const localVarPath = `/graphs/offenses-per-provider-per-date/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentDevicesDeployedPerZone({ data, options = {} }: IgraphPercentDevicesDeployedPerZoneProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphPercentDevicesDeployedPerZone.');
            }
            const localVarPath = `/graphs/percent-devices-deployed-per-zone/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentDevicesDeployedPerZonePerProvider({ data, options = {} }: IgraphPercentDevicesDeployedPerZonePerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphPercentDevicesDeployedPerZonePerProvider.');
            }
            const localVarPath = `/graphs/percent-devices-deployed-per-zone-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentageOfOffensesPerKind({ data, options = {} }: IgraphPercentageOfOffensesPerKindProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphPercentageOfOffensesPerKind.');
            }
            const localVarPath = `/graphs/percentage-of-offenses-per-kind/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentageOfTripsCloseToPublicTransports({ data, options = {} }: IgraphPercentageOfTripsCloseToPublicTransportsProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphPercentageOfTripsCloseToPublicTransports.');
            }
            const localVarPath = `/graphs/percenrage-of-trips-close-to-stops/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentageOfTripsPerProvider({ data, options = {} }: IgraphPercentageOfTripsPerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphPercentageOfTripsPerProvider.');
            }
            const localVarPath = `/graphs/percentage-of-trips-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphRatioOfTripsPerVehiclePerProvider({ data, options = {} }: IgraphRatioOfTripsPerVehiclePerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphRatioOfTripsPerVehiclePerProvider.');
            }
            const localVarPath = `/graphs/ratio-of-trips-per-vehicle-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTotalDistance({ data, options = {} }: IgraphTotalDistanceProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphTotalDistance.');
            }
            const localVarPath = `/graphs/total-distance/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTotalDistancePerProvider({ data, options = {} }: IgraphTotalDistancePerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphTotalDistancePerProvider.');
            }
            const localVarPath = `/graphs/total-distance-per-provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTripFlows({ data, options = {} }: IgraphTripFlowsProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphTripFlows.');
            }
            const localVarPath = `/graphs/trips-flows/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTripsDistribution({ data, options = {} }: IgraphTripsDistributionProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphTripsDistribution.');
            }
            const localVarPath = `/graphs/trips-distribution/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTripsDuration({ data, options = {} }: IgraphTripsDurationProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphTripsDuration.');
            }
            const localVarPath = `/graphs/trips-duration/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphUtilizationRate({ data, options = {} }: IgraphUtilizationRateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphUtilizationRate.');
            }
            const localVarPath = `/graphs/utilization_rate/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphUtilizationRatePerProvider({ data, options = {} }: IgraphUtilizationRatePerProviderProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling graphUtilizationRatePerProvider.');
            }
            const localVarPath = `/graphs/utilization_rate_per_provider/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"GraphFilters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} report_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGraphList({ report_id, options = {} }: IreportGraphListProps): FetchArgs {
            // verify required parameter 'report_id' is not null or undefined
            if (report_id === null || report_id === undefined) {
                throw new RequiredError('report_id','Required parameter report_id was null or undefined when calling reportGraphList.');
            }
            const localVarPath = `/graphs/report-graph-list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (report_id !== undefined) {
                localVarQueryParameter['report_id'] = report_id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GraphsApi - functional programming interface
 * @export
 */
export const GraphsApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        graphAnomaliesPerProviderURL({ data, options }: IgraphAnomaliesPerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphAnomaliesPerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAnomaliesPerProvider({ data, options }: IgraphAnomaliesPerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphAnomaliesPerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphAnomaliesPerTypeURL({ data, options }: IgraphAnomaliesPerTypeProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphAnomaliesPerType({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAnomaliesPerType({ data, options }: IgraphAnomaliesPerTypeProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphStackResponse>> {
            const localVarFetchArgs = this.graphAnomaliesPerTypeURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphAnomaliesRatePerProviderURL({ data, options }: IgraphAnomaliesRatePerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphAnomaliesRatePerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAnomaliesRatePerProvider({ data, options }: IgraphAnomaliesRatePerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphAnomaliesRatePerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphAverageDeploymentDurationPerZoneURL({ data, options }: IgraphAverageDeploymentDurationPerZoneProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphAverageDeploymentDurationPerZone({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAverageDeploymentDurationPerZone({ data, options }: IgraphAverageDeploymentDurationPerZoneProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphData> {
            const localVarFetchArgs = this.graphAverageDeploymentDurationPerZoneURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphAverageFleetSizePerProviderURL({ data, options }: IgraphAverageFleetSizePerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphAverageFleetSizePerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAverageFleetSizePerProvider({ data, options }: IgraphAverageFleetSizePerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphAverageFleetSizePerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphAverageFleetSizePerProviderOnRangeURL({ data, options }: IgraphAverageFleetSizePerProviderOnRangeProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphAverageFleetSizePerProviderOnRange({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAverageFleetSizePerProviderOnRange({ data, options }: IgraphAverageFleetSizePerProviderOnRangeProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphBucket>> {
            const localVarFetchArgs = this.graphAverageFleetSizePerProviderOnRangeURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphDevicesDeployedPerProviderURL({ data, options }: IgraphDevicesDeployedPerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphDevicesDeployedPerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphDevicesDeployedPerProvider({ data, options }: IgraphDevicesDeployedPerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphDevicesDeployedPerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphDevicesPerStatusURL({ data, options }: IgraphDevicesPerStatusProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphDevicesPerStatus({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphDevicesPerStatus({ data, options }: IgraphDevicesPerStatusProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphStackResponse>> {
            const localVarFetchArgs = this.graphDevicesPerStatusURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphEnergyConsumptionPerProviderURL({ data, options }: IgraphEnergyConsumptionPerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphEnergyConsumptionPerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphEnergyConsumptionPerProvider({ data, options }: IgraphEnergyConsumptionPerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphEnergyConsumptionPerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphFleetAvailabilityURL({ data, options }: IgraphFleetAvailabilityProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphFleetAvailability({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphFleetAvailability({ data, options }: IgraphFleetAvailabilityProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphBucketResponse>> {
            const localVarFetchArgs = this.graphFleetAvailabilityURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphGazEmissionCompareToAlternateVehicleURL({ data, options }: IgraphGazEmissionCompareToAlternateVehicleProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphGazEmissionCompareToAlternateVehicle({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphGazEmissionCompareToAlternateVehicle({ data, options }: IgraphGazEmissionCompareToAlternateVehicleProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphGazEmissionCompareToAlternateVehicleURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphGazEmissionPerProviderURL({ data, options }: IgraphGazEmissionPerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphGazEmissionPerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphGazEmissionPerProvider({ data, options }: IgraphGazEmissionPerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphCompareWithTotalResponse> {
            const localVarFetchArgs = this.graphGazEmissionPerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphLatencyHistogramURL({ data, options }: IgraphLatencyHistogramProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphLatencyHistogram({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphLatencyHistogram({ data, options }: IgraphLatencyHistogramProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphBucket>> {
            const localVarFetchArgs = this.graphLatencyHistogramURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphLatencyPerProviderURL({ data, options }: IgraphLatencyPerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphLatencyPerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphLatencyPerProvider({ data, options }: IgraphLatencyPerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphLatencyPerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphNumberOfNewUsersURL({ data, options }: IgraphNumberOfNewUsersProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphNumberOfNewUsers({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfNewUsers({ data, options }: IgraphNumberOfNewUsersProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphBucketWithTotalResponse> {
            const localVarFetchArgs = this.graphNumberOfNewUsersURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphNumberOfNewUsersPerProviderURL({ data, options }: IgraphNumberOfNewUsersPerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphNumberOfNewUsersPerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfNewUsersPerProvider({ data, options }: IgraphNumberOfNewUsersPerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphCompareWithTotalResponse> {
            const localVarFetchArgs = this.graphNumberOfNewUsersPerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphNumberOfTripsURL({ data, options }: IgraphNumberOfTripsProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphNumberOfTrips({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTrips({ data, options }: IgraphNumberOfTripsProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphBucketWithTotalResponse> {
            const localVarFetchArgs = this.graphNumberOfTripsURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphNumberOfTripsPerProviderURL({ data, options }: IgraphNumberOfTripsPerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphNumberOfTripsPerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTripsPerProvider({ data, options }: IgraphNumberOfTripsPerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphCompareWithTotalResponse> {
            const localVarFetchArgs = this.graphNumberOfTripsPerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphNumberOfTripsPerVehicleURL({ data, options }: IgraphNumberOfTripsPerVehicleProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphNumberOfTripsPerVehicle({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTripsPerVehicle({ data, options }: IgraphNumberOfTripsPerVehicleProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphStackResponse>> {
            const localVarFetchArgs = this.graphNumberOfTripsPerVehicleURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphNumberOfTripsPerZoneURL({ data, options }: IgraphNumberOfTripsPerZoneProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphNumberOfTripsPerZone({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTripsPerZone({ data, options }: IgraphNumberOfTripsPerZoneProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphData> {
            const localVarFetchArgs = this.graphNumberOfTripsPerZoneURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphNumberOfUniqueUsersURL({ data, options }: IgraphNumberOfUniqueUsersProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphNumberOfUniqueUsers({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfUniqueUsers({ data, options }: IgraphNumberOfUniqueUsersProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphBucketWithTotalResponse> {
            const localVarFetchArgs = this.graphNumberOfUniqueUsersURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphNumberOfUniqueUsersPerProviderURL({ data, options }: IgraphNumberOfUniqueUsersPerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphNumberOfUniqueUsersPerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfUniqueUsersPerProvider({ data, options }: IgraphNumberOfUniqueUsersPerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphCompareWithTotalResponse> {
            const localVarFetchArgs = this.graphNumberOfUniqueUsersPerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphNumberOfUsersPerTripPerformedURL({ data, options }: IgraphNumberOfUsersPerTripPerformedProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphNumberOfUsersPerTripPerformed({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfUsersPerTripPerformed({ data, options }: IgraphNumberOfUsersPerTripPerformedProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphStackResponse>> {
            const localVarFetchArgs = this.graphNumberOfUsersPerTripPerformedURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphOffensePricePerProviderPerDateURL({ data, options }: IgraphOffensePricePerProviderPerDateProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphOffensePricePerProviderPerDate({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphOffensePricePerProviderPerDate({ data, options }: IgraphOffensePricePerProviderPerDateProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphData> {
            const localVarFetchArgs = this.graphOffensePricePerProviderPerDateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphOffensesPerKindURL({ data, options }: IgraphOffensesPerKindProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphOffensesPerKind({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphOffensesPerKind({ data, options }: IgraphOffensesPerKindProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphStackResponse>> {
            const localVarFetchArgs = this.graphOffensesPerKindURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphOffensesPerProviderPerDateURL({ data, options }: IgraphOffensesPerProviderPerDateProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphOffensesPerProviderPerDate({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphOffensesPerProviderPerDate({ data, options }: IgraphOffensesPerProviderPerDateProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphData> {
            const localVarFetchArgs = this.graphOffensesPerProviderPerDateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphPercentDevicesDeployedPerZoneURL({ data, options }: IgraphPercentDevicesDeployedPerZoneProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphPercentDevicesDeployedPerZone({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentDevicesDeployedPerZone({ data, options }: IgraphPercentDevicesDeployedPerZoneProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphPercentDevicesDeployedPerZoneURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphPercentDevicesDeployedPerZonePerProviderURL({ data, options }: IgraphPercentDevicesDeployedPerZonePerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphPercentDevicesDeployedPerZonePerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentDevicesDeployedPerZonePerProvider({ data, options }: IgraphPercentDevicesDeployedPerZonePerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphPercentDevicesDeployedPerZonePerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphPercentageOfOffensesPerKindURL({ data, options }: IgraphPercentageOfOffensesPerKindProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphPercentageOfOffensesPerKind({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentageOfOffensesPerKind({ data, options }: IgraphPercentageOfOffensesPerKindProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphStackResponse>> {
            const localVarFetchArgs = this.graphPercentageOfOffensesPerKindURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphPercentageOfTripsCloseToPublicTransportsURL({ data, options }: IgraphPercentageOfTripsCloseToPublicTransportsProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphPercentageOfTripsCloseToPublicTransports({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentageOfTripsCloseToPublicTransports({ data, options }: IgraphPercentageOfTripsCloseToPublicTransportsProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphPercentageOfTripsCloseToPublicTransportsURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphPercentageOfTripsPerProviderURL({ data, options }: IgraphPercentageOfTripsPerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphPercentageOfTripsPerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentageOfTripsPerProvider({ data, options }: IgraphPercentageOfTripsPerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphStackResponse>> {
            const localVarFetchArgs = this.graphPercentageOfTripsPerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphRatioOfTripsPerVehiclePerProviderURL({ data, options }: IgraphRatioOfTripsPerVehiclePerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphRatioOfTripsPerVehiclePerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphRatioOfTripsPerVehiclePerProvider({ data, options }: IgraphRatioOfTripsPerVehiclePerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphRatioOfTripsPerVehiclePerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphTotalDistanceURL({ data, options }: IgraphTotalDistanceProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphTotalDistance({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTotalDistance({ data, options }: IgraphTotalDistanceProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphBucketWithTotalResponse> {
            const localVarFetchArgs = this.graphTotalDistanceURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphTotalDistancePerProviderURL({ data, options }: IgraphTotalDistancePerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphTotalDistancePerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTotalDistancePerProvider({ data, options }: IgraphTotalDistancePerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphCompareWithTotalResponse> {
            const localVarFetchArgs = this.graphTotalDistancePerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphTripFlowsURL({ data, options }: IgraphTripFlowsProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphTripFlows({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTripFlows({ data, options }: IgraphTripFlowsProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphFlowsResponse> {
            const localVarFetchArgs = this.graphTripFlowsURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphTripsDistributionURL({ data, options }: IgraphTripsDistributionProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphTripsDistribution({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTripsDistribution({ data, options }: IgraphTripsDistributionProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphStackWithAverageResponse> {
            const localVarFetchArgs = this.graphTripsDistributionURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphTripsDurationURL({ data, options }: IgraphTripsDurationProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphTripsDuration({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTripsDuration({ data, options }: IgraphTripsDurationProps): (fetch?: FetchAPI, basePath?: string) => Promise<GraphStackWithAverageResponse> {
            const localVarFetchArgs = this.graphTripsDurationURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphUtilizationRateURL({ data, options }: IgraphUtilizationRateProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphUtilizationRate({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphUtilizationRate({ data, options }: IgraphUtilizationRateProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphBucketResponse>> {
            const localVarFetchArgs = this.graphUtilizationRateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        graphUtilizationRatePerProviderURL({ data, options }: IgraphUtilizationRatePerProviderProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).graphUtilizationRatePerProvider({ data, options });
        },

        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphUtilizationRatePerProvider({ data, options }: IgraphUtilizationRatePerProviderProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphCompareResponse>> {
            const localVarFetchArgs = this.graphUtilizationRatePerProviderURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        reportGraphListURL({ report_id, options }: IreportGraphListProps): FetchArgs {
            return GraphsApiFetchParamCreator(configuration).reportGraphList({ report_id, options });
        },

        /**
         * 
         * @param {string} report_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGraphList({ report_id, options }: IreportGraphListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<GraphReport>> {
            const localVarFetchArgs = this.reportGraphListURL({ report_id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * GraphsApi - factory interface
 * @export
 */
export const GraphsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAnomaliesPerProvider({ data, options }: IgraphAnomaliesPerProviderProps) {
            return GraphsApiFp(configuration).graphAnomaliesPerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAnomaliesPerType({ data, options }: IgraphAnomaliesPerTypeProps) {
            return GraphsApiFp(configuration).graphAnomaliesPerType({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAnomaliesRatePerProvider({ data, options }: IgraphAnomaliesRatePerProviderProps) {
            return GraphsApiFp(configuration).graphAnomaliesRatePerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAverageDeploymentDurationPerZone({ data, options }: IgraphAverageDeploymentDurationPerZoneProps) {
            return GraphsApiFp(configuration).graphAverageDeploymentDurationPerZone({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAverageFleetSizePerProvider({ data, options }: IgraphAverageFleetSizePerProviderProps) {
            return GraphsApiFp(configuration).graphAverageFleetSizePerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphAverageFleetSizePerProviderOnRange({ data, options }: IgraphAverageFleetSizePerProviderOnRangeProps) {
            return GraphsApiFp(configuration).graphAverageFleetSizePerProviderOnRange({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphDevicesDeployedPerProvider({ data, options }: IgraphDevicesDeployedPerProviderProps) {
            return GraphsApiFp(configuration).graphDevicesDeployedPerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphDevicesPerStatus({ data, options }: IgraphDevicesPerStatusProps) {
            return GraphsApiFp(configuration).graphDevicesPerStatus({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphEnergyConsumptionPerProvider({ data, options }: IgraphEnergyConsumptionPerProviderProps) {
            return GraphsApiFp(configuration).graphEnergyConsumptionPerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphFleetAvailability({ data, options }: IgraphFleetAvailabilityProps) {
            return GraphsApiFp(configuration).graphFleetAvailability({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphGazEmissionCompareToAlternateVehicle({ data, options }: IgraphGazEmissionCompareToAlternateVehicleProps) {
            return GraphsApiFp(configuration).graphGazEmissionCompareToAlternateVehicle({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphGazEmissionPerProvider({ data, options }: IgraphGazEmissionPerProviderProps) {
            return GraphsApiFp(configuration).graphGazEmissionPerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphLatencyHistogram({ data, options }: IgraphLatencyHistogramProps) {
            return GraphsApiFp(configuration).graphLatencyHistogram({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphLatencyPerProvider({ data, options }: IgraphLatencyPerProviderProps) {
            return GraphsApiFp(configuration).graphLatencyPerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfNewUsers({ data, options }: IgraphNumberOfNewUsersProps) {
            return GraphsApiFp(configuration).graphNumberOfNewUsers({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfNewUsersPerProvider({ data, options }: IgraphNumberOfNewUsersPerProviderProps) {
            return GraphsApiFp(configuration).graphNumberOfNewUsersPerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTrips({ data, options }: IgraphNumberOfTripsProps) {
            return GraphsApiFp(configuration).graphNumberOfTrips({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTripsPerProvider({ data, options }: IgraphNumberOfTripsPerProviderProps) {
            return GraphsApiFp(configuration).graphNumberOfTripsPerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTripsPerVehicle({ data, options }: IgraphNumberOfTripsPerVehicleProps) {
            return GraphsApiFp(configuration).graphNumberOfTripsPerVehicle({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfTripsPerZone({ data, options }: IgraphNumberOfTripsPerZoneProps) {
            return GraphsApiFp(configuration).graphNumberOfTripsPerZone({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfUniqueUsers({ data, options }: IgraphNumberOfUniqueUsersProps) {
            return GraphsApiFp(configuration).graphNumberOfUniqueUsers({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfUniqueUsersPerProvider({ data, options }: IgraphNumberOfUniqueUsersPerProviderProps) {
            return GraphsApiFp(configuration).graphNumberOfUniqueUsersPerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphNumberOfUsersPerTripPerformed({ data, options }: IgraphNumberOfUsersPerTripPerformedProps) {
            return GraphsApiFp(configuration).graphNumberOfUsersPerTripPerformed({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphOffensePricePerProviderPerDate({ data, options }: IgraphOffensePricePerProviderPerDateProps) {
            return GraphsApiFp(configuration).graphOffensePricePerProviderPerDate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphOffensesPerKind({ data, options }: IgraphOffensesPerKindProps) {
            return GraphsApiFp(configuration).graphOffensesPerKind({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphOffensesPerProviderPerDate({ data, options }: IgraphOffensesPerProviderPerDateProps) {
            return GraphsApiFp(configuration).graphOffensesPerProviderPerDate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentDevicesDeployedPerZone({ data, options }: IgraphPercentDevicesDeployedPerZoneProps) {
            return GraphsApiFp(configuration).graphPercentDevicesDeployedPerZone({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentDevicesDeployedPerZonePerProvider({ data, options }: IgraphPercentDevicesDeployedPerZonePerProviderProps) {
            return GraphsApiFp(configuration).graphPercentDevicesDeployedPerZonePerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentageOfOffensesPerKind({ data, options }: IgraphPercentageOfOffensesPerKindProps) {
            return GraphsApiFp(configuration).graphPercentageOfOffensesPerKind({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentageOfTripsCloseToPublicTransports({ data, options }: IgraphPercentageOfTripsCloseToPublicTransportsProps) {
            return GraphsApiFp(configuration).graphPercentageOfTripsCloseToPublicTransports({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphPercentageOfTripsPerProvider({ data, options }: IgraphPercentageOfTripsPerProviderProps) {
            return GraphsApiFp(configuration).graphPercentageOfTripsPerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphRatioOfTripsPerVehiclePerProvider({ data, options }: IgraphRatioOfTripsPerVehiclePerProviderProps) {
            return GraphsApiFp(configuration).graphRatioOfTripsPerVehiclePerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTotalDistance({ data, options }: IgraphTotalDistanceProps) {
            return GraphsApiFp(configuration).graphTotalDistance({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTotalDistancePerProvider({ data, options }: IgraphTotalDistancePerProviderProps) {
            return GraphsApiFp(configuration).graphTotalDistancePerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTripFlows({ data, options }: IgraphTripFlowsProps) {
            return GraphsApiFp(configuration).graphTripFlows({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTripsDistribution({ data, options }: IgraphTripsDistributionProps) {
            return GraphsApiFp(configuration).graphTripsDistribution({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphTripsDuration({ data, options }: IgraphTripsDurationProps) {
            return GraphsApiFp(configuration).graphTripsDuration({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphUtilizationRate({ data, options }: IgraphUtilizationRateProps) {
            return GraphsApiFp(configuration).graphUtilizationRate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {GraphFilters} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        graphUtilizationRatePerProvider({ data, options }: IgraphUtilizationRatePerProviderProps) {
            return GraphsApiFp(configuration).graphUtilizationRatePerProvider({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} report_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGraphList({ report_id, options }: IreportGraphListProps) {
            return GraphsApiFp(configuration).reportGraphList({ report_id, options })(fetch, basePath);
        },
    };
};

/**
 * GraphsApi - object-oriented interface
 * @export
 * @class GraphsApi
 * @extends {BaseAPI}
 */
export class GraphsApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``graphAnomaliesPerProvider`` for arguments and options.
     *
     */
    public graphAnomaliesPerProviderURL({ data, options }: IgraphAnomaliesPerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphAnomaliesPerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphAnomaliesPerProvider({ data, options }: IgraphAnomaliesPerProviderProps) {
        return GraphsApiFp(this.configuration).graphAnomaliesPerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphAnomaliesPerType`` for arguments and options.
     *
     */
    public graphAnomaliesPerTypeURL({ data, options }: IgraphAnomaliesPerTypeProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphAnomaliesPerTypeURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphAnomaliesPerType({ data, options }: IgraphAnomaliesPerTypeProps) {
        return GraphsApiFp(this.configuration).graphAnomaliesPerType({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphAnomaliesRatePerProvider`` for arguments and options.
     *
     */
    public graphAnomaliesRatePerProviderURL({ data, options }: IgraphAnomaliesRatePerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphAnomaliesRatePerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphAnomaliesRatePerProvider({ data, options }: IgraphAnomaliesRatePerProviderProps) {
        return GraphsApiFp(this.configuration).graphAnomaliesRatePerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphAverageDeploymentDurationPerZone`` for arguments and options.
     *
     */
    public graphAverageDeploymentDurationPerZoneURL({ data, options }: IgraphAverageDeploymentDurationPerZoneProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphAverageDeploymentDurationPerZoneURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphAverageDeploymentDurationPerZone({ data, options }: IgraphAverageDeploymentDurationPerZoneProps) {
        return GraphsApiFp(this.configuration).graphAverageDeploymentDurationPerZone({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphAverageFleetSizePerProvider`` for arguments and options.
     *
     */
    public graphAverageFleetSizePerProviderURL({ data, options }: IgraphAverageFleetSizePerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphAverageFleetSizePerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphAverageFleetSizePerProvider({ data, options }: IgraphAverageFleetSizePerProviderProps) {
        return GraphsApiFp(this.configuration).graphAverageFleetSizePerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphAverageFleetSizePerProviderOnRange`` for arguments and options.
     *
     */
    public graphAverageFleetSizePerProviderOnRangeURL({ data, options }: IgraphAverageFleetSizePerProviderOnRangeProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphAverageFleetSizePerProviderOnRangeURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphAverageFleetSizePerProviderOnRange({ data, options }: IgraphAverageFleetSizePerProviderOnRangeProps) {
        return GraphsApiFp(this.configuration).graphAverageFleetSizePerProviderOnRange({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphDevicesDeployedPerProvider`` for arguments and options.
     *
     */
    public graphDevicesDeployedPerProviderURL({ data, options }: IgraphDevicesDeployedPerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphDevicesDeployedPerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphDevicesDeployedPerProvider({ data, options }: IgraphDevicesDeployedPerProviderProps) {
        return GraphsApiFp(this.configuration).graphDevicesDeployedPerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphDevicesPerStatus`` for arguments and options.
     *
     */
    public graphDevicesPerStatusURL({ data, options }: IgraphDevicesPerStatusProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphDevicesPerStatusURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphDevicesPerStatus({ data, options }: IgraphDevicesPerStatusProps) {
        return GraphsApiFp(this.configuration).graphDevicesPerStatus({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphEnergyConsumptionPerProvider`` for arguments and options.
     *
     */
    public graphEnergyConsumptionPerProviderURL({ data, options }: IgraphEnergyConsumptionPerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphEnergyConsumptionPerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphEnergyConsumptionPerProvider({ data, options }: IgraphEnergyConsumptionPerProviderProps) {
        return GraphsApiFp(this.configuration).graphEnergyConsumptionPerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphFleetAvailability`` for arguments and options.
     *
     */
    public graphFleetAvailabilityURL({ data, options }: IgraphFleetAvailabilityProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphFleetAvailabilityURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphFleetAvailability({ data, options }: IgraphFleetAvailabilityProps) {
        return GraphsApiFp(this.configuration).graphFleetAvailability({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphGazEmissionCompareToAlternateVehicle`` for arguments and options.
     *
     */
    public graphGazEmissionCompareToAlternateVehicleURL({ data, options }: IgraphGazEmissionCompareToAlternateVehicleProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphGazEmissionCompareToAlternateVehicleURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphGazEmissionCompareToAlternateVehicle({ data, options }: IgraphGazEmissionCompareToAlternateVehicleProps) {
        return GraphsApiFp(this.configuration).graphGazEmissionCompareToAlternateVehicle({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphGazEmissionPerProvider`` for arguments and options.
     *
     */
    public graphGazEmissionPerProviderURL({ data, options }: IgraphGazEmissionPerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphGazEmissionPerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphGazEmissionPerProvider({ data, options }: IgraphGazEmissionPerProviderProps) {
        return GraphsApiFp(this.configuration).graphGazEmissionPerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphLatencyHistogram`` for arguments and options.
     *
     */
    public graphLatencyHistogramURL({ data, options }: IgraphLatencyHistogramProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphLatencyHistogramURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphLatencyHistogram({ data, options }: IgraphLatencyHistogramProps) {
        return GraphsApiFp(this.configuration).graphLatencyHistogram({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphLatencyPerProvider`` for arguments and options.
     *
     */
    public graphLatencyPerProviderURL({ data, options }: IgraphLatencyPerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphLatencyPerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphLatencyPerProvider({ data, options }: IgraphLatencyPerProviderProps) {
        return GraphsApiFp(this.configuration).graphLatencyPerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphNumberOfNewUsers`` for arguments and options.
     *
     */
    public graphNumberOfNewUsersURL({ data, options }: IgraphNumberOfNewUsersProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphNumberOfNewUsersURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphNumberOfNewUsers({ data, options }: IgraphNumberOfNewUsersProps) {
        return GraphsApiFp(this.configuration).graphNumberOfNewUsers({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphNumberOfNewUsersPerProvider`` for arguments and options.
     *
     */
    public graphNumberOfNewUsersPerProviderURL({ data, options }: IgraphNumberOfNewUsersPerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphNumberOfNewUsersPerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphNumberOfNewUsersPerProvider({ data, options }: IgraphNumberOfNewUsersPerProviderProps) {
        return GraphsApiFp(this.configuration).graphNumberOfNewUsersPerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphNumberOfTrips`` for arguments and options.
     *
     */
    public graphNumberOfTripsURL({ data, options }: IgraphNumberOfTripsProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphNumberOfTripsURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphNumberOfTrips({ data, options }: IgraphNumberOfTripsProps) {
        return GraphsApiFp(this.configuration).graphNumberOfTrips({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphNumberOfTripsPerProvider`` for arguments and options.
     *
     */
    public graphNumberOfTripsPerProviderURL({ data, options }: IgraphNumberOfTripsPerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphNumberOfTripsPerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphNumberOfTripsPerProvider({ data, options }: IgraphNumberOfTripsPerProviderProps) {
        return GraphsApiFp(this.configuration).graphNumberOfTripsPerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphNumberOfTripsPerVehicle`` for arguments and options.
     *
     */
    public graphNumberOfTripsPerVehicleURL({ data, options }: IgraphNumberOfTripsPerVehicleProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphNumberOfTripsPerVehicleURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphNumberOfTripsPerVehicle({ data, options }: IgraphNumberOfTripsPerVehicleProps) {
        return GraphsApiFp(this.configuration).graphNumberOfTripsPerVehicle({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphNumberOfTripsPerZone`` for arguments and options.
     *
     */
    public graphNumberOfTripsPerZoneURL({ data, options }: IgraphNumberOfTripsPerZoneProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphNumberOfTripsPerZoneURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphNumberOfTripsPerZone({ data, options }: IgraphNumberOfTripsPerZoneProps) {
        return GraphsApiFp(this.configuration).graphNumberOfTripsPerZone({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphNumberOfUniqueUsers`` for arguments and options.
     *
     */
    public graphNumberOfUniqueUsersURL({ data, options }: IgraphNumberOfUniqueUsersProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphNumberOfUniqueUsersURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphNumberOfUniqueUsers({ data, options }: IgraphNumberOfUniqueUsersProps) {
        return GraphsApiFp(this.configuration).graphNumberOfUniqueUsers({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphNumberOfUniqueUsersPerProvider`` for arguments and options.
     *
     */
    public graphNumberOfUniqueUsersPerProviderURL({ data, options }: IgraphNumberOfUniqueUsersPerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphNumberOfUniqueUsersPerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphNumberOfUniqueUsersPerProvider({ data, options }: IgraphNumberOfUniqueUsersPerProviderProps) {
        return GraphsApiFp(this.configuration).graphNumberOfUniqueUsersPerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphNumberOfUsersPerTripPerformed`` for arguments and options.
     *
     */
    public graphNumberOfUsersPerTripPerformedURL({ data, options }: IgraphNumberOfUsersPerTripPerformedProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphNumberOfUsersPerTripPerformedURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphNumberOfUsersPerTripPerformed({ data, options }: IgraphNumberOfUsersPerTripPerformedProps) {
        return GraphsApiFp(this.configuration).graphNumberOfUsersPerTripPerformed({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphOffensePricePerProviderPerDate`` for arguments and options.
     *
     */
    public graphOffensePricePerProviderPerDateURL({ data, options }: IgraphOffensePricePerProviderPerDateProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphOffensePricePerProviderPerDateURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphOffensePricePerProviderPerDate({ data, options }: IgraphOffensePricePerProviderPerDateProps) {
        return GraphsApiFp(this.configuration).graphOffensePricePerProviderPerDate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphOffensesPerKind`` for arguments and options.
     *
     */
    public graphOffensesPerKindURL({ data, options }: IgraphOffensesPerKindProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphOffensesPerKindURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphOffensesPerKind({ data, options }: IgraphOffensesPerKindProps) {
        return GraphsApiFp(this.configuration).graphOffensesPerKind({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphOffensesPerProviderPerDate`` for arguments and options.
     *
     */
    public graphOffensesPerProviderPerDateURL({ data, options }: IgraphOffensesPerProviderPerDateProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphOffensesPerProviderPerDateURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphOffensesPerProviderPerDate({ data, options }: IgraphOffensesPerProviderPerDateProps) {
        return GraphsApiFp(this.configuration).graphOffensesPerProviderPerDate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphPercentDevicesDeployedPerZone`` for arguments and options.
     *
     */
    public graphPercentDevicesDeployedPerZoneURL({ data, options }: IgraphPercentDevicesDeployedPerZoneProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphPercentDevicesDeployedPerZoneURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphPercentDevicesDeployedPerZone({ data, options }: IgraphPercentDevicesDeployedPerZoneProps) {
        return GraphsApiFp(this.configuration).graphPercentDevicesDeployedPerZone({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphPercentDevicesDeployedPerZonePerProvider`` for arguments and options.
     *
     */
    public graphPercentDevicesDeployedPerZonePerProviderURL({ data, options }: IgraphPercentDevicesDeployedPerZonePerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphPercentDevicesDeployedPerZonePerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphPercentDevicesDeployedPerZonePerProvider({ data, options }: IgraphPercentDevicesDeployedPerZonePerProviderProps) {
        return GraphsApiFp(this.configuration).graphPercentDevicesDeployedPerZonePerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphPercentageOfOffensesPerKind`` for arguments and options.
     *
     */
    public graphPercentageOfOffensesPerKindURL({ data, options }: IgraphPercentageOfOffensesPerKindProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphPercentageOfOffensesPerKindURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphPercentageOfOffensesPerKind({ data, options }: IgraphPercentageOfOffensesPerKindProps) {
        return GraphsApiFp(this.configuration).graphPercentageOfOffensesPerKind({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphPercentageOfTripsCloseToPublicTransports`` for arguments and options.
     *
     */
    public graphPercentageOfTripsCloseToPublicTransportsURL({ data, options }: IgraphPercentageOfTripsCloseToPublicTransportsProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphPercentageOfTripsCloseToPublicTransportsURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphPercentageOfTripsCloseToPublicTransports({ data, options }: IgraphPercentageOfTripsCloseToPublicTransportsProps) {
        return GraphsApiFp(this.configuration).graphPercentageOfTripsCloseToPublicTransports({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphPercentageOfTripsPerProvider`` for arguments and options.
     *
     */
    public graphPercentageOfTripsPerProviderURL({ data, options }: IgraphPercentageOfTripsPerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphPercentageOfTripsPerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphPercentageOfTripsPerProvider({ data, options }: IgraphPercentageOfTripsPerProviderProps) {
        return GraphsApiFp(this.configuration).graphPercentageOfTripsPerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphRatioOfTripsPerVehiclePerProvider`` for arguments and options.
     *
     */
    public graphRatioOfTripsPerVehiclePerProviderURL({ data, options }: IgraphRatioOfTripsPerVehiclePerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphRatioOfTripsPerVehiclePerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphRatioOfTripsPerVehiclePerProvider({ data, options }: IgraphRatioOfTripsPerVehiclePerProviderProps) {
        return GraphsApiFp(this.configuration).graphRatioOfTripsPerVehiclePerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphTotalDistance`` for arguments and options.
     *
     */
    public graphTotalDistanceURL({ data, options }: IgraphTotalDistanceProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphTotalDistanceURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphTotalDistance({ data, options }: IgraphTotalDistanceProps) {
        return GraphsApiFp(this.configuration).graphTotalDistance({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphTotalDistancePerProvider`` for arguments and options.
     *
     */
    public graphTotalDistancePerProviderURL({ data, options }: IgraphTotalDistancePerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphTotalDistancePerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphTotalDistancePerProvider({ data, options }: IgraphTotalDistancePerProviderProps) {
        return GraphsApiFp(this.configuration).graphTotalDistancePerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphTripFlows`` for arguments and options.
     *
     */
    public graphTripFlowsURL({ data, options }: IgraphTripFlowsProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphTripFlowsURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphTripFlows({ data, options }: IgraphTripFlowsProps) {
        return GraphsApiFp(this.configuration).graphTripFlows({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphTripsDistribution`` for arguments and options.
     *
     */
    public graphTripsDistributionURL({ data, options }: IgraphTripsDistributionProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphTripsDistributionURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphTripsDistribution({ data, options }: IgraphTripsDistributionProps) {
        return GraphsApiFp(this.configuration).graphTripsDistribution({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphTripsDuration`` for arguments and options.
     *
     */
    public graphTripsDurationURL({ data, options }: IgraphTripsDurationProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphTripsDurationURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphTripsDuration({ data, options }: IgraphTripsDurationProps) {
        return GraphsApiFp(this.configuration).graphTripsDuration({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphUtilizationRate`` for arguments and options.
     *
     */
    public graphUtilizationRateURL({ data, options }: IgraphUtilizationRateProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphUtilizationRateURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphUtilizationRate({ data, options }: IgraphUtilizationRateProps) {
        return GraphsApiFp(this.configuration).graphUtilizationRate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``graphUtilizationRatePerProvider`` for arguments and options.
     *
     */
    public graphUtilizationRatePerProviderURL({ data, options }: IgraphUtilizationRatePerProviderProps): FetchArgs {
        return GraphsApiFp(this.configuration).graphUtilizationRatePerProviderURL({ data, options });
    }

    /**
     * 
     * @param {GraphFilters} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public graphUtilizationRatePerProvider({ data, options }: IgraphUtilizationRatePerProviderProps) {
        return GraphsApiFp(this.configuration).graphUtilizationRatePerProvider({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``reportGraphList`` for arguments and options.
     *
     */
    public reportGraphListURL({ report_id, options }: IreportGraphListProps): FetchArgs {
        return GraphsApiFp(this.configuration).reportGraphListURL({ report_id, options });
    }

    /**
     * 
     * @param {string} report_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GraphsApi
     */
    public reportGraphList({ report_id, options }: IreportGraphListProps) {
        return GraphsApiFp(this.configuration).reportGraphList({ report_id, options })(this.fetchData, this.basePath);
    }

}

/**
 * homepageDevicesList parameters
 */
export interface IhomepageDevicesListProps {
    type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    provider?: Array<string>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    telemetry_after?: string, // range (lower bound)
    telemetry_before?: string, // range (upper bound)
    options?: any,
};

/**
 * homepageDevicesRead parameters
 */
export interface IhomepageDevicesReadProps {
    id: string,
    options?: any,
};

/**
 * homepageFavoritesCreate parameters
 */
export interface IhomepageFavoritesCreateProps {
    data: Favorite,
    options?: any,
};

/**
 * homepageFavoritesDelete parameters
 */
export interface IhomepageFavoritesDeleteProps {
    user_id: string,
    page_id: 'reports' | 'report_area_flow' | 'report_historial_map' | 'map' | 'trips' | 'trips_list' | 'trips_heatmap' | 'trips_KPI' | 'trips_env_KPI' | 'trips_user_KPI' | 'vehicles' | 'vehicles_list' | 'vehicles_deployment_KPI' | 'vehicles_utilization_KPI' | 'providers' | 'fee_rates' | 'fee_rates_list' | 'fee_scheme' | 'fees_table' | 'policies' | 'policies_list' | 'policies_violations' | 'policies_violation_detail' | 'policies_details_graphs' | 'policies_smart_patrol' | 'policies_violation_map' | 'policies_penalty_scheme' | 'policies_kpi' | 'mds' | 'areas' | 'logs' | 'parking' | 'ride_hailing' | 'ycurb' | 'safety' | 'docked_bikes' | 'passengers_services_test' | 'senmap' | 'parking_bay' | 'vehicles_kpis' | 'utilization_kpis' | 'trips_kpis' | 'heatmaps' | 'heatmaps_street_segment' | 'environment_kpis' | 'data_quality_kpis' | 'vehicles_list_standalone' | 'trips_list_standalone' | 'trips_user_KPI_standalone' | 'smart_loading_zone' | 'curb_overview', // Page ID
    options?: any,
};

/**
 * homepageFavoritesRead parameters
 */
export interface IhomepageFavoritesReadProps {
    user_id: string,
    options?: any,
};

/**
 * providerMetrics parameters
 */
export interface IproviderMetricsProps {
    options?: any,
};

/**
 * HomepageApi - fetch parameter creator
 * @export
 */
export const HomepageApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageDevicesList({ type, provider, status, telemetry_after, telemetry_before, options = {} }: IhomepageDevicesListProps): FetchArgs {
            const localVarPath = `/homepage/devices/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (telemetry_after !== undefined) {
                localVarQueryParameter['telemetry_after'] = telemetry_after;
            }

            if (telemetry_before !== undefined) {
                localVarQueryParameter['telemetry_before'] = telemetry_before;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageDevicesRead({ id, options = {} }: IhomepageDevicesReadProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling homepageDevicesRead.');
            }
            const localVarPath = `/homepage/devices/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Favorite} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageFavoritesCreate({ data, options = {} }: IhomepageFavoritesCreateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling homepageFavoritesCreate.');
            }
            const localVarPath = `/homepage/favorites/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Favorite" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} user_id 
         * @param {'reports' | 'report_area_flow' | 'report_historial_map' | 'map' | 'trips' | 'trips_list' | 'trips_heatmap' | 'trips_KPI' | 'trips_env_KPI' | 'trips_user_KPI' | 'vehicles' | 'vehicles_list' | 'vehicles_deployment_KPI' | 'vehicles_utilization_KPI' | 'providers' | 'fee_rates' | 'fee_rates_list' | 'fee_scheme' | 'fees_table' | 'policies' | 'policies_list' | 'policies_violations' | 'policies_violation_detail' | 'policies_details_graphs' | 'policies_smart_patrol' | 'policies_violation_map' | 'policies_penalty_scheme' | 'policies_kpi' | 'mds' | 'areas' | 'logs' | 'parking' | 'ride_hailing' | 'ycurb' | 'safety' | 'docked_bikes' | 'passengers_services_test' | 'senmap' | 'parking_bay' | 'vehicles_kpis' | 'utilization_kpis' | 'trips_kpis' | 'heatmaps' | 'heatmaps_street_segment' | 'environment_kpis' | 'data_quality_kpis' | 'vehicles_list_standalone' | 'trips_list_standalone' | 'trips_user_KPI_standalone' | 'smart_loading_zone' | 'curb_overview'} page_id Page ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageFavoritesDelete({ user_id, page_id, options = {} }: IhomepageFavoritesDeleteProps): FetchArgs {
            // verify required parameter 'user_id' is not null or undefined
            if (user_id === null || user_id === undefined) {
                throw new RequiredError('user_id','Required parameter user_id was null or undefined when calling homepageFavoritesDelete.');
            }
            // verify required parameter 'page_id' is not null or undefined
            if (page_id === null || page_id === undefined) {
                throw new RequiredError('page_id','Required parameter page_id was null or undefined when calling homepageFavoritesDelete.');
            }
            const localVarPath = `/homepage/favorites/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(user_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (page_id !== undefined) {
                localVarQueryParameter['page_id'] = page_id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} user_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageFavoritesRead({ user_id, options = {} }: IhomepageFavoritesReadProps): FetchArgs {
            // verify required parameter 'user_id' is not null or undefined
            if (user_id === null || user_id === undefined) {
                throw new RequiredError('user_id','Required parameter user_id was null or undefined when calling homepageFavoritesRead.');
            }
            const localVarPath = `/homepage/favorites/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(user_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unified end-point for all providers metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerMetrics({ options = {} }: IproviderMetricsProps): FetchArgs {
            const localVarPath = `/homepage/providers_metrics`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HomepageApi - functional programming interface
 * @export
 */
export const HomepageApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        homepageDevicesListURL({ type, provider, status, telemetry_after, telemetry_before, options }: IhomepageDevicesListProps): FetchArgs {
            return HomepageApiFetchParamCreator(configuration).homepageDevicesList({ type, provider, status, telemetry_after, telemetry_before, options });
        },

        /**
         * 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageDevicesList({ type, provider, status, telemetry_after, telemetry_before, options }: IhomepageDevicesListProps): (fetch?: FetchAPI, basePath?: string) => Promise<HomepageVehicleResponse> {
            const localVarFetchArgs = this.homepageDevicesListURL({ type, provider, status, telemetry_after, telemetry_before, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        homepageDevicesReadURL({ id, options }: IhomepageDevicesReadProps): FetchArgs {
            return HomepageApiFetchParamCreator(configuration).homepageDevicesRead({ id, options });
        },

        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageDevicesRead({ id, options }: IhomepageDevicesReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.homepageDevicesReadURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        homepageFavoritesCreateURL({ data, options }: IhomepageFavoritesCreateProps): FetchArgs {
            return HomepageApiFetchParamCreator(configuration).homepageFavoritesCreate({ data, options });
        },

        /**
         * 
         * @param {Favorite} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageFavoritesCreate({ data, options }: IhomepageFavoritesCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<Favorite> {
            const localVarFetchArgs = this.homepageFavoritesCreateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        homepageFavoritesDeleteURL({ user_id, page_id, options }: IhomepageFavoritesDeleteProps): FetchArgs {
            return HomepageApiFetchParamCreator(configuration).homepageFavoritesDelete({ user_id, page_id, options });
        },

        /**
         * 
         * @param {string} user_id 
         * @param {'reports' | 'report_area_flow' | 'report_historial_map' | 'map' | 'trips' | 'trips_list' | 'trips_heatmap' | 'trips_KPI' | 'trips_env_KPI' | 'trips_user_KPI' | 'vehicles' | 'vehicles_list' | 'vehicles_deployment_KPI' | 'vehicles_utilization_KPI' | 'providers' | 'fee_rates' | 'fee_rates_list' | 'fee_scheme' | 'fees_table' | 'policies' | 'policies_list' | 'policies_violations' | 'policies_violation_detail' | 'policies_details_graphs' | 'policies_smart_patrol' | 'policies_violation_map' | 'policies_penalty_scheme' | 'policies_kpi' | 'mds' | 'areas' | 'logs' | 'parking' | 'ride_hailing' | 'ycurb' | 'safety' | 'docked_bikes' | 'passengers_services_test' | 'senmap' | 'parking_bay' | 'vehicles_kpis' | 'utilization_kpis' | 'trips_kpis' | 'heatmaps' | 'heatmaps_street_segment' | 'environment_kpis' | 'data_quality_kpis' | 'vehicles_list_standalone' | 'trips_list_standalone' | 'trips_user_KPI_standalone' | 'smart_loading_zone' | 'curb_overview'} page_id Page ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageFavoritesDelete({ user_id, page_id, options }: IhomepageFavoritesDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.homepageFavoritesDeleteURL({ user_id, page_id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        homepageFavoritesReadURL({ user_id, options }: IhomepageFavoritesReadProps): FetchArgs {
            return HomepageApiFetchParamCreator(configuration).homepageFavoritesRead({ user_id, options });
        },

        /**
         * 
         * @param {string} user_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageFavoritesRead({ user_id, options }: IhomepageFavoritesReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Favorite>> {
            const localVarFetchArgs = this.homepageFavoritesReadURL({ user_id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        providerMetricsURL({ options }: IproviderMetricsProps): FetchArgs {
            return HomepageApiFetchParamCreator(configuration).providerMetrics({ options });
        },

        /**
         * Unified end-point for all providers metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerMetrics({ options }: IproviderMetricsProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ProviderMetrics>> {
            const localVarFetchArgs = this.providerMetricsURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * HomepageApi - factory interface
 * @export
 */
export const HomepageApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageDevicesList({ type, provider, status, telemetry_after, telemetry_before, options }: IhomepageDevicesListProps) {
            return HomepageApiFp(configuration).homepageDevicesList({ type, provider, status, telemetry_after, telemetry_before, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageDevicesRead({ id, options }: IhomepageDevicesReadProps) {
            return HomepageApiFp(configuration).homepageDevicesRead({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {Favorite} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageFavoritesCreate({ data, options }: IhomepageFavoritesCreateProps) {
            return HomepageApiFp(configuration).homepageFavoritesCreate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} user_id 
         * @param {'reports' | 'report_area_flow' | 'report_historial_map' | 'map' | 'trips' | 'trips_list' | 'trips_heatmap' | 'trips_KPI' | 'trips_env_KPI' | 'trips_user_KPI' | 'vehicles' | 'vehicles_list' | 'vehicles_deployment_KPI' | 'vehicles_utilization_KPI' | 'providers' | 'fee_rates' | 'fee_rates_list' | 'fee_scheme' | 'fees_table' | 'policies' | 'policies_list' | 'policies_violations' | 'policies_violation_detail' | 'policies_details_graphs' | 'policies_smart_patrol' | 'policies_violation_map' | 'policies_penalty_scheme' | 'policies_kpi' | 'mds' | 'areas' | 'logs' | 'parking' | 'ride_hailing' | 'ycurb' | 'safety' | 'docked_bikes' | 'passengers_services_test' | 'senmap' | 'parking_bay' | 'vehicles_kpis' | 'utilization_kpis' | 'trips_kpis' | 'heatmaps' | 'heatmaps_street_segment' | 'environment_kpis' | 'data_quality_kpis' | 'vehicles_list_standalone' | 'trips_list_standalone' | 'trips_user_KPI_standalone' | 'smart_loading_zone' | 'curb_overview'} page_id Page ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageFavoritesDelete({ user_id, page_id, options }: IhomepageFavoritesDeleteProps) {
            return HomepageApiFp(configuration).homepageFavoritesDelete({ user_id, page_id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} user_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homepageFavoritesRead({ user_id, options }: IhomepageFavoritesReadProps) {
            return HomepageApiFp(configuration).homepageFavoritesRead({ user_id, options })(fetch, basePath);
        },
        /**
         * Unified end-point for all providers metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providerMetrics({ options }: IproviderMetricsProps) {
            return HomepageApiFp(configuration).providerMetrics({ options })(fetch, basePath);
        },
    };
};

/**
 * HomepageApi - object-oriented interface
 * @export
 * @class HomepageApi
 * @extends {BaseAPI}
 */
export class HomepageApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``homepageDevicesList`` for arguments and options.
     *
     */
    public homepageDevicesListURL({ type, provider, status, telemetry_after, telemetry_before, options }: IhomepageDevicesListProps = {}): FetchArgs {
        return HomepageApiFp(this.configuration).homepageDevicesListURL({ type, provider, status, telemetry_after, telemetry_before, options });
    }

    /**
     * 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
     * @param {Array<string>} [provider] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {string} [telemetry_after] range (lower bound)
     * @param {string} [telemetry_before] range (upper bound)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomepageApi
     */
    public homepageDevicesList({ type, provider, status, telemetry_after, telemetry_before, options }: IhomepageDevicesListProps = {}) {
        return HomepageApiFp(this.configuration).homepageDevicesList({ type, provider, status, telemetry_after, telemetry_before, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``homepageDevicesRead`` for arguments and options.
     *
     */
    public homepageDevicesReadURL({ id, options }: IhomepageDevicesReadProps): FetchArgs {
        return HomepageApiFp(this.configuration).homepageDevicesReadURL({ id, options });
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomepageApi
     */
    public homepageDevicesRead({ id, options }: IhomepageDevicesReadProps) {
        return HomepageApiFp(this.configuration).homepageDevicesRead({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``homepageFavoritesCreate`` for arguments and options.
     *
     */
    public homepageFavoritesCreateURL({ data, options }: IhomepageFavoritesCreateProps): FetchArgs {
        return HomepageApiFp(this.configuration).homepageFavoritesCreateURL({ data, options });
    }

    /**
     * 
     * @param {Favorite} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomepageApi
     */
    public homepageFavoritesCreate({ data, options }: IhomepageFavoritesCreateProps) {
        return HomepageApiFp(this.configuration).homepageFavoritesCreate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``homepageFavoritesDelete`` for arguments and options.
     *
     */
    public homepageFavoritesDeleteURL({ user_id, page_id, options }: IhomepageFavoritesDeleteProps): FetchArgs {
        return HomepageApiFp(this.configuration).homepageFavoritesDeleteURL({ user_id, page_id, options });
    }

    /**
     * 
     * @param {string} user_id 
     * @param {'reports' | 'report_area_flow' | 'report_historial_map' | 'map' | 'trips' | 'trips_list' | 'trips_heatmap' | 'trips_KPI' | 'trips_env_KPI' | 'trips_user_KPI' | 'vehicles' | 'vehicles_list' | 'vehicles_deployment_KPI' | 'vehicles_utilization_KPI' | 'providers' | 'fee_rates' | 'fee_rates_list' | 'fee_scheme' | 'fees_table' | 'policies' | 'policies_list' | 'policies_violations' | 'policies_violation_detail' | 'policies_details_graphs' | 'policies_smart_patrol' | 'policies_violation_map' | 'policies_penalty_scheme' | 'policies_kpi' | 'mds' | 'areas' | 'logs' | 'parking' | 'ride_hailing' | 'ycurb' | 'safety' | 'docked_bikes' | 'passengers_services_test' | 'senmap' | 'parking_bay' | 'vehicles_kpis' | 'utilization_kpis' | 'trips_kpis' | 'heatmaps' | 'heatmaps_street_segment' | 'environment_kpis' | 'data_quality_kpis' | 'vehicles_list_standalone' | 'trips_list_standalone' | 'trips_user_KPI_standalone' | 'smart_loading_zone' | 'curb_overview'} page_id Page ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomepageApi
     */
    public homepageFavoritesDelete({ user_id, page_id, options }: IhomepageFavoritesDeleteProps) {
        return HomepageApiFp(this.configuration).homepageFavoritesDelete({ user_id, page_id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``homepageFavoritesRead`` for arguments and options.
     *
     */
    public homepageFavoritesReadURL({ user_id, options }: IhomepageFavoritesReadProps): FetchArgs {
        return HomepageApiFp(this.configuration).homepageFavoritesReadURL({ user_id, options });
    }

    /**
     * 
     * @param {string} user_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomepageApi
     */
    public homepageFavoritesRead({ user_id, options }: IhomepageFavoritesReadProps) {
        return HomepageApiFp(this.configuration).homepageFavoritesRead({ user_id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``providerMetrics`` for arguments and options.
     *
     */
    public providerMetricsURL({ options }: IproviderMetricsProps = {}): FetchArgs {
        return HomepageApiFp(this.configuration).providerMetricsURL({ options });
    }

    /**
     * Unified end-point for all providers metrics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomepageApi
     */
    public providerMetrics({ options }: IproviderMetricsProps = {}) {
        return HomepageApiFp(this.configuration).providerMetrics({ options })(this.fetchData, this.basePath);
    }

}

/**
 * jurisdictionBoundaryList parameters
 */
export interface IjurisdictionBoundaryListProps {
    options?: any,
};

/**
 * jurisdictionKpiGeometriesList parameters
 */
export interface IjurisdictionKpiGeometriesListProps {
    agency_key: string,
    options?: any,
};

/**
 * jurisdictionKpiGeometriesRead parameters
 */
export interface IjurisdictionKpiGeometriesReadProps {
    agency_key: string,
    slug: string, // Short identifier of the geometry. Used for the indexation.
    options?: any,
};

/**
 * jurisdictionKpiGeometriesZoneNames parameters
 */
export interface IjurisdictionKpiGeometriesZoneNamesProps {
    agency_key: string,
    slug: string, // Short identifier of the geometry. Used for the indexation.
    options?: any,
};

/**
 * JurisdictionApi - fetch parameter creator
 * @export
 */
export const JurisdictionApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionBoundaryList({ options = {} }: IjurisdictionBoundaryListProps): FetchArgs {
            const localVarPath = `/jurisdiction/boundary/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} agency_key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionKpiGeometriesList({ agency_key, options = {} }: IjurisdictionKpiGeometriesListProps): FetchArgs {
            // verify required parameter 'agency_key' is not null or undefined
            if (agency_key === null || agency_key === undefined) {
                throw new RequiredError('agency_key','Required parameter agency_key was null or undefined when calling jurisdictionKpiGeometriesList.');
            }
            const localVarPath = `/jurisdiction/{agency_key}/kpi_geometries/`
                .replace(`{${"agency_key"}}`, encodeURIComponent(String(agency_key)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} agency_key 
         * @param {string} slug Short identifier of the geometry. Used for the indexation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionKpiGeometriesRead({ agency_key, slug, options = {} }: IjurisdictionKpiGeometriesReadProps): FetchArgs {
            // verify required parameter 'agency_key' is not null or undefined
            if (agency_key === null || agency_key === undefined) {
                throw new RequiredError('agency_key','Required parameter agency_key was null or undefined when calling jurisdictionKpiGeometriesRead.');
            }
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug','Required parameter slug was null or undefined when calling jurisdictionKpiGeometriesRead.');
            }
            const localVarPath = `/jurisdiction/{agency_key}/kpi_geometries/{slug}/`
                .replace(`{${"agency_key"}}`, encodeURIComponent(String(agency_key)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} agency_key 
         * @param {string} slug Short identifier of the geometry. Used for the indexation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionKpiGeometriesZoneNames({ agency_key, slug, options = {} }: IjurisdictionKpiGeometriesZoneNamesProps): FetchArgs {
            // verify required parameter 'agency_key' is not null or undefined
            if (agency_key === null || agency_key === undefined) {
                throw new RequiredError('agency_key','Required parameter agency_key was null or undefined when calling jurisdictionKpiGeometriesZoneNames.');
            }
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug','Required parameter slug was null or undefined when calling jurisdictionKpiGeometriesZoneNames.');
            }
            const localVarPath = `/jurisdiction/{agency_key}/kpi_geometries/{slug}/zone_names/`
                .replace(`{${"agency_key"}}`, encodeURIComponent(String(agency_key)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JurisdictionApi - functional programming interface
 * @export
 */
export const JurisdictionApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        jurisdictionBoundaryListURL({ options }: IjurisdictionBoundaryListProps): FetchArgs {
            return JurisdictionApiFetchParamCreator(configuration).jurisdictionBoundaryList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionBoundaryList({ options }: IjurisdictionBoundaryListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.jurisdictionBoundaryListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        jurisdictionKpiGeometriesListURL({ agency_key, options }: IjurisdictionKpiGeometriesListProps): FetchArgs {
            return JurisdictionApiFetchParamCreator(configuration).jurisdictionKpiGeometriesList({ agency_key, options });
        },

        /**
         * 
         * @param {string} agency_key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionKpiGeometriesList({ agency_key, options }: IjurisdictionKpiGeometriesListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<KPIGeometry>> {
            const localVarFetchArgs = this.jurisdictionKpiGeometriesListURL({ agency_key, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        jurisdictionKpiGeometriesReadURL({ agency_key, slug, options }: IjurisdictionKpiGeometriesReadProps): FetchArgs {
            return JurisdictionApiFetchParamCreator(configuration).jurisdictionKpiGeometriesRead({ agency_key, slug, options });
        },

        /**
         * 
         * @param {string} agency_key 
         * @param {string} slug Short identifier of the geometry. Used for the indexation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionKpiGeometriesRead({ agency_key, slug, options }: IjurisdictionKpiGeometriesReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<KPIGeometry> {
            const localVarFetchArgs = this.jurisdictionKpiGeometriesReadURL({ agency_key, slug, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        jurisdictionKpiGeometriesZoneNamesURL({ agency_key, slug, options }: IjurisdictionKpiGeometriesZoneNamesProps): FetchArgs {
            return JurisdictionApiFetchParamCreator(configuration).jurisdictionKpiGeometriesZoneNames({ agency_key, slug, options });
        },

        /**
         * 
         * @param {string} agency_key 
         * @param {string} slug Short identifier of the geometry. Used for the indexation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionKpiGeometriesZoneNames({ agency_key, slug, options }: IjurisdictionKpiGeometriesZoneNamesProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ZoneName>> {
            const localVarFetchArgs = this.jurisdictionKpiGeometriesZoneNamesURL({ agency_key, slug, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * JurisdictionApi - factory interface
 * @export
 */
export const JurisdictionApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionBoundaryList({ options }: IjurisdictionBoundaryListProps) {
            return JurisdictionApiFp(configuration).jurisdictionBoundaryList({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} agency_key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionKpiGeometriesList({ agency_key, options }: IjurisdictionKpiGeometriesListProps) {
            return JurisdictionApiFp(configuration).jurisdictionKpiGeometriesList({ agency_key, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} agency_key 
         * @param {string} slug Short identifier of the geometry. Used for the indexation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionKpiGeometriesRead({ agency_key, slug, options }: IjurisdictionKpiGeometriesReadProps) {
            return JurisdictionApiFp(configuration).jurisdictionKpiGeometriesRead({ agency_key, slug, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} agency_key 
         * @param {string} slug Short identifier of the geometry. Used for the indexation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jurisdictionKpiGeometriesZoneNames({ agency_key, slug, options }: IjurisdictionKpiGeometriesZoneNamesProps) {
            return JurisdictionApiFp(configuration).jurisdictionKpiGeometriesZoneNames({ agency_key, slug, options })(fetch, basePath);
        },
    };
};

/**
 * JurisdictionApi - object-oriented interface
 * @export
 * @class JurisdictionApi
 * @extends {BaseAPI}
 */
export class JurisdictionApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``jurisdictionBoundaryList`` for arguments and options.
     *
     */
    public jurisdictionBoundaryListURL({ options }: IjurisdictionBoundaryListProps = {}): FetchArgs {
        return JurisdictionApiFp(this.configuration).jurisdictionBoundaryListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JurisdictionApi
     */
    public jurisdictionBoundaryList({ options }: IjurisdictionBoundaryListProps = {}) {
        return JurisdictionApiFp(this.configuration).jurisdictionBoundaryList({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``jurisdictionKpiGeometriesList`` for arguments and options.
     *
     */
    public jurisdictionKpiGeometriesListURL({ agency_key, options }: IjurisdictionKpiGeometriesListProps): FetchArgs {
        return JurisdictionApiFp(this.configuration).jurisdictionKpiGeometriesListURL({ agency_key, options });
    }

    /**
     * 
     * @param {string} agency_key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JurisdictionApi
     */
    public jurisdictionKpiGeometriesList({ agency_key, options }: IjurisdictionKpiGeometriesListProps) {
        return JurisdictionApiFp(this.configuration).jurisdictionKpiGeometriesList({ agency_key, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``jurisdictionKpiGeometriesRead`` for arguments and options.
     *
     */
    public jurisdictionKpiGeometriesReadURL({ agency_key, slug, options }: IjurisdictionKpiGeometriesReadProps): FetchArgs {
        return JurisdictionApiFp(this.configuration).jurisdictionKpiGeometriesReadURL({ agency_key, slug, options });
    }

    /**
     * 
     * @param {string} agency_key 
     * @param {string} slug Short identifier of the geometry. Used for the indexation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JurisdictionApi
     */
    public jurisdictionKpiGeometriesRead({ agency_key, slug, options }: IjurisdictionKpiGeometriesReadProps) {
        return JurisdictionApiFp(this.configuration).jurisdictionKpiGeometriesRead({ agency_key, slug, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``jurisdictionKpiGeometriesZoneNames`` for arguments and options.
     *
     */
    public jurisdictionKpiGeometriesZoneNamesURL({ agency_key, slug, options }: IjurisdictionKpiGeometriesZoneNamesProps): FetchArgs {
        return JurisdictionApiFp(this.configuration).jurisdictionKpiGeometriesZoneNamesURL({ agency_key, slug, options });
    }

    /**
     * 
     * @param {string} agency_key 
     * @param {string} slug Short identifier of the geometry. Used for the indexation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JurisdictionApi
     */
    public jurisdictionKpiGeometriesZoneNames({ agency_key, slug, options }: IjurisdictionKpiGeometriesZoneNamesProps) {
        return JurisdictionApiFp(this.configuration).jurisdictionKpiGeometriesZoneNames({ agency_key, slug, options })(this.fetchData, this.basePath);
    }

}

/**
 * mdsCredentialsCreate parameters
 */
export interface ImdsCredentialsCreateProps {
    data: MdsApiCredentials,
    options?: any,
};

/**
 * mdsCredentialsDelete parameters
 */
export interface ImdsCredentialsDeleteProps {
    id: number, // A unique integer value identifying this mds api credentials.
    options?: any,
};

/**
 * mdsCredentialsList parameters
 */
export interface ImdsCredentialsListProps {
    options?: any,
};

/**
 * mdsCredentialsPartialUpdate parameters
 */
export interface ImdsCredentialsPartialUpdateProps {
    id: number, // A unique integer value identifying this mds api credentials.
    data: MdsApiCredentials,
    options?: any,
};

/**
 * mdsCredentialsRead parameters
 */
export interface ImdsCredentialsReadProps {
    id: number, // A unique integer value identifying this mds api credentials.
    options?: any,
};

/**
 * mdsCredentialsUpdate parameters
 */
export interface ImdsCredentialsUpdateProps {
    id: number, // A unique integer value identifying this mds api credentials.
    data: MdsApiCredentials,
    options?: any,
};

/**
 * MdsCredentialsApi - fetch parameter creator
 * @export
 */
export const MdsCredentialsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {MdsApiCredentials} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsCreate({ data, options = {} }: ImdsCredentialsCreateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling mdsCredentialsCreate.');
            }
            const localVarPath = `/mds_credentials/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MdsApiCredentials" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsDelete({ id, options = {} }: ImdsCredentialsDeleteProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling mdsCredentialsDelete.');
            }
            const localVarPath = `/mds_credentials/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsList({ options = {} }: ImdsCredentialsListProps): FetchArgs {
            const localVarPath = `/mds_credentials/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {MdsApiCredentials} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsPartialUpdate({ id, data, options = {} }: ImdsCredentialsPartialUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling mdsCredentialsPartialUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling mdsCredentialsPartialUpdate.');
            }
            const localVarPath = `/mds_credentials/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MdsApiCredentials" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsRead({ id, options = {} }: ImdsCredentialsReadProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling mdsCredentialsRead.');
            }
            const localVarPath = `/mds_credentials/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {MdsApiCredentials} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsUpdate({ id, data, options = {} }: ImdsCredentialsUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling mdsCredentialsUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling mdsCredentialsUpdate.');
            }
            const localVarPath = `/mds_credentials/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MdsApiCredentials" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MdsCredentialsApi - functional programming interface
 * @export
 */
export const MdsCredentialsApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        mdsCredentialsCreateURL({ data, options }: ImdsCredentialsCreateProps): FetchArgs {
            return MdsCredentialsApiFetchParamCreator(configuration).mdsCredentialsCreate({ data, options });
        },

        /**
         * 
         * @param {MdsApiCredentials} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsCreate({ data, options }: ImdsCredentialsCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<MdsApiCredentials> {
            const localVarFetchArgs = this.mdsCredentialsCreateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        mdsCredentialsDeleteURL({ id, options }: ImdsCredentialsDeleteProps): FetchArgs {
            return MdsCredentialsApiFetchParamCreator(configuration).mdsCredentialsDelete({ id, options });
        },

        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsDelete({ id, options }: ImdsCredentialsDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.mdsCredentialsDeleteURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        mdsCredentialsListURL({ options }: ImdsCredentialsListProps): FetchArgs {
            return MdsCredentialsApiFetchParamCreator(configuration).mdsCredentialsList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsList({ options }: ImdsCredentialsListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<MdsApiCredentials>> {
            const localVarFetchArgs = this.mdsCredentialsListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        mdsCredentialsPartialUpdateURL({ id, data, options }: ImdsCredentialsPartialUpdateProps): FetchArgs {
            return MdsCredentialsApiFetchParamCreator(configuration).mdsCredentialsPartialUpdate({ id, data, options });
        },

        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {MdsApiCredentials} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsPartialUpdate({ id, data, options }: ImdsCredentialsPartialUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<MdsApiCredentials> {
            const localVarFetchArgs = this.mdsCredentialsPartialUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        mdsCredentialsReadURL({ id, options }: ImdsCredentialsReadProps): FetchArgs {
            return MdsCredentialsApiFetchParamCreator(configuration).mdsCredentialsRead({ id, options });
        },

        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsRead({ id, options }: ImdsCredentialsReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<MdsApiCredentials> {
            const localVarFetchArgs = this.mdsCredentialsReadURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        mdsCredentialsUpdateURL({ id, data, options }: ImdsCredentialsUpdateProps): FetchArgs {
            return MdsCredentialsApiFetchParamCreator(configuration).mdsCredentialsUpdate({ id, data, options });
        },

        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {MdsApiCredentials} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsUpdate({ id, data, options }: ImdsCredentialsUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<MdsApiCredentials> {
            const localVarFetchArgs = this.mdsCredentialsUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * MdsCredentialsApi - factory interface
 * @export
 */
export const MdsCredentialsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {MdsApiCredentials} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsCreate({ data, options }: ImdsCredentialsCreateProps) {
            return MdsCredentialsApiFp(configuration).mdsCredentialsCreate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsDelete({ id, options }: ImdsCredentialsDeleteProps) {
            return MdsCredentialsApiFp(configuration).mdsCredentialsDelete({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsList({ options }: ImdsCredentialsListProps) {
            return MdsCredentialsApiFp(configuration).mdsCredentialsList({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {MdsApiCredentials} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsPartialUpdate({ id, data, options }: ImdsCredentialsPartialUpdateProps) {
            return MdsCredentialsApiFp(configuration).mdsCredentialsPartialUpdate({ id, data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsRead({ id, options }: ImdsCredentialsReadProps) {
            return MdsCredentialsApiFp(configuration).mdsCredentialsRead({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this mds api credentials.
         * @param {MdsApiCredentials} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mdsCredentialsUpdate({ id, data, options }: ImdsCredentialsUpdateProps) {
            return MdsCredentialsApiFp(configuration).mdsCredentialsUpdate({ id, data, options })(fetch, basePath);
        },
    };
};

/**
 * MdsCredentialsApi - object-oriented interface
 * @export
 * @class MdsCredentialsApi
 * @extends {BaseAPI}
 */
export class MdsCredentialsApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``mdsCredentialsCreate`` for arguments and options.
     *
     */
    public mdsCredentialsCreateURL({ data, options }: ImdsCredentialsCreateProps): FetchArgs {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsCreateURL({ data, options });
    }

    /**
     * 
     * @param {MdsApiCredentials} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdsCredentialsApi
     */
    public mdsCredentialsCreate({ data, options }: ImdsCredentialsCreateProps) {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsCreate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``mdsCredentialsDelete`` for arguments and options.
     *
     */
    public mdsCredentialsDeleteURL({ id, options }: ImdsCredentialsDeleteProps): FetchArgs {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsDeleteURL({ id, options });
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this mds api credentials.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdsCredentialsApi
     */
    public mdsCredentialsDelete({ id, options }: ImdsCredentialsDeleteProps) {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsDelete({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``mdsCredentialsList`` for arguments and options.
     *
     */
    public mdsCredentialsListURL({ options }: ImdsCredentialsListProps = {}): FetchArgs {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdsCredentialsApi
     */
    public mdsCredentialsList({ options }: ImdsCredentialsListProps = {}) {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsList({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``mdsCredentialsPartialUpdate`` for arguments and options.
     *
     */
    public mdsCredentialsPartialUpdateURL({ id, data, options }: ImdsCredentialsPartialUpdateProps): FetchArgs {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsPartialUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this mds api credentials.
     * @param {MdsApiCredentials} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdsCredentialsApi
     */
    public mdsCredentialsPartialUpdate({ id, data, options }: ImdsCredentialsPartialUpdateProps) {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsPartialUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``mdsCredentialsRead`` for arguments and options.
     *
     */
    public mdsCredentialsReadURL({ id, options }: ImdsCredentialsReadProps): FetchArgs {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsReadURL({ id, options });
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this mds api credentials.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdsCredentialsApi
     */
    public mdsCredentialsRead({ id, options }: ImdsCredentialsReadProps) {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsRead({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``mdsCredentialsUpdate`` for arguments and options.
     *
     */
    public mdsCredentialsUpdateURL({ id, data, options }: ImdsCredentialsUpdateProps): FetchArgs {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this mds api credentials.
     * @param {MdsApiCredentials} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MdsCredentialsApi
     */
    public mdsCredentialsUpdate({ id, data, options }: ImdsCredentialsUpdateProps) {
        return MdsCredentialsApiFp(this.configuration).mdsCredentialsUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

}

/**
 * exportFleetOffenseProof parameters
 */
export interface IexportFleetOffenseProofProps {
    pk?: string, // 
    provider_ids?: Array<string>, // 
    vin?: string, // 
    policy_ids?: Array<string>, // 
    policy_types?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>, // 
    jurisdiction_keys?: Array<string>, // 
    start_date_after?: string, // range (lower bound)
    start_date_before?: string, // range (upper bound)
    end_date_after?: string, // range (lower bound)
    end_date_before?: string, // range (upper bound)
    include_abnormals?: boolean, // 
    event_types?: Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    policy_statuses?: Array<'ongoing' | 'finished'>, // 
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    offense_status?: Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>, // 
    lang?: string, // language to which export headers and rows should be translated
    id?: number,
    options?: any,
};

/**
 * exportOffenseList parameters
 */
export interface IexportOffenseListProps {
    pk?: string, // 
    provider_ids?: Array<string>, // 
    vin?: string, // 
    policy_ids?: Array<string>, // 
    policy_types?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>, // 
    jurisdiction_keys?: Array<string>, // 
    start_date_after?: string, // range (lower bound)
    start_date_before?: string, // range (upper bound)
    end_date_after?: string, // range (lower bound)
    end_date_before?: string, // range (upper bound)
    include_abnormals?: boolean, // 
    event_types?: Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    policy_statuses?: Array<'ongoing' | 'finished'>, // 
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    offense_status?: Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>, // 
    lang?: string, // language to which export headers and rows should be translated
    options?: any,
};

/**
 * exportPolicyOffenseList parameters
 */
export interface IexportPolicyOffenseListProps {
    policy_id: string,
    provider_ids?: Array<string>, // 
    start_date_after?: string, // range (lower bound)
    start_date_before?: string, // range (upper bound)
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    end_date_after?: string, // range (lower bound)
    end_date_before?: string, // range (upper bound)
    include_abnormals?: boolean, // 
    event_types?: Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    lang?: string, // language to which export headers and rows should be translated
    options?: any,
};

/**
 * exportPolicyOffenseListNotFilteredByStartDate parameters
 */
export interface IexportPolicyOffenseListNotFilteredByStartDateProps {
    policy_id: string,
    provider_ids?: Array<string>, // 
    start_date_after?: string, // range (lower bound)
    start_date_before?: string, // range (upper bound)
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    end_date_after?: string, // range (lower bound)
    end_date_before?: string, // range (upper bound)
    include_abnormals?: boolean, // 
    event_types?: Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    lang?: string, // language to which export headers and rows should be translated
    options?: any,
};

/**
 * offenseList parameters
 */
export interface IoffenseListProps {
    pk?: string, // 
    provider_ids?: Array<string>, // 
    vin?: string, // 
    policy_ids?: Array<string>, // 
    policy_types?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>, // 
    jurisdiction_keys?: Array<string>, // 
    start_date_after?: string, // range (lower bound)
    start_date_before?: string, // range (upper bound)
    end_date_after?: string, // range (lower bound)
    end_date_before?: string, // range (upper bound)
    include_abnormals?: boolean, // 
    event_types?: Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    policy_statuses?: Array<'ongoing' | 'finished'>, // 
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    offense_status?: Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>, // 
    options?: any,
};

/**
 * offenseMapList parameters
 */
export interface IoffenseMapListProps {
    pk?: string, // 
    provider_ids?: Array<string>, // 
    vin?: string, // 
    policy_ids?: Array<string>, // 
    policy_types?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>, // 
    jurisdiction_keys?: Array<string>, // 
    start_date_after?: string, // range (lower bound)
    start_date_before?: string, // range (upper bound)
    end_date_after?: string, // range (lower bound)
    end_date_before?: string, // range (upper bound)
    include_abnormals?: boolean, // 
    event_types?: Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    policy_statuses?: Array<'ongoing' | 'finished'>, // 
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    offense_status?: Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>, // 
    options?: any,
};

/**
 * offensesExportPictures parameters
 */
export interface IoffensesExportPicturesProps {
    offense_uid: string,
    options?: any,
};

/**
 * policyFacetedGraphs parameters
 */
export interface IpolicyFacetedGraphsProps {
    policy_id: string,
    granularity: 'quarter' | 'month' | 'week' | 'day' | 'hour',
    provider_ids?: Array<string>, // 
    start_date_after?: string, // range (lower bound)
    start_date_before?: string, // range (upper bound)
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    end_date_after?: string, // range (lower bound)
    end_date_before?: string, // range (upper bound)
    include_abnormals?: boolean, // 
    event_types?: Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    options?: any,
};

/**
 * policyOffenseList parameters
 */
export interface IpolicyOffenseListProps {
    policy_id: string,
    provider_ids?: Array<string>, // 
    start_date_after?: string, // range (lower bound)
    start_date_before?: string, // range (upper bound)
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    end_date_after?: string, // range (lower bound)
    end_date_before?: string, // range (upper bound)
    include_abnormals?: boolean, // 
    event_types?: Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    options?: any,
};

/**
 * tripTaxationAmountsList parameters
 */
export interface ItripTaxationAmountsListProps {
    policy_ids: Array<string>,
    provider_ids: Array<string>,
    trip_datetime_range_start: string,
    trip_datetime_range_end: string,
    options?: any,
};

/**
 * tripTaxationFeesExport parameters
 */
export interface ItripTaxationFeesExportProps {
    policy_id: string,
    offset?: number,
    language?: string,
    trip_id?: string,
    provider_ids?: Array<string>,
    distance_min?: number,
    distance_max?: number,
    amount_range_start?: number,
    amount_range_end?: number,
    trip_datetime_range_start?: string,
    trip_datetime_range_end?: string,
    vehicle_types?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>,
    policy_kind?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>,
    options?: any,
};

/**
 * tripTaxationFeesList parameters
 */
export interface ItripTaxationFeesListProps {
    policy_id: string,
    offset?: number,
    language?: string,
    trip_id?: string,
    provider_ids?: Array<string>,
    distance_min?: number,
    distance_max?: number,
    amount_range_start?: number,
    amount_range_end?: number,
    trip_datetime_range_start?: string,
    trip_datetime_range_end?: string,
    vehicle_types?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>,
    policy_kind?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>,
    options?: any,
};

/**
 * tripTaxationLineFeesExport parameters
 */
export interface ItripTaxationLineFeesExportProps {
    policy_ids: Array<string>,
    provider_ids: Array<string>,
    trip_datetime_range_start: string,
    trip_datetime_range_end: string,
    options?: any,
};

/**
 * OffensesApi - fetch parameter creator
 * @export
 */
export const OffensesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFleetOffenseProof({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options = {} }: IexportFleetOffenseProofProps): FetchArgs {
            const localVarPath = `/offenses/export-fleet-offense-proof/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (pk !== undefined) {
                localVarQueryParameter['pk'] = pk;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (vin !== undefined) {
                localVarQueryParameter['vin'] = vin;
            }

            if (policy_ids) {
                localVarQueryParameter['policy_ids'] = policy_ids;
            }

            if (policy_types) {
                localVarQueryParameter['policy_types'] = policy_types;
            }

            if (jurisdiction_keys) {
                localVarQueryParameter['jurisdiction_keys'] = jurisdiction_keys;
            }

            if (start_date_after !== undefined) {
                localVarQueryParameter['start_date_after'] = start_date_after;
            }

            if (start_date_before !== undefined) {
                localVarQueryParameter['start_date_before'] = start_date_before;
            }

            if (end_date_after !== undefined) {
                localVarQueryParameter['end_date_after'] = end_date_after;
            }

            if (end_date_before !== undefined) {
                localVarQueryParameter['end_date_before'] = end_date_before;
            }

            if (include_abnormals !== undefined) {
                localVarQueryParameter['include_abnormals'] = include_abnormals;
            }

            if (event_types) {
                localVarQueryParameter['event_types'] = event_types;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (policy_statuses) {
                localVarQueryParameter['policy_statuses'] = policy_statuses;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (offense_status) {
                localVarQueryParameter['offense_status'] = offense_status;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOffenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options = {} }: IexportOffenseListProps): FetchArgs {
            const localVarPath = `/offenses/export-list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (pk !== undefined) {
                localVarQueryParameter['pk'] = pk;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (vin !== undefined) {
                localVarQueryParameter['vin'] = vin;
            }

            if (policy_ids) {
                localVarQueryParameter['policy_ids'] = policy_ids;
            }

            if (policy_types) {
                localVarQueryParameter['policy_types'] = policy_types;
            }

            if (jurisdiction_keys) {
                localVarQueryParameter['jurisdiction_keys'] = jurisdiction_keys;
            }

            if (start_date_after !== undefined) {
                localVarQueryParameter['start_date_after'] = start_date_after;
            }

            if (start_date_before !== undefined) {
                localVarQueryParameter['start_date_before'] = start_date_before;
            }

            if (end_date_after !== undefined) {
                localVarQueryParameter['end_date_after'] = end_date_after;
            }

            if (end_date_before !== undefined) {
                localVarQueryParameter['end_date_before'] = end_date_before;
            }

            if (include_abnormals !== undefined) {
                localVarQueryParameter['include_abnormals'] = include_abnormals;
            }

            if (event_types) {
                localVarQueryParameter['event_types'] = event_types;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (policy_statuses) {
                localVarQueryParameter['policy_statuses'] = policy_statuses;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (offense_status) {
                localVarQueryParameter['offense_status'] = offense_status;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPolicyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options = {} }: IexportPolicyOffenseListProps): FetchArgs {
            // verify required parameter 'policy_id' is not null or undefined
            if (policy_id === null || policy_id === undefined) {
                throw new RequiredError('policy_id','Required parameter policy_id was null or undefined when calling exportPolicyOffenseList.');
            }
            const localVarPath = `/offenses/export-policy-list/{policy_id}/`
                .replace(`{${"policy_id"}}`, encodeURIComponent(String(policy_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (start_date_after !== undefined) {
                localVarQueryParameter['start_date_after'] = start_date_after;
            }

            if (start_date_before !== undefined) {
                localVarQueryParameter['start_date_before'] = start_date_before;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (end_date_after !== undefined) {
                localVarQueryParameter['end_date_after'] = end_date_after;
            }

            if (end_date_before !== undefined) {
                localVarQueryParameter['end_date_before'] = end_date_before;
            }

            if (include_abnormals !== undefined) {
                localVarQueryParameter['include_abnormals'] = include_abnormals;
            }

            if (event_types) {
                localVarQueryParameter['event_types'] = event_types;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPolicyOffenseListNotFilteredByStartDate({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options = {} }: IexportPolicyOffenseListNotFilteredByStartDateProps): FetchArgs {
            // verify required parameter 'policy_id' is not null or undefined
            if (policy_id === null || policy_id === undefined) {
                throw new RequiredError('policy_id','Required parameter policy_id was null or undefined when calling exportPolicyOffenseListNotFilteredByStartDate.');
            }
            const localVarPath = `/offenses/export-policy-list-not-filtered-by-start-date/{policy_id}/`
                .replace(`{${"policy_id"}}`, encodeURIComponent(String(policy_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (start_date_after !== undefined) {
                localVarQueryParameter['start_date_after'] = start_date_after;
            }

            if (start_date_before !== undefined) {
                localVarQueryParameter['start_date_before'] = start_date_before;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (end_date_after !== undefined) {
                localVarQueryParameter['end_date_after'] = end_date_after;
            }

            if (end_date_before !== undefined) {
                localVarQueryParameter['end_date_before'] = end_date_before;
            }

            if (include_abnormals !== undefined) {
                localVarQueryParameter['include_abnormals'] = include_abnormals;
            }

            if (event_types) {
                localVarQueryParameter['event_types'] = event_types;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options = {} }: IoffenseListProps): FetchArgs {
            const localVarPath = `/offenses/list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (pk !== undefined) {
                localVarQueryParameter['pk'] = pk;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (vin !== undefined) {
                localVarQueryParameter['vin'] = vin;
            }

            if (policy_ids) {
                localVarQueryParameter['policy_ids'] = policy_ids;
            }

            if (policy_types) {
                localVarQueryParameter['policy_types'] = policy_types;
            }

            if (jurisdiction_keys) {
                localVarQueryParameter['jurisdiction_keys'] = jurisdiction_keys;
            }

            if (start_date_after !== undefined) {
                localVarQueryParameter['start_date_after'] = start_date_after;
            }

            if (start_date_before !== undefined) {
                localVarQueryParameter['start_date_before'] = start_date_before;
            }

            if (end_date_after !== undefined) {
                localVarQueryParameter['end_date_after'] = end_date_after;
            }

            if (end_date_before !== undefined) {
                localVarQueryParameter['end_date_before'] = end_date_before;
            }

            if (include_abnormals !== undefined) {
                localVarQueryParameter['include_abnormals'] = include_abnormals;
            }

            if (event_types) {
                localVarQueryParameter['event_types'] = event_types;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (policy_statuses) {
                localVarQueryParameter['policy_statuses'] = policy_statuses;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (offense_status) {
                localVarQueryParameter['offense_status'] = offense_status;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offenseMapList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options = {} }: IoffenseMapListProps): FetchArgs {
            const localVarPath = `/offenses/list_map/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (pk !== undefined) {
                localVarQueryParameter['pk'] = pk;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (vin !== undefined) {
                localVarQueryParameter['vin'] = vin;
            }

            if (policy_ids) {
                localVarQueryParameter['policy_ids'] = policy_ids;
            }

            if (policy_types) {
                localVarQueryParameter['policy_types'] = policy_types;
            }

            if (jurisdiction_keys) {
                localVarQueryParameter['jurisdiction_keys'] = jurisdiction_keys;
            }

            if (start_date_after !== undefined) {
                localVarQueryParameter['start_date_after'] = start_date_after;
            }

            if (start_date_before !== undefined) {
                localVarQueryParameter['start_date_before'] = start_date_before;
            }

            if (end_date_after !== undefined) {
                localVarQueryParameter['end_date_after'] = end_date_after;
            }

            if (end_date_before !== undefined) {
                localVarQueryParameter['end_date_before'] = end_date_before;
            }

            if (include_abnormals !== undefined) {
                localVarQueryParameter['include_abnormals'] = include_abnormals;
            }

            if (event_types) {
                localVarQueryParameter['event_types'] = event_types;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (policy_statuses) {
                localVarQueryParameter['policy_statuses'] = policy_statuses;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (offense_status) {
                localVarQueryParameter['offense_status'] = offense_status;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offense_uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offensesExportPictures({ offense_uid, options = {} }: IoffensesExportPicturesProps): FetchArgs {
            // verify required parameter 'offense_uid' is not null or undefined
            if (offense_uid === null || offense_uid === undefined) {
                throw new RequiredError('offense_uid','Required parameter offense_uid was null or undefined when calling offensesExportPictures.');
            }
            const localVarPath = `/offenses/export-pictures/{offense_uid}`
                .replace(`{${"offense_uid"}}`, encodeURIComponent(String(offense_uid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {'quarter' | 'month' | 'week' | 'day' | 'hour'} granularity 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyFacetedGraphs({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options = {} }: IpolicyFacetedGraphsProps): FetchArgs {
            // verify required parameter 'policy_id' is not null or undefined
            if (policy_id === null || policy_id === undefined) {
                throw new RequiredError('policy_id','Required parameter policy_id was null or undefined when calling policyFacetedGraphs.');
            }
            // verify required parameter 'granularity' is not null or undefined
            if (granularity === null || granularity === undefined) {
                throw new RequiredError('granularity','Required parameter granularity was null or undefined when calling policyFacetedGraphs.');
            }
            const localVarPath = `/offenses/policy-faceted-graphs/{policy_id}/`
                .replace(`{${"policy_id"}}`, encodeURIComponent(String(policy_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (start_date_after !== undefined) {
                localVarQueryParameter['start_date_after'] = start_date_after;
            }

            if (start_date_before !== undefined) {
                localVarQueryParameter['start_date_before'] = start_date_before;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (end_date_after !== undefined) {
                localVarQueryParameter['end_date_after'] = end_date_after;
            }

            if (end_date_before !== undefined) {
                localVarQueryParameter['end_date_before'] = end_date_before;
            }

            if (include_abnormals !== undefined) {
                localVarQueryParameter['include_abnormals'] = include_abnormals;
            }

            if (event_types) {
                localVarQueryParameter['event_types'] = event_types;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options = {} }: IpolicyOffenseListProps): FetchArgs {
            // verify required parameter 'policy_id' is not null or undefined
            if (policy_id === null || policy_id === undefined) {
                throw new RequiredError('policy_id','Required parameter policy_id was null or undefined when calling policyOffenseList.');
            }
            const localVarPath = `/offenses/policy-list/{policy_id}/`
                .replace(`{${"policy_id"}}`, encodeURIComponent(String(policy_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (start_date_after !== undefined) {
                localVarQueryParameter['start_date_after'] = start_date_after;
            }

            if (start_date_before !== undefined) {
                localVarQueryParameter['start_date_before'] = start_date_before;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (end_date_after !== undefined) {
                localVarQueryParameter['end_date_after'] = end_date_after;
            }

            if (end_date_before !== undefined) {
                localVarQueryParameter['end_date_before'] = end_date_before;
            }

            if (include_abnormals !== undefined) {
                localVarQueryParameter['include_abnormals'] = include_abnormals;
            }

            if (event_types) {
                localVarQueryParameter['event_types'] = event_types;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} policy_ids 
         * @param {Array<string>} provider_ids 
         * @param {string} trip_datetime_range_start 
         * @param {string} trip_datetime_range_end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationAmountsList({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options = {} }: ItripTaxationAmountsListProps): FetchArgs {
            // verify required parameter 'policy_ids' is not null or undefined
            if (policy_ids === null || policy_ids === undefined) {
                throw new RequiredError('policy_ids','Required parameter policy_ids was null or undefined when calling tripTaxationAmountsList.');
            }
            // verify required parameter 'provider_ids' is not null or undefined
            if (provider_ids === null || provider_ids === undefined) {
                throw new RequiredError('provider_ids','Required parameter provider_ids was null or undefined when calling tripTaxationAmountsList.');
            }
            // verify required parameter 'trip_datetime_range_start' is not null or undefined
            if (trip_datetime_range_start === null || trip_datetime_range_start === undefined) {
                throw new RequiredError('trip_datetime_range_start','Required parameter trip_datetime_range_start was null or undefined when calling tripTaxationAmountsList.');
            }
            // verify required parameter 'trip_datetime_range_end' is not null or undefined
            if (trip_datetime_range_end === null || trip_datetime_range_end === undefined) {
                throw new RequiredError('trip_datetime_range_end','Required parameter trip_datetime_range_end was null or undefined when calling tripTaxationAmountsList.');
            }
            const localVarPath = `/offenses/trip-taxation-amounts-list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (policy_ids) {
                localVarQueryParameter['policy_ids'] = policy_ids;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (trip_datetime_range_start !== undefined) {
                localVarQueryParameter['trip_datetime_range_start'] = trip_datetime_range_start;
            }

            if (trip_datetime_range_end !== undefined) {
                localVarQueryParameter['trip_datetime_range_end'] = trip_datetime_range_end;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {number} [offset] 
         * @param {string} [language] 
         * @param {string} [trip_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [amount_range_start] 
         * @param {number} [amount_range_end] 
         * @param {string} [trip_datetime_range_start] 
         * @param {string} [trip_datetime_range_end] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_types] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationFeesExport({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options = {} }: ItripTaxationFeesExportProps): FetchArgs {
            // verify required parameter 'policy_id' is not null or undefined
            if (policy_id === null || policy_id === undefined) {
                throw new RequiredError('policy_id','Required parameter policy_id was null or undefined when calling tripTaxationFeesExport.');
            }
            const localVarPath = `/offenses/export-trip-taxation-fees/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (policy_id !== undefined) {
                localVarQueryParameter['policy_id'] = policy_id;
            }

            if (trip_id !== undefined) {
                localVarQueryParameter['trip_id'] = trip_id;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (distance_min !== undefined) {
                localVarQueryParameter['distance_min'] = distance_min;
            }

            if (distance_max !== undefined) {
                localVarQueryParameter['distance_max'] = distance_max;
            }

            if (amount_range_start !== undefined) {
                localVarQueryParameter['amount_range_start'] = amount_range_start;
            }

            if (amount_range_end !== undefined) {
                localVarQueryParameter['amount_range_end'] = amount_range_end;
            }

            if (trip_datetime_range_start !== undefined) {
                localVarQueryParameter['trip_datetime_range_start'] = trip_datetime_range_start;
            }

            if (trip_datetime_range_end !== undefined) {
                localVarQueryParameter['trip_datetime_range_end'] = trip_datetime_range_end;
            }

            if (vehicle_types) {
                localVarQueryParameter['vehicle_types'] = vehicle_types;
            }

            if (policy_kind) {
                localVarQueryParameter['policy_kind'] = policy_kind;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {number} [offset] 
         * @param {string} [language] 
         * @param {string} [trip_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [amount_range_start] 
         * @param {number} [amount_range_end] 
         * @param {string} [trip_datetime_range_start] 
         * @param {string} [trip_datetime_range_end] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_types] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationFeesList({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options = {} }: ItripTaxationFeesListProps): FetchArgs {
            // verify required parameter 'policy_id' is not null or undefined
            if (policy_id === null || policy_id === undefined) {
                throw new RequiredError('policy_id','Required parameter policy_id was null or undefined when calling tripTaxationFeesList.');
            }
            const localVarPath = `/offenses/trip-taxation-fees/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (policy_id !== undefined) {
                localVarQueryParameter['policy_id'] = policy_id;
            }

            if (trip_id !== undefined) {
                localVarQueryParameter['trip_id'] = trip_id;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (distance_min !== undefined) {
                localVarQueryParameter['distance_min'] = distance_min;
            }

            if (distance_max !== undefined) {
                localVarQueryParameter['distance_max'] = distance_max;
            }

            if (amount_range_start !== undefined) {
                localVarQueryParameter['amount_range_start'] = amount_range_start;
            }

            if (amount_range_end !== undefined) {
                localVarQueryParameter['amount_range_end'] = amount_range_end;
            }

            if (trip_datetime_range_start !== undefined) {
                localVarQueryParameter['trip_datetime_range_start'] = trip_datetime_range_start;
            }

            if (trip_datetime_range_end !== undefined) {
                localVarQueryParameter['trip_datetime_range_end'] = trip_datetime_range_end;
            }

            if (vehicle_types) {
                localVarQueryParameter['vehicle_types'] = vehicle_types;
            }

            if (policy_kind) {
                localVarQueryParameter['policy_kind'] = policy_kind;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} policy_ids 
         * @param {Array<string>} provider_ids 
         * @param {string} trip_datetime_range_start 
         * @param {string} trip_datetime_range_end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationLineFeesExport({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options = {} }: ItripTaxationLineFeesExportProps): FetchArgs {
            // verify required parameter 'policy_ids' is not null or undefined
            if (policy_ids === null || policy_ids === undefined) {
                throw new RequiredError('policy_ids','Required parameter policy_ids was null or undefined when calling tripTaxationLineFeesExport.');
            }
            // verify required parameter 'provider_ids' is not null or undefined
            if (provider_ids === null || provider_ids === undefined) {
                throw new RequiredError('provider_ids','Required parameter provider_ids was null or undefined when calling tripTaxationLineFeesExport.');
            }
            // verify required parameter 'trip_datetime_range_start' is not null or undefined
            if (trip_datetime_range_start === null || trip_datetime_range_start === undefined) {
                throw new RequiredError('trip_datetime_range_start','Required parameter trip_datetime_range_start was null or undefined when calling tripTaxationLineFeesExport.');
            }
            // verify required parameter 'trip_datetime_range_end' is not null or undefined
            if (trip_datetime_range_end === null || trip_datetime_range_end === undefined) {
                throw new RequiredError('trip_datetime_range_end','Required parameter trip_datetime_range_end was null or undefined when calling tripTaxationLineFeesExport.');
            }
            const localVarPath = `/offenses/export-trip-taxation-fees-lines/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (policy_ids) {
                localVarQueryParameter['policy_ids'] = policy_ids;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (trip_datetime_range_start !== undefined) {
                localVarQueryParameter['trip_datetime_range_start'] = trip_datetime_range_start;
            }

            if (trip_datetime_range_end !== undefined) {
                localVarQueryParameter['trip_datetime_range_end'] = trip_datetime_range_end;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OffensesApi - functional programming interface
 * @export
 */
export const OffensesApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        exportFleetOffenseProofURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options }: IexportFleetOffenseProofProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).exportFleetOffenseProof({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options });
        },

        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFleetOffenseProof({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options }: IexportFleetOffenseProofProps): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = this.exportFleetOffenseProofURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        exportOffenseListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options }: IexportOffenseListProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).exportOffenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options });
        },

        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOffenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options }: IexportOffenseListProps): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = this.exportOffenseListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        exportPolicyOffenseListURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options }: IexportPolicyOffenseListProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).exportPolicyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options });
        },

        /**
         * 
         * @param {string} policy_id 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPolicyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options }: IexportPolicyOffenseListProps): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = this.exportPolicyOffenseListURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        exportPolicyOffenseListNotFilteredByStartDateURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options }: IexportPolicyOffenseListNotFilteredByStartDateProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).exportPolicyOffenseListNotFilteredByStartDate({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options });
        },

        /**
         * 
         * @param {string} policy_id 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPolicyOffenseListNotFilteredByStartDate({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options }: IexportPolicyOffenseListNotFilteredByStartDateProps): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = this.exportPolicyOffenseListNotFilteredByStartDateURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        offenseListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options }: IoffenseListProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).offenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options });
        },

        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options }: IoffenseListProps): (fetch?: FetchAPI, basePath?: string) => Promise<OffenseListResponse> {
            const localVarFetchArgs = this.offenseListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        offenseMapListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options }: IoffenseMapListProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).offenseMapList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options });
        },

        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offenseMapList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options }: IoffenseMapListProps): (fetch?: FetchAPI, basePath?: string) => Promise<OffenseMapListResponse> {
            const localVarFetchArgs = this.offenseMapListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        offensesExportPicturesURL({ offense_uid, options }: IoffensesExportPicturesProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).offensesExportPictures({ offense_uid, options });
        },

        /**
         * 
         * @param {string} offense_uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offensesExportPictures({ offense_uid, options }: IoffensesExportPicturesProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.offensesExportPicturesURL({ offense_uid, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policyFacetedGraphsURL({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options }: IpolicyFacetedGraphsProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).policyFacetedGraphs({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options });
        },

        /**
         * 
         * @param {string} policy_id 
         * @param {'quarter' | 'month' | 'week' | 'day' | 'hour'} granularity 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyFacetedGraphs({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options }: IpolicyFacetedGraphsProps): (fetch?: FetchAPI, basePath?: string) => Promise<PolicyFacetedGraphsResponse> {
            const localVarFetchArgs = this.policyFacetedGraphsURL({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policyOffenseListURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options }: IpolicyOffenseListProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).policyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options });
        },

        /**
         * 
         * @param {string} policy_id 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options }: IpolicyOffenseListProps): (fetch?: FetchAPI, basePath?: string) => Promise<PolicyOffenseListResponse> {
            const localVarFetchArgs = this.policyOffenseListURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        tripTaxationAmountsListURL({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options }: ItripTaxationAmountsListProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).tripTaxationAmountsList({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options });
        },

        /**
         * 
         * @param {Array<string>} policy_ids 
         * @param {Array<string>} provider_ids 
         * @param {string} trip_datetime_range_start 
         * @param {string} trip_datetime_range_end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationAmountsList({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options }: ItripTaxationAmountsListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TripTaxationFeesAmountsByProviderResponse>> {
            const localVarFetchArgs = this.tripTaxationAmountsListURL({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        tripTaxationFeesExportURL({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options }: ItripTaxationFeesExportProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).tripTaxationFeesExport({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options });
        },

        /**
         * 
         * @param {string} policy_id 
         * @param {number} [offset] 
         * @param {string} [language] 
         * @param {string} [trip_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [amount_range_start] 
         * @param {number} [amount_range_end] 
         * @param {string} [trip_datetime_range_start] 
         * @param {string} [trip_datetime_range_end] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_types] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationFeesExport({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options }: ItripTaxationFeesExportProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TripTaxationFee>> {
            const localVarFetchArgs = this.tripTaxationFeesExportURL({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        tripTaxationFeesListURL({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options }: ItripTaxationFeesListProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).tripTaxationFeesList({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options });
        },

        /**
         * 
         * @param {string} policy_id 
         * @param {number} [offset] 
         * @param {string} [language] 
         * @param {string} [trip_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [amount_range_start] 
         * @param {number} [amount_range_end] 
         * @param {string} [trip_datetime_range_start] 
         * @param {string} [trip_datetime_range_end] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_types] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationFeesList({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options }: ItripTaxationFeesListProps): (fetch?: FetchAPI, basePath?: string) => Promise<TripTaxationFeesResponse> {
            const localVarFetchArgs = this.tripTaxationFeesListURL({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        tripTaxationLineFeesExportURL({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options }: ItripTaxationLineFeesExportProps): FetchArgs {
            return OffensesApiFetchParamCreator(configuration).tripTaxationLineFeesExport({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options });
        },

        /**
         * 
         * @param {Array<string>} policy_ids 
         * @param {Array<string>} provider_ids 
         * @param {string} trip_datetime_range_start 
         * @param {string} trip_datetime_range_end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationLineFeesExport({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options }: ItripTaxationLineFeesExportProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TripTaxationFee>> {
            const localVarFetchArgs = this.tripTaxationLineFeesExportURL({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * OffensesApi - factory interface
 * @export
 */
export const OffensesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFleetOffenseProof({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options }: IexportFleetOffenseProofProps) {
            return OffensesApiFp(configuration).exportFleetOffenseProof({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOffenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options }: IexportOffenseListProps) {
            return OffensesApiFp(configuration).exportOffenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPolicyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options }: IexportPolicyOffenseListProps) {
            return OffensesApiFp(configuration).exportPolicyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [lang] language to which export headers and rows should be translated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPolicyOffenseListNotFilteredByStartDate({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options }: IexportPolicyOffenseListNotFilteredByStartDateProps) {
            return OffensesApiFp(configuration).exportPolicyOffenseListNotFilteredByStartDate({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options }: IoffenseListProps) {
            return OffensesApiFp(configuration).offenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} [pk] 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [vin] 
         * @param {Array<string>} [policy_ids] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
         * @param {Array<string>} [jurisdiction_keys] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offenseMapList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options }: IoffenseMapListProps) {
            return OffensesApiFp(configuration).offenseMapList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} offense_uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offensesExportPictures({ offense_uid, options }: IoffensesExportPicturesProps) {
            return OffensesApiFp(configuration).offensesExportPictures({ offense_uid, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {'quarter' | 'month' | 'week' | 'day' | 'hour'} granularity 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyFacetedGraphs({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options }: IpolicyFacetedGraphsProps) {
            return OffensesApiFp(configuration).policyFacetedGraphs({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {Array<string>} [provider_ids] 
         * @param {string} [start_date_after] range (lower bound)
         * @param {string} [start_date_before] range (upper bound)
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {string} [end_date_after] range (lower bound)
         * @param {string} [end_date_before] range (upper bound)
         * @param {boolean} [include_abnormals] 
         * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options }: IpolicyOffenseListProps) {
            return OffensesApiFp(configuration).policyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options })(fetch, basePath);
        },
        /**
         * 
         * @param {Array<string>} policy_ids 
         * @param {Array<string>} provider_ids 
         * @param {string} trip_datetime_range_start 
         * @param {string} trip_datetime_range_end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationAmountsList({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options }: ItripTaxationAmountsListProps) {
            return OffensesApiFp(configuration).tripTaxationAmountsList({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {number} [offset] 
         * @param {string} [language] 
         * @param {string} [trip_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [amount_range_start] 
         * @param {number} [amount_range_end] 
         * @param {string} [trip_datetime_range_start] 
         * @param {string} [trip_datetime_range_end] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_types] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationFeesExport({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options }: ItripTaxationFeesExportProps) {
            return OffensesApiFp(configuration).tripTaxationFeesExport({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} policy_id 
         * @param {number} [offset] 
         * @param {string} [language] 
         * @param {string} [trip_id] 
         * @param {Array<string>} [provider_ids] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [amount_range_start] 
         * @param {number} [amount_range_end] 
         * @param {string} [trip_datetime_range_start] 
         * @param {string} [trip_datetime_range_end] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_types] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationFeesList({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options }: ItripTaxationFeesListProps) {
            return OffensesApiFp(configuration).tripTaxationFeesList({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options })(fetch, basePath);
        },
        /**
         * 
         * @param {Array<string>} policy_ids 
         * @param {Array<string>} provider_ids 
         * @param {string} trip_datetime_range_start 
         * @param {string} trip_datetime_range_end 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTaxationLineFeesExport({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options }: ItripTaxationLineFeesExportProps) {
            return OffensesApiFp(configuration).tripTaxationLineFeesExport({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options })(fetch, basePath);
        },
    };
};

/**
 * OffensesApi - object-oriented interface
 * @export
 * @class OffensesApi
 * @extends {BaseAPI}
 */
export class OffensesApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``exportFleetOffenseProof`` for arguments and options.
     *
     */
    public exportFleetOffenseProofURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options }: IexportFleetOffenseProofProps = {}): FetchArgs {
        return OffensesApiFp(this.configuration).exportFleetOffenseProofURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options });
    }

    /**
     * 
     * @param {string} [pk] 
     * @param {Array<string>} [provider_ids] 
     * @param {string} [vin] 
     * @param {Array<string>} [policy_ids] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
     * @param {Array<string>} [jurisdiction_keys] 
     * @param {string} [start_date_after] range (lower bound)
     * @param {string} [start_date_before] range (upper bound)
     * @param {string} [end_date_after] range (lower bound)
     * @param {string} [end_date_before] range (upper bound)
     * @param {boolean} [include_abnormals] 
     * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
     * @param {string} [lang] language to which export headers and rows should be translated
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public exportFleetOffenseProof({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options }: IexportFleetOffenseProofProps = {}) {
        return OffensesApiFp(this.configuration).exportFleetOffenseProof({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``exportOffenseList`` for arguments and options.
     *
     */
    public exportOffenseListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options }: IexportOffenseListProps = {}): FetchArgs {
        return OffensesApiFp(this.configuration).exportOffenseListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options });
    }

    /**
     * 
     * @param {string} [pk] 
     * @param {Array<string>} [provider_ids] 
     * @param {string} [vin] 
     * @param {Array<string>} [policy_ids] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
     * @param {Array<string>} [jurisdiction_keys] 
     * @param {string} [start_date_after] range (lower bound)
     * @param {string} [start_date_before] range (upper bound)
     * @param {string} [end_date_after] range (lower bound)
     * @param {string} [end_date_before] range (upper bound)
     * @param {boolean} [include_abnormals] 
     * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
     * @param {string} [lang] language to which export headers and rows should be translated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public exportOffenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options }: IexportOffenseListProps = {}) {
        return OffensesApiFp(this.configuration).exportOffenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, lang, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``exportPolicyOffenseList`` for arguments and options.
     *
     */
    public exportPolicyOffenseListURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options }: IexportPolicyOffenseListProps): FetchArgs {
        return OffensesApiFp(this.configuration).exportPolicyOffenseListURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options });
    }

    /**
     * 
     * @param {string} policy_id 
     * @param {Array<string>} [provider_ids] 
     * @param {string} [start_date_after] range (lower bound)
     * @param {string} [start_date_before] range (upper bound)
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {string} [end_date_after] range (lower bound)
     * @param {string} [end_date_before] range (upper bound)
     * @param {boolean} [include_abnormals] 
     * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {string} [lang] language to which export headers and rows should be translated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public exportPolicyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options }: IexportPolicyOffenseListProps) {
        return OffensesApiFp(this.configuration).exportPolicyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``exportPolicyOffenseListNotFilteredByStartDate`` for arguments and options.
     *
     */
    public exportPolicyOffenseListNotFilteredByStartDateURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options }: IexportPolicyOffenseListNotFilteredByStartDateProps): FetchArgs {
        return OffensesApiFp(this.configuration).exportPolicyOffenseListNotFilteredByStartDateURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options });
    }

    /**
     * 
     * @param {string} policy_id 
     * @param {Array<string>} [provider_ids] 
     * @param {string} [start_date_after] range (lower bound)
     * @param {string} [start_date_before] range (upper bound)
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {string} [end_date_after] range (lower bound)
     * @param {string} [end_date_before] range (upper bound)
     * @param {boolean} [include_abnormals] 
     * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {string} [lang] language to which export headers and rows should be translated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public exportPolicyOffenseListNotFilteredByStartDate({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options }: IexportPolicyOffenseListNotFilteredByStartDateProps) {
        return OffensesApiFp(this.configuration).exportPolicyOffenseListNotFilteredByStartDate({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, lang, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``offenseList`` for arguments and options.
     *
     */
    public offenseListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options }: IoffenseListProps = {}): FetchArgs {
        return OffensesApiFp(this.configuration).offenseListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options });
    }

    /**
     * 
     * @param {string} [pk] 
     * @param {Array<string>} [provider_ids] 
     * @param {string} [vin] 
     * @param {Array<string>} [policy_ids] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
     * @param {Array<string>} [jurisdiction_keys] 
     * @param {string} [start_date_after] range (lower bound)
     * @param {string} [start_date_before] range (upper bound)
     * @param {string} [end_date_after] range (lower bound)
     * @param {string} [end_date_before] range (upper bound)
     * @param {boolean} [include_abnormals] 
     * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public offenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options }: IoffenseListProps = {}) {
        return OffensesApiFp(this.configuration).offenseList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``offenseMapList`` for arguments and options.
     *
     */
    public offenseMapListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options }: IoffenseMapListProps = {}): FetchArgs {
        return OffensesApiFp(this.configuration).offenseMapListURL({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options });
    }

    /**
     * 
     * @param {string} [pk] 
     * @param {Array<string>} [provider_ids] 
     * @param {string} [vin] 
     * @param {Array<string>} [policy_ids] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_types] 
     * @param {Array<string>} [jurisdiction_keys] 
     * @param {string} [start_date_after] range (lower bound)
     * @param {string} [start_date_before] range (upper bound)
     * @param {string} [end_date_after] range (lower bound)
     * @param {string} [end_date_before] range (upper bound)
     * @param {boolean} [include_abnormals] 
     * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {Array<'ongoing' | 'finished'>} [policy_statuses] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<'auto_confirmed' | 'confirmed_by_agent' | 'agent_to_check' | 'invalidated'>} [offense_status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public offenseMapList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options }: IoffenseMapListProps = {}) {
        return OffensesApiFp(this.configuration).offenseMapList({ pk, provider_ids, vin, policy_ids, policy_types, jurisdiction_keys, start_date_after, start_date_before, end_date_after, end_date_before, include_abnormals, event_types, status, policy_statuses, vehicle_type, offense_status, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``offensesExportPictures`` for arguments and options.
     *
     */
    public offensesExportPicturesURL({ offense_uid, options }: IoffensesExportPicturesProps): FetchArgs {
        return OffensesApiFp(this.configuration).offensesExportPicturesURL({ offense_uid, options });
    }

    /**
     * 
     * @param {string} offense_uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public offensesExportPictures({ offense_uid, options }: IoffensesExportPicturesProps) {
        return OffensesApiFp(this.configuration).offensesExportPictures({ offense_uid, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policyFacetedGraphs`` for arguments and options.
     *
     */
    public policyFacetedGraphsURL({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options }: IpolicyFacetedGraphsProps): FetchArgs {
        return OffensesApiFp(this.configuration).policyFacetedGraphsURL({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options });
    }

    /**
     * 
     * @param {string} policy_id 
     * @param {'quarter' | 'month' | 'week' | 'day' | 'hour'} granularity 
     * @param {Array<string>} [provider_ids] 
     * @param {string} [start_date_after] range (lower bound)
     * @param {string} [start_date_before] range (upper bound)
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {string} [end_date_after] range (lower bound)
     * @param {string} [end_date_before] range (upper bound)
     * @param {boolean} [include_abnormals] 
     * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public policyFacetedGraphs({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options }: IpolicyFacetedGraphsProps) {
        return OffensesApiFp(this.configuration).policyFacetedGraphs({ policy_id, granularity, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policyOffenseList`` for arguments and options.
     *
     */
    public policyOffenseListURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options }: IpolicyOffenseListProps): FetchArgs {
        return OffensesApiFp(this.configuration).policyOffenseListURL({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options });
    }

    /**
     * 
     * @param {string} policy_id 
     * @param {Array<string>} [provider_ids] 
     * @param {string} [start_date_after] range (lower bound)
     * @param {string} [start_date_before] range (upper bound)
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {string} [end_date_after] range (lower bound)
     * @param {string} [end_date_before] range (upper bound)
     * @param {boolean} [include_abnormals] 
     * @param {Array<'agency_drop_off' | 'agency_pick_up' | 'battery_charged' | 'battery_low' | 'comms_lost' | 'comms_restored' | 'compliance_pick_up' | 'decommissioned' | 'driver_cancellation' | 'located' | 'maintenance' | 'maintenance_pick_up' | 'missing' | 'off_hours' | 'on_hours' | 'passenger_cancellation' | 'provider_drop_off' | 'rebalance_pick_up' | 'reservation_cancel' | 'reservation_start' | 'reservation_stop' | 'service_end' | 'system_resume' | 'system_start' | 'system_suspend' | 'trip_cancel' | 'trip_end' | 'trip_enter_jurisdiction' | 'trip_leave_jurisdiction' | 'trip_start' | 'trip_stop' | 'unspecified' | 'notification_sent' | 'changed_geographies' | 'charging_end' | 'charging_start' | 'customer_cancellation' | 'fueling_end' | 'fueling_start' | 'maintenance_end' | 'not_located' | 'order_drop_off' | 'order_pick_up' | 'provider_cancellation' | 'recommission' | 'remote_end' | 'remote_start' | 'service_start' | 'trip_pause' | 'trip_resume'>} [event_types] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public policyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options }: IpolicyOffenseListProps) {
        return OffensesApiFp(this.configuration).policyOffenseList({ policy_id, provider_ids, start_date_after, start_date_before, vehicle_type, end_date_after, end_date_before, include_abnormals, event_types, status, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``tripTaxationAmountsList`` for arguments and options.
     *
     */
    public tripTaxationAmountsListURL({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options }: ItripTaxationAmountsListProps): FetchArgs {
        return OffensesApiFp(this.configuration).tripTaxationAmountsListURL({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options });
    }

    /**
     * 
     * @param {Array<string>} policy_ids 
     * @param {Array<string>} provider_ids 
     * @param {string} trip_datetime_range_start 
     * @param {string} trip_datetime_range_end 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public tripTaxationAmountsList({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options }: ItripTaxationAmountsListProps) {
        return OffensesApiFp(this.configuration).tripTaxationAmountsList({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``tripTaxationFeesExport`` for arguments and options.
     *
     */
    public tripTaxationFeesExportURL({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options }: ItripTaxationFeesExportProps): FetchArgs {
        return OffensesApiFp(this.configuration).tripTaxationFeesExportURL({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options });
    }

    /**
     * 
     * @param {string} policy_id 
     * @param {number} [offset] 
     * @param {string} [language] 
     * @param {string} [trip_id] 
     * @param {Array<string>} [provider_ids] 
     * @param {number} [distance_min] 
     * @param {number} [distance_max] 
     * @param {number} [amount_range_start] 
     * @param {number} [amount_range_end] 
     * @param {string} [trip_datetime_range_start] 
     * @param {string} [trip_datetime_range_end] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_types] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_kind] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public tripTaxationFeesExport({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options }: ItripTaxationFeesExportProps) {
        return OffensesApiFp(this.configuration).tripTaxationFeesExport({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``tripTaxationFeesList`` for arguments and options.
     *
     */
    public tripTaxationFeesListURL({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options }: ItripTaxationFeesListProps): FetchArgs {
        return OffensesApiFp(this.configuration).tripTaxationFeesListURL({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options });
    }

    /**
     * 
     * @param {string} policy_id 
     * @param {number} [offset] 
     * @param {string} [language] 
     * @param {string} [trip_id] 
     * @param {Array<string>} [provider_ids] 
     * @param {number} [distance_min] 
     * @param {number} [distance_max] 
     * @param {number} [amount_range_start] 
     * @param {number} [amount_range_end] 
     * @param {string} [trip_datetime_range_start] 
     * @param {string} [trip_datetime_range_end] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_types] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [policy_kind] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public tripTaxationFeesList({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options }: ItripTaxationFeesListProps) {
        return OffensesApiFp(this.configuration).tripTaxationFeesList({ policy_id, offset, language, trip_id, provider_ids, distance_min, distance_max, amount_range_start, amount_range_end, trip_datetime_range_start, trip_datetime_range_end, vehicle_types, policy_kind, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``tripTaxationLineFeesExport`` for arguments and options.
     *
     */
    public tripTaxationLineFeesExportURL({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options }: ItripTaxationLineFeesExportProps): FetchArgs {
        return OffensesApiFp(this.configuration).tripTaxationLineFeesExportURL({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options });
    }

    /**
     * 
     * @param {Array<string>} policy_ids 
     * @param {Array<string>} provider_ids 
     * @param {string} trip_datetime_range_start 
     * @param {string} trip_datetime_range_end 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OffensesApi
     */
    public tripTaxationLineFeesExport({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options }: ItripTaxationLineFeesExportProps) {
        return OffensesApiFp(this.configuration).tripTaxationLineFeesExport({ policy_ids, provider_ids, trip_datetime_range_start, trip_datetime_range_end, options })(this.fetchData, this.basePath);
    }

}

/**
 * changePassword parameters
 */
export interface IchangePasswordProps {
    data: ChangePassword,
    options?: any,
};

/**
 * PasswordApi - fetch parameter creator
 * @export
 */
export const PasswordApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ChangePassword} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword({ data, options = {} }: IchangePasswordProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling changePassword.');
            }
            const localVarPath = `/password/change`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChangePassword" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PasswordApi - functional programming interface
 * @export
 */
export const PasswordApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        changePasswordURL({ data, options }: IchangePasswordProps): FetchArgs {
            return PasswordApiFetchParamCreator(configuration).changePassword({ data, options });
        },

        /**
         * 
         * @param {ChangePassword} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword({ data, options }: IchangePasswordProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.changePasswordURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * PasswordApi - factory interface
 * @export
 */
export const PasswordApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {ChangePassword} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword({ data, options }: IchangePasswordProps) {
            return PasswordApiFp(configuration).changePassword({ data, options })(fetch, basePath);
        },
    };
};

/**
 * PasswordApi - object-oriented interface
 * @export
 * @class PasswordApi
 * @extends {BaseAPI}
 */
export class PasswordApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``changePassword`` for arguments and options.
     *
     */
    public changePasswordURL({ data, options }: IchangePasswordProps): FetchArgs {
        return PasswordApiFp(this.configuration).changePasswordURL({ data, options });
    }

    /**
     * 
     * @param {ChangePassword} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApi
     */
    public changePassword({ data, options }: IchangePasswordProps) {
        return PasswordApiFp(this.configuration).changePassword({ data, options })(this.fetchData, this.basePath);
    }

}

/**
 * penaltySchemesCreate parameters
 */
export interface IpenaltySchemesCreateProps {
    data: CreatePenaltyScheme,
    options?: any,
};

/**
 * penaltySchemesDelete parameters
 */
export interface IpenaltySchemesDeleteProps {
    id: string, // A UUID string identifying this penalty scheme.
    options?: any,
};

/**
 * penaltySchemesList parameters
 */
export interface IpenaltySchemesListProps {
    is_fee_rates?: boolean, // 
    limit?: number, // Number of results to return per page.
    offset?: number, // The initial index from which to return the results.
    options?: any,
};

/**
 * PenaltySchemesApi - fetch parameter creator
 * @export
 */
export const PenaltySchemesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreatePenaltyScheme} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        penaltySchemesCreate({ data, options = {} }: IpenaltySchemesCreateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling penaltySchemesCreate.');
            }
            const localVarPath = `/penalty_schemes/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreatePenaltyScheme" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this penalty scheme.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        penaltySchemesDelete({ id, options = {} }: IpenaltySchemesDeleteProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling penaltySchemesDelete.');
            }
            const localVarPath = `/penalty_schemes/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [is_fee_rates] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        penaltySchemesList({ is_fee_rates, limit, offset, options = {} }: IpenaltySchemesListProps): FetchArgs {
            const localVarPath = `/penalty_schemes/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (is_fee_rates !== undefined) {
                localVarQueryParameter['is_fee_rates'] = is_fee_rates;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PenaltySchemesApi - functional programming interface
 * @export
 */
export const PenaltySchemesApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        penaltySchemesCreateURL({ data, options }: IpenaltySchemesCreateProps): FetchArgs {
            return PenaltySchemesApiFetchParamCreator(configuration).penaltySchemesCreate({ data, options });
        },

        /**
         * 
         * @param {CreatePenaltyScheme} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        penaltySchemesCreate({ data, options }: IpenaltySchemesCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<PenaltyScheme> {
            const localVarFetchArgs = this.penaltySchemesCreateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        penaltySchemesDeleteURL({ id, options }: IpenaltySchemesDeleteProps): FetchArgs {
            return PenaltySchemesApiFetchParamCreator(configuration).penaltySchemesDelete({ id, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this penalty scheme.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        penaltySchemesDelete({ id, options }: IpenaltySchemesDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.penaltySchemesDeleteURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        penaltySchemesListURL({ is_fee_rates, limit, offset, options }: IpenaltySchemesListProps): FetchArgs {
            return PenaltySchemesApiFetchParamCreator(configuration).penaltySchemesList({ is_fee_rates, limit, offset, options });
        },

        /**
         * 
         * @param {boolean} [is_fee_rates] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        penaltySchemesList({ is_fee_rates, limit, offset, options }: IpenaltySchemesListProps): (fetch?: FetchAPI, basePath?: string) => Promise<PenaltyScheme> {
            const localVarFetchArgs = this.penaltySchemesListURL({ is_fee_rates, limit, offset, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * PenaltySchemesApi - factory interface
 * @export
 */
export const PenaltySchemesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {CreatePenaltyScheme} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        penaltySchemesCreate({ data, options }: IpenaltySchemesCreateProps) {
            return PenaltySchemesApiFp(configuration).penaltySchemesCreate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this penalty scheme.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        penaltySchemesDelete({ id, options }: IpenaltySchemesDeleteProps) {
            return PenaltySchemesApiFp(configuration).penaltySchemesDelete({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {boolean} [is_fee_rates] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        penaltySchemesList({ is_fee_rates, limit, offset, options }: IpenaltySchemesListProps) {
            return PenaltySchemesApiFp(configuration).penaltySchemesList({ is_fee_rates, limit, offset, options })(fetch, basePath);
        },
    };
};

/**
 * PenaltySchemesApi - object-oriented interface
 * @export
 * @class PenaltySchemesApi
 * @extends {BaseAPI}
 */
export class PenaltySchemesApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``penaltySchemesCreate`` for arguments and options.
     *
     */
    public penaltySchemesCreateURL({ data, options }: IpenaltySchemesCreateProps): FetchArgs {
        return PenaltySchemesApiFp(this.configuration).penaltySchemesCreateURL({ data, options });
    }

    /**
     * 
     * @param {CreatePenaltyScheme} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PenaltySchemesApi
     */
    public penaltySchemesCreate({ data, options }: IpenaltySchemesCreateProps) {
        return PenaltySchemesApiFp(this.configuration).penaltySchemesCreate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``penaltySchemesDelete`` for arguments and options.
     *
     */
    public penaltySchemesDeleteURL({ id, options }: IpenaltySchemesDeleteProps): FetchArgs {
        return PenaltySchemesApiFp(this.configuration).penaltySchemesDeleteURL({ id, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this penalty scheme.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PenaltySchemesApi
     */
    public penaltySchemesDelete({ id, options }: IpenaltySchemesDeleteProps) {
        return PenaltySchemesApiFp(this.configuration).penaltySchemesDelete({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``penaltySchemesList`` for arguments and options.
     *
     */
    public penaltySchemesListURL({ is_fee_rates, limit, offset, options }: IpenaltySchemesListProps = {}): FetchArgs {
        return PenaltySchemesApiFp(this.configuration).penaltySchemesListURL({ is_fee_rates, limit, offset, options });
    }

    /**
     * 
     * @param {boolean} [is_fee_rates] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PenaltySchemesApi
     */
    public penaltySchemesList({ is_fee_rates, limit, offset, options }: IpenaltySchemesListProps = {}) {
        return PenaltySchemesApiFp(this.configuration).penaltySchemesList({ is_fee_rates, limit, offset, options })(this.fetchData, this.basePath);
    }

}

/**
 * policiesAreasAndNames parameters
 */
export interface IpoliciesAreasAndNamesProps {
    published?: boolean, // 
    active_at?: string, // 
    kind?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>, // 
    providers?: Array<string>, // 
    tz?: string, // 
    lang?: string, // 
    name?: string, // 
    status?: Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>, // 
    recent?: boolean, // 
    exclude?: string, // 
    limit?: number, // Number of results to return per page.
    offset?: number, // The initial index from which to return the results.
    options?: any,
};

/**
 * policiesByCorrelationIdGeometries parameters
 */
export interface IpoliciesByCorrelationIdGeometriesProps {
    correlation_id: string, // Shared by all the versions of a policy, as editing a published policy publishes a new one
    options?: any,
};

/**
 * policiesByCorrelationIdRead parameters
 */
export interface IpoliciesByCorrelationIdReadProps {
    correlation_id: string, // Shared by all the versions of a policy, as editing a published policy publishes a new one
    options?: any,
};

/**
 * policiesCancelScheduledChange parameters
 */
export interface IpoliciesCancelScheduledChangeProps {
    id: string, // A UUID string identifying this policy.
    options?: any,
};

/**
 * policiesCreate parameters
 */
export interface IpoliciesCreateProps {
    data: PolicyInput,
    options?: any,
};

/**
 * policiesDelete parameters
 */
export interface IpoliciesDeleteProps {
    id: string, // A UUID string identifying this policy.
    options?: any,
};

/**
 * policiesExist parameters
 */
export interface IpoliciesExistProps {
    published?: boolean, // 
    active_at?: string, // 
    kind?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>, // 
    providers?: Array<string>, // 
    tz?: string, // 
    lang?: string, // 
    name?: string, // 
    status?: Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>, // 
    recent?: boolean, // 
    exclude?: string, // 
    limit?: number, // Number of results to return per page.
    offset?: number, // The initial index from which to return the results.
    options?: any,
};

/**
 * policiesExport parameters
 */
export interface IpoliciesExportProps {
    published?: boolean, // 
    active_at?: string, // 
    kind?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>, // 
    providers?: Array<string>, // 
    tz?: string, // 
    lang?: string, // 
    name?: string, // 
    status?: Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>, // 
    recent?: boolean, // 
    exclude?: string, // 
    limit?: number, // Number of results to return per page.
    offset?: number, // The initial index from which to return the results.
    options?: any,
};

/**
 * policiesHistory parameters
 */
export interface IpoliciesHistoryProps {
    id: string, // A UUID string identifying this policy.
    options?: any,
};

/**
 * policiesList parameters
 */
export interface IpoliciesListProps {
    published?: boolean, // 
    active_at?: string, // 
    kind?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>, // 
    providers?: Array<string>, // 
    tz?: string, // 
    lang?: string, // 
    name?: string, // 
    status?: Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>, // 
    recent?: boolean, // 
    exclude?: string, // 
    limit?: number, // Number of results to return per page.
    offset?: number, // The initial index from which to return the results.
    options?: any,
};

/**
 * policiesListLight parameters
 */
export interface IpoliciesListLightProps {
    published?: boolean, // 
    active_at?: string, // 
    kind?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>, // 
    providers?: Array<string>, // 
    tz?: string, // 
    lang?: string, // 
    name?: string, // 
    status?: Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>, // 
    recent?: boolean, // 
    exclude?: string, // 
    limit?: number, // Number of results to return per page.
    offset?: number, // The initial index from which to return the results.
    options?: any,
};

/**
 * policiesNames parameters
 */
export interface IpoliciesNamesProps {
    published?: boolean, // 
    active_at?: string, // 
    kind?: Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>, // 
    providers?: Array<string>, // 
    tz?: string, // 
    lang?: string, // 
    name?: string, // 
    status?: Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>, // 
    recent?: boolean, // 
    exclude?: string, // 
    limit?: number, // Number of results to return per page.
    offset?: number, // The initial index from which to return the results.
    options?: any,
};

/**
 * policiesNewVersion parameters
 */
export interface IpoliciesNewVersionProps {
    id: string, // A UUID string identifying this policy.
    data: PolicyNewVersionInput,
    options?: any,
};

/**
 * policiesPartialUpdate parameters
 */
export interface IpoliciesPartialUpdateProps {
    id: string, // A UUID string identifying this policy.
    data: PolicyInput,
    options?: any,
};

/**
 * policiesRead parameters
 */
export interface IpoliciesReadProps {
    id: string, // A UUID string identifying this policy.
    options?: any,
};

/**
 * policiesUpdate parameters
 */
export interface IpoliciesUpdateProps {
    id: string, // A UUID string identifying this policy.
    data: PolicyInput,
    options?: any,
};

/**
 * policiesViewed parameters
 */
export interface IpoliciesViewedProps {
    id: string, // A UUID string identifying this policy.
    options?: any,
};

/**
 * PoliciesApi - fetch parameter creator
 * @export
 */
export const PoliciesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Used to return the policy areas and name for the front filter panels
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesAreasAndNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options = {} }: IpoliciesAreasAndNamesProps): FetchArgs {
            const localVarPath = `/policies/names_areas/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (published !== undefined) {
                localVarQueryParameter['published'] = published;
            }

            if (active_at !== undefined) {
                localVarQueryParameter['active_at'] = active_at;
            }

            if (kind) {
                localVarQueryParameter['kind'] = kind;
            }

            if (providers) {
                localVarQueryParameter['providers'] = providers;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (recent !== undefined) {
                localVarQueryParameter['recent'] = recent;
            }

            if (exclude !== undefined) {
                localVarQueryParameter['exclude'] = exclude;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} correlation_id Shared by all the versions of a policy, as editing a published policy publishes a new one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesByCorrelationIdGeometries({ correlation_id, options = {} }: IpoliciesByCorrelationIdGeometriesProps): FetchArgs {
            // verify required parameter 'correlation_id' is not null or undefined
            if (correlation_id === null || correlation_id === undefined) {
                throw new RequiredError('correlation_id','Required parameter correlation_id was null or undefined when calling policiesByCorrelationIdGeometries.');
            }
            const localVarPath = `/policies/by_correlation_id/{correlation_id}/geometries/`
                .replace(`{${"correlation_id"}}`, encodeURIComponent(String(correlation_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * Each version is its own `Policy` row with the same `correlation_id`, so `current_versions()` keeps one per
         * @summary Return the version in effect among the versions sharing `correlation_id`, as `list` shows it.
         * @param {string} correlation_id Shared by all the versions of a policy, as editing a published policy publishes a new one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesByCorrelationIdRead({ correlation_id, options = {} }: IpoliciesByCorrelationIdReadProps): FetchArgs {
            // verify required parameter 'correlation_id' is not null or undefined
            if (correlation_id === null || correlation_id === undefined) {
                throw new RequiredError('correlation_id','Required parameter correlation_id was null or undefined when calling policiesByCorrelationIdRead.');
            }
            const localVarPath = `/policies/by_correlation_id/{correlation_id}/`
                .replace(`{${"correlation_id"}}`, encodeURIComponent(String(correlation_id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel the scheduled change of a policy, asked on its latest version: the version in effect stays.
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesCancelScheduledChange({ id, options = {} }: IpoliciesCancelScheduledChangeProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling policiesCancelScheduledChange.');
            }
            const localVarPath = `/policies/{id}/cancel_scheduled_change/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PolicyInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesCreate({ data, options = {} }: IpoliciesCreateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling policiesCreate.');
            }
            const localVarPath = `/policies/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PolicyInput" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesDelete({ id, options = {} }: IpoliciesDeleteProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling policiesDelete.');
            }
            const localVarPath = `/policies/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesExist({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options = {} }: IpoliciesExistProps): FetchArgs {
            const localVarPath = `/policies/exist/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (published !== undefined) {
                localVarQueryParameter['published'] = published;
            }

            if (active_at !== undefined) {
                localVarQueryParameter['active_at'] = active_at;
            }

            if (kind) {
                localVarQueryParameter['kind'] = kind;
            }

            if (providers) {
                localVarQueryParameter['providers'] = providers;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (recent !== undefined) {
                localVarQueryParameter['recent'] = recent;
            }

            if (exclude !== undefined) {
                localVarQueryParameter['exclude'] = exclude;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesExport({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options = {} }: IpoliciesExportProps): FetchArgs {
            const localVarPath = `/policies/export/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (published !== undefined) {
                localVarQueryParameter['published'] = published;
            }

            if (active_at !== undefined) {
                localVarQueryParameter['active_at'] = active_at;
            }

            if (kind) {
                localVarQueryParameter['kind'] = kind;
            }

            if (providers) {
                localVarQueryParameter['providers'] = providers;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (recent !== undefined) {
                localVarQueryParameter['recent'] = recent;
            }

            if (exclude !== undefined) {
                localVarQueryParameter['exclude'] = exclude;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the changes made to a policy through all its versions, the latest first.
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesHistory({ id, options = {} }: IpoliciesHistoryProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling policiesHistory.');
            }
            const localVarPath = `/policies/{id}/history/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesList({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options = {} }: IpoliciesListProps): FetchArgs {
            const localVarPath = `/policies/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (published !== undefined) {
                localVarQueryParameter['published'] = published;
            }

            if (active_at !== undefined) {
                localVarQueryParameter['active_at'] = active_at;
            }

            if (kind) {
                localVarQueryParameter['kind'] = kind;
            }

            if (providers) {
                localVarQueryParameter['providers'] = providers;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (recent !== undefined) {
                localVarQueryParameter['recent'] = recent;
            }

            if (exclude !== undefined) {
                localVarQueryParameter['exclude'] = exclude;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesListLight({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options = {} }: IpoliciesListLightProps): FetchArgs {
            const localVarPath = `/policies/list_light/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (published !== undefined) {
                localVarQueryParameter['published'] = published;
            }

            if (active_at !== undefined) {
                localVarQueryParameter['active_at'] = active_at;
            }

            if (kind) {
                localVarQueryParameter['kind'] = kind;
            }

            if (providers) {
                localVarQueryParameter['providers'] = providers;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (recent !== undefined) {
                localVarQueryParameter['recent'] = recent;
            }

            if (exclude !== undefined) {
                localVarQueryParameter['exclude'] = exclude;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used to return the policy names for the front filter panels
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options = {} }: IpoliciesNamesProps): FetchArgs {
            const localVarPath = `/policies/names/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (published !== undefined) {
                localVarQueryParameter['published'] = published;
            }

            if (active_at !== undefined) {
                localVarQueryParameter['active_at'] = active_at;
            }

            if (kind) {
                localVarQueryParameter['kind'] = kind;
            }

            if (providers) {
                localVarQueryParameter['providers'] = providers;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (recent !== undefined) {
                localVarQueryParameter['recent'] = recent;
            }

            if (exclude !== undefined) {
                localVarQueryParameter['exclude'] = exclude;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit a published policy by publishing a new version of it, as published MDS policies are immutable.
         * @param {string} id A UUID string identifying this policy.
         * @param {PolicyNewVersionInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesNewVersion({ id, data, options = {} }: IpoliciesNewVersionProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling policiesNewVersion.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling policiesNewVersion.');
            }
            const localVarPath = `/policies/{id}/new_version/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PolicyNewVersionInput" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {PolicyInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesPartialUpdate({ id, data, options = {} }: IpoliciesPartialUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling policiesPartialUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling policiesPartialUpdate.');
            }
            const localVarPath = `/policies/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PolicyInput" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesRead({ id, options = {} }: IpoliciesReadProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling policiesRead.');
            }
            const localVarPath = `/policies/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {PolicyInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesUpdate({ id, data, options = {} }: IpoliciesUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling policiesUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling policiesUpdate.');
            }
            const localVarPath = `/policies/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PolicyInput" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesViewed({ id, options = {} }: IpoliciesViewedProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling policiesViewed.');
            }
            const localVarPath = `/policies/{id}/viewed/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoliciesApi - functional programming interface
 * @export
 */
export const PoliciesApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        policiesAreasAndNamesURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesAreasAndNamesProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesAreasAndNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
        },

        /**
         * Used to return the policy areas and name for the front filter panels
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesAreasAndNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesAreasAndNamesProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<PolicyNameArea>> {
            const localVarFetchArgs = this.policiesAreasAndNamesURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesByCorrelationIdGeometriesURL({ correlation_id, options }: IpoliciesByCorrelationIdGeometriesProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesByCorrelationIdGeometries({ correlation_id, options });
        },

        /**
         * 
         * @param {string} correlation_id Shared by all the versions of a policy, as editing a published policy publishes a new one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesByCorrelationIdGeometries({ correlation_id, options }: IpoliciesByCorrelationIdGeometriesProps): (fetch?: FetchAPI, basePath?: string) => Promise<FeatureCollection> {
            const localVarFetchArgs = this.policiesByCorrelationIdGeometriesURL({ correlation_id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesByCorrelationIdReadURL({ correlation_id, options }: IpoliciesByCorrelationIdReadProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesByCorrelationIdRead({ correlation_id, options });
        },

        /**
         * Each version is its own `Policy` row with the same `correlation_id`, so `current_versions()` keeps one per
         * @summary Return the version in effect among the versions sharing `correlation_id`, as `list` shows it.
         * @param {string} correlation_id Shared by all the versions of a policy, as editing a published policy publishes a new one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesByCorrelationIdRead({ correlation_id, options }: IpoliciesByCorrelationIdReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<Policy> {
            const localVarFetchArgs = this.policiesByCorrelationIdReadURL({ correlation_id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesCancelScheduledChangeURL({ id, options }: IpoliciesCancelScheduledChangeProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesCancelScheduledChange({ id, options });
        },

        /**
         * Cancel the scheduled change of a policy, asked on its latest version: the version in effect stays.
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesCancelScheduledChange({ id, options }: IpoliciesCancelScheduledChangeProps): (fetch?: FetchAPI, basePath?: string) => Promise<Policy> {
            const localVarFetchArgs = this.policiesCancelScheduledChangeURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesCreateURL({ data, options }: IpoliciesCreateProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesCreate({ data, options });
        },

        /**
         * 
         * @param {PolicyInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesCreate({ data, options }: IpoliciesCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.policiesCreateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesDeleteURL({ id, options }: IpoliciesDeleteProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesDelete({ id, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesDelete({ id, options }: IpoliciesDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.policiesDeleteURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesExistURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesExistProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesExist({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
        },

        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesExist({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesExistProps): (fetch?: FetchAPI, basePath?: string) => Promise<ExistPolicyResponse> {
            const localVarFetchArgs = this.policiesExistURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesExportURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesExportProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesExport({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
        },

        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesExport({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesExportProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LightPolicy>> {
            const localVarFetchArgs = this.policiesExportURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesHistoryURL({ id, options }: IpoliciesHistoryProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesHistory({ id, options });
        },

        /**
         * List the changes made to a policy through all its versions, the latest first.
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesHistory({ id, options }: IpoliciesHistoryProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<PolicyChange>> {
            const localVarFetchArgs = this.policiesHistoryURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesListURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesListProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesList({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
        },

        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesList({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesListProps): (fetch?: FetchAPI, basePath?: string) => Promise<PolicyListResponse> {
            const localVarFetchArgs = this.policiesListURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesListLightURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesListLightProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesListLight({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
        },

        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesListLight({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesListLightProps): (fetch?: FetchAPI, basePath?: string) => Promise<LightPolicyResponse> {
            const localVarFetchArgs = this.policiesListLightURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesNamesURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesNamesProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
        },

        /**
         * Used to return the policy names for the front filter panels
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesNamesProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<PolicyName>> {
            const localVarFetchArgs = this.policiesNamesURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesNewVersionURL({ id, data, options }: IpoliciesNewVersionProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesNewVersion({ id, data, options });
        },

        /**
         * Edit a published policy by publishing a new version of it, as published MDS policies are immutable.
         * @param {string} id A UUID string identifying this policy.
         * @param {PolicyNewVersionInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesNewVersion({ id, data, options }: IpoliciesNewVersionProps): (fetch?: FetchAPI, basePath?: string) => Promise<Policy> {
            const localVarFetchArgs = this.policiesNewVersionURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesPartialUpdateURL({ id, data, options }: IpoliciesPartialUpdateProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesPartialUpdate({ id, data, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {PolicyInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesPartialUpdate({ id, data, options }: IpoliciesPartialUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.policiesPartialUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesReadURL({ id, options }: IpoliciesReadProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesRead({ id, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesRead({ id, options }: IpoliciesReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<Policy> {
            const localVarFetchArgs = this.policiesReadURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesUpdateURL({ id, data, options }: IpoliciesUpdateProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesUpdate({ id, data, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {PolicyInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesUpdate({ id, data, options }: IpoliciesUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.policiesUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policiesViewedURL({ id, options }: IpoliciesViewedProps): FetchArgs {
            return PoliciesApiFetchParamCreator(configuration).policiesViewed({ id, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesViewed({ id, options }: IpoliciesViewedProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.policiesViewedURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * PoliciesApi - factory interface
 * @export
 */
export const PoliciesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Used to return the policy areas and name for the front filter panels
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesAreasAndNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesAreasAndNamesProps) {
            return PoliciesApiFp(configuration).policiesAreasAndNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} correlation_id Shared by all the versions of a policy, as editing a published policy publishes a new one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesByCorrelationIdGeometries({ correlation_id, options }: IpoliciesByCorrelationIdGeometriesProps) {
            return PoliciesApiFp(configuration).policiesByCorrelationIdGeometries({ correlation_id, options })(fetch, basePath);
        },
        /**
         * Each version is its own `Policy` row with the same `correlation_id`, so `current_versions()` keeps one per
         * @summary Return the version in effect among the versions sharing `correlation_id`, as `list` shows it.
         * @param {string} correlation_id Shared by all the versions of a policy, as editing a published policy publishes a new one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesByCorrelationIdRead({ correlation_id, options }: IpoliciesByCorrelationIdReadProps) {
            return PoliciesApiFp(configuration).policiesByCorrelationIdRead({ correlation_id, options })(fetch, basePath);
        },
        /**
         * Cancel the scheduled change of a policy, asked on its latest version: the version in effect stays.
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesCancelScheduledChange({ id, options }: IpoliciesCancelScheduledChangeProps) {
            return PoliciesApiFp(configuration).policiesCancelScheduledChange({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {PolicyInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesCreate({ data, options }: IpoliciesCreateProps) {
            return PoliciesApiFp(configuration).policiesCreate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesDelete({ id, options }: IpoliciesDeleteProps) {
            return PoliciesApiFp(configuration).policiesDelete({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesExist({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesExistProps) {
            return PoliciesApiFp(configuration).policiesExist({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(fetch, basePath);
        },
        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesExport({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesExportProps) {
            return PoliciesApiFp(configuration).policiesExport({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(fetch, basePath);
        },
        /**
         * List the changes made to a policy through all its versions, the latest first.
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesHistory({ id, options }: IpoliciesHistoryProps) {
            return PoliciesApiFp(configuration).policiesHistory({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesList({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesListProps) {
            return PoliciesApiFp(configuration).policiesList({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(fetch, basePath);
        },
        /**
         * 
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesListLight({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesListLightProps) {
            return PoliciesApiFp(configuration).policiesListLight({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(fetch, basePath);
        },
        /**
         * Used to return the policy names for the front filter panels
         * @param {boolean} [published] 
         * @param {string} [active_at] 
         * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
         * @param {Array<string>} [providers] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [name] 
         * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
         * @param {boolean} [recent] 
         * @param {string} [exclude] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesNamesProps) {
            return PoliciesApiFp(configuration).policiesNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(fetch, basePath);
        },
        /**
         * Edit a published policy by publishing a new version of it, as published MDS policies are immutable.
         * @param {string} id A UUID string identifying this policy.
         * @param {PolicyNewVersionInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesNewVersion({ id, data, options }: IpoliciesNewVersionProps) {
            return PoliciesApiFp(configuration).policiesNewVersion({ id, data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {PolicyInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesPartialUpdate({ id, data, options }: IpoliciesPartialUpdateProps) {
            return PoliciesApiFp(configuration).policiesPartialUpdate({ id, data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesRead({ id, options }: IpoliciesReadProps) {
            return PoliciesApiFp(configuration).policiesRead({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {PolicyInput} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesUpdate({ id, data, options }: IpoliciesUpdateProps) {
            return PoliciesApiFp(configuration).policiesUpdate({ id, data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this policy.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policiesViewed({ id, options }: IpoliciesViewedProps) {
            return PoliciesApiFp(configuration).policiesViewed({ id, options })(fetch, basePath);
        },
    };
};

/**
 * PoliciesApi - object-oriented interface
 * @export
 * @class PoliciesApi
 * @extends {BaseAPI}
 */
export class PoliciesApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesAreasAndNames`` for arguments and options.
     *
     */
    public policiesAreasAndNamesURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesAreasAndNamesProps = {}): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesAreasAndNamesURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
    }

    /**
     * Used to return the policy areas and name for the front filter panels
     * @param {boolean} [published] 
     * @param {string} [active_at] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
     * @param {Array<string>} [providers] 
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [name] 
     * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
     * @param {boolean} [recent] 
     * @param {string} [exclude] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesAreasAndNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesAreasAndNamesProps = {}) {
        return PoliciesApiFp(this.configuration).policiesAreasAndNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesByCorrelationIdGeometries`` for arguments and options.
     *
     */
    public policiesByCorrelationIdGeometriesURL({ correlation_id, options }: IpoliciesByCorrelationIdGeometriesProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesByCorrelationIdGeometriesURL({ correlation_id, options });
    }

    /**
     * 
     * @param {string} correlation_id Shared by all the versions of a policy, as editing a published policy publishes a new one
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesByCorrelationIdGeometries({ correlation_id, options }: IpoliciesByCorrelationIdGeometriesProps) {
        return PoliciesApiFp(this.configuration).policiesByCorrelationIdGeometries({ correlation_id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesByCorrelationIdRead`` for arguments and options.
     *
     */
    public policiesByCorrelationIdReadURL({ correlation_id, options }: IpoliciesByCorrelationIdReadProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesByCorrelationIdReadURL({ correlation_id, options });
    }

    /**
     * Each version is its own `Policy` row with the same `correlation_id`, so `current_versions()` keeps one per
     * @summary Return the version in effect among the versions sharing `correlation_id`, as `list` shows it.
     * @param {string} correlation_id Shared by all the versions of a policy, as editing a published policy publishes a new one
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesByCorrelationIdRead({ correlation_id, options }: IpoliciesByCorrelationIdReadProps) {
        return PoliciesApiFp(this.configuration).policiesByCorrelationIdRead({ correlation_id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesCancelScheduledChange`` for arguments and options.
     *
     */
    public policiesCancelScheduledChangeURL({ id, options }: IpoliciesCancelScheduledChangeProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesCancelScheduledChangeURL({ id, options });
    }

    /**
     * Cancel the scheduled change of a policy, asked on its latest version: the version in effect stays.
     * @param {string} id A UUID string identifying this policy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesCancelScheduledChange({ id, options }: IpoliciesCancelScheduledChangeProps) {
        return PoliciesApiFp(this.configuration).policiesCancelScheduledChange({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesCreate`` for arguments and options.
     *
     */
    public policiesCreateURL({ data, options }: IpoliciesCreateProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesCreateURL({ data, options });
    }

    /**
     * 
     * @param {PolicyInput} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesCreate({ data, options }: IpoliciesCreateProps) {
        return PoliciesApiFp(this.configuration).policiesCreate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesDelete`` for arguments and options.
     *
     */
    public policiesDeleteURL({ id, options }: IpoliciesDeleteProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesDeleteURL({ id, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this policy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesDelete({ id, options }: IpoliciesDeleteProps) {
        return PoliciesApiFp(this.configuration).policiesDelete({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesExist`` for arguments and options.
     *
     */
    public policiesExistURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesExistProps = {}): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesExistURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
    }

    /**
     * 
     * @param {boolean} [published] 
     * @param {string} [active_at] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
     * @param {Array<string>} [providers] 
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [name] 
     * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
     * @param {boolean} [recent] 
     * @param {string} [exclude] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesExist({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesExistProps = {}) {
        return PoliciesApiFp(this.configuration).policiesExist({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesExport`` for arguments and options.
     *
     */
    public policiesExportURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesExportProps = {}): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesExportURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
    }

    /**
     * 
     * @param {boolean} [published] 
     * @param {string} [active_at] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
     * @param {Array<string>} [providers] 
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [name] 
     * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
     * @param {boolean} [recent] 
     * @param {string} [exclude] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesExport({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesExportProps = {}) {
        return PoliciesApiFp(this.configuration).policiesExport({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesHistory`` for arguments and options.
     *
     */
    public policiesHistoryURL({ id, options }: IpoliciesHistoryProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesHistoryURL({ id, options });
    }

    /**
     * List the changes made to a policy through all its versions, the latest first.
     * @param {string} id A UUID string identifying this policy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesHistory({ id, options }: IpoliciesHistoryProps) {
        return PoliciesApiFp(this.configuration).policiesHistory({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesList`` for arguments and options.
     *
     */
    public policiesListURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesListProps = {}): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesListURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
    }

    /**
     * 
     * @param {boolean} [published] 
     * @param {string} [active_at] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
     * @param {Array<string>} [providers] 
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [name] 
     * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
     * @param {boolean} [recent] 
     * @param {string} [exclude] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesList({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesListProps = {}) {
        return PoliciesApiFp(this.configuration).policiesList({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesListLight`` for arguments and options.
     *
     */
    public policiesListLightURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesListLightProps = {}): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesListLightURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
    }

    /**
     * 
     * @param {boolean} [published] 
     * @param {string} [active_at] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
     * @param {Array<string>} [providers] 
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [name] 
     * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
     * @param {boolean} [recent] 
     * @param {string} [exclude] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesListLight({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesListLightProps = {}) {
        return PoliciesApiFp(this.configuration).policiesListLight({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesNames`` for arguments and options.
     *
     */
    public policiesNamesURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesNamesProps = {}): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesNamesURL({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options });
    }

    /**
     * Used to return the policy names for the front filter panels
     * @param {boolean} [published] 
     * @param {string} [active_at] 
     * @param {Array<'speed' | 'geofence' | 'absolute_fleet_size' | 'fleet_budget' | 'permit' | 'parking' | 'trip_taxation' | 'beginner_speed_limit' | 'beginner_allowed_hours' | 'vehicle_deployment' | 'maintenance' | 'dwell_time' | 'abandoned' | 'balancing' | 'sidewalk' | 'time' | 'user'>} [kind] 
     * @param {Array<string>} [providers] 
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [name] 
     * @param {Array<'draft' | 'upcoming' | 'ongoing' | 'finished' | 'cancelled'>} [status] 
     * @param {boolean} [recent] 
     * @param {string} [exclude] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options }: IpoliciesNamesProps = {}) {
        return PoliciesApiFp(this.configuration).policiesNames({ published, active_at, kind, providers, tz, lang, name, status, recent, exclude, limit, offset, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesNewVersion`` for arguments and options.
     *
     */
    public policiesNewVersionURL({ id, data, options }: IpoliciesNewVersionProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesNewVersionURL({ id, data, options });
    }

    /**
     * Edit a published policy by publishing a new version of it, as published MDS policies are immutable.
     * @param {string} id A UUID string identifying this policy.
     * @param {PolicyNewVersionInput} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesNewVersion({ id, data, options }: IpoliciesNewVersionProps) {
        return PoliciesApiFp(this.configuration).policiesNewVersion({ id, data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesPartialUpdate`` for arguments and options.
     *
     */
    public policiesPartialUpdateURL({ id, data, options }: IpoliciesPartialUpdateProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesPartialUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this policy.
     * @param {PolicyInput} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesPartialUpdate({ id, data, options }: IpoliciesPartialUpdateProps) {
        return PoliciesApiFp(this.configuration).policiesPartialUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesRead`` for arguments and options.
     *
     */
    public policiesReadURL({ id, options }: IpoliciesReadProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesReadURL({ id, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this policy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesRead({ id, options }: IpoliciesReadProps) {
        return PoliciesApiFp(this.configuration).policiesRead({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesUpdate`` for arguments and options.
     *
     */
    public policiesUpdateURL({ id, data, options }: IpoliciesUpdateProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this policy.
     * @param {PolicyInput} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesUpdate({ id, data, options }: IpoliciesUpdateProps) {
        return PoliciesApiFp(this.configuration).policiesUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policiesViewed`` for arguments and options.
     *
     */
    public policiesViewedURL({ id, options }: IpoliciesViewedProps): FetchArgs {
        return PoliciesApiFp(this.configuration).policiesViewedURL({ id, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this policy.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    public policiesViewed({ id, options }: IpoliciesViewedProps) {
        return PoliciesApiFp(this.configuration).policiesViewed({ id, options })(this.fetchData, this.basePath);
    }

}

/**
 * policyAmountsCreate parameters
 */
export interface IpolicyAmountsCreateProps {
    penalty_scheme: string,
    data: PolicyAmountCreate,
    options?: any,
};

/**
 * policyAmountsExport parameters
 */
export interface IpolicyAmountsExportProps {
    penalty_scheme: string,
    provider: string, // 
    tz: string,
    lang: string,
    options?: any,
};

/**
 * policyAmountsExportPdf parameters
 */
export interface IpolicyAmountsExportPdfProps {
    penalty_scheme: string,
    provider: string, // 
    tz: string,
    lang: string,
    start_time?: string,
    end_time?: string,
    options?: any,
};

/**
 * PolicyAmountsApi - fetch parameter creator
 * @export
 */
export const PolicyAmountsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} penalty_scheme 
         * @param {PolicyAmountCreate} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyAmountsCreate({ penalty_scheme, data, options = {} }: IpolicyAmountsCreateProps): FetchArgs {
            // verify required parameter 'penalty_scheme' is not null or undefined
            if (penalty_scheme === null || penalty_scheme === undefined) {
                throw new RequiredError('penalty_scheme','Required parameter penalty_scheme was null or undefined when calling policyAmountsCreate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling policyAmountsCreate.');
            }
            const localVarPath = `/policy_amounts/{penalty_scheme}/`
                .replace(`{${"penalty_scheme"}}`, encodeURIComponent(String(penalty_scheme)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PolicyAmountCreate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} penalty_scheme 
         * @param {string} provider 
         * @param {string} tz 
         * @param {string} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyAmountsExport({ penalty_scheme, provider, tz, lang, options = {} }: IpolicyAmountsExportProps): FetchArgs {
            // verify required parameter 'penalty_scheme' is not null or undefined
            if (penalty_scheme === null || penalty_scheme === undefined) {
                throw new RequiredError('penalty_scheme','Required parameter penalty_scheme was null or undefined when calling policyAmountsExport.');
            }
            // verify required parameter 'provider' is not null or undefined
            if (provider === null || provider === undefined) {
                throw new RequiredError('provider','Required parameter provider was null or undefined when calling policyAmountsExport.');
            }
            // verify required parameter 'tz' is not null or undefined
            if (tz === null || tz === undefined) {
                throw new RequiredError('tz','Required parameter tz was null or undefined when calling policyAmountsExport.');
            }
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling policyAmountsExport.');
            }
            const localVarPath = `/policy_amounts/{penalty_scheme}/export/`
                .replace(`{${"penalty_scheme"}}`, encodeURIComponent(String(penalty_scheme)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} penalty_scheme 
         * @param {string} provider 
         * @param {string} tz 
         * @param {string} lang 
         * @param {string} [start_time] 
         * @param {string} [end_time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyAmountsExportPdf({ penalty_scheme, provider, tz, lang, start_time, end_time, options = {} }: IpolicyAmountsExportPdfProps): FetchArgs {
            // verify required parameter 'penalty_scheme' is not null or undefined
            if (penalty_scheme === null || penalty_scheme === undefined) {
                throw new RequiredError('penalty_scheme','Required parameter penalty_scheme was null or undefined when calling policyAmountsExportPdf.');
            }
            // verify required parameter 'provider' is not null or undefined
            if (provider === null || provider === undefined) {
                throw new RequiredError('provider','Required parameter provider was null or undefined when calling policyAmountsExportPdf.');
            }
            // verify required parameter 'tz' is not null or undefined
            if (tz === null || tz === undefined) {
                throw new RequiredError('tz','Required parameter tz was null or undefined when calling policyAmountsExportPdf.');
            }
            // verify required parameter 'lang' is not null or undefined
            if (lang === null || lang === undefined) {
                throw new RequiredError('lang','Required parameter lang was null or undefined when calling policyAmountsExportPdf.');
            }
            const localVarPath = `/policy_amounts/{penalty_scheme}/export_pdf/`
                .replace(`{${"penalty_scheme"}}`, encodeURIComponent(String(penalty_scheme)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (start_time !== undefined) {
                localVarQueryParameter['start_time'] = start_time;
            }

            if (end_time !== undefined) {
                localVarQueryParameter['end_time'] = end_time;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PolicyAmountsApi - functional programming interface
 * @export
 */
export const PolicyAmountsApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        policyAmountsCreateURL({ penalty_scheme, data, options }: IpolicyAmountsCreateProps): FetchArgs {
            return PolicyAmountsApiFetchParamCreator(configuration).policyAmountsCreate({ penalty_scheme, data, options });
        },

        /**
         * 
         * @param {string} penalty_scheme 
         * @param {PolicyAmountCreate} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyAmountsCreate({ penalty_scheme, data, options }: IpolicyAmountsCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<PolicyAmount> {
            const localVarFetchArgs = this.policyAmountsCreateURL({ penalty_scheme, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policyAmountsExportURL({ penalty_scheme, provider, tz, lang, options }: IpolicyAmountsExportProps): FetchArgs {
            return PolicyAmountsApiFetchParamCreator(configuration).policyAmountsExport({ penalty_scheme, provider, tz, lang, options });
        },

        /**
         * 
         * @param {string} penalty_scheme 
         * @param {string} provider 
         * @param {string} tz 
         * @param {string} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyAmountsExport({ penalty_scheme, provider, tz, lang, options }: IpolicyAmountsExportProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.policyAmountsExportURL({ penalty_scheme, provider, tz, lang, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policyAmountsExportPdfURL({ penalty_scheme, provider, tz, lang, start_time, end_time, options }: IpolicyAmountsExportPdfProps): FetchArgs {
            return PolicyAmountsApiFetchParamCreator(configuration).policyAmountsExportPdf({ penalty_scheme, provider, tz, lang, start_time, end_time, options });
        },

        /**
         * 
         * @param {string} penalty_scheme 
         * @param {string} provider 
         * @param {string} tz 
         * @param {string} lang 
         * @param {string} [start_time] 
         * @param {string} [end_time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyAmountsExportPdf({ penalty_scheme, provider, tz, lang, start_time, end_time, options }: IpolicyAmountsExportPdfProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.policyAmountsExportPdfURL({ penalty_scheme, provider, tz, lang, start_time, end_time, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * PolicyAmountsApi - factory interface
 * @export
 */
export const PolicyAmountsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} penalty_scheme 
         * @param {PolicyAmountCreate} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyAmountsCreate({ penalty_scheme, data, options }: IpolicyAmountsCreateProps) {
            return PolicyAmountsApiFp(configuration).policyAmountsCreate({ penalty_scheme, data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} penalty_scheme 
         * @param {string} provider 
         * @param {string} tz 
         * @param {string} lang 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyAmountsExport({ penalty_scheme, provider, tz, lang, options }: IpolicyAmountsExportProps) {
            return PolicyAmountsApiFp(configuration).policyAmountsExport({ penalty_scheme, provider, tz, lang, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} penalty_scheme 
         * @param {string} provider 
         * @param {string} tz 
         * @param {string} lang 
         * @param {string} [start_time] 
         * @param {string} [end_time] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyAmountsExportPdf({ penalty_scheme, provider, tz, lang, start_time, end_time, options }: IpolicyAmountsExportPdfProps) {
            return PolicyAmountsApiFp(configuration).policyAmountsExportPdf({ penalty_scheme, provider, tz, lang, start_time, end_time, options })(fetch, basePath);
        },
    };
};

/**
 * PolicyAmountsApi - object-oriented interface
 * @export
 * @class PolicyAmountsApi
 * @extends {BaseAPI}
 */
export class PolicyAmountsApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``policyAmountsCreate`` for arguments and options.
     *
     */
    public policyAmountsCreateURL({ penalty_scheme, data, options }: IpolicyAmountsCreateProps): FetchArgs {
        return PolicyAmountsApiFp(this.configuration).policyAmountsCreateURL({ penalty_scheme, data, options });
    }

    /**
     * 
     * @param {string} penalty_scheme 
     * @param {PolicyAmountCreate} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAmountsApi
     */
    public policyAmountsCreate({ penalty_scheme, data, options }: IpolicyAmountsCreateProps) {
        return PolicyAmountsApiFp(this.configuration).policyAmountsCreate({ penalty_scheme, data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policyAmountsExport`` for arguments and options.
     *
     */
    public policyAmountsExportURL({ penalty_scheme, provider, tz, lang, options }: IpolicyAmountsExportProps): FetchArgs {
        return PolicyAmountsApiFp(this.configuration).policyAmountsExportURL({ penalty_scheme, provider, tz, lang, options });
    }

    /**
     * 
     * @param {string} penalty_scheme 
     * @param {string} provider 
     * @param {string} tz 
     * @param {string} lang 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAmountsApi
     */
    public policyAmountsExport({ penalty_scheme, provider, tz, lang, options }: IpolicyAmountsExportProps) {
        return PolicyAmountsApiFp(this.configuration).policyAmountsExport({ penalty_scheme, provider, tz, lang, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policyAmountsExportPdf`` for arguments and options.
     *
     */
    public policyAmountsExportPdfURL({ penalty_scheme, provider, tz, lang, start_time, end_time, options }: IpolicyAmountsExportPdfProps): FetchArgs {
        return PolicyAmountsApiFp(this.configuration).policyAmountsExportPdfURL({ penalty_scheme, provider, tz, lang, start_time, end_time, options });
    }

    /**
     * 
     * @param {string} penalty_scheme 
     * @param {string} provider 
     * @param {string} tz 
     * @param {string} lang 
     * @param {string} [start_time] 
     * @param {string} [end_time] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyAmountsApi
     */
    public policyAmountsExportPdf({ penalty_scheme, provider, tz, lang, start_time, end_time, options }: IpolicyAmountsExportPdfProps) {
        return PolicyAmountsApiFp(this.configuration).policyAmountsExportPdf({ penalty_scheme, provider, tz, lang, start_time, end_time, options })(this.fetchData, this.basePath);
    }

}

/**
 * policyKindsList parameters
 */
export interface IpolicyKindsListProps {
    options?: any,
};

/**
 * policyKindsUpdate parameters
 */
export interface IpolicyKindsUpdateProps {
    kind: string,
    data: PolicyKind,
    options?: any,
};

/**
 * PolicyKindsApi - fetch parameter creator
 * @export
 */
export const PolicyKindsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyKindsList({ options = {} }: IpolicyKindsListProps): FetchArgs {
            const localVarPath = `/policy_kinds/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kind 
         * @param {PolicyKind} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyKindsUpdate({ kind, data, options = {} }: IpolicyKindsUpdateProps): FetchArgs {
            // verify required parameter 'kind' is not null or undefined
            if (kind === null || kind === undefined) {
                throw new RequiredError('kind','Required parameter kind was null or undefined when calling policyKindsUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling policyKindsUpdate.');
            }
            const localVarPath = `/policy_kinds/{kind}/`
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PolicyKind" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PolicyKindsApi - functional programming interface
 * @export
 */
export const PolicyKindsApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        policyKindsListURL({ options }: IpolicyKindsListProps): FetchArgs {
            return PolicyKindsApiFetchParamCreator(configuration).policyKindsList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyKindsList({ options }: IpolicyKindsListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<PolicyKind>> {
            const localVarFetchArgs = this.policyKindsListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        policyKindsUpdateURL({ kind, data, options }: IpolicyKindsUpdateProps): FetchArgs {
            return PolicyKindsApiFetchParamCreator(configuration).policyKindsUpdate({ kind, data, options });
        },

        /**
         * 
         * @param {string} kind 
         * @param {PolicyKind} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyKindsUpdate({ kind, data, options }: IpolicyKindsUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<PolicyKind> {
            const localVarFetchArgs = this.policyKindsUpdateURL({ kind, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * PolicyKindsApi - factory interface
 * @export
 */
export const PolicyKindsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyKindsList({ options }: IpolicyKindsListProps) {
            return PolicyKindsApiFp(configuration).policyKindsList({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} kind 
         * @param {PolicyKind} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        policyKindsUpdate({ kind, data, options }: IpolicyKindsUpdateProps) {
            return PolicyKindsApiFp(configuration).policyKindsUpdate({ kind, data, options })(fetch, basePath);
        },
    };
};

/**
 * PolicyKindsApi - object-oriented interface
 * @export
 * @class PolicyKindsApi
 * @extends {BaseAPI}
 */
export class PolicyKindsApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``policyKindsList`` for arguments and options.
     *
     */
    public policyKindsListURL({ options }: IpolicyKindsListProps = {}): FetchArgs {
        return PolicyKindsApiFp(this.configuration).policyKindsListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyKindsApi
     */
    public policyKindsList({ options }: IpolicyKindsListProps = {}) {
        return PolicyKindsApiFp(this.configuration).policyKindsList({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``policyKindsUpdate`` for arguments and options.
     *
     */
    public policyKindsUpdateURL({ kind, data, options }: IpolicyKindsUpdateProps): FetchArgs {
        return PolicyKindsApiFp(this.configuration).policyKindsUpdateURL({ kind, data, options });
    }

    /**
     * 
     * @param {string} kind 
     * @param {PolicyKind} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolicyKindsApi
     */
    public policyKindsUpdate({ kind, data, options }: IpolicyKindsUpdateProps) {
        return PolicyKindsApiFp(this.configuration).policyKindsUpdate({ kind, data, options })(this.fetchData, this.basePath);
    }

}

/**
 * polygonsCreate parameters
 */
export interface IpolygonsCreateProps {
    data: PolygonRequest,
    options?: any,
};

/**
 * polygonsDelete parameters
 */
export interface IpolygonsDeleteProps {
    id: string, // A UUID string identifying this polygon.
    options?: any,
};

/**
 * polygonsDeleteListPolygon parameters
 */
export interface IpolygonsDeleteListPolygonProps {
    data: DeleteListPolygonRequest,
    options?: any,
};

/**
 * polygonsImportPolygons parameters
 */
export interface IpolygonsImportPolygonsProps {
    data: PolygonsImportRequest,
    options?: any,
};

/**
 * polygonsLightList parameters
 */
export interface IpolygonsLightListProps {
    options?: any,
};

/**
 * polygonsList parameters
 */
export interface IpolygonsListProps {
    options?: any,
};

/**
 * polygonsPartialUpdate parameters
 */
export interface IpolygonsPartialUpdateProps {
    id: string, // A UUID string identifying this polygon.
    data: PolygonRequest,
    options?: any,
};

/**
 * polygonsRead parameters
 */
export interface IpolygonsReadProps {
    id: string, // A UUID string identifying this polygon.
    options?: any,
};

/**
 * polygonsUpdate parameters
 */
export interface IpolygonsUpdateProps {
    id: string, // A UUID string identifying this polygon.
    data: PolygonRequest,
    options?: any,
};

/**
 * PolygonsApi - fetch parameter creator
 * @export
 */
export const PolygonsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsCreate({ data, options = {} }: IpolygonsCreateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling polygonsCreate.');
            }
            const localVarPath = `/polygons/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PolygonRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsDelete({ id, options = {} }: IpolygonsDeleteProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling polygonsDelete.');
            }
            const localVarPath = `/polygons/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteListPolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsDeleteListPolygon({ data, options = {} }: IpolygonsDeleteListPolygonProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling polygonsDeleteListPolygon.');
            }
            const localVarPath = `/polygons/delete_list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DeleteListPolygonRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PolygonsImportRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsImportPolygons({ data, options = {} }: IpolygonsImportPolygonsProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling polygonsImportPolygons.');
            }
            const localVarPath = `/polygons/import/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PolygonsImportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsLightList({ options = {} }: IpolygonsLightListProps): FetchArgs {
            const localVarPath = `/polygons/light_list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsList({ options = {} }: IpolygonsListProps): FetchArgs {
            const localVarPath = `/polygons/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {PolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsPartialUpdate({ id, data, options = {} }: IpolygonsPartialUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling polygonsPartialUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling polygonsPartialUpdate.');
            }
            const localVarPath = `/polygons/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PolygonRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsRead({ id, options = {} }: IpolygonsReadProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling polygonsRead.');
            }
            const localVarPath = `/polygons/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {PolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsUpdate({ id, data, options = {} }: IpolygonsUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling polygonsUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling polygonsUpdate.');
            }
            const localVarPath = `/polygons/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PolygonRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PolygonsApi - functional programming interface
 * @export
 */
export const PolygonsApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        polygonsCreateURL({ data, options }: IpolygonsCreateProps): FetchArgs {
            return PolygonsApiFetchParamCreator(configuration).polygonsCreate({ data, options });
        },

        /**
         * 
         * @param {PolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsCreate({ data, options }: IpolygonsCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.polygonsCreateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        polygonsDeleteURL({ id, options }: IpolygonsDeleteProps): FetchArgs {
            return PolygonsApiFetchParamCreator(configuration).polygonsDelete({ id, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsDelete({ id, options }: IpolygonsDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.polygonsDeleteURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        polygonsDeleteListPolygonURL({ data, options }: IpolygonsDeleteListPolygonProps): FetchArgs {
            return PolygonsApiFetchParamCreator(configuration).polygonsDeleteListPolygon({ data, options });
        },

        /**
         * 
         * @param {DeleteListPolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsDeleteListPolygon({ data, options }: IpolygonsDeleteListPolygonProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.polygonsDeleteListPolygonURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        polygonsImportPolygonsURL({ data, options }: IpolygonsImportPolygonsProps): FetchArgs {
            return PolygonsApiFetchParamCreator(configuration).polygonsImportPolygons({ data, options });
        },

        /**
         * 
         * @param {PolygonsImportRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsImportPolygons({ data, options }: IpolygonsImportPolygonsProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.polygonsImportPolygonsURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        polygonsLightListURL({ options }: IpolygonsLightListProps): FetchArgs {
            return PolygonsApiFetchParamCreator(configuration).polygonsLightList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsLightList({ options }: IpolygonsLightListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LightPolygon>> {
            const localVarFetchArgs = this.polygonsLightListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        polygonsListURL({ options }: IpolygonsListProps): FetchArgs {
            return PolygonsApiFetchParamCreator(configuration).polygonsList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsList({ options }: IpolygonsListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<PolygonResponse>> {
            const localVarFetchArgs = this.polygonsListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        polygonsPartialUpdateURL({ id, data, options }: IpolygonsPartialUpdateProps): FetchArgs {
            return PolygonsApiFetchParamCreator(configuration).polygonsPartialUpdate({ id, data, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {PolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsPartialUpdate({ id, data, options }: IpolygonsPartialUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.polygonsPartialUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        polygonsReadURL({ id, options }: IpolygonsReadProps): FetchArgs {
            return PolygonsApiFetchParamCreator(configuration).polygonsRead({ id, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsRead({ id, options }: IpolygonsReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<PolygonResponse> {
            const localVarFetchArgs = this.polygonsReadURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        polygonsUpdateURL({ id, data, options }: IpolygonsUpdateProps): FetchArgs {
            return PolygonsApiFetchParamCreator(configuration).polygonsUpdate({ id, data, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {PolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsUpdate({ id, data, options }: IpolygonsUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.polygonsUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * PolygonsApi - factory interface
 * @export
 */
export const PolygonsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {PolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsCreate({ data, options }: IpolygonsCreateProps) {
            return PolygonsApiFp(configuration).polygonsCreate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsDelete({ id, options }: IpolygonsDeleteProps) {
            return PolygonsApiFp(configuration).polygonsDelete({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {DeleteListPolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsDeleteListPolygon({ data, options }: IpolygonsDeleteListPolygonProps) {
            return PolygonsApiFp(configuration).polygonsDeleteListPolygon({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {PolygonsImportRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsImportPolygons({ data, options }: IpolygonsImportPolygonsProps) {
            return PolygonsApiFp(configuration).polygonsImportPolygons({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsLightList({ options }: IpolygonsLightListProps) {
            return PolygonsApiFp(configuration).polygonsLightList({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsList({ options }: IpolygonsListProps) {
            return PolygonsApiFp(configuration).polygonsList({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {PolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsPartialUpdate({ id, data, options }: IpolygonsPartialUpdateProps) {
            return PolygonsApiFp(configuration).polygonsPartialUpdate({ id, data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsRead({ id, options }: IpolygonsReadProps) {
            return PolygonsApiFp(configuration).polygonsRead({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this polygon.
         * @param {PolygonRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polygonsUpdate({ id, data, options }: IpolygonsUpdateProps) {
            return PolygonsApiFp(configuration).polygonsUpdate({ id, data, options })(fetch, basePath);
        },
    };
};

/**
 * PolygonsApi - object-oriented interface
 * @export
 * @class PolygonsApi
 * @extends {BaseAPI}
 */
export class PolygonsApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``polygonsCreate`` for arguments and options.
     *
     */
    public polygonsCreateURL({ data, options }: IpolygonsCreateProps): FetchArgs {
        return PolygonsApiFp(this.configuration).polygonsCreateURL({ data, options });
    }

    /**
     * 
     * @param {PolygonRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public polygonsCreate({ data, options }: IpolygonsCreateProps) {
        return PolygonsApiFp(this.configuration).polygonsCreate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``polygonsDelete`` for arguments and options.
     *
     */
    public polygonsDeleteURL({ id, options }: IpolygonsDeleteProps): FetchArgs {
        return PolygonsApiFp(this.configuration).polygonsDeleteURL({ id, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this polygon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public polygonsDelete({ id, options }: IpolygonsDeleteProps) {
        return PolygonsApiFp(this.configuration).polygonsDelete({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``polygonsDeleteListPolygon`` for arguments and options.
     *
     */
    public polygonsDeleteListPolygonURL({ data, options }: IpolygonsDeleteListPolygonProps): FetchArgs {
        return PolygonsApiFp(this.configuration).polygonsDeleteListPolygonURL({ data, options });
    }

    /**
     * 
     * @param {DeleteListPolygonRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public polygonsDeleteListPolygon({ data, options }: IpolygonsDeleteListPolygonProps) {
        return PolygonsApiFp(this.configuration).polygonsDeleteListPolygon({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``polygonsImportPolygons`` for arguments and options.
     *
     */
    public polygonsImportPolygonsURL({ data, options }: IpolygonsImportPolygonsProps): FetchArgs {
        return PolygonsApiFp(this.configuration).polygonsImportPolygonsURL({ data, options });
    }

    /**
     * 
     * @param {PolygonsImportRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public polygonsImportPolygons({ data, options }: IpolygonsImportPolygonsProps) {
        return PolygonsApiFp(this.configuration).polygonsImportPolygons({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``polygonsLightList`` for arguments and options.
     *
     */
    public polygonsLightListURL({ options }: IpolygonsLightListProps = {}): FetchArgs {
        return PolygonsApiFp(this.configuration).polygonsLightListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public polygonsLightList({ options }: IpolygonsLightListProps = {}) {
        return PolygonsApiFp(this.configuration).polygonsLightList({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``polygonsList`` for arguments and options.
     *
     */
    public polygonsListURL({ options }: IpolygonsListProps = {}): FetchArgs {
        return PolygonsApiFp(this.configuration).polygonsListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public polygonsList({ options }: IpolygonsListProps = {}) {
        return PolygonsApiFp(this.configuration).polygonsList({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``polygonsPartialUpdate`` for arguments and options.
     *
     */
    public polygonsPartialUpdateURL({ id, data, options }: IpolygonsPartialUpdateProps): FetchArgs {
        return PolygonsApiFp(this.configuration).polygonsPartialUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this polygon.
     * @param {PolygonRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public polygonsPartialUpdate({ id, data, options }: IpolygonsPartialUpdateProps) {
        return PolygonsApiFp(this.configuration).polygonsPartialUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``polygonsRead`` for arguments and options.
     *
     */
    public polygonsReadURL({ id, options }: IpolygonsReadProps): FetchArgs {
        return PolygonsApiFp(this.configuration).polygonsReadURL({ id, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this polygon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public polygonsRead({ id, options }: IpolygonsReadProps) {
        return PolygonsApiFp(this.configuration).polygonsRead({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``polygonsUpdate`` for arguments and options.
     *
     */
    public polygonsUpdateURL({ id, data, options }: IpolygonsUpdateProps): FetchArgs {
        return PolygonsApiFp(this.configuration).polygonsUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this polygon.
     * @param {PolygonRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolygonsApi
     */
    public polygonsUpdate({ id, data, options }: IpolygonsUpdateProps) {
        return PolygonsApiFp(this.configuration).polygonsUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

}

/**
 * powerbiReportRead parameters
 */
export interface IpowerbiReportReadProps {
    report_name: 'vehicles_kpis_powerbi_report' | 'utilization_kpis_powerbi_report' | 'trips_kpis_powerbi_report' | 'ride_hailing_powerbi_report' | 'safety_powerbi_report' | 'passengers_services_test_powerbi_report' | 'parking_powerbi_report' | 'parking_bay_powerbi_report' | 'heatmap_powerbi_report' | 'environment_kpis_powerbi_report' | 'docked_bikes_powerbi_report' | 'data_quality_kpis_powerbi_report' | 'smart_loading_zone_powerbi_report' | 'curb_overview_powerbi_report',
    options?: any,
};

/**
 * PowerbiApi - fetch parameter creator
 * @export
 */
export const PowerbiApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {'vehicles_kpis_powerbi_report' | 'utilization_kpis_powerbi_report' | 'trips_kpis_powerbi_report' | 'ride_hailing_powerbi_report' | 'safety_powerbi_report' | 'passengers_services_test_powerbi_report' | 'parking_powerbi_report' | 'parking_bay_powerbi_report' | 'heatmap_powerbi_report' | 'environment_kpis_powerbi_report' | 'docked_bikes_powerbi_report' | 'data_quality_kpis_powerbi_report' | 'smart_loading_zone_powerbi_report' | 'curb_overview_powerbi_report'} report_name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        powerbiReportRead({ report_name, options = {} }: IpowerbiReportReadProps): FetchArgs {
            // verify required parameter 'report_name' is not null or undefined
            if (report_name === null || report_name === undefined) {
                throw new RequiredError('report_name','Required parameter report_name was null or undefined when calling powerbiReportRead.');
            }
            const localVarPath = `/powerbi/report/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (report_name !== undefined) {
                localVarQueryParameter['report_name'] = report_name;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PowerbiApi - functional programming interface
 * @export
 */
export const PowerbiApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        powerbiReportReadURL({ report_name, options }: IpowerbiReportReadProps): FetchArgs {
            return PowerbiApiFetchParamCreator(configuration).powerbiReportRead({ report_name, options });
        },

        /**
         * 
         * @param {'vehicles_kpis_powerbi_report' | 'utilization_kpis_powerbi_report' | 'trips_kpis_powerbi_report' | 'ride_hailing_powerbi_report' | 'safety_powerbi_report' | 'passengers_services_test_powerbi_report' | 'parking_powerbi_report' | 'parking_bay_powerbi_report' | 'heatmap_powerbi_report' | 'environment_kpis_powerbi_report' | 'docked_bikes_powerbi_report' | 'data_quality_kpis_powerbi_report' | 'smart_loading_zone_powerbi_report' | 'curb_overview_powerbi_report'} report_name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        powerbiReportRead({ report_name, options }: IpowerbiReportReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<PowerBIReport> {
            const localVarFetchArgs = this.powerbiReportReadURL({ report_name, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * PowerbiApi - factory interface
 * @export
 */
export const PowerbiApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {'vehicles_kpis_powerbi_report' | 'utilization_kpis_powerbi_report' | 'trips_kpis_powerbi_report' | 'ride_hailing_powerbi_report' | 'safety_powerbi_report' | 'passengers_services_test_powerbi_report' | 'parking_powerbi_report' | 'parking_bay_powerbi_report' | 'heatmap_powerbi_report' | 'environment_kpis_powerbi_report' | 'docked_bikes_powerbi_report' | 'data_quality_kpis_powerbi_report' | 'smart_loading_zone_powerbi_report' | 'curb_overview_powerbi_report'} report_name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        powerbiReportRead({ report_name, options }: IpowerbiReportReadProps) {
            return PowerbiApiFp(configuration).powerbiReportRead({ report_name, options })(fetch, basePath);
        },
    };
};

/**
 * PowerbiApi - object-oriented interface
 * @export
 * @class PowerbiApi
 * @extends {BaseAPI}
 */
export class PowerbiApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``powerbiReportRead`` for arguments and options.
     *
     */
    public powerbiReportReadURL({ report_name, options }: IpowerbiReportReadProps): FetchArgs {
        return PowerbiApiFp(this.configuration).powerbiReportReadURL({ report_name, options });
    }

    /**
     * 
     * @param {'vehicles_kpis_powerbi_report' | 'utilization_kpis_powerbi_report' | 'trips_kpis_powerbi_report' | 'ride_hailing_powerbi_report' | 'safety_powerbi_report' | 'passengers_services_test_powerbi_report' | 'parking_powerbi_report' | 'parking_bay_powerbi_report' | 'heatmap_powerbi_report' | 'environment_kpis_powerbi_report' | 'docked_bikes_powerbi_report' | 'data_quality_kpis_powerbi_report' | 'smart_loading_zone_powerbi_report' | 'curb_overview_powerbi_report'} report_name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PowerbiApi
     */
    public powerbiReportRead({ report_name, options }: IpowerbiReportReadProps) {
        return PowerbiApiFp(this.configuration).powerbiReportRead({ report_name, options })(this.fetchData, this.basePath);
    }

}

/**
 * providersCreate parameters
 */
export interface IprovidersCreateProps {
    data: Provider,
    options?: any,
};

/**
 * providersDelete parameters
 */
export interface IprovidersDeleteProps {
    id: string, // A UUID string identifying this provider.
    options?: any,
};

/**
 * providersList parameters
 */
export interface IprovidersListProps {
    is_active?: boolean, // 
    options?: any,
};

/**
 * providersPartialUpdate parameters
 */
export interface IprovidersPartialUpdateProps {
    id: string, // A UUID string identifying this provider.
    data: Provider,
    options?: any,
};

/**
 * providersRead parameters
 */
export interface IprovidersReadProps {
    id: string, // A UUID string identifying this provider.
    options?: any,
};

/**
 * providersUpdate parameters
 */
export interface IprovidersUpdateProps {
    id: string, // A UUID string identifying this provider.
    data: Provider,
    options?: any,
};

/**
 * ProvidersApi - fetch parameter creator
 * @export
 */
export const ProvidersApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Provider} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersCreate({ data, options = {} }: IprovidersCreateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling providersCreate.');
            }
            const localVarPath = `/providers/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Provider" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersDelete({ id, options = {} }: IprovidersDeleteProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling providersDelete.');
            }
            const localVarPath = `/providers/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [is_active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersList({ is_active, options = {} }: IprovidersListProps): FetchArgs {
            const localVarPath = `/providers/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (is_active !== undefined) {
                localVarQueryParameter['is_active'] = is_active;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {Provider} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersPartialUpdate({ id, data, options = {} }: IprovidersPartialUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling providersPartialUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling providersPartialUpdate.');
            }
            const localVarPath = `/providers/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Provider" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersRead({ id, options = {} }: IprovidersReadProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling providersRead.');
            }
            const localVarPath = `/providers/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {Provider} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersUpdate({ id, data, options = {} }: IprovidersUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling providersUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling providersUpdate.');
            }
            const localVarPath = `/providers/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Provider" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProvidersApi - functional programming interface
 * @export
 */
export const ProvidersApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        providersCreateURL({ data, options }: IprovidersCreateProps): FetchArgs {
            return ProvidersApiFetchParamCreator(configuration).providersCreate({ data, options });
        },

        /**
         * 
         * @param {Provider} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersCreate({ data, options }: IprovidersCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<Provider> {
            const localVarFetchArgs = this.providersCreateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        providersDeleteURL({ id, options }: IprovidersDeleteProps): FetchArgs {
            return ProvidersApiFetchParamCreator(configuration).providersDelete({ id, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersDelete({ id, options }: IprovidersDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.providersDeleteURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        providersListURL({ is_active, options }: IprovidersListProps): FetchArgs {
            return ProvidersApiFetchParamCreator(configuration).providersList({ is_active, options });
        },

        /**
         * 
         * @param {boolean} [is_active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersList({ is_active, options }: IprovidersListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Provider>> {
            const localVarFetchArgs = this.providersListURL({ is_active, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        providersPartialUpdateURL({ id, data, options }: IprovidersPartialUpdateProps): FetchArgs {
            return ProvidersApiFetchParamCreator(configuration).providersPartialUpdate({ id, data, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {Provider} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersPartialUpdate({ id, data, options }: IprovidersPartialUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<Provider> {
            const localVarFetchArgs = this.providersPartialUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        providersReadURL({ id, options }: IprovidersReadProps): FetchArgs {
            return ProvidersApiFetchParamCreator(configuration).providersRead({ id, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersRead({ id, options }: IprovidersReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<Provider> {
            const localVarFetchArgs = this.providersReadURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        providersUpdateURL({ id, data, options }: IprovidersUpdateProps): FetchArgs {
            return ProvidersApiFetchParamCreator(configuration).providersUpdate({ id, data, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {Provider} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersUpdate({ id, data, options }: IprovidersUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<Provider> {
            const localVarFetchArgs = this.providersUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * ProvidersApi - factory interface
 * @export
 */
export const ProvidersApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {Provider} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersCreate({ data, options }: IprovidersCreateProps) {
            return ProvidersApiFp(configuration).providersCreate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersDelete({ id, options }: IprovidersDeleteProps) {
            return ProvidersApiFp(configuration).providersDelete({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {boolean} [is_active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersList({ is_active, options }: IprovidersListProps) {
            return ProvidersApiFp(configuration).providersList({ is_active, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {Provider} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersPartialUpdate({ id, data, options }: IprovidersPartialUpdateProps) {
            return ProvidersApiFp(configuration).providersPartialUpdate({ id, data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersRead({ id, options }: IprovidersReadProps) {
            return ProvidersApiFp(configuration).providersRead({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this provider.
         * @param {Provider} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        providersUpdate({ id, data, options }: IprovidersUpdateProps) {
            return ProvidersApiFp(configuration).providersUpdate({ id, data, options })(fetch, basePath);
        },
    };
};

/**
 * ProvidersApi - object-oriented interface
 * @export
 * @class ProvidersApi
 * @extends {BaseAPI}
 */
export class ProvidersApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``providersCreate`` for arguments and options.
     *
     */
    public providersCreateURL({ data, options }: IprovidersCreateProps): FetchArgs {
        return ProvidersApiFp(this.configuration).providersCreateURL({ data, options });
    }

    /**
     * 
     * @param {Provider} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providersCreate({ data, options }: IprovidersCreateProps) {
        return ProvidersApiFp(this.configuration).providersCreate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``providersDelete`` for arguments and options.
     *
     */
    public providersDeleteURL({ id, options }: IprovidersDeleteProps): FetchArgs {
        return ProvidersApiFp(this.configuration).providersDeleteURL({ id, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providersDelete({ id, options }: IprovidersDeleteProps) {
        return ProvidersApiFp(this.configuration).providersDelete({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``providersList`` for arguments and options.
     *
     */
    public providersListURL({ is_active, options }: IprovidersListProps = {}): FetchArgs {
        return ProvidersApiFp(this.configuration).providersListURL({ is_active, options });
    }

    /**
     * 
     * @param {boolean} [is_active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providersList({ is_active, options }: IprovidersListProps = {}) {
        return ProvidersApiFp(this.configuration).providersList({ is_active, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``providersPartialUpdate`` for arguments and options.
     *
     */
    public providersPartialUpdateURL({ id, data, options }: IprovidersPartialUpdateProps): FetchArgs {
        return ProvidersApiFp(this.configuration).providersPartialUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this provider.
     * @param {Provider} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providersPartialUpdate({ id, data, options }: IprovidersPartialUpdateProps) {
        return ProvidersApiFp(this.configuration).providersPartialUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``providersRead`` for arguments and options.
     *
     */
    public providersReadURL({ id, options }: IprovidersReadProps): FetchArgs {
        return ProvidersApiFp(this.configuration).providersReadURL({ id, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this provider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providersRead({ id, options }: IprovidersReadProps) {
        return ProvidersApiFp(this.configuration).providersRead({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``providersUpdate`` for arguments and options.
     *
     */
    public providersUpdateURL({ id, data, options }: IprovidersUpdateProps): FetchArgs {
        return ProvidersApiFp(this.configuration).providersUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this provider.
     * @param {Provider} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public providersUpdate({ id, data, options }: IprovidersUpdateProps) {
        return ProvidersApiFp(this.configuration).providersUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

}

/**
 * reportsCreate parameters
 */
export interface IreportsCreateProps {
    data: CreateReport,
    options?: any,
};

/**
 * reportsDelete parameters
 */
export interface IreportsDeleteProps {
    id: number, // A unique integer value identifying this report.
    options?: any,
};

/**
 * reportsExport parameters
 */
export interface IreportsExportProps {
    id: number, // A unique integer value identifying this report.
    tz?: string,
    lang?: string,
    granularity?: string,
    options?: any,
};

/**
 * reportsList parameters
 */
export interface IreportsListProps {
    kind?: 'area_flow' | 'historical_map' | 'effective_presence', // 
    created_by?: Array<string>, // 
    name?: string, // 
    type?: Array<'area_flow' | 'historical_map' | 'effective_presence'>, // 
    options?: any,
};

/**
 * reportsPartialUpdate parameters
 */
export interface IreportsPartialUpdateProps {
    id: number, // A unique integer value identifying this report.
    data: UpdateReport,
    options?: any,
};

/**
 * reportsRead parameters
 */
export interface IreportsReadProps {
    id: number, // A unique integer value identifying this report.
    options?: any,
};

/**
 * reportsUpdate parameters
 */
export interface IreportsUpdateProps {
    id: number, // A unique integer value identifying this report.
    data: UpdateReport,
    options?: any,
};

/**
 * ReportsApi - fetch parameter creator
 * @export
 */
export const ReportsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateReport} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCreate({ data, options = {} }: IreportsCreateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling reportsCreate.');
            }
            const localVarPath = `/reports/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateReport" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDelete({ id, options = {} }: IreportsDeleteProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportsDelete.');
            }
            const localVarPath = `/reports/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [granularity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsExport({ id, tz, lang, granularity, options = {} }: IreportsExportProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportsExport.');
            }
            const localVarPath = `/reports/{id}/export/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'area_flow' | 'historical_map' | 'effective_presence'} [kind] 
         * @param {Array<string>} [created_by] 
         * @param {string} [name] 
         * @param {Array<'area_flow' | 'historical_map' | 'effective_presence'>} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsList({ kind, created_by, name, type, options = {} }: IreportsListProps): FetchArgs {
            const localVarPath = `/reports/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (created_by) {
                localVarQueryParameter['created_by'] = created_by;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {UpdateReport} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsPartialUpdate({ id, data, options = {} }: IreportsPartialUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportsPartialUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling reportsPartialUpdate.');
            }
            const localVarPath = `/reports/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateReport" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsRead({ id, options = {} }: IreportsReadProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportsRead.');
            }
            const localVarPath = `/reports/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {UpdateReport} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUpdate({ id, data, options = {} }: IreportsUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportsUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling reportsUpdate.');
            }
            const localVarPath = `/reports/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateReport" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        reportsCreateURL({ data, options }: IreportsCreateProps): FetchArgs {
            return ReportsApiFetchParamCreator(configuration).reportsCreate({ data, options });
        },

        /**
         * 
         * @param {CreateReport} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCreate({ data, options }: IreportsCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.reportsCreateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        reportsDeleteURL({ id, options }: IreportsDeleteProps): FetchArgs {
            return ReportsApiFetchParamCreator(configuration).reportsDelete({ id, options });
        },

        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDelete({ id, options }: IreportsDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.reportsDeleteURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        reportsExportURL({ id, tz, lang, granularity, options }: IreportsExportProps): FetchArgs {
            return ReportsApiFetchParamCreator(configuration).reportsExport({ id, tz, lang, granularity, options });
        },

        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [granularity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsExport({ id, tz, lang, granularity, options }: IreportsExportProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.reportsExportURL({ id, tz, lang, granularity, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        reportsListURL({ kind, created_by, name, type, options }: IreportsListProps): FetchArgs {
            return ReportsApiFetchParamCreator(configuration).reportsList({ kind, created_by, name, type, options });
        },

        /**
         * 
         * @param {'area_flow' | 'historical_map' | 'effective_presence'} [kind] 
         * @param {Array<string>} [created_by] 
         * @param {string} [name] 
         * @param {Array<'area_flow' | 'historical_map' | 'effective_presence'>} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsList({ kind, created_by, name, type, options }: IreportsListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ListReport>> {
            const localVarFetchArgs = this.reportsListURL({ kind, created_by, name, type, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        reportsPartialUpdateURL({ id, data, options }: IreportsPartialUpdateProps): FetchArgs {
            return ReportsApiFetchParamCreator(configuration).reportsPartialUpdate({ id, data, options });
        },

        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {UpdateReport} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsPartialUpdate({ id, data, options }: IreportsPartialUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.reportsPartialUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        reportsReadURL({ id, options }: IreportsReadProps): FetchArgs {
            return ReportsApiFetchParamCreator(configuration).reportsRead({ id, options });
        },

        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsRead({ id, options }: IreportsReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<RetrievedReport> {
            const localVarFetchArgs = this.reportsReadURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        reportsUpdateURL({ id, data, options }: IreportsUpdateProps): FetchArgs {
            return ReportsApiFetchParamCreator(configuration).reportsUpdate({ id, data, options });
        },

        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {UpdateReport} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUpdate({ id, data, options }: IreportsUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.reportsUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {CreateReport} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCreate({ data, options }: IreportsCreateProps) {
            return ReportsApiFp(configuration).reportsCreate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDelete({ id, options }: IreportsDeleteProps) {
            return ReportsApiFp(configuration).reportsDelete({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [granularity] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsExport({ id, tz, lang, granularity, options }: IreportsExportProps) {
            return ReportsApiFp(configuration).reportsExport({ id, tz, lang, granularity, options })(fetch, basePath);
        },
        /**
         * 
         * @param {'area_flow' | 'historical_map' | 'effective_presence'} [kind] 
         * @param {Array<string>} [created_by] 
         * @param {string} [name] 
         * @param {Array<'area_flow' | 'historical_map' | 'effective_presence'>} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsList({ kind, created_by, name, type, options }: IreportsListProps) {
            return ReportsApiFp(configuration).reportsList({ kind, created_by, name, type, options })(fetch, basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {UpdateReport} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsPartialUpdate({ id, data, options }: IreportsPartialUpdateProps) {
            return ReportsApiFp(configuration).reportsPartialUpdate({ id, data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsRead({ id, options }: IreportsReadProps) {
            return ReportsApiFp(configuration).reportsRead({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this report.
         * @param {UpdateReport} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUpdate({ id, data, options }: IreportsUpdateProps) {
            return ReportsApiFp(configuration).reportsUpdate({ id, data, options })(fetch, basePath);
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``reportsCreate`` for arguments and options.
     *
     */
    public reportsCreateURL({ data, options }: IreportsCreateProps): FetchArgs {
        return ReportsApiFp(this.configuration).reportsCreateURL({ data, options });
    }

    /**
     * 
     * @param {CreateReport} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsCreate({ data, options }: IreportsCreateProps) {
        return ReportsApiFp(this.configuration).reportsCreate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``reportsDelete`` for arguments and options.
     *
     */
    public reportsDeleteURL({ id, options }: IreportsDeleteProps): FetchArgs {
        return ReportsApiFp(this.configuration).reportsDeleteURL({ id, options });
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this report.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsDelete({ id, options }: IreportsDeleteProps) {
        return ReportsApiFp(this.configuration).reportsDelete({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``reportsExport`` for arguments and options.
     *
     */
    public reportsExportURL({ id, tz, lang, granularity, options }: IreportsExportProps): FetchArgs {
        return ReportsApiFp(this.configuration).reportsExportURL({ id, tz, lang, granularity, options });
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this report.
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [granularity] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsExport({ id, tz, lang, granularity, options }: IreportsExportProps) {
        return ReportsApiFp(this.configuration).reportsExport({ id, tz, lang, granularity, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``reportsList`` for arguments and options.
     *
     */
    public reportsListURL({ kind, created_by, name, type, options }: IreportsListProps = {}): FetchArgs {
        return ReportsApiFp(this.configuration).reportsListURL({ kind, created_by, name, type, options });
    }

    /**
     * 
     * @param {'area_flow' | 'historical_map' | 'effective_presence'} [kind] 
     * @param {Array<string>} [created_by] 
     * @param {string} [name] 
     * @param {Array<'area_flow' | 'historical_map' | 'effective_presence'>} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsList({ kind, created_by, name, type, options }: IreportsListProps = {}) {
        return ReportsApiFp(this.configuration).reportsList({ kind, created_by, name, type, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``reportsPartialUpdate`` for arguments and options.
     *
     */
    public reportsPartialUpdateURL({ id, data, options }: IreportsPartialUpdateProps): FetchArgs {
        return ReportsApiFp(this.configuration).reportsPartialUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this report.
     * @param {UpdateReport} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsPartialUpdate({ id, data, options }: IreportsPartialUpdateProps) {
        return ReportsApiFp(this.configuration).reportsPartialUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``reportsRead`` for arguments and options.
     *
     */
    public reportsReadURL({ id, options }: IreportsReadProps): FetchArgs {
        return ReportsApiFp(this.configuration).reportsReadURL({ id, options });
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this report.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsRead({ id, options }: IreportsReadProps) {
        return ReportsApiFp(this.configuration).reportsRead({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``reportsUpdate`` for arguments and options.
     *
     */
    public reportsUpdateURL({ id, data, options }: IreportsUpdateProps): FetchArgs {
        return ReportsApiFp(this.configuration).reportsUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this report.
     * @param {UpdateReport} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsUpdate({ id, data, options }: IreportsUpdateProps) {
        return ReportsApiFp(this.configuration).reportsUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

}

/**
 * serviceAreasBufferArea parameters
 */
export interface IserviceAreasBufferAreaProps {
    data: BufferAreaRequest,
    options?: any,
};

/**
 * serviceAreasCreate parameters
 */
export interface IserviceAreasCreateProps {
    data: AreaRequest,
    options?: any,
};

/**
 * serviceAreasDelete parameters
 */
export interface IserviceAreasDeleteProps {
    id: string, // A UUID string identifying this area.
    options?: any,
};

/**
 * serviceAreasLabels parameters
 */
export interface IserviceAreasLabelsProps {
    policies_id?: Array<string>,
    options?: any,
};

/**
 * serviceAreasLightList parameters
 */
export interface IserviceAreasLightListProps {
    options?: any,
};

/**
 * serviceAreasList parameters
 */
export interface IserviceAreasListProps {
    options?: any,
};

/**
 * serviceAreasMergeAreas parameters
 */
export interface IserviceAreasMergeAreasProps {
    data: MergeAreasRequest,
    options?: any,
};

/**
 * serviceAreasPartialUpdate parameters
 */
export interface IserviceAreasPartialUpdateProps {
    id: string, // A UUID string identifying this area.
    data: AreaRequest,
    options?: any,
};

/**
 * serviceAreasRead parameters
 */
export interface IserviceAreasReadProps {
    id: string, // A UUID string identifying this area.
    options?: any,
};

/**
 * serviceAreasSubtractAreas parameters
 */
export interface IserviceAreasSubtractAreasProps {
    data: SubtractAreasRequest,
    options?: any,
};

/**
 * serviceAreasUpdate parameters
 */
export interface IserviceAreasUpdateProps {
    id: string, // A UUID string identifying this area.
    data: AreaRequest,
    options?: any,
};

/**
 * ServiceAreasApi - fetch parameter creator
 * @export
 */
export const ServiceAreasApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BufferAreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasBufferArea({ data, options = {} }: IserviceAreasBufferAreaProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling serviceAreasBufferArea.');
            }
            const localVarPath = `/service_areas/buffer_area/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BufferAreaRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasCreate({ data, options = {} }: IserviceAreasCreateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling serviceAreasCreate.');
            }
            const localVarPath = `/service_areas/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AreaRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasDelete({ id, options = {} }: IserviceAreasDeleteProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling serviceAreasDelete.');
            }
            const localVarPath = `/service_areas/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a list of area names and id on *all* areas. We want to have all versions since this is used to display a Area label from the policy/Report area_id
         * @param {Array<string>} [policies_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasLabels({ policies_id, options = {} }: IserviceAreasLabelsProps): FetchArgs {
            const localVarPath = `/service_areas/labels/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (policies_id) {
                localVarQueryParameter['policies_id'] = policies_id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only the columns listed by the frontend using the latest_versions manager.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasLightList({ options = {} }: IserviceAreasLightListProps): FetchArgs {
            const localVarPath = `/service_areas/light_list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Areas using the latest_versions manager.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasList({ options = {} }: IserviceAreasListProps): FetchArgs {
            const localVarPath = `/service_areas/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MergeAreasRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasMergeAreas({ data, options = {} }: IserviceAreasMergeAreasProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling serviceAreasMergeAreas.');
            }
            const localVarPath = `/service_areas/merge_areas/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"MergeAreasRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {AreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasPartialUpdate({ id, data, options = {} }: IserviceAreasPartialUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling serviceAreasPartialUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling serviceAreasPartialUpdate.');
            }
            const localVarPath = `/service_areas/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AreaRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasRead({ id, options = {} }: IserviceAreasReadProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling serviceAreasRead.');
            }
            const localVarPath = `/service_areas/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubtractAreasRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasSubtractAreas({ data, options = {} }: IserviceAreasSubtractAreasProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling serviceAreasSubtractAreas.');
            }
            const localVarPath = `/service_areas/subtract_areas/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SubtractAreasRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {AreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasUpdate({ id, data, options = {} }: IserviceAreasUpdateProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling serviceAreasUpdate.');
            }
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling serviceAreasUpdate.');
            }
            const localVarPath = `/service_areas/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AreaRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceAreasApi - functional programming interface
 * @export
 */
export const ServiceAreasApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        serviceAreasBufferAreaURL({ data, options }: IserviceAreasBufferAreaProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasBufferArea({ data, options });
        },

        /**
         * 
         * @param {BufferAreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasBufferArea({ data, options }: IserviceAreasBufferAreaProps): (fetch?: FetchAPI, basePath?: string) => Promise<CreatedAreaResponse> {
            const localVarFetchArgs = this.serviceAreasBufferAreaURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        serviceAreasCreateURL({ data, options }: IserviceAreasCreateProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasCreate({ data, options });
        },

        /**
         * 
         * @param {AreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasCreate({ data, options }: IserviceAreasCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.serviceAreasCreateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        serviceAreasDeleteURL({ id, options }: IserviceAreasDeleteProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasDelete({ id, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasDelete({ id, options }: IserviceAreasDeleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.serviceAreasDeleteURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        serviceAreasLabelsURL({ policies_id, options }: IserviceAreasLabelsProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasLabels({ policies_id, options });
        },

        /**
         * Fetch a list of area names and id on *all* areas. We want to have all versions since this is used to display a Area label from the policy/Report area_id
         * @param {Array<string>} [policies_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasLabels({ policies_id, options }: IserviceAreasLabelsProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AreaLabelResponse>> {
            const localVarFetchArgs = this.serviceAreasLabelsURL({ policies_id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        serviceAreasLightListURL({ options }: IserviceAreasLightListProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasLightList({ options });
        },

        /**
         * Only the columns listed by the frontend using the latest_versions manager.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasLightList({ options }: IserviceAreasLightListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<LightArea>> {
            const localVarFetchArgs = this.serviceAreasLightListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        serviceAreasListURL({ options }: IserviceAreasListProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasList({ options });
        },

        /**
         * List Areas using the latest_versions manager.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasList({ options }: IserviceAreasListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AreaResponse>> {
            const localVarFetchArgs = this.serviceAreasListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        serviceAreasMergeAreasURL({ data, options }: IserviceAreasMergeAreasProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasMergeAreas({ data, options });
        },

        /**
         * 
         * @param {MergeAreasRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasMergeAreas({ data, options }: IserviceAreasMergeAreasProps): (fetch?: FetchAPI, basePath?: string) => Promise<CreatedAreaResponse> {
            const localVarFetchArgs = this.serviceAreasMergeAreasURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        serviceAreasPartialUpdateURL({ id, data, options }: IserviceAreasPartialUpdateProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasPartialUpdate({ id, data, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {AreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasPartialUpdate({ id, data, options }: IserviceAreasPartialUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.serviceAreasPartialUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        serviceAreasReadURL({ id, options }: IserviceAreasReadProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasRead({ id, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasRead({ id, options }: IserviceAreasReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<AreaResponse> {
            const localVarFetchArgs = this.serviceAreasReadURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        serviceAreasSubtractAreasURL({ data, options }: IserviceAreasSubtractAreasProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasSubtractAreas({ data, options });
        },

        /**
         * 
         * @param {SubtractAreasRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasSubtractAreas({ data, options }: IserviceAreasSubtractAreasProps): (fetch?: FetchAPI, basePath?: string) => Promise<CreatedAreaResponse> {
            const localVarFetchArgs = this.serviceAreasSubtractAreasURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        serviceAreasUpdateURL({ id, data, options }: IserviceAreasUpdateProps): FetchArgs {
            return ServiceAreasApiFetchParamCreator(configuration).serviceAreasUpdate({ id, data, options });
        },

        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {AreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasUpdate({ id, data, options }: IserviceAreasUpdateProps): (fetch?: FetchAPI, basePath?: string) => Promise<EmptyResponse> {
            const localVarFetchArgs = this.serviceAreasUpdateURL({ id, data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * ServiceAreasApi - factory interface
 * @export
 */
export const ServiceAreasApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {BufferAreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasBufferArea({ data, options }: IserviceAreasBufferAreaProps) {
            return ServiceAreasApiFp(configuration).serviceAreasBufferArea({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {AreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasCreate({ data, options }: IserviceAreasCreateProps) {
            return ServiceAreasApiFp(configuration).serviceAreasCreate({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasDelete({ id, options }: IserviceAreasDeleteProps) {
            return ServiceAreasApiFp(configuration).serviceAreasDelete({ id, options })(fetch, basePath);
        },
        /**
         * Fetch a list of area names and id on *all* areas. We want to have all versions since this is used to display a Area label from the policy/Report area_id
         * @param {Array<string>} [policies_id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasLabels({ policies_id, options }: IserviceAreasLabelsProps) {
            return ServiceAreasApiFp(configuration).serviceAreasLabels({ policies_id, options })(fetch, basePath);
        },
        /**
         * Only the columns listed by the frontend using the latest_versions manager.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasLightList({ options }: IserviceAreasLightListProps) {
            return ServiceAreasApiFp(configuration).serviceAreasLightList({ options })(fetch, basePath);
        },
        /**
         * List Areas using the latest_versions manager.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasList({ options }: IserviceAreasListProps) {
            return ServiceAreasApiFp(configuration).serviceAreasList({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {MergeAreasRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasMergeAreas({ data, options }: IserviceAreasMergeAreasProps) {
            return ServiceAreasApiFp(configuration).serviceAreasMergeAreas({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {AreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasPartialUpdate({ id, data, options }: IserviceAreasPartialUpdateProps) {
            return ServiceAreasApiFp(configuration).serviceAreasPartialUpdate({ id, data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasRead({ id, options }: IserviceAreasReadProps) {
            return ServiceAreasApiFp(configuration).serviceAreasRead({ id, options })(fetch, basePath);
        },
        /**
         * 
         * @param {SubtractAreasRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasSubtractAreas({ data, options }: IserviceAreasSubtractAreasProps) {
            return ServiceAreasApiFp(configuration).serviceAreasSubtractAreas({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this area.
         * @param {AreaRequest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAreasUpdate({ id, data, options }: IserviceAreasUpdateProps) {
            return ServiceAreasApiFp(configuration).serviceAreasUpdate({ id, data, options })(fetch, basePath);
        },
    };
};

/**
 * ServiceAreasApi - object-oriented interface
 * @export
 * @class ServiceAreasApi
 * @extends {BaseAPI}
 */
export class ServiceAreasApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasBufferArea`` for arguments and options.
     *
     */
    public serviceAreasBufferAreaURL({ data, options }: IserviceAreasBufferAreaProps): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasBufferAreaURL({ data, options });
    }

    /**
     * 
     * @param {BufferAreaRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasBufferArea({ data, options }: IserviceAreasBufferAreaProps) {
        return ServiceAreasApiFp(this.configuration).serviceAreasBufferArea({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasCreate`` for arguments and options.
     *
     */
    public serviceAreasCreateURL({ data, options }: IserviceAreasCreateProps): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasCreateURL({ data, options });
    }

    /**
     * 
     * @param {AreaRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasCreate({ data, options }: IserviceAreasCreateProps) {
        return ServiceAreasApiFp(this.configuration).serviceAreasCreate({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasDelete`` for arguments and options.
     *
     */
    public serviceAreasDeleteURL({ id, options }: IserviceAreasDeleteProps): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasDeleteURL({ id, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this area.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasDelete({ id, options }: IserviceAreasDeleteProps) {
        return ServiceAreasApiFp(this.configuration).serviceAreasDelete({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasLabels`` for arguments and options.
     *
     */
    public serviceAreasLabelsURL({ policies_id, options }: IserviceAreasLabelsProps = {}): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasLabelsURL({ policies_id, options });
    }

    /**
     * Fetch a list of area names and id on *all* areas. We want to have all versions since this is used to display a Area label from the policy/Report area_id
     * @param {Array<string>} [policies_id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasLabels({ policies_id, options }: IserviceAreasLabelsProps = {}) {
        return ServiceAreasApiFp(this.configuration).serviceAreasLabels({ policies_id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasLightList`` for arguments and options.
     *
     */
    public serviceAreasLightListURL({ options }: IserviceAreasLightListProps = {}): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasLightListURL({ options });
    }

    /**
     * Only the columns listed by the frontend using the latest_versions manager.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasLightList({ options }: IserviceAreasLightListProps = {}) {
        return ServiceAreasApiFp(this.configuration).serviceAreasLightList({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasList`` for arguments and options.
     *
     */
    public serviceAreasListURL({ options }: IserviceAreasListProps = {}): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasListURL({ options });
    }

    /**
     * List Areas using the latest_versions manager.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasList({ options }: IserviceAreasListProps = {}) {
        return ServiceAreasApiFp(this.configuration).serviceAreasList({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasMergeAreas`` for arguments and options.
     *
     */
    public serviceAreasMergeAreasURL({ data, options }: IserviceAreasMergeAreasProps): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasMergeAreasURL({ data, options });
    }

    /**
     * 
     * @param {MergeAreasRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasMergeAreas({ data, options }: IserviceAreasMergeAreasProps) {
        return ServiceAreasApiFp(this.configuration).serviceAreasMergeAreas({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasPartialUpdate`` for arguments and options.
     *
     */
    public serviceAreasPartialUpdateURL({ id, data, options }: IserviceAreasPartialUpdateProps): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasPartialUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this area.
     * @param {AreaRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasPartialUpdate({ id, data, options }: IserviceAreasPartialUpdateProps) {
        return ServiceAreasApiFp(this.configuration).serviceAreasPartialUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasRead`` for arguments and options.
     *
     */
    public serviceAreasReadURL({ id, options }: IserviceAreasReadProps): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasReadURL({ id, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this area.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasRead({ id, options }: IserviceAreasReadProps) {
        return ServiceAreasApiFp(this.configuration).serviceAreasRead({ id, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasSubtractAreas`` for arguments and options.
     *
     */
    public serviceAreasSubtractAreasURL({ data, options }: IserviceAreasSubtractAreasProps): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasSubtractAreasURL({ data, options });
    }

    /**
     * 
     * @param {SubtractAreasRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasSubtractAreas({ data, options }: IserviceAreasSubtractAreasProps) {
        return ServiceAreasApiFp(this.configuration).serviceAreasSubtractAreas({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``serviceAreasUpdate`` for arguments and options.
     *
     */
    public serviceAreasUpdateURL({ id, data, options }: IserviceAreasUpdateProps): FetchArgs {
        return ServiceAreasApiFp(this.configuration).serviceAreasUpdateURL({ id, data, options });
    }

    /**
     * 
     * @param {string} id A UUID string identifying this area.
     * @param {AreaRequest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAreasApi
     */
    public serviceAreasUpdate({ id, data, options }: IserviceAreasUpdateProps) {
        return ServiceAreasApiFp(this.configuration).serviceAreasUpdate({ id, data, options })(this.fetchData, this.basePath);
    }

}

/**
 * smartPatrolAgentsList parameters
 */
export interface IsmartPatrolAgentsListProps {
    options?: any,
};

/**
 * smartPatrolExport parameters
 */
export interface IsmartPatrolExportProps {
    id?: Array<string>, // Multiple values may be separated by commas.
    vin?: Array<string>, // Multiple values may be separated by commas.
    created_at_after?: string, // range (lower bound)
    created_at_before?: string, // range (upper bound)
    provider_names?: Array<string>, // Multiple values may be separated by commas.
    type?: Array<string>, // Multiple values may be separated by commas.
    vehicule_types?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    agent_names?: Array<string>, // 
    tz?: string, // 
    lang?: string, // 
    options?: any,
};

/**
 * smartPatrolExportPictures parameters
 */
export interface IsmartPatrolExportPicturesProps {
    offense_uid: string,
    options?: any,
};

/**
 * smartPatrolListList parameters
 */
export interface IsmartPatrolListListProps {
    id?: Array<string>, // Multiple values may be separated by commas.
    vin?: Array<string>, // Multiple values may be separated by commas.
    created_at_after?: string, // range (lower bound)
    created_at_before?: string, // range (upper bound)
    provider_names?: Array<string>, // Multiple values may be separated by commas.
    type?: Array<string>, // Multiple values may be separated by commas.
    vehicule_types?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    agent_names?: Array<string>, // 
    tz?: string, // 
    lang?: string, // 
    options?: any,
};

/**
 * smartPatrolOffensesCreate parameters
 */
export interface IsmartPatrolOffensesCreateProps {
    data: SmartPatrolOffenseCreate,
    options?: any,
};

/**
 * SmartPatrolApi - fetch parameter creator
 * @export
 */
export const SmartPatrolApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolAgentsList({ options = {} }: IsmartPatrolAgentsListProps): FetchArgs {
            const localVarPath = `/smart_patrol/agents/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [id] Multiple values may be separated by commas.
         * @param {Array<string>} [vin] Multiple values may be separated by commas.
         * @param {string} [created_at_after] range (lower bound)
         * @param {string} [created_at_before] range (upper bound)
         * @param {Array<string>} [provider_names] Multiple values may be separated by commas.
         * @param {Array<string>} [type] Multiple values may be separated by commas.
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicule_types] 
         * @param {Array<string>} [agent_names] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolExport({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options = {} }: IsmartPatrolExportProps): FetchArgs {
            const localVarPath = `/smart_patrol/export/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id) {
                localVarQueryParameter['id'] = id;
            }

            if (vin) {
                localVarQueryParameter['vin'] = vin;
            }

            if (created_at_after !== undefined) {
                localVarQueryParameter['created_at_after'] = created_at_after;
            }

            if (created_at_before !== undefined) {
                localVarQueryParameter['created_at_before'] = created_at_before;
            }

            if (provider_names) {
                localVarQueryParameter['provider_names'] = provider_names;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (vehicule_types) {
                localVarQueryParameter['vehicule_types'] = vehicule_types;
            }

            if (agent_names) {
                localVarQueryParameter['agent_names'] = agent_names;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} offense_uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolExportPictures({ offense_uid, options = {} }: IsmartPatrolExportPicturesProps): FetchArgs {
            // verify required parameter 'offense_uid' is not null or undefined
            if (offense_uid === null || offense_uid === undefined) {
                throw new RequiredError('offense_uid','Required parameter offense_uid was null or undefined when calling smartPatrolExportPictures.');
            }
            const localVarPath = `/smart_patrol/export-pictures/{offense_uid}`
                .replace(`{${"offense_uid"}}`, encodeURIComponent(String(offense_uid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [id] Multiple values may be separated by commas.
         * @param {Array<string>} [vin] Multiple values may be separated by commas.
         * @param {string} [created_at_after] range (lower bound)
         * @param {string} [created_at_before] range (upper bound)
         * @param {Array<string>} [provider_names] Multiple values may be separated by commas.
         * @param {Array<string>} [type] Multiple values may be separated by commas.
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicule_types] 
         * @param {Array<string>} [agent_names] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolListList({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options = {} }: IsmartPatrolListListProps): FetchArgs {
            const localVarPath = `/smart_patrol/list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id) {
                localVarQueryParameter['id'] = id;
            }

            if (vin) {
                localVarQueryParameter['vin'] = vin;
            }

            if (created_at_after !== undefined) {
                localVarQueryParameter['created_at_after'] = created_at_after;
            }

            if (created_at_before !== undefined) {
                localVarQueryParameter['created_at_before'] = created_at_before;
            }

            if (provider_names) {
                localVarQueryParameter['provider_names'] = provider_names;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (vehicule_types) {
                localVarQueryParameter['vehicule_types'] = vehicule_types;
            }

            if (agent_names) {
                localVarQueryParameter['agent_names'] = agent_names;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SmartPatrolOffenseCreate} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolOffensesCreate({ data, options = {} }: IsmartPatrolOffensesCreateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling smartPatrolOffensesCreate.');
            }
            const localVarPath = `/smart_patrol/offenses/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SmartPatrolOffenseCreate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SmartPatrolApi - functional programming interface
 * @export
 */
export const SmartPatrolApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        smartPatrolAgentsListURL({ options }: IsmartPatrolAgentsListProps): FetchArgs {
            return SmartPatrolApiFetchParamCreator(configuration).smartPatrolAgentsList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolAgentsList({ options }: IsmartPatrolAgentsListProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Agent>> {
            const localVarFetchArgs = this.smartPatrolAgentsListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        smartPatrolExportURL({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options }: IsmartPatrolExportProps): FetchArgs {
            return SmartPatrolApiFetchParamCreator(configuration).smartPatrolExport({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options });
        },

        /**
         * 
         * @param {Array<string>} [id] Multiple values may be separated by commas.
         * @param {Array<string>} [vin] Multiple values may be separated by commas.
         * @param {string} [created_at_after] range (lower bound)
         * @param {string} [created_at_before] range (upper bound)
         * @param {Array<string>} [provider_names] Multiple values may be separated by commas.
         * @param {Array<string>} [type] Multiple values may be separated by commas.
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicule_types] 
         * @param {Array<string>} [agent_names] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolExport({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options }: IsmartPatrolExportProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SmartPatrolOffense>> {
            const localVarFetchArgs = this.smartPatrolExportURL({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        smartPatrolExportPicturesURL({ offense_uid, options }: IsmartPatrolExportPicturesProps): FetchArgs {
            return SmartPatrolApiFetchParamCreator(configuration).smartPatrolExportPictures({ offense_uid, options });
        },

        /**
         * 
         * @param {string} offense_uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolExportPictures({ offense_uid, options }: IsmartPatrolExportPicturesProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.smartPatrolExportPicturesURL({ offense_uid, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        smartPatrolListListURL({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options }: IsmartPatrolListListProps): FetchArgs {
            return SmartPatrolApiFetchParamCreator(configuration).smartPatrolListList({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options });
        },

        /**
         * 
         * @param {Array<string>} [id] Multiple values may be separated by commas.
         * @param {Array<string>} [vin] Multiple values may be separated by commas.
         * @param {string} [created_at_after] range (lower bound)
         * @param {string} [created_at_before] range (upper bound)
         * @param {Array<string>} [provider_names] Multiple values may be separated by commas.
         * @param {Array<string>} [type] Multiple values may be separated by commas.
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicule_types] 
         * @param {Array<string>} [agent_names] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolListList({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options }: IsmartPatrolListListProps): (fetch?: FetchAPI, basePath?: string) => Promise<SmartPatrolOffenseResponse> {
            const localVarFetchArgs = this.smartPatrolListListURL({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        smartPatrolOffensesCreateURL({ data, options }: IsmartPatrolOffensesCreateProps): FetchArgs {
            return SmartPatrolApiFetchParamCreator(configuration).smartPatrolOffensesCreate({ data, options });
        },

        /**
         * 
         * @param {SmartPatrolOffenseCreate} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolOffensesCreate({ data, options }: IsmartPatrolOffensesCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<SmartPatrolOffense> {
            const localVarFetchArgs = this.smartPatrolOffensesCreateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * SmartPatrolApi - factory interface
 * @export
 */
export const SmartPatrolApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolAgentsList({ options }: IsmartPatrolAgentsListProps) {
            return SmartPatrolApiFp(configuration).smartPatrolAgentsList({ options })(fetch, basePath);
        },
        /**
         * 
         * @param {Array<string>} [id] Multiple values may be separated by commas.
         * @param {Array<string>} [vin] Multiple values may be separated by commas.
         * @param {string} [created_at_after] range (lower bound)
         * @param {string} [created_at_before] range (upper bound)
         * @param {Array<string>} [provider_names] Multiple values may be separated by commas.
         * @param {Array<string>} [type] Multiple values may be separated by commas.
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicule_types] 
         * @param {Array<string>} [agent_names] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolExport({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options }: IsmartPatrolExportProps) {
            return SmartPatrolApiFp(configuration).smartPatrolExport({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} offense_uid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolExportPictures({ offense_uid, options }: IsmartPatrolExportPicturesProps) {
            return SmartPatrolApiFp(configuration).smartPatrolExportPictures({ offense_uid, options })(fetch, basePath);
        },
        /**
         * 
         * @param {Array<string>} [id] Multiple values may be separated by commas.
         * @param {Array<string>} [vin] Multiple values may be separated by commas.
         * @param {string} [created_at_after] range (lower bound)
         * @param {string} [created_at_before] range (upper bound)
         * @param {Array<string>} [provider_names] Multiple values may be separated by commas.
         * @param {Array<string>} [type] Multiple values may be separated by commas.
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicule_types] 
         * @param {Array<string>} [agent_names] 
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolListList({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options }: IsmartPatrolListListProps) {
            return SmartPatrolApiFp(configuration).smartPatrolListList({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options })(fetch, basePath);
        },
        /**
         * 
         * @param {SmartPatrolOffenseCreate} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartPatrolOffensesCreate({ data, options }: IsmartPatrolOffensesCreateProps) {
            return SmartPatrolApiFp(configuration).smartPatrolOffensesCreate({ data, options })(fetch, basePath);
        },
    };
};

/**
 * SmartPatrolApi - object-oriented interface
 * @export
 * @class SmartPatrolApi
 * @extends {BaseAPI}
 */
export class SmartPatrolApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``smartPatrolAgentsList`` for arguments and options.
     *
     */
    public smartPatrolAgentsListURL({ options }: IsmartPatrolAgentsListProps = {}): FetchArgs {
        return SmartPatrolApiFp(this.configuration).smartPatrolAgentsListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartPatrolApi
     */
    public smartPatrolAgentsList({ options }: IsmartPatrolAgentsListProps = {}) {
        return SmartPatrolApiFp(this.configuration).smartPatrolAgentsList({ options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``smartPatrolExport`` for arguments and options.
     *
     */
    public smartPatrolExportURL({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options }: IsmartPatrolExportProps = {}): FetchArgs {
        return SmartPatrolApiFp(this.configuration).smartPatrolExportURL({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options });
    }

    /**
     * 
     * @param {Array<string>} [id] Multiple values may be separated by commas.
     * @param {Array<string>} [vin] Multiple values may be separated by commas.
     * @param {string} [created_at_after] range (lower bound)
     * @param {string} [created_at_before] range (upper bound)
     * @param {Array<string>} [provider_names] Multiple values may be separated by commas.
     * @param {Array<string>} [type] Multiple values may be separated by commas.
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicule_types] 
     * @param {Array<string>} [agent_names] 
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartPatrolApi
     */
    public smartPatrolExport({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options }: IsmartPatrolExportProps = {}) {
        return SmartPatrolApiFp(this.configuration).smartPatrolExport({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``smartPatrolExportPictures`` for arguments and options.
     *
     */
    public smartPatrolExportPicturesURL({ offense_uid, options }: IsmartPatrolExportPicturesProps): FetchArgs {
        return SmartPatrolApiFp(this.configuration).smartPatrolExportPicturesURL({ offense_uid, options });
    }

    /**
     * 
     * @param {string} offense_uid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartPatrolApi
     */
    public smartPatrolExportPictures({ offense_uid, options }: IsmartPatrolExportPicturesProps) {
        return SmartPatrolApiFp(this.configuration).smartPatrolExportPictures({ offense_uid, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``smartPatrolListList`` for arguments and options.
     *
     */
    public smartPatrolListListURL({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options }: IsmartPatrolListListProps = {}): FetchArgs {
        return SmartPatrolApiFp(this.configuration).smartPatrolListListURL({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options });
    }

    /**
     * 
     * @param {Array<string>} [id] Multiple values may be separated by commas.
     * @param {Array<string>} [vin] Multiple values may be separated by commas.
     * @param {string} [created_at_after] range (lower bound)
     * @param {string} [created_at_before] range (upper bound)
     * @param {Array<string>} [provider_names] Multiple values may be separated by commas.
     * @param {Array<string>} [type] Multiple values may be separated by commas.
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicule_types] 
     * @param {Array<string>} [agent_names] 
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartPatrolApi
     */
    public smartPatrolListList({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options }: IsmartPatrolListListProps = {}) {
        return SmartPatrolApiFp(this.configuration).smartPatrolListList({ id, vin, created_at_after, created_at_before, provider_names, type, vehicule_types, agent_names, tz, lang, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``smartPatrolOffensesCreate`` for arguments and options.
     *
     */
    public smartPatrolOffensesCreateURL({ data, options }: IsmartPatrolOffensesCreateProps): FetchArgs {
        return SmartPatrolApiFp(this.configuration).smartPatrolOffensesCreateURL({ data, options });
    }

    /**
     * 
     * @param {SmartPatrolOffenseCreate} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmartPatrolApi
     */
    public smartPatrolOffensesCreate({ data, options }: IsmartPatrolOffensesCreateProps) {
        return SmartPatrolApiFp(this.configuration).smartPatrolOffensesCreate({ data, options })(this.fetchData, this.basePath);
    }

}

/**
 * stopsList parameters
 */
export interface IstopsListProps {
    line_type?: Array<'bus' | 'train' | 'tram' | 'subway' | 'bike' | 'ferry'>, // 
    options?: any,
};

/**
 * stopsRead parameters
 */
export interface IstopsReadProps {
    uid: string, // A UUID string identifying this stops.
    options?: any,
};

/**
 * StopsApi - fetch parameter creator
 * @export
 */
export const StopsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<'bus' | 'train' | 'tram' | 'subway' | 'bike' | 'ferry'>} [line_type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopsList({ line_type, options = {} }: IstopsListProps): FetchArgs {
            const localVarPath = `/stops/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (line_type) {
                localVarQueryParameter['line_type'] = line_type;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uid A UUID string identifying this stops.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopsRead({ uid, options = {} }: IstopsReadProps): FetchArgs {
            // verify required parameter 'uid' is not null or undefined
            if (uid === null || uid === undefined) {
                throw new RequiredError('uid','Required parameter uid was null or undefined when calling stopsRead.');
            }
            const localVarPath = `/stops/{uid}/`
                .replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StopsApi - functional programming interface
 * @export
 */
export const StopsApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        stopsListURL({ line_type, options }: IstopsListProps): FetchArgs {
            return StopsApiFetchParamCreator(configuration).stopsList({ line_type, options });
        },

        /**
         * 
         * @param {Array<'bus' | 'train' | 'tram' | 'subway' | 'bike' | 'ferry'>} [line_type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopsList({ line_type, options }: IstopsListProps): (fetch?: FetchAPI, basePath?: string) => Promise<StopsResponse> {
            const localVarFetchArgs = this.stopsListURL({ line_type, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        stopsReadURL({ uid, options }: IstopsReadProps): FetchArgs {
            return StopsApiFetchParamCreator(configuration).stopsRead({ uid, options });
        },

        /**
         * 
         * @param {string} uid A UUID string identifying this stops.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopsRead({ uid, options }: IstopsReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = this.stopsReadURL({ uid, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * StopsApi - factory interface
 * @export
 */
export const StopsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {Array<'bus' | 'train' | 'tram' | 'subway' | 'bike' | 'ferry'>} [line_type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopsList({ line_type, options }: IstopsListProps) {
            return StopsApiFp(configuration).stopsList({ line_type, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} uid A UUID string identifying this stops.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopsRead({ uid, options }: IstopsReadProps) {
            return StopsApiFp(configuration).stopsRead({ uid, options })(fetch, basePath);
        },
    };
};

/**
 * StopsApi - object-oriented interface
 * @export
 * @class StopsApi
 * @extends {BaseAPI}
 */
export class StopsApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``stopsList`` for arguments and options.
     *
     */
    public stopsListURL({ line_type, options }: IstopsListProps = {}): FetchArgs {
        return StopsApiFp(this.configuration).stopsListURL({ line_type, options });
    }

    /**
     * 
     * @param {Array<'bus' | 'train' | 'tram' | 'subway' | 'bike' | 'ferry'>} [line_type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StopsApi
     */
    public stopsList({ line_type, options }: IstopsListProps = {}) {
        return StopsApiFp(this.configuration).stopsList({ line_type, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``stopsRead`` for arguments and options.
     *
     */
    public stopsReadURL({ uid, options }: IstopsReadProps): FetchArgs {
        return StopsApiFp(this.configuration).stopsReadURL({ uid, options });
    }

    /**
     * 
     * @param {string} uid A UUID string identifying this stops.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StopsApi
     */
    public stopsRead({ uid, options }: IstopsReadProps) {
        return StopsApiFp(this.configuration).stopsRead({ uid, options })(this.fetchData, this.basePath);
    }

}

/**
 * tripCountExportInStreetSegments parameters
 */
export interface ItripCountExportInStreetSegmentsProps {
    layer: string,
    offset?: number,
    page?: number,
    page_size?: number,
    language?: string,
    id?: string,
    time_range_start_start?: string,
    time_range_start_end?: string,
    time_range_end_start?: string,
    time_range_end_end?: string,
    duration_min?: number,
    duration_max?: number,
    distance_min?: number,
    distance_max?: number,
    speed_min?: number,
    speed_max?: number,
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>,
    propulsion_type?: Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>,
    provider_ids?: Array<string>,
    origins?: Array<string>,
    destinations?: Array<string>,
    day_of_week?: Array<number>,
    trips_per_street_min?: number,
    trips_per_street_max?: number,
    include_documents?: boolean,
    options?: any,
};

/**
 * tripCountInStreetSegment parameters
 */
export interface ItripCountInStreetSegmentProps {
    layer: string,
    offset?: number,
    page?: number,
    page_size?: number,
    language?: string,
    id?: string,
    time_range_start_start?: string,
    time_range_start_end?: string,
    time_range_end_start?: string,
    time_range_end_end?: string,
    duration_min?: number,
    duration_max?: number,
    distance_min?: number,
    distance_max?: number,
    speed_min?: number,
    speed_max?: number,
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>,
    propulsion_type?: Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>,
    provider_ids?: Array<string>,
    origins?: Array<string>,
    destinations?: Array<string>,
    day_of_week?: Array<number>,
    trips_per_street_min?: number,
    trips_per_street_max?: number,
    include_documents?: boolean,
    options?: any,
};

/**
 * tripExportList parameters
 */
export interface ItripExportListProps {
    layer: string,
    offset?: number,
    page?: number,
    page_size?: number,
    language?: string,
    id?: string,
    time_range_start_start?: string,
    time_range_start_end?: string,
    time_range_end_start?: string,
    time_range_end_end?: string,
    duration_min?: number,
    duration_max?: number,
    distance_min?: number,
    distance_max?: number,
    speed_min?: number,
    speed_max?: number,
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>,
    propulsion_type?: Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>,
    provider_ids?: Array<string>,
    origins?: Array<string>,
    destinations?: Array<string>,
    day_of_week?: Array<number>,
    trips_per_street_min?: number,
    trips_per_street_max?: number,
    include_documents?: boolean,
    options?: any,
};

/**
 * tripFacetedList parameters
 */
export interface ItripFacetedListProps {
    layer: string,
    offset?: number,
    page?: number,
    page_size?: number,
    language?: string,
    id?: string,
    time_range_start_start?: string,
    time_range_start_end?: string,
    time_range_end_start?: string,
    time_range_end_end?: string,
    duration_min?: number,
    duration_max?: number,
    distance_min?: number,
    distance_max?: number,
    speed_min?: number,
    speed_max?: number,
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>,
    propulsion_type?: Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>,
    provider_ids?: Array<string>,
    origins?: Array<string>,
    destinations?: Array<string>,
    day_of_week?: Array<number>,
    trips_per_street_min?: number,
    trips_per_street_max?: number,
    include_documents?: boolean,
    options?: any,
};

/**
 * tripOriginDestinationCount parameters
 */
export interface ItripOriginDestinationCountProps {
    layer: string,
    offset?: number,
    page?: number,
    page_size?: number,
    language?: string,
    id?: string,
    time_range_start_start?: string,
    time_range_start_end?: string,
    time_range_end_start?: string,
    time_range_end_end?: string,
    duration_min?: number,
    duration_max?: number,
    distance_min?: number,
    distance_max?: number,
    speed_min?: number,
    speed_max?: number,
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>,
    propulsion_type?: Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>,
    provider_ids?: Array<string>,
    origins?: Array<string>,
    destinations?: Array<string>,
    day_of_week?: Array<number>,
    trips_per_street_min?: number,
    trips_per_street_max?: number,
    include_documents?: boolean,
    options?: any,
};

/**
 * tripTigerAggregations parameters
 */
export interface ItripTigerAggregationsProps {
    layer: string,
    time_range_start_start?: string,
    time_range_start_end?: string,
    time_range_end_start?: string,
    time_range_end_end?: string,
    duration_min?: number,
    duration_max?: number,
    distance_min?: number,
    distance_max?: number,
    speed_min?: number,
    speed_max?: number,
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>,
    provider_ids?: Array<string>,
    origins?: Array<string>,
    destinations?: Array<string>,
    day_of_week?: Array<number>,
    options?: any,
};

/**
 * tripTigerList parameters
 */
export interface ItripTigerListProps {
    layer: string,
    offset?: number,
    id?: string,
    time_range_start_start?: string,
    time_range_start_end?: string,
    time_range_end_start?: string,
    time_range_end_end?: string,
    duration_min?: number,
    duration_max?: number,
    distance_min?: number,
    distance_max?: number,
    speed_min?: number,
    speed_max?: number,
    vehicle_type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>,
    provider_ids?: Array<string>,
    origins?: Array<string>,
    destinations?: Array<string>,
    day_of_week?: Array<number>,
    options?: any,
};

/**
 * TripApi - fetch parameter creator
 * @export
 */
export const TripApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripCountExportInStreetSegments({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options = {} }: ItripCountExportInStreetSegmentsProps): FetchArgs {
            // verify required parameter 'layer' is not null or undefined
            if (layer === null || layer === undefined) {
                throw new RequiredError('layer','Required parameter layer was null or undefined when calling tripCountExportInStreetSegments.');
            }
            const localVarPath = `/trip/export-trip-per-street-segments/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (page_size !== undefined) {
                localVarQueryParameter['page_size'] = page_size;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (layer !== undefined) {
                localVarQueryParameter['layer'] = layer;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (time_range_start_start !== undefined) {
                localVarQueryParameter['time_range_start_start'] = time_range_start_start;
            }

            if (time_range_start_end !== undefined) {
                localVarQueryParameter['time_range_start_end'] = time_range_start_end;
            }

            if (time_range_end_start !== undefined) {
                localVarQueryParameter['time_range_end_start'] = time_range_end_start;
            }

            if (time_range_end_end !== undefined) {
                localVarQueryParameter['time_range_end_end'] = time_range_end_end;
            }

            if (duration_min !== undefined) {
                localVarQueryParameter['duration_min'] = duration_min;
            }

            if (duration_max !== undefined) {
                localVarQueryParameter['duration_max'] = duration_max;
            }

            if (distance_min !== undefined) {
                localVarQueryParameter['distance_min'] = distance_min;
            }

            if (distance_max !== undefined) {
                localVarQueryParameter['distance_max'] = distance_max;
            }

            if (speed_min !== undefined) {
                localVarQueryParameter['speed_min'] = speed_min;
            }

            if (speed_max !== undefined) {
                localVarQueryParameter['speed_max'] = speed_max;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (propulsion_type) {
                localVarQueryParameter['propulsion_type'] = propulsion_type;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (origins) {
                localVarQueryParameter['origins'] = origins;
            }

            if (destinations) {
                localVarQueryParameter['destinations'] = destinations;
            }

            if (day_of_week) {
                localVarQueryParameter['day_of_week'] = day_of_week;
            }

            if (trips_per_street_min !== undefined) {
                localVarQueryParameter['trips_per_street_min'] = trips_per_street_min;
            }

            if (trips_per_street_max !== undefined) {
                localVarQueryParameter['trips_per_street_max'] = trips_per_street_max;
            }

            if (include_documents !== undefined) {
                localVarQueryParameter['include_documents'] = include_documents;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripCountInStreetSegment({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options = {} }: ItripCountInStreetSegmentProps): FetchArgs {
            // verify required parameter 'layer' is not null or undefined
            if (layer === null || layer === undefined) {
                throw new RequiredError('layer','Required parameter layer was null or undefined when calling tripCountInStreetSegment.');
            }
            const localVarPath = `/trip/trip-count-in-street-segment/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (page_size !== undefined) {
                localVarQueryParameter['page_size'] = page_size;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (layer !== undefined) {
                localVarQueryParameter['layer'] = layer;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (time_range_start_start !== undefined) {
                localVarQueryParameter['time_range_start_start'] = time_range_start_start;
            }

            if (time_range_start_end !== undefined) {
                localVarQueryParameter['time_range_start_end'] = time_range_start_end;
            }

            if (time_range_end_start !== undefined) {
                localVarQueryParameter['time_range_end_start'] = time_range_end_start;
            }

            if (time_range_end_end !== undefined) {
                localVarQueryParameter['time_range_end_end'] = time_range_end_end;
            }

            if (duration_min !== undefined) {
                localVarQueryParameter['duration_min'] = duration_min;
            }

            if (duration_max !== undefined) {
                localVarQueryParameter['duration_max'] = duration_max;
            }

            if (distance_min !== undefined) {
                localVarQueryParameter['distance_min'] = distance_min;
            }

            if (distance_max !== undefined) {
                localVarQueryParameter['distance_max'] = distance_max;
            }

            if (speed_min !== undefined) {
                localVarQueryParameter['speed_min'] = speed_min;
            }

            if (speed_max !== undefined) {
                localVarQueryParameter['speed_max'] = speed_max;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (propulsion_type) {
                localVarQueryParameter['propulsion_type'] = propulsion_type;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (origins) {
                localVarQueryParameter['origins'] = origins;
            }

            if (destinations) {
                localVarQueryParameter['destinations'] = destinations;
            }

            if (day_of_week) {
                localVarQueryParameter['day_of_week'] = day_of_week;
            }

            if (trips_per_street_min !== undefined) {
                localVarQueryParameter['trips_per_street_min'] = trips_per_street_min;
            }

            if (trips_per_street_max !== undefined) {
                localVarQueryParameter['trips_per_street_max'] = trips_per_street_max;
            }

            if (include_documents !== undefined) {
                localVarQueryParameter['include_documents'] = include_documents;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripExportList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options = {} }: ItripExportListProps): FetchArgs {
            // verify required parameter 'layer' is not null or undefined
            if (layer === null || layer === undefined) {
                throw new RequiredError('layer','Required parameter layer was null or undefined when calling tripExportList.');
            }
            const localVarPath = `/trip/export-list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (page_size !== undefined) {
                localVarQueryParameter['page_size'] = page_size;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (layer !== undefined) {
                localVarQueryParameter['layer'] = layer;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (time_range_start_start !== undefined) {
                localVarQueryParameter['time_range_start_start'] = time_range_start_start;
            }

            if (time_range_start_end !== undefined) {
                localVarQueryParameter['time_range_start_end'] = time_range_start_end;
            }

            if (time_range_end_start !== undefined) {
                localVarQueryParameter['time_range_end_start'] = time_range_end_start;
            }

            if (time_range_end_end !== undefined) {
                localVarQueryParameter['time_range_end_end'] = time_range_end_end;
            }

            if (duration_min !== undefined) {
                localVarQueryParameter['duration_min'] = duration_min;
            }

            if (duration_max !== undefined) {
                localVarQueryParameter['duration_max'] = duration_max;
            }

            if (distance_min !== undefined) {
                localVarQueryParameter['distance_min'] = distance_min;
            }

            if (distance_max !== undefined) {
                localVarQueryParameter['distance_max'] = distance_max;
            }

            if (speed_min !== undefined) {
                localVarQueryParameter['speed_min'] = speed_min;
            }

            if (speed_max !== undefined) {
                localVarQueryParameter['speed_max'] = speed_max;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (propulsion_type) {
                localVarQueryParameter['propulsion_type'] = propulsion_type;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (origins) {
                localVarQueryParameter['origins'] = origins;
            }

            if (destinations) {
                localVarQueryParameter['destinations'] = destinations;
            }

            if (day_of_week) {
                localVarQueryParameter['day_of_week'] = day_of_week;
            }

            if (trips_per_street_min !== undefined) {
                localVarQueryParameter['trips_per_street_min'] = trips_per_street_min;
            }

            if (trips_per_street_max !== undefined) {
                localVarQueryParameter['trips_per_street_max'] = trips_per_street_max;
            }

            if (include_documents !== undefined) {
                localVarQueryParameter['include_documents'] = include_documents;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripFacetedList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options = {} }: ItripFacetedListProps): FetchArgs {
            // verify required parameter 'layer' is not null or undefined
            if (layer === null || layer === undefined) {
                throw new RequiredError('layer','Required parameter layer was null or undefined when calling tripFacetedList.');
            }
            const localVarPath = `/trip/list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (page_size !== undefined) {
                localVarQueryParameter['page_size'] = page_size;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (layer !== undefined) {
                localVarQueryParameter['layer'] = layer;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (time_range_start_start !== undefined) {
                localVarQueryParameter['time_range_start_start'] = time_range_start_start;
            }

            if (time_range_start_end !== undefined) {
                localVarQueryParameter['time_range_start_end'] = time_range_start_end;
            }

            if (time_range_end_start !== undefined) {
                localVarQueryParameter['time_range_end_start'] = time_range_end_start;
            }

            if (time_range_end_end !== undefined) {
                localVarQueryParameter['time_range_end_end'] = time_range_end_end;
            }

            if (duration_min !== undefined) {
                localVarQueryParameter['duration_min'] = duration_min;
            }

            if (duration_max !== undefined) {
                localVarQueryParameter['duration_max'] = duration_max;
            }

            if (distance_min !== undefined) {
                localVarQueryParameter['distance_min'] = distance_min;
            }

            if (distance_max !== undefined) {
                localVarQueryParameter['distance_max'] = distance_max;
            }

            if (speed_min !== undefined) {
                localVarQueryParameter['speed_min'] = speed_min;
            }

            if (speed_max !== undefined) {
                localVarQueryParameter['speed_max'] = speed_max;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (propulsion_type) {
                localVarQueryParameter['propulsion_type'] = propulsion_type;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (origins) {
                localVarQueryParameter['origins'] = origins;
            }

            if (destinations) {
                localVarQueryParameter['destinations'] = destinations;
            }

            if (day_of_week) {
                localVarQueryParameter['day_of_week'] = day_of_week;
            }

            if (trips_per_street_min !== undefined) {
                localVarQueryParameter['trips_per_street_min'] = trips_per_street_min;
            }

            if (trips_per_street_max !== undefined) {
                localVarQueryParameter['trips_per_street_max'] = trips_per_street_max;
            }

            if (include_documents !== undefined) {
                localVarQueryParameter['include_documents'] = include_documents;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripOriginDestinationCount({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options = {} }: ItripOriginDestinationCountProps): FetchArgs {
            // verify required parameter 'layer' is not null or undefined
            if (layer === null || layer === undefined) {
                throw new RequiredError('layer','Required parameter layer was null or undefined when calling tripOriginDestinationCount.');
            }
            const localVarPath = `/trip/trip-origin-destination-count/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (page_size !== undefined) {
                localVarQueryParameter['page_size'] = page_size;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (layer !== undefined) {
                localVarQueryParameter['layer'] = layer;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (time_range_start_start !== undefined) {
                localVarQueryParameter['time_range_start_start'] = time_range_start_start;
            }

            if (time_range_start_end !== undefined) {
                localVarQueryParameter['time_range_start_end'] = time_range_start_end;
            }

            if (time_range_end_start !== undefined) {
                localVarQueryParameter['time_range_end_start'] = time_range_end_start;
            }

            if (time_range_end_end !== undefined) {
                localVarQueryParameter['time_range_end_end'] = time_range_end_end;
            }

            if (duration_min !== undefined) {
                localVarQueryParameter['duration_min'] = duration_min;
            }

            if (duration_max !== undefined) {
                localVarQueryParameter['duration_max'] = duration_max;
            }

            if (distance_min !== undefined) {
                localVarQueryParameter['distance_min'] = distance_min;
            }

            if (distance_max !== undefined) {
                localVarQueryParameter['distance_max'] = distance_max;
            }

            if (speed_min !== undefined) {
                localVarQueryParameter['speed_min'] = speed_min;
            }

            if (speed_max !== undefined) {
                localVarQueryParameter['speed_max'] = speed_max;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (propulsion_type) {
                localVarQueryParameter['propulsion_type'] = propulsion_type;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (origins) {
                localVarQueryParameter['origins'] = origins;
            }

            if (destinations) {
                localVarQueryParameter['destinations'] = destinations;
            }

            if (day_of_week) {
                localVarQueryParameter['day_of_week'] = day_of_week;
            }

            if (trips_per_street_min !== undefined) {
                localVarQueryParameter['trips_per_street_min'] = trips_per_street_min;
            }

            if (trips_per_street_max !== undefined) {
                localVarQueryParameter['trips_per_street_max'] = trips_per_street_max;
            }

            if (include_documents !== undefined) {
                localVarQueryParameter['include_documents'] = include_documents;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} layer 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTigerAggregations({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options = {} }: ItripTigerAggregationsProps): FetchArgs {
            // verify required parameter 'layer' is not null or undefined
            if (layer === null || layer === undefined) {
                throw new RequiredError('layer','Required parameter layer was null or undefined when calling tripTigerAggregations.');
            }
            const localVarPath = `/trip/tiger-aggregations/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (layer !== undefined) {
                localVarQueryParameter['layer'] = layer;
            }

            if (time_range_start_start !== undefined) {
                localVarQueryParameter['time_range_start_start'] = time_range_start_start;
            }

            if (time_range_start_end !== undefined) {
                localVarQueryParameter['time_range_start_end'] = time_range_start_end;
            }

            if (time_range_end_start !== undefined) {
                localVarQueryParameter['time_range_end_start'] = time_range_end_start;
            }

            if (time_range_end_end !== undefined) {
                localVarQueryParameter['time_range_end_end'] = time_range_end_end;
            }

            if (duration_min !== undefined) {
                localVarQueryParameter['duration_min'] = duration_min;
            }

            if (duration_max !== undefined) {
                localVarQueryParameter['duration_max'] = duration_max;
            }

            if (distance_min !== undefined) {
                localVarQueryParameter['distance_min'] = distance_min;
            }

            if (distance_max !== undefined) {
                localVarQueryParameter['distance_max'] = distance_max;
            }

            if (speed_min !== undefined) {
                localVarQueryParameter['speed_min'] = speed_min;
            }

            if (speed_max !== undefined) {
                localVarQueryParameter['speed_max'] = speed_max;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (origins) {
                localVarQueryParameter['origins'] = origins;
            }

            if (destinations) {
                localVarQueryParameter['destinations'] = destinations;
            }

            if (day_of_week) {
                localVarQueryParameter['day_of_week'] = day_of_week;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTigerList({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options = {} }: ItripTigerListProps): FetchArgs {
            // verify required parameter 'layer' is not null or undefined
            if (layer === null || layer === undefined) {
                throw new RequiredError('layer','Required parameter layer was null or undefined when calling tripTigerList.');
            }
            const localVarPath = `/trip/tiger-list/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (layer !== undefined) {
                localVarQueryParameter['layer'] = layer;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (time_range_start_start !== undefined) {
                localVarQueryParameter['time_range_start_start'] = time_range_start_start;
            }

            if (time_range_start_end !== undefined) {
                localVarQueryParameter['time_range_start_end'] = time_range_start_end;
            }

            if (time_range_end_start !== undefined) {
                localVarQueryParameter['time_range_end_start'] = time_range_end_start;
            }

            if (time_range_end_end !== undefined) {
                localVarQueryParameter['time_range_end_end'] = time_range_end_end;
            }

            if (duration_min !== undefined) {
                localVarQueryParameter['duration_min'] = duration_min;
            }

            if (duration_max !== undefined) {
                localVarQueryParameter['duration_max'] = duration_max;
            }

            if (distance_min !== undefined) {
                localVarQueryParameter['distance_min'] = distance_min;
            }

            if (distance_max !== undefined) {
                localVarQueryParameter['distance_max'] = distance_max;
            }

            if (speed_min !== undefined) {
                localVarQueryParameter['speed_min'] = speed_min;
            }

            if (speed_max !== undefined) {
                localVarQueryParameter['speed_max'] = speed_max;
            }

            if (vehicle_type) {
                localVarQueryParameter['vehicle_type'] = vehicle_type;
            }

            if (provider_ids) {
                localVarQueryParameter['provider_ids'] = provider_ids;
            }

            if (origins) {
                localVarQueryParameter['origins'] = origins;
            }

            if (destinations) {
                localVarQueryParameter['destinations'] = destinations;
            }

            if (day_of_week) {
                localVarQueryParameter['day_of_week'] = day_of_week;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TripApi - functional programming interface
 * @export
 */
export const TripApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        tripCountExportInStreetSegmentsURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripCountExportInStreetSegmentsProps): FetchArgs {
            return TripApiFetchParamCreator(configuration).tripCountExportInStreetSegments({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
        },

        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripCountExportInStreetSegments({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripCountExportInStreetSegmentsProps): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = this.tripCountExportInStreetSegmentsURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        tripCountInStreetSegmentURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripCountInStreetSegmentProps): FetchArgs {
            return TripApiFetchParamCreator(configuration).tripCountInStreetSegment({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
        },

        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripCountInStreetSegment({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripCountInStreetSegmentProps): (fetch?: FetchAPI, basePath?: string) => Promise<TripCountInStreetSegment> {
            const localVarFetchArgs = this.tripCountInStreetSegmentURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        tripExportListURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripExportListProps): FetchArgs {
            return TripApiFetchParamCreator(configuration).tripExportList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
        },

        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripExportList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripExportListProps): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = this.tripExportListURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        tripFacetedListURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripFacetedListProps): FetchArgs {
            return TripApiFetchParamCreator(configuration).tripFacetedList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
        },

        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripFacetedList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripFacetedListProps): (fetch?: FetchAPI, basePath?: string) => Promise<TripsFacetedListResponse> {
            const localVarFetchArgs = this.tripFacetedListURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        tripOriginDestinationCountURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripOriginDestinationCountProps): FetchArgs {
            return TripApiFetchParamCreator(configuration).tripOriginDestinationCount({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
        },

        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripOriginDestinationCount({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripOriginDestinationCountProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TripOriginDestination>> {
            const localVarFetchArgs = this.tripOriginDestinationCountURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        tripTigerAggregationsURL({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options }: ItripTigerAggregationsProps): FetchArgs {
            return TripApiFetchParamCreator(configuration).tripTigerAggregations({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options });
        },

        /**
         * 
         * @param {string} layer 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTigerAggregations({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options }: ItripTigerAggregationsProps): (fetch?: FetchAPI, basePath?: string) => Promise<TigerTripAggregationsResponse> {
            const localVarFetchArgs = this.tripTigerAggregationsURL({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        tripTigerListURL({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options }: ItripTigerListProps): FetchArgs {
            return TripApiFetchParamCreator(configuration).tripTigerList({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options });
        },

        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTigerList({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options }: ItripTigerListProps): (fetch?: FetchAPI, basePath?: string) => Promise<TigerTripListResponse> {
            const localVarFetchArgs = this.tripTigerListURL({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * TripApi - factory interface
 * @export
 */
export const TripApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripCountExportInStreetSegments({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripCountExportInStreetSegmentsProps) {
            return TripApiFp(configuration).tripCountExportInStreetSegments({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripCountInStreetSegment({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripCountInStreetSegmentProps) {
            return TripApiFp(configuration).tripCountInStreetSegment({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripExportList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripExportListProps) {
            return TripApiFp(configuration).tripExportList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripFacetedList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripFacetedListProps) {
            return TripApiFp(configuration).tripFacetedList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {number} [page] 
         * @param {number} [page_size] 
         * @param {string} [language] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {number} [trips_per_street_min] 
         * @param {number} [trips_per_street_max] 
         * @param {boolean} [include_documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripOriginDestinationCount({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripOriginDestinationCountProps) {
            return TripApiFp(configuration).tripOriginDestinationCount({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} layer 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTigerAggregations({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options }: ItripTigerAggregationsProps) {
            return TripApiFp(configuration).tripTigerAggregations({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} layer 
         * @param {number} [offset] 
         * @param {string} [id] 
         * @param {string} [time_range_start_start] 
         * @param {string} [time_range_start_end] 
         * @param {string} [time_range_end_start] 
         * @param {string} [time_range_end_end] 
         * @param {number} [duration_min] 
         * @param {number} [duration_max] 
         * @param {number} [distance_min] 
         * @param {number} [distance_max] 
         * @param {number} [speed_min] 
         * @param {number} [speed_max] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
         * @param {Array<string>} [provider_ids] 
         * @param {Array<string>} [origins] 
         * @param {Array<string>} [destinations] 
         * @param {Array<number>} [day_of_week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripTigerList({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options }: ItripTigerListProps) {
            return TripApiFp(configuration).tripTigerList({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options })(fetch, basePath);
        },
    };
};

/**
 * TripApi - object-oriented interface
 * @export
 * @class TripApi
 * @extends {BaseAPI}
 */
export class TripApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``tripCountExportInStreetSegments`` for arguments and options.
     *
     */
    public tripCountExportInStreetSegmentsURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripCountExportInStreetSegmentsProps): FetchArgs {
        return TripApiFp(this.configuration).tripCountExportInStreetSegmentsURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
    }

    /**
     * 
     * @param {string} layer 
     * @param {number} [offset] 
     * @param {number} [page] 
     * @param {number} [page_size] 
     * @param {string} [language] 
     * @param {string} [id] 
     * @param {string} [time_range_start_start] 
     * @param {string} [time_range_start_end] 
     * @param {string} [time_range_end_start] 
     * @param {string} [time_range_end_end] 
     * @param {number} [duration_min] 
     * @param {number} [duration_max] 
     * @param {number} [distance_min] 
     * @param {number} [distance_max] 
     * @param {number} [speed_min] 
     * @param {number} [speed_max] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
     * @param {Array<string>} [provider_ids] 
     * @param {Array<string>} [origins] 
     * @param {Array<string>} [destinations] 
     * @param {Array<number>} [day_of_week] 
     * @param {number} [trips_per_street_min] 
     * @param {number} [trips_per_street_max] 
     * @param {boolean} [include_documents] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public tripCountExportInStreetSegments({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripCountExportInStreetSegmentsProps) {
        return TripApiFp(this.configuration).tripCountExportInStreetSegments({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``tripCountInStreetSegment`` for arguments and options.
     *
     */
    public tripCountInStreetSegmentURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripCountInStreetSegmentProps): FetchArgs {
        return TripApiFp(this.configuration).tripCountInStreetSegmentURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
    }

    /**
     * 
     * @param {string} layer 
     * @param {number} [offset] 
     * @param {number} [page] 
     * @param {number} [page_size] 
     * @param {string} [language] 
     * @param {string} [id] 
     * @param {string} [time_range_start_start] 
     * @param {string} [time_range_start_end] 
     * @param {string} [time_range_end_start] 
     * @param {string} [time_range_end_end] 
     * @param {number} [duration_min] 
     * @param {number} [duration_max] 
     * @param {number} [distance_min] 
     * @param {number} [distance_max] 
     * @param {number} [speed_min] 
     * @param {number} [speed_max] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
     * @param {Array<string>} [provider_ids] 
     * @param {Array<string>} [origins] 
     * @param {Array<string>} [destinations] 
     * @param {Array<number>} [day_of_week] 
     * @param {number} [trips_per_street_min] 
     * @param {number} [trips_per_street_max] 
     * @param {boolean} [include_documents] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public tripCountInStreetSegment({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripCountInStreetSegmentProps) {
        return TripApiFp(this.configuration).tripCountInStreetSegment({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``tripExportList`` for arguments and options.
     *
     */
    public tripExportListURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripExportListProps): FetchArgs {
        return TripApiFp(this.configuration).tripExportListURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
    }

    /**
     * 
     * @param {string} layer 
     * @param {number} [offset] 
     * @param {number} [page] 
     * @param {number} [page_size] 
     * @param {string} [language] 
     * @param {string} [id] 
     * @param {string} [time_range_start_start] 
     * @param {string} [time_range_start_end] 
     * @param {string} [time_range_end_start] 
     * @param {string} [time_range_end_end] 
     * @param {number} [duration_min] 
     * @param {number} [duration_max] 
     * @param {number} [distance_min] 
     * @param {number} [distance_max] 
     * @param {number} [speed_min] 
     * @param {number} [speed_max] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
     * @param {Array<string>} [provider_ids] 
     * @param {Array<string>} [origins] 
     * @param {Array<string>} [destinations] 
     * @param {Array<number>} [day_of_week] 
     * @param {number} [trips_per_street_min] 
     * @param {number} [trips_per_street_max] 
     * @param {boolean} [include_documents] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public tripExportList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripExportListProps) {
        return TripApiFp(this.configuration).tripExportList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``tripFacetedList`` for arguments and options.
     *
     */
    public tripFacetedListURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripFacetedListProps): FetchArgs {
        return TripApiFp(this.configuration).tripFacetedListURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
    }

    /**
     * 
     * @param {string} layer 
     * @param {number} [offset] 
     * @param {number} [page] 
     * @param {number} [page_size] 
     * @param {string} [language] 
     * @param {string} [id] 
     * @param {string} [time_range_start_start] 
     * @param {string} [time_range_start_end] 
     * @param {string} [time_range_end_start] 
     * @param {string} [time_range_end_end] 
     * @param {number} [duration_min] 
     * @param {number} [duration_max] 
     * @param {number} [distance_min] 
     * @param {number} [distance_max] 
     * @param {number} [speed_min] 
     * @param {number} [speed_max] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
     * @param {Array<string>} [provider_ids] 
     * @param {Array<string>} [origins] 
     * @param {Array<string>} [destinations] 
     * @param {Array<number>} [day_of_week] 
     * @param {number} [trips_per_street_min] 
     * @param {number} [trips_per_street_max] 
     * @param {boolean} [include_documents] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public tripFacetedList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripFacetedListProps) {
        return TripApiFp(this.configuration).tripFacetedList({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``tripOriginDestinationCount`` for arguments and options.
     *
     */
    public tripOriginDestinationCountURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripOriginDestinationCountProps): FetchArgs {
        return TripApiFp(this.configuration).tripOriginDestinationCountURL({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options });
    }

    /**
     * 
     * @param {string} layer 
     * @param {number} [offset] 
     * @param {number} [page] 
     * @param {number} [page_size] 
     * @param {string} [language] 
     * @param {string} [id] 
     * @param {string} [time_range_start_start] 
     * @param {string} [time_range_start_end] 
     * @param {string} [time_range_end_start] 
     * @param {string} [time_range_end_end] 
     * @param {number} [duration_min] 
     * @param {number} [duration_max] 
     * @param {number} [distance_min] 
     * @param {number} [distance_max] 
     * @param {number} [speed_min] 
     * @param {number} [speed_max] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<'human' | 'electric_assist' | 'electric' | 'combustion' | 'missing'>} [propulsion_type] 
     * @param {Array<string>} [provider_ids] 
     * @param {Array<string>} [origins] 
     * @param {Array<string>} [destinations] 
     * @param {Array<number>} [day_of_week] 
     * @param {number} [trips_per_street_min] 
     * @param {number} [trips_per_street_max] 
     * @param {boolean} [include_documents] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public tripOriginDestinationCount({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options }: ItripOriginDestinationCountProps) {
        return TripApiFp(this.configuration).tripOriginDestinationCount({ layer, offset, page, page_size, language, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, propulsion_type, provider_ids, origins, destinations, day_of_week, trips_per_street_min, trips_per_street_max, include_documents, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``tripTigerAggregations`` for arguments and options.
     *
     */
    public tripTigerAggregationsURL({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options }: ItripTigerAggregationsProps): FetchArgs {
        return TripApiFp(this.configuration).tripTigerAggregationsURL({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options });
    }

    /**
     * 
     * @param {string} layer 
     * @param {string} [time_range_start_start] 
     * @param {string} [time_range_start_end] 
     * @param {string} [time_range_end_start] 
     * @param {string} [time_range_end_end] 
     * @param {number} [duration_min] 
     * @param {number} [duration_max] 
     * @param {number} [distance_min] 
     * @param {number} [distance_max] 
     * @param {number} [speed_min] 
     * @param {number} [speed_max] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<string>} [provider_ids] 
     * @param {Array<string>} [origins] 
     * @param {Array<string>} [destinations] 
     * @param {Array<number>} [day_of_week] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public tripTigerAggregations({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options }: ItripTigerAggregationsProps) {
        return TripApiFp(this.configuration).tripTigerAggregations({ layer, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``tripTigerList`` for arguments and options.
     *
     */
    public tripTigerListURL({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options }: ItripTigerListProps): FetchArgs {
        return TripApiFp(this.configuration).tripTigerListURL({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options });
    }

    /**
     * 
     * @param {string} layer 
     * @param {number} [offset] 
     * @param {string} [id] 
     * @param {string} [time_range_start_start] 
     * @param {string} [time_range_start_end] 
     * @param {string} [time_range_end_start] 
     * @param {string} [time_range_end_end] 
     * @param {number} [duration_min] 
     * @param {number} [duration_max] 
     * @param {number} [distance_min] 
     * @param {number} [distance_max] 
     * @param {number} [speed_min] 
     * @param {number} [speed_max] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [vehicle_type] 
     * @param {Array<string>} [provider_ids] 
     * @param {Array<string>} [origins] 
     * @param {Array<string>} [destinations] 
     * @param {Array<number>} [day_of_week] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TripApi
     */
    public tripTigerList({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options }: ItripTigerListProps) {
        return TripApiFp(this.configuration).tripTigerList({ layer, offset, id, time_range_start_start, time_range_start_end, time_range_end_start, time_range_end_end, duration_min, duration_max, distance_min, distance_max, speed_min, speed_max, vehicle_type, provider_ids, origins, destinations, day_of_week, options })(this.fetchData, this.basePath);
    }

}

/**
 * uploadParkingBayCreate parameters
 */
export interface IuploadParkingBayCreateProps {
    options?: any,
};

/**
 * UploadParkingBayApi - fetch parameter creator
 * @export
 */
export const UploadParkingBayApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadParkingBayCreate({ options = {} }: IuploadParkingBayCreateProps): FetchArgs {
            const localVarPath = `/upload_parking_bay/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadParkingBayApi - functional programming interface
 * @export
 */
export const UploadParkingBayApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        uploadParkingBayCreateURL({ options }: IuploadParkingBayCreateProps): FetchArgs {
            return UploadParkingBayApiFetchParamCreator(configuration).uploadParkingBayCreate({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadParkingBayCreate({ options }: IuploadParkingBayCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<UploadParkingBayValidation> {
            const localVarFetchArgs = this.uploadParkingBayCreateURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * UploadParkingBayApi - factory interface
 * @export
 */
export const UploadParkingBayApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadParkingBayCreate({ options }: IuploadParkingBayCreateProps) {
            return UploadParkingBayApiFp(configuration).uploadParkingBayCreate({ options })(fetch, basePath);
        },
    };
};

/**
 * UploadParkingBayApi - object-oriented interface
 * @export
 * @class UploadParkingBayApi
 * @extends {BaseAPI}
 */
export class UploadParkingBayApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``uploadParkingBayCreate`` for arguments and options.
     *
     */
    public uploadParkingBayCreateURL({ options }: IuploadParkingBayCreateProps = {}): FetchArgs {
        return UploadParkingBayApiFp(this.configuration).uploadParkingBayCreateURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadParkingBayApi
     */
    public uploadParkingBayCreate({ options }: IuploadParkingBayCreateProps = {}) {
        return UploadParkingBayApiFp(this.configuration).uploadParkingBayCreate({ options })(this.fetchData, this.basePath);
    }

}

/**
 * userToggle2faList parameters
 */
export interface IuserToggle2faListProps {
    options?: any,
};

/**
 * UserToggle2faApi - fetch parameter creator
 * @export
 */
export const UserToggle2faApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userToggle2faList({ options = {} }: IuserToggle2faListProps): FetchArgs {
            const localVarPath = `/user_toggle_2fa/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserToggle2faApi - functional programming interface
 * @export
 */
export const UserToggle2faApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        userToggle2faListURL({ options }: IuserToggle2faListProps): FetchArgs {
            return UserToggle2faApiFetchParamCreator(configuration).userToggle2faList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userToggle2faList({ options }: IuserToggle2faListProps): (fetch?: FetchAPI, basePath?: string) => Promise<TotpLink> {
            const localVarFetchArgs = this.userToggle2faListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * UserToggle2faApi - factory interface
 * @export
 */
export const UserToggle2faApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userToggle2faList({ options }: IuserToggle2faListProps) {
            return UserToggle2faApiFp(configuration).userToggle2faList({ options })(fetch, basePath);
        },
    };
};

/**
 * UserToggle2faApi - object-oriented interface
 * @export
 * @class UserToggle2faApi
 * @extends {BaseAPI}
 */
export class UserToggle2faApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``userToggle2faList`` for arguments and options.
     *
     */
    public userToggle2faListURL({ options }: IuserToggle2faListProps = {}): FetchArgs {
        return UserToggle2faApiFp(this.configuration).userToggle2faListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserToggle2faApi
     */
    public userToggle2faList({ options }: IuserToggle2faListProps = {}) {
        return UserToggle2faApiFp(this.configuration).userToggle2faList({ options })(this.fetchData, this.basePath);
    }

}

/**
 * userTotpList parameters
 */
export interface IuserTotpListProps {
    options?: any,
};

/**
 * UserTotpApi - fetch parameter creator
 * @export
 */
export const UserTotpApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userTotpList({ options = {} }: IuserTotpListProps): FetchArgs {
            const localVarPath = `/user_totp/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserTotpApi - functional programming interface
 * @export
 */
export const UserTotpApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        userTotpListURL({ options }: IuserTotpListProps): FetchArgs {
            return UserTotpApiFetchParamCreator(configuration).userTotpList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userTotpList({ options }: IuserTotpListProps): (fetch?: FetchAPI, basePath?: string) => Promise<TotpLink> {
            const localVarFetchArgs = this.userTotpListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * UserTotpApi - factory interface
 * @export
 */
export const UserTotpApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userTotpList({ options }: IuserTotpListProps) {
            return UserTotpApiFp(configuration).userTotpList({ options })(fetch, basePath);
        },
    };
};

/**
 * UserTotpApi - object-oriented interface
 * @export
 * @class UserTotpApi
 * @extends {BaseAPI}
 */
export class UserTotpApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``userTotpList`` for arguments and options.
     *
     */
    public userTotpListURL({ options }: IuserTotpListProps = {}): FetchArgs {
        return UserTotpApiFp(this.configuration).userTotpListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTotpApi
     */
    public userTotpList({ options }: IuserTotpListProps = {}) {
        return UserTotpApiFp(this.configuration).userTotpList({ options })(this.fetchData, this.basePath);
    }

}

/**
 * userValidate2faCreate parameters
 */
export interface IuserValidate2faCreateProps {
    data: TwoFactorToken,
    options?: any,
};

/**
 * UserValidate2faApi - fetch parameter creator
 * @export
 */
export const UserValidate2faApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TwoFactorToken} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userValidate2faCreate({ data, options = {} }: IuserValidate2faCreateProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling userValidate2faCreate.');
            }
            const localVarPath = `/user_validate_2fa/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TwoFactorToken" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserValidate2faApi - functional programming interface
 * @export
 */
export const UserValidate2faApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        userValidate2faCreateURL({ data, options }: IuserValidate2faCreateProps): FetchArgs {
            return UserValidate2faApiFetchParamCreator(configuration).userValidate2faCreate({ data, options });
        },

        /**
         * 
         * @param {TwoFactorToken} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userValidate2faCreate({ data, options }: IuserValidate2faCreateProps): (fetch?: FetchAPI, basePath?: string) => Promise<TwoFactorValidation> {
            const localVarFetchArgs = this.userValidate2faCreateURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * UserValidate2faApi - factory interface
 * @export
 */
export const UserValidate2faApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {TwoFactorToken} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userValidate2faCreate({ data, options }: IuserValidate2faCreateProps) {
            return UserValidate2faApiFp(configuration).userValidate2faCreate({ data, options })(fetch, basePath);
        },
    };
};

/**
 * UserValidate2faApi - object-oriented interface
 * @export
 * @class UserValidate2faApi
 * @extends {BaseAPI}
 */
export class UserValidate2faApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``userValidate2faCreate`` for arguments and options.
     *
     */
    public userValidate2faCreateURL({ data, options }: IuserValidate2faCreateProps): FetchArgs {
        return UserValidate2faApiFp(this.configuration).userValidate2faCreateURL({ data, options });
    }

    /**
     * 
     * @param {TwoFactorToken} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserValidate2faApi
     */
    public userValidate2faCreate({ data, options }: IuserValidate2faCreateProps) {
        return UserValidate2faApiFp(this.configuration).userValidate2faCreate({ data, options })(this.fetchData, this.basePath);
    }

}

/**
 * userinfoList parameters
 */
export interface IuserinfoListProps {
    options?: any,
};

/**
 * UserinfoApi - fetch parameter creator
 * @export
 */
export const UserinfoApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfoList({ options = {} }: IuserinfoListProps): FetchArgs {
            const localVarPath = `/userinfo/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserinfoApi - functional programming interface
 * @export
 */
export const UserinfoApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        userinfoListURL({ options }: IuserinfoListProps): FetchArgs {
            return UserinfoApiFetchParamCreator(configuration).userinfoList({ options });
        },

        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfoList({ options }: IuserinfoListProps): (fetch?: FetchAPI, basePath?: string) => Promise<UserInfo> {
            const localVarFetchArgs = this.userinfoListURL({ options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * UserinfoApi - factory interface
 * @export
 */
export const UserinfoApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userinfoList({ options }: IuserinfoListProps) {
            return UserinfoApiFp(configuration).userinfoList({ options })(fetch, basePath);
        },
    };
};

/**
 * UserinfoApi - object-oriented interface
 * @export
 * @class UserinfoApi
 * @extends {BaseAPI}
 */
export class UserinfoApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``userinfoList`` for arguments and options.
     *
     */
    public userinfoListURL({ options }: IuserinfoListProps = {}): FetchArgs {
        return UserinfoApiFp(this.configuration).userinfoListURL({ options });
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserinfoApi
     */
    public userinfoList({ options }: IuserinfoListProps = {}) {
        return UserinfoApiFp(this.configuration).userinfoList({ options })(this.fetchData, this.basePath);
    }

}

/**
 * vehiclesAutocomplete parameters
 */
export interface IvehiclesAutocompleteProps {
    id?: string, // 
    type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    provider?: Array<string>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    propulsion?: string, // Multiple values may be separated by commas.
    identification_number?: string, // 
    telemetry_after?: string, // range (lower bound)
    telemetry_before?: string, // range (upper bound)
    tz?: string, // 
    lang?: string, // 
    vin?: string, // 
    within_zone?: string, // 
    areas?: Array<string>, // 
    within_polygon?: string, // 
    options?: any,
};

/**
 * vehiclesExport parameters
 */
export interface IvehiclesExportProps {
    id?: string, // 
    type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    provider?: Array<string>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    propulsion?: string, // Multiple values may be separated by commas.
    identification_number?: string, // 
    telemetry_after?: string, // range (lower bound)
    telemetry_before?: string, // range (upper bound)
    tz?: string, // 
    lang?: string, // 
    vin?: string, // 
    within_zone?: string, // 
    areas?: Array<string>, // 
    within_polygon?: string, // 
    options?: any,
};

/**
 * vehiclesInZone parameters
 */
export interface IvehiclesInZoneProps {
    id?: string, // 
    type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    provider?: Array<string>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    propulsion?: string, // Multiple values may be separated by commas.
    identification_number?: string, // 
    telemetry_after?: string, // range (lower bound)
    telemetry_before?: string, // range (upper bound)
    tz?: string, // 
    lang?: string, // 
    vin?: string, // 
    within_zone?: string, // 
    areas?: Array<string>, // 
    within_polygon?: string, // 
    options?: any,
};

/**
 * vehiclesList parameters
 */
export interface IvehiclesListProps {
    id?: string, // 
    type?: Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>, // 
    provider?: Array<string>, // 
    status?: Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>, // 
    propulsion?: string, // Multiple values may be separated by commas.
    identification_number?: string, // 
    telemetry_after?: string, // range (lower bound)
    telemetry_before?: string, // range (upper bound)
    tz?: string, // 
    lang?: string, // 
    vin?: string, // 
    within_zone?: string, // 
    areas?: Array<string>, // 
    within_polygon?: string, // 
    options?: any,
};

/**
 * vehiclesProperties parameters
 */
export interface IvehiclesPropertiesProps {
    data: VehicleUids,
    options?: any,
};

/**
 * vehiclesRead parameters
 */
export interface IvehiclesReadProps {
    id: string,
    options?: any,
};

/**
 * VehiclesApi - fetch parameter creator
 * @export
 */
export const VehiclesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesAutocomplete({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options = {} }: IvehiclesAutocompleteProps): FetchArgs {
            const localVarPath = `/vehicles/autocomplete/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (propulsion !== undefined) {
                localVarQueryParameter['propulsion'] = propulsion;
            }

            if (identification_number !== undefined) {
                localVarQueryParameter['identification_number'] = identification_number;
            }

            if (telemetry_after !== undefined) {
                localVarQueryParameter['telemetry_after'] = telemetry_after;
            }

            if (telemetry_before !== undefined) {
                localVarQueryParameter['telemetry_before'] = telemetry_before;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (vin !== undefined) {
                localVarQueryParameter['vin'] = vin;
            }

            if (within_zone !== undefined) {
                localVarQueryParameter['within_zone'] = within_zone;
            }

            if (areas) {
                localVarQueryParameter['areas'] = areas;
            }

            if (within_polygon !== undefined) {
                localVarQueryParameter['within_polygon'] = within_polygon;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesExport({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options = {} }: IvehiclesExportProps): FetchArgs {
            const localVarPath = `/vehicles/export/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (propulsion !== undefined) {
                localVarQueryParameter['propulsion'] = propulsion;
            }

            if (identification_number !== undefined) {
                localVarQueryParameter['identification_number'] = identification_number;
            }

            if (telemetry_after !== undefined) {
                localVarQueryParameter['telemetry_after'] = telemetry_after;
            }

            if (telemetry_before !== undefined) {
                localVarQueryParameter['telemetry_before'] = telemetry_before;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (vin !== undefined) {
                localVarQueryParameter['vin'] = vin;
            }

            if (within_zone !== undefined) {
                localVarQueryParameter['within_zone'] = within_zone;
            }

            if (areas) {
                localVarQueryParameter['areas'] = areas;
            }

            if (within_polygon !== undefined) {
                localVarQueryParameter['within_polygon'] = within_polygon;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesInZone({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options = {} }: IvehiclesInZoneProps): FetchArgs {
            const localVarPath = `/vehicles/in_zone/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (propulsion !== undefined) {
                localVarQueryParameter['propulsion'] = propulsion;
            }

            if (identification_number !== undefined) {
                localVarQueryParameter['identification_number'] = identification_number;
            }

            if (telemetry_after !== undefined) {
                localVarQueryParameter['telemetry_after'] = telemetry_after;
            }

            if (telemetry_before !== undefined) {
                localVarQueryParameter['telemetry_before'] = telemetry_before;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (vin !== undefined) {
                localVarQueryParameter['vin'] = vin;
            }

            if (within_zone !== undefined) {
                localVarQueryParameter['within_zone'] = within_zone;
            }

            if (areas) {
                localVarQueryParameter['areas'] = areas;
            }

            if (within_polygon !== undefined) {
                localVarQueryParameter['within_polygon'] = within_polygon;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesList({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options = {} }: IvehiclesListProps): FetchArgs {
            const localVarPath = `/vehicles/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (provider) {
                localVarQueryParameter['provider'] = provider;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (propulsion !== undefined) {
                localVarQueryParameter['propulsion'] = propulsion;
            }

            if (identification_number !== undefined) {
                localVarQueryParameter['identification_number'] = identification_number;
            }

            if (telemetry_after !== undefined) {
                localVarQueryParameter['telemetry_after'] = telemetry_after;
            }

            if (telemetry_before !== undefined) {
                localVarQueryParameter['telemetry_before'] = telemetry_before;
            }

            if (tz !== undefined) {
                localVarQueryParameter['tz'] = tz;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (vin !== undefined) {
                localVarQueryParameter['vin'] = vin;
            }

            if (within_zone !== undefined) {
                localVarQueryParameter['within_zone'] = within_zone;
            }

            if (areas) {
                localVarQueryParameter['areas'] = areas;
            }

            if (within_polygon !== undefined) {
                localVarQueryParameter['within_polygon'] = within_polygon;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a dictionary of the {uid: [vin, provider, propulsion, ...} format. It's a little ugly, the serializer is dump and straightforward, but it's efficient as we need this information to export the historical map reports before we completely revamp the whole feature. Do not use this in other portions of the code, or make it a little smarter.
         * @param {VehicleUids} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesProperties({ data, options = {} }: IvehiclesPropertiesProps): FetchArgs {
            // verify required parameter 'data' is not null or undefined
            if (data === null || data === undefined) {
                throw new RequiredError('data','Required parameter data was null or undefined when calling vehiclesProperties.');
            }
            const localVarPath = `/vehicles/properties/`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VehicleUids" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesRead({ id, options = {} }: IvehiclesReadProps): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling vehiclesRead.');
            }
            const localVarPath = `/vehicles/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
					? configuration.apiKey("Authorization")
					: configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            const {search, ...localVarUrlObjWithoutSearch} = localVarUrlObj;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObjWithoutSearch),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehiclesApi - functional programming interface
 * @export
 */
export const VehiclesApiFp = function(configuration?: Configuration) {
    return {
        /**
         */
        vehiclesAutocompleteURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesAutocompleteProps): FetchArgs {
            return VehiclesApiFetchParamCreator(configuration).vehiclesAutocomplete({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
        },

        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesAutocomplete({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesAutocompleteProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<VehicleAutocomplete>> {
            const localVarFetchArgs = this.vehiclesAutocompleteURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        vehiclesExportURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesExportProps): FetchArgs {
            return VehiclesApiFetchParamCreator(configuration).vehiclesExport({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
        },

        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesExport({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesExportProps): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleResponse> {
            const localVarFetchArgs = this.vehiclesExportURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        vehiclesInZoneURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesInZoneProps): FetchArgs {
            return VehiclesApiFetchParamCreator(configuration).vehiclesInZone({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
        },

        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesInZone({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesInZoneProps): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Vehicle>> {
            const localVarFetchArgs = this.vehiclesInZoneURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        vehiclesListURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesListProps): FetchArgs {
            return VehiclesApiFetchParamCreator(configuration).vehiclesList({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
        },

        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesList({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesListProps): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleResponse> {
            const localVarFetchArgs = this.vehiclesListURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        vehiclesPropertiesURL({ data, options }: IvehiclesPropertiesProps): FetchArgs {
            return VehiclesApiFetchParamCreator(configuration).vehiclesProperties({ data, options });
        },

        /**
         * Returns a dictionary of the {uid: [vin, provider, propulsion, ...} format. It's a little ugly, the serializer is dump and straightforward, but it's efficient as we need this information to export the historical map reports before we completely revamp the whole feature. Do not use this in other portions of the code, or make it a little smarter.
         * @param {VehicleUids} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesProperties({ data, options }: IvehiclesPropertiesProps): (fetch?: FetchAPI, basePath?: string) => Promise<VehicleProperties> {
            const localVarFetchArgs = this.vehiclesPropertiesURL({ data, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
        /**
         */
        vehiclesReadURL({ id, options }: IvehiclesReadProps): FetchArgs {
            return VehiclesApiFetchParamCreator(configuration).vehiclesRead({ id, options });
        },

        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesRead({ id, options }: IvehiclesReadProps): (fetch?: FetchAPI, basePath?: string) => Promise<RetrieveVehicle> {
            const localVarFetchArgs = this.vehiclesReadURL({ id, options });
            return async (fetchData: FetchAPI = fetch, basePath: string = BASE_PATH) => {
                return fetchData(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    return handleGeneratedApiResponse(response)
                });
            };
        },
    }
};

/**
 * VehiclesApi - factory interface
 * @export
 */
export const VehiclesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesAutocomplete({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesAutocompleteProps) {
            return VehiclesApiFp(configuration).vehiclesAutocomplete({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesExport({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesExportProps) {
            return VehiclesApiFp(configuration).vehiclesExport({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesInZone({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesInZoneProps) {
            return VehiclesApiFp(configuration).vehiclesInZone({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
         * @param {Array<string>} [provider] 
         * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
         * @param {string} [propulsion] Multiple values may be separated by commas.
         * @param {string} [identification_number] 
         * @param {string} [telemetry_after] range (lower bound)
         * @param {string} [telemetry_before] range (upper bound)
         * @param {string} [tz] 
         * @param {string} [lang] 
         * @param {string} [vin] 
         * @param {string} [within_zone] 
         * @param {Array<string>} [areas] 
         * @param {string} [within_polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesList({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesListProps) {
            return VehiclesApiFp(configuration).vehiclesList({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options })(fetch, basePath);
        },
        /**
         * Returns a dictionary of the {uid: [vin, provider, propulsion, ...} format. It's a little ugly, the serializer is dump and straightforward, but it's efficient as we need this information to export the historical map reports before we completely revamp the whole feature. Do not use this in other portions of the code, or make it a little smarter.
         * @param {VehicleUids} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesProperties({ data, options }: IvehiclesPropertiesProps) {
            return VehiclesApiFp(configuration).vehiclesProperties({ data, options })(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesRead({ id, options }: IvehiclesReadProps) {
            return VehiclesApiFp(configuration).vehiclesRead({ id, options })(fetch, basePath);
        },
    };
};

/**
 * VehiclesApi - object-oriented interface
 * @export
 * @class VehiclesApi
 * @extends {BaseAPI}
 */
export class VehiclesApi extends BaseAPI {
    /**
     * Returns the URL string and options for Fetch.
     * See ``vehiclesAutocomplete`` for arguments and options.
     *
     */
    public vehiclesAutocompleteURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesAutocompleteProps = {}): FetchArgs {
        return VehiclesApiFp(this.configuration).vehiclesAutocompleteURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
    }

    /**
     * 
     * @param {string} [id] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
     * @param {Array<string>} [provider] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {string} [propulsion] Multiple values may be separated by commas.
     * @param {string} [identification_number] 
     * @param {string} [telemetry_after] range (lower bound)
     * @param {string} [telemetry_before] range (upper bound)
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [vin] 
     * @param {string} [within_zone] 
     * @param {Array<string>} [areas] 
     * @param {string} [within_polygon] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesAutocomplete({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesAutocompleteProps = {}) {
        return VehiclesApiFp(this.configuration).vehiclesAutocomplete({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``vehiclesExport`` for arguments and options.
     *
     */
    public vehiclesExportURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesExportProps = {}): FetchArgs {
        return VehiclesApiFp(this.configuration).vehiclesExportURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
    }

    /**
     * 
     * @param {string} [id] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
     * @param {Array<string>} [provider] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {string} [propulsion] Multiple values may be separated by commas.
     * @param {string} [identification_number] 
     * @param {string} [telemetry_after] range (lower bound)
     * @param {string} [telemetry_before] range (upper bound)
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [vin] 
     * @param {string} [within_zone] 
     * @param {Array<string>} [areas] 
     * @param {string} [within_polygon] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesExport({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesExportProps = {}) {
        return VehiclesApiFp(this.configuration).vehiclesExport({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``vehiclesInZone`` for arguments and options.
     *
     */
    public vehiclesInZoneURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesInZoneProps = {}): FetchArgs {
        return VehiclesApiFp(this.configuration).vehiclesInZoneURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
    }

    /**
     * 
     * @param {string} [id] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
     * @param {Array<string>} [provider] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {string} [propulsion] Multiple values may be separated by commas.
     * @param {string} [identification_number] 
     * @param {string} [telemetry_after] range (lower bound)
     * @param {string} [telemetry_before] range (upper bound)
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [vin] 
     * @param {string} [within_zone] 
     * @param {Array<string>} [areas] 
     * @param {string} [within_polygon] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesInZone({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesInZoneProps = {}) {
        return VehiclesApiFp(this.configuration).vehiclesInZone({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``vehiclesList`` for arguments and options.
     *
     */
    public vehiclesListURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesListProps = {}): FetchArgs {
        return VehiclesApiFp(this.configuration).vehiclesListURL({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options });
    }

    /**
     * 
     * @param {string} [id] 
     * @param {Array<'bicycle' | 'car' | 'cargo_bicycle' | 'delivery_bot' | 'moped' | 'other' | 'scooter' | 'scooter_seated'>} [type] 
     * @param {Array<string>} [provider] 
     * @param {Array<'available' | 'elsewhere' | 'non_operational' | 'on_trip' | 'removed' | 'reserved' | 'unknown' | 'stopped' | 'non_contactable' | 'missing'>} [status] 
     * @param {string} [propulsion] Multiple values may be separated by commas.
     * @param {string} [identification_number] 
     * @param {string} [telemetry_after] range (lower bound)
     * @param {string} [telemetry_before] range (upper bound)
     * @param {string} [tz] 
     * @param {string} [lang] 
     * @param {string} [vin] 
     * @param {string} [within_zone] 
     * @param {Array<string>} [areas] 
     * @param {string} [within_polygon] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesList({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options }: IvehiclesListProps = {}) {
        return VehiclesApiFp(this.configuration).vehiclesList({ id, type, provider, status, propulsion, identification_number, telemetry_after, telemetry_before, tz, lang, vin, within_zone, areas, within_polygon, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``vehiclesProperties`` for arguments and options.
     *
     */
    public vehiclesPropertiesURL({ data, options }: IvehiclesPropertiesProps): FetchArgs {
        return VehiclesApiFp(this.configuration).vehiclesPropertiesURL({ data, options });
    }

    /**
     * Returns a dictionary of the {uid: [vin, provider, propulsion, ...} format. It's a little ugly, the serializer is dump and straightforward, but it's efficient as we need this information to export the historical map reports before we completely revamp the whole feature. Do not use this in other portions of the code, or make it a little smarter.
     * @param {VehicleUids} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesProperties({ data, options }: IvehiclesPropertiesProps) {
        return VehiclesApiFp(this.configuration).vehiclesProperties({ data, options })(this.fetchData, this.basePath);
    }

    /**
     * Returns the URL string and options for Fetch.
     * See ``vehiclesRead`` for arguments and options.
     *
     */
    public vehiclesReadURL({ id, options }: IvehiclesReadProps): FetchArgs {
        return VehiclesApiFp(this.configuration).vehiclesReadURL({ id, options });
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesRead({ id, options }: IvehiclesReadProps) {
        return VehiclesApiFp(this.configuration).vehiclesRead({ id, options })(this.fetchData, this.basePath);
    }

}

